import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const EyeTracking20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h3a.5.5 0 000-1h-3A2.5 2.5 0 002 4.5v3a.5.5 0 001 0v-3zm0 11c0 .83.67 1.5 1.5 1.5h3a.5.5 0 010 1h-3A2.5 2.5 0 012 15.5v-3a.5.5 0 011 0v3zM15.5 3c.83 0 1.5.67 1.5 1.5v3a.5.5 0 001 0v-3A2.5 2.5 0 0015.5 2h-3a.5.5 0 000 1h3zM17 15.5c0 .83-.67 1.5-1.5 1.5h-3a.5.5 0 000 1h3a2.5 2.5 0 002.5-2.5v-3a.5.5 0 00-1 0v3zm-10-4a3 3 0 116 0 3 3 0 01-6 0zm3-2a2 2 0 100 4 2 2 0 000-4zm-5.05.22a.5.5 0 01-.9-.44l.45.22-.45-.22v-.01l.01-.01a2.1 2.1 0 01.08-.14l.25-.38A6.85 6.85 0 0110 6a6.85 6.85 0 015.62 2.74 5.13 5.13 0 01.33.52v.01l-.44.23.45-.22a.5.5 0 01-.9.45V9.7a2.5 2.5 0 00-.25-.39A5.86 5.86 0 0010 7a5.86 5.86 0 00-4.8 2.32 4.14 4.14 0 00-.24.39l-.01.01z",
    fill: primaryFill
  }));
};

export const EyeTracking20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTracking20RegularIcon, 'EyeTracking20Regular');

const EyeTracking24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.49 15.65a.75.75 0 00-1.49 0V19.43A2.75 2.75 0 004.58 22h3.77a.75.75 0 000-1.5H4.62a1.25 1.25 0 01-1.12-1.12v-3.63l-.01-.1zm18.5 0a.75.75 0 00-1.5.1v3.63c-.06.63-.6 1.12-1.24 1.12h-3.6a.75.75 0 00.1 1.5h3.66A2.75 2.75 0 0022 19.25v-3.5l-.01-.1zm-13-12.9A.75.75 0 008.26 2H4.58A2.75 2.75 0 002 4.76v3.6a.75.75 0 001.5-.1V4.62C3.57 4 4.1 3.5 4.75 3.5h3.6A.75.75 0 009 2.74zm10.42-.74L19.25 2h-3.6a.75.75 0 000 1.5h3.72c.6.07 1.06.53 1.12 1.12v3.63l.01.1a.75.75 0 001.49 0V4.58A2.75 2.75 0 0019.41 2zM8.5 13.5a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm-2.29-1.76v.02a.75.75 0 01-.97.44c-.6-.22-.44-.97-.44-.97v-.02a2.5 2.5 0 01.1-.2A7.57 7.57 0 0112 6.75a7.73 7.73 0 016.84 3.75 6.3 6.3 0 01.35.71v.02h.01a.75.75 0 01-1.4.53l-.01-.02-.04-.1-.21-.39a6.07 6.07 0 00-5.54-3 6.24 6.24 0 00-5.54 3 4.78 4.78 0 00-.25.5z",
    fill: primaryFill
  }));
};

export const EyeTracking24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTracking24FilledIcon, 'EyeTracking24Filled');

const EyeTracking24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 2a.75.75 0 01.1 1.5h-3.6c-.65 0-1.18.5-1.25 1.12v3.63a.75.75 0 01-1.5.1v-3.6a2.75 2.75 0 012.58-2.74L4.75 2h3.5zM3.49 15.65a.75.75 0 00-1.49 0V19.43A2.75 2.75 0 004.58 22h3.77a.75.75 0 000-1.5H4.62a1.25 1.25 0 01-1.12-1.12v-3.63l-.01-.1zm18.5 0a.75.75 0 00-1.5.1v3.63c-.06.63-.6 1.12-1.24 1.12h-3.6a.75.75 0 00.1 1.5h3.66A2.75 2.75 0 0022 19.25v-3.5l-.01-.1zM19.41 2L19.25 2h-3.6a.75.75 0 000 1.5h3.72c.6.07 1.06.53 1.12 1.12v3.63l.01.1a.75.75 0 001.49 0V4.58A2.75 2.75 0 0019.41 2zm-13.2 9.75v-.02l.04-.1.21-.39a6.07 6.07 0 015.54-3 6.24 6.24 0 015.54 3 4.78 4.78 0 01.25.5v.01c.16.38.59.59.97.44a.75.75 0 00.44-.96v-.03a3.2 3.2 0 00-.1-.2A7.57 7.57 0 0012 6.75a7.73 7.73 0 00-6.84 3.75 6.26 6.26 0 00-.35.71v.02c-.01 0-.17.75.43.97.38.15.81-.05.96-.43zM12 10a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm-2 3.5a2 2 0 114 0 2 2 0 01-4 0z",
    fill: primaryFill
  }));
};

export const EyeTracking24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTracking24RegularIcon, 'EyeTracking24Regular');

const EyeTrackingOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.02 13.72l1.13 1.13a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7l1.13 1.13A2 2 0 002 4v1.5a.5.5 0 001 0V4a1 1 0 01.03-.26L4.7 5.41A4.95 4.95 0 003.04 7.3v.01a.5.5 0 00.92.38v-.01L4 7.62c.02-.06.07-.14.13-.24a3.73 3.73 0 011.3-1.24l.95.95a2.5 2.5 0 103.53 3.53l2.35 2.35A1 1 0 0112 13h-1.5a.5.5 0 000 1H12a2 2 0 001.02-.28zm-6.29-9.1l.9.89L8 5.5a4.6 4.6 0 013.23 1.12 3.73 3.73 0 01.8 1.06s.25.45.66.28a.5.5 0 00.27-.65c-.1-.22 0 0 0 0V7.3a1.8 1.8 0 00-.06-.13c-.04-.08-.1-.2-.19-.33a4.73 4.73 0 00-.81-.96A5.6 5.6 0 008 4.5c-.46 0-.88.04-1.27.11zM13 10.87l1 1V10.5a.5.5 0 00-1 0v.38zM4.12 2l1 1h.38a.5.5 0 000-1H4.12zM2 12c0 1.1.9 2 2 2h1.5a.5.5 0 000-1H4a1 1 0 01-1-1v-1.5a.5.5 0 00-1 0V12zM12 2a2 2 0 012 2v1.5a.5.5 0 01-1 0V4a1 1 0 00-1-1h-1.5a.5.5 0 010-1H12z",
    fill: primaryFill
  }));
};

export const EyeTrackingOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOff16FilledIcon, 'EyeTrackingOff16Filled');

const EyeTrackingOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.02 13.72l1.13 1.13a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7l1.13 1.13A2 2 0 002 4v1.5a.5.5 0 001 0V4a1 1 0 01.03-.26L4.7 5.41A4.95 4.95 0 003.04 7.3v.01a.5.5 0 00.92.38v-.01L4 7.62c.02-.06.07-.14.13-.24a3.73 3.73 0 011.3-1.24l.95.95a2.5 2.5 0 103.53 3.53l2.35 2.35A1 1 0 0112 13h-1.5a.5.5 0 100 1H12a2 2 0 001.02-.28zM9.2 9.9a1.5 1.5 0 11-2.1-2.1l2.1 2.1zM6.73 4.61l.9.9L8 5.5a4.6 4.6 0 013.23 1.12 3.73 3.73 0 01.8 1.06s.25.45.66.28a.5.5 0 00.27-.65c-.1-.22 0 0 0 0V7.3a1.85 1.85 0 00-.06-.13c-.04-.08-.1-.2-.19-.33a4.73 4.73 0 00-.81-.96A5.6 5.6 0 008 4.5c-.46 0-.88.04-1.27.11zM13 10.88l1 1V10.5a.5.5 0 10-1 0v.38zM4.12 2l1 1h.38a.5.5 0 000-1H4.12zM4 14a2 2 0 01-2-2v-1.5a.5.5 0 111 0V12a1 1 0 001 1h1.5a.5.5 0 110 1H4zM14 4a2 2 0 00-2-2h-1.5a.5.5 0 000 1H12a1 1 0 011 1v1.5a.5.5 0 001 0V4z",
    fill: primaryFill
  }));
};

export const EyeTrackingOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOff16RegularIcon, 'EyeTrackingOff16Regular');

const EyeTrackingOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v3a.5.5 0 001 0v-3c0-.23.05-.45.15-.65L6.29 7a6.6 6.6 0 00-2.23 2.27v.01l.44.23-.45-.22a.5.5 0 00.9.44v-.01a2.39 2.39 0 01.25-.39 5.49 5.49 0 011.82-1.6l1.3 1.3a3 3 0 104.16 4.17l3.67 3.66c-.2.1-.42.15-.65.15h-3a.5.5 0 000 1h3c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 00.7-.7l-.26-.27-.74-.73-3.93-3.94-3.63-3.63L8.01 7.3l-.78-.78-3.38-3.37-.73-.74-.27-.26a.5.5 0 10-.7.7l.26.27zm15.57 12.73l.02-.35v-3a.5.5 0 00-1 0v2.38l.98.97zm-8.81-8.8A7 7 0 0110 7a5.86 5.86 0 014.8 2.32 4.13 4.13 0 01.24.39l.01.01a.5.5 0 00.9-.44v-.01l-.01-.01a1.7 1.7 0 00-.08-.14l-.25-.38A6.85 6.85 0 0010 6c-.63 0-1.2.07-1.7.18l.86.87zm6.78 2.23l-.06.03-.39.19.45-.22zM5.12 3H7.5a.5.5 0 000-1h-3c-.12 0-.24 0-.35.02l.97.98zM3 15.5c0 .83.67 1.5 1.5 1.5h3a.5.5 0 010 1h-3A2.5 2.5 0 012 15.5v-3a.5.5 0 011 0v3zm14-11c0-.83-.67-1.5-1.5-1.5h-3a.5.5 0 010-1h3A2.5 2.5 0 0118 4.5v3a.5.5 0 01-1 0v-3z",
    fill: primaryFill
  }));
};

export const EyeTrackingOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOff20FilledIcon, 'EyeTrackingOff20Filled');

const EyeTrackingOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.41 3.12C2.15 3.52 2 4 2 4.5v3a.5.5 0 001 0v-3c0-.23.05-.45.15-.65L6.29 7a6.6 6.6 0 00-2.23 2.27v.01l.44.23-.45-.22a.5.5 0 00.9.44v-.01a2.39 2.39 0 01.25-.39 5.49 5.49 0 011.82-1.6l1.3 1.3a3 3 0 104.16 4.17l3.67 3.66c-.2.1-.42.15-.65.15h-3a.5.5 0 000 1h3c.5 0 .98-.15 1.38-.41l.27.26a.5.5 0 00.7-.7l-.26-.27-.74-.73-3.93-3.94-3.63-3.63L8.01 7.3l-.78-.78-3.38-3.37-.73-.74-.27-.26a.5.5 0 10-.7.7l.26.27zm9.34 9.34a2 2 0 11-2.71-2.71l2.71 2.71zm6.23 3.4l.02-.36v-3a.5.5 0 00-1 0v2.38l.98.97zM9.17 7.04A7 7 0 0110 7a5.86 5.86 0 014.8 2.32 4.13 4.13 0 01.24.39l.01.01a.5.5 0 00.9-.44v-.01l-.01-.01a1.7 1.7 0 00-.08-.14l-.25-.38A6.85 6.85 0 0010 6c-.63 0-1.2.07-1.7.18l.86.87zm6.78 2.23l-.06.03-.39.19.45-.22zM5.12 3H7.5a.5.5 0 000-1h-3c-.12 0-.24 0-.35.02l.97.98zM4.5 17A1.5 1.5 0 013 15.5v-3a.5.5 0 00-1 0v3A2.5 2.5 0 004.5 18h3a.5.5 0 000-1h-3zm11-14c.83 0 1.5.67 1.5 1.5v3a.5.5 0 001 0v-3A2.5 2.5 0 0015.5 2h-3a.5.5 0 000 1h3z",
    fill: primaryFill
  }));
};

export const EyeTrackingOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOff20RegularIcon, 'EyeTrackingOff20Regular');

const EyeTrackingOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l.13.13c-.23.4-.35.85-.35 1.34v3.6a.75.75 0 001.5-.1V4.62l.01-.05 3.68 3.68A7.44 7.44 0 004.8 11.2v.02c-.01 0-.17.75.43.97.38.15.81-.05.96-.43l.01-.03a2.85 2.85 0 01.25-.49 6.07 6.07 0 011.8-1.93l1.5 1.5a3.5 3.5 0 104.92 4.93l4.75 4.74-.18.01h-3.6a.75.75 0 00.1 1.5h3.66c.43-.03.83-.15 1.18-.35l.13.13a.75.75 0 001.06-1.06L3.28 2.22zm8.17 6.05l-1.33-1.33c.57-.12 1.2-.19 1.88-.19a7.73 7.73 0 016.84 3.75 6.3 6.3 0 01.33.67l.02.04v.02h.01a.75.75 0 01-1.4.53l-.01-.02-.04-.1-.21-.39a6.07 6.07 0 00-5.54-3c-.19 0-.37 0-.55.02zM22 18.82l-1.5-1.5v-1.57a.75.75 0 011.49-.1v3.17zM6.68 3.5L5.18 2h3.07a.75.75 0 01.1 1.5H6.68zM2.75 15c.38 0 .7.28.74.65v3.6l.01.13c.06.59.53 1.06 1.12 1.12h3.73a.75.75 0 010 1.5H4.58A2.75 2.75 0 012 19.43V15.65a.75.75 0 01.75-.65zm16.5-13h.16A2.75 2.75 0 0122 4.59v3.77a.75.75 0 01-1.49 0V4.62a1.25 1.25 0 00-1.13-1.11l-.12-.01h-3.6a.75.75 0 010-1.5h3.6z",
    fill: primaryFill
  }));
};

export const EyeTrackingOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOff24FilledIcon, 'EyeTrackingOff24Filled');

const EyeTrackingOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l.13.13c-.23.4-.35.85-.35 1.34v3.6a.75.75 0 001.5-.1V4.62l.01-.05 3.68 3.68A7.44 7.44 0 004.8 11.2v.02c-.01 0-.17.75.43.97.38.15.81-.05.96-.43l.01-.03a2.85 2.85 0 01.25-.49 6.07 6.07 0 011.8-1.93l1.5 1.5a3.5 3.5 0 104.92 4.93l4.75 4.74-.18.01h-3.6a.75.75 0 00.1 1.5h3.66c.43-.03.83-.15 1.18-.35l.13.13a.75.75 0 001.06-1.06L3.28 2.22zm10.34 12.46a2 2 0 11-2.8-2.8l2.8 2.8zm-2.17-6.41l-1.33-1.33c.57-.12 1.2-.19 1.88-.19a7.73 7.73 0 016.84 3.75 6.3 6.3 0 01.33.67l.02.04v.02h.01a.75.75 0 01-1.4.53l-.01-.02-.04-.1-.21-.39a6.07 6.07 0 00-5.54-3c-.19 0-.37 0-.55.02zM22 18.82l-1.5-1.5v-1.57a.75.75 0 011.49-.1v3.17zM6.68 3.5L5.18 2h3.07a.75.75 0 01.1 1.5H6.68zM2.75 15c.38 0 .7.28.74.65v3.6l.01.13c.06.59.53 1.06 1.12 1.12h3.73a.75.75 0 010 1.5H4.58A2.75 2.75 0 012 19.43V15.65a.75.75 0 01.75-.65zm16.5-13h.16A2.75 2.75 0 0122 4.59v3.77a.75.75 0 01-1.49 0V4.62a1.25 1.25 0 00-1.13-1.11l-.12-.01h-3.6a.75.75 0 010-1.5h3.6z",
    fill: primaryFill
  }));
};

export const EyeTrackingOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyeTrackingOff24RegularIcon, 'EyeTrackingOff24Regular');

const Eyedropper20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.25 2.75a2.62 2.62 0 00-3.71 0L12.5 3.8l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-6.35 6.35A1.5 1.5 0 003 13.91v.5l-.96 2.26a1 1 0 001.32 1.31L5.6 17h.49c.4 0 .78-.16 1.06-.44l6.35-6.35.35.35a1.5 1.5 0 002.12 0l.59-.58a1.5 1.5 0 000-2.13l-.35-.35 1.04-1.04a2.62 2.62 0 000-3.7zM10.5 7.21l2.3 2.3-6.36 6.34a.5.5 0 01-.35.15H5.5a.5.5 0 00-.2.04l-2.34 1.03 1-2.36a.5.5 0 00.04-.2v-.6a.5.5 0 01.15-.35l6.35-6.35z",
    fill: primaryFill
  }));
};

export const Eyedropper20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Eyedropper20FilledIcon, 'Eyedropper20Filled');

const Eyedropper20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.25 2.75a2.62 2.62 0 00-3.71 0L12.5 3.8l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-6.35 6.35A1.5 1.5 0 003 13.91v.5l-.96 2.26a1 1 0 001.32 1.31L5.6 17h.49c.4 0 .78-.16 1.06-.44l6.35-6.35.35.35a1.5 1.5 0 002.12 0l.59-.58a1.5 1.5 0 000-2.13l-.35-.35 1.04-1.04a2.62 2.62 0 000-3.7zm-3 .71a1.62 1.62 0 012.29 2.3l-1.4 1.39a.5.5 0 000 .7l.71.71c.2.2.2.51 0 .7l-.58.6a.5.5 0 01-.71 0l-4.41-4.42a.5.5 0 010-.7l.58-.59c.2-.2.52-.2.71 0l.7.7a.5.5 0 00.71 0l1.4-1.39zM12.79 9.5l-6.35 6.35a.5.5 0 01-.35.15H5.5a.5.5 0 00-.2.04l-2.34 1.03 1-2.36a.5.5 0 00.04-.2v-.6a.5.5 0 01.15-.35l6.35-6.35 2.3 2.3z",
    fill: primaryFill
  }));
};

export const Eyedropper20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Eyedropper20RegularIcon, 'Eyedropper20Regular');

const Eyedropper24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.03 2.97a3.58 3.58 0 00-5.06 0L14 4.94l-.01-.01a1.75 1.75 0 00-2.48 0l-.58.58c-.69.69-.69 1.8 0 2.48V8l-6.77 6.78c-.42.42-.66 1-.66 1.6v.68L2.22 19.4c-.84 1.53.84 3.2 2.37 2.37l2.35-1.28h.69c.6 0 1.17-.24 1.59-.66L16 13.06l.01.01c.69.69 1.8.69 2.48 0l.58-.58c.69-.69.69-1.8 0-2.48V10l1.96-1.97a3.58 3.58 0 000-5.06zM12 9.07L14.94 12l-6.78 6.78a.75.75 0 01-.53.22h-.88a.75.75 0 00-.36.1l-2.51 1.36a.23.23 0 01-.16.04.26.26 0 01-.14-.08.26.26 0 01-.08-.14c0-.03 0-.09.04-.16l1.37-2.51c.06-.11.09-.23.09-.36v-.88c0-.2.08-.39.22-.53L12 9.06z",
    fill: primaryFill
  }));
};

export const Eyedropper24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Eyedropper24FilledIcon, 'Eyedropper24Filled');

const Eyedropper24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.03 2.97a3.58 3.58 0 00-5.06 0L14 4.94l-.01-.01a1.75 1.75 0 00-2.48 0l-.58.58c-.69.69-.69 1.8 0 2.48V8l-6.77 6.78c-.42.42-.66 1-.66 1.6v.68L2.22 19.4c-.84 1.53.84 3.2 2.37 2.37l2.35-1.28h.69c.6 0 1.17-.24 1.59-.66L16 13.06l.01.01c.69.69 1.8.69 2.48 0l.58-.58c.69-.69.69-1.8 0-2.48V10l1.96-1.97a3.58 3.58 0 000-5.06zm-4 1.06a2.08 2.08 0 012.94 2.94l-2.5 2.5c-.3.3-.3.77 0 1.06l.54.54c.1.1.1.26 0 .36l-.58.58c-.1.1-.26.1-.36 0L12 6.93a.25.25 0 010-.36l.58-.58c.1-.1.26-.1.36 0l.54.54c.3.3.77.3 1.06 0l2.5-2.5zM14.93 12l-6.77 6.78a.75.75 0 01-.53.22h-.88a.75.75 0 00-.36.1l-2.51 1.36a.23.23 0 01-.16.04.26.26 0 01-.14-.08.26.26 0 01-.08-.14c0-.03 0-.09.04-.16l1.37-2.51c.06-.11.09-.23.09-.36v-.88c0-.2.08-.39.22-.53L12 9.06 14.94 12z",
    fill: primaryFill
  }));
};

export const Eyedropper24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Eyedropper24RegularIcon, 'Eyedropper24Regular');

const EyedropperOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.8 8.5L2.14 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-5.65-5.64-4.35 4.35a1.5 1.5 0 01-1.06.44H5.6l-2.25.98a1 1 0 01-1.32-1.3L3 14.41v-.5c0-.4.16-.79.44-1.07L7.79 8.5zm3 3L8.5 9.2l-4.35 4.36a.5.5 0 00-.15.35v.6a.5.5 0 01-.04.2l-1 2.36 2.34-1.03a.5.5 0 01.2-.04h.59a.5.5 0 00.35-.15l4.35-4.35zm2-2l-.6.59.72.7.58-.58.35.35a1.5 1.5 0 002.13 0l.58-.59a1.5 1.5 0 000-2.12l-.35-.35 1.04-1.04a2.62 2.62 0 10-3.71-3.7L12.5 3.78l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-.58.59.7.7.6-.58 2.28 2.29zm1.45-6.04a1.62 1.62 0 112.29 2.3l-1.4 1.39a.5.5 0 000 .7l.71.71c.2.2.2.51 0 .7l-.58.6a.5.5 0 01-.7 0l-4.42-4.42a.5.5 0 010-.7l.59-.6c.2-.19.5-.19.7 0l.7.71a.5.5 0 00.71 0l1.4-1.39z",
    fill: primaryFill
  }));
};

export const EyedropperOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperOff20FilledIcon, 'EyedropperOff20Filled');

const EyedropperOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.8 8.5L2.14 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-5.65-5.64-4.35 4.35a1.5 1.5 0 01-1.06.44H5.6l-2.25.98a1 1 0 01-1.32-1.3L3 14.41v-.5c0-.4.16-.79.44-1.07L7.79 8.5zm3 3L8.5 9.2l-4.35 4.36a.5.5 0 00-.15.35v.6a.5.5 0 01-.04.2l-1 2.36 2.34-1.03a.5.5 0 01.2-.04h.59a.5.5 0 00.35-.15l4.35-4.35zm2-2l-.6.59.72.7.58-.58.35.35a1.5 1.5 0 002.13 0l.58-.59a1.5 1.5 0 000-2.12l-.35-.35 1.04-1.04a2.62 2.62 0 10-3.71-3.7L12.5 3.78l-.35-.35a1.5 1.5 0 00-2.12 0l-.59.59a1.5 1.5 0 000 2.12l.35.35-.58.59.7.7.6-.58 2.28 2.29z",
    fill: primaryFill
  }));
};

export const EyedropperOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperOff20RegularIcon, 'EyedropperOff20Regular');

const EyedropperOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.94 10L2.22 3.28a.75.75 0 111.06-1.06l18.5 18.5a.75.75 0 01-1.06 1.06L14 15.06l-4.78 4.78c-.42.42-1 .66-1.59.66h-.69L4.6 21.78c-1.54.84-3.22-.84-2.38-2.37l1.28-2.35v-.69c0-.6.24-1.17.66-1.59L8.94 10zm4 4L10 11.06l-4.78 4.78a.75.75 0 00-.22.53v.88c0 .13-.03.25-.09.36l-1.37 2.51a.23.23 0 00-.03.16c0 .05.03.1.07.14.04.04.1.07.14.08.04 0 .09 0 .16-.04l2.51-1.37c.11-.06.24-.09.36-.09h.88c.2 0 .39-.08.53-.22L12.94 14zm5.55-.93c-.5.5-1.2.63-1.82.42l-6.16-6.16a1.75 1.75 0 01.42-1.82l.58-.58c.69-.69 1.8-.69 2.48 0H14l1.97-1.96a3.58 3.58 0 015.06 5.06L19.06 10l.01.01c.69.69.69 1.8 0 2.48l-.58.58zm-1.46-9.04l-2.5 2.5c-.3.3-.77.3-1.06 0l-.54-.54a.25.25 0 00-.36 0l-.58.58c-.1.1-.1.26 0 .36L17.07 12c.1.1.26.1.36 0l.58-.58c.1-.1.1-.26 0-.36l-.54-.54a.75.75 0 010-1.06l2.5-2.5a2.08 2.08 0 10-2.94-2.94z",
    fill: primaryFill
  }));
};

export const EyedropperOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperOff24FilledIcon, 'EyedropperOff24Filled');

const EyedropperOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.94 10l-4.78 4.78c-.42.42-.66 1-.66 1.6v.68L2.22 19.4c-.84 1.53.84 3.2 2.38 2.37l2.34-1.28h.69c.6 0 1.17-.24 1.6-.66L14 15.06l6.72 6.72a.75.75 0 001.06-1.06L3.28 2.22a.75.75 0 10-1.06 1.06L8.94 10zm4 4l-4.78 4.78a.75.75 0 01-.53.22h-.88a.75.75 0 00-.36.1l-2.51 1.36a.23.23 0 01-.16.04.26.26 0 01-.14-.08.26.26 0 01-.07-.14c-.01-.04-.01-.09.03-.16l1.37-2.51c.06-.11.1-.23.1-.36v-.88c0-.2.07-.39.21-.53L10 11.06 12.94 14zm5.55-.93c-.5.5-1.2.63-1.82.42l-6.16-6.16a1.75 1.75 0 01.42-1.82l.58-.58c.69-.69 1.8-.69 2.48 0H14l1.97-1.96a3.58 3.58 0 015.06 5.06L19.06 10l.01.01c.69.69.69 1.8 0 2.48l-.58.58z",
    fill: primaryFill
  }));
};

export const EyedropperOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/EyedropperOff24RegularIcon, 'EyedropperOff24Regular');

const FStop16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.06 4.1c.19-1.17 1.4-1.89 2.53-1.49l.4.15a.75.75 0 10.51-1.42l-.4-.14c-2.01-.72-4.18.56-4.53 2.66L7.1 6.75H4.5a.75.75 0 100 1.5h2.35l-.43 2.63a1.92 1.92 0 01-2.93 1.3l-.34-.21a.75.75 0 10-.8 1.26l.34.22a3.42 3.42 0 005.2-2.32l.48-2.88h2.13a.75.75 0 000-1.5H8.62l.44-2.65z",
    fill: primaryFill
  }));
};

export const FStop16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop16FilledIcon, 'FStop16Filled');

const FStop16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.84 3.84a2.17 2.17 0 012.72-1.73l.8.22a.5.5 0 10.27-.96l-.8-.22a3.17 3.17 0 00-3.97 2.53L7.3 7H4.5a.5.5 0 100 1h2.65l-.53 3.18a2.17 2.17 0 01-3.19 1.55l-.69-.39a.5.5 0 00-.48.88l.69.38a3.17 3.17 0 004.66-2.25L8.16 8h2.34a.5.5 0 000-1H8.32l.52-3.16z",
    fill: primaryFill
  }));
};

export const FStop16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop16RegularIcon, 'FStop16Regular');

const FStop20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.08 5.68c.28-1.63 2-2.58 3.53-1.95l.36.14a.75.75 0 10.56-1.38l-.36-.15A4.08 4.08 0 009.6 5.43L9 9H5.74a.75.75 0 000 1.5h2.98l-.5 2.96a2.58 2.58 0 01-3.92 1.75l-.16-.1a.75.75 0 00-.8 1.27l.16.1c2.46 1.55 5.7.1 6.2-2.77l.55-3.21h2.99a.75.75 0 100-1.5h-2.74l.57-3.32z",
    fill: primaryFill
  }));
};

export const FStop20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop20FilledIcon, 'FStop20Filled');

const FStop20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.88 5.35a2.83 2.83 0 013.68-2.22l.78.26a.5.5 0 10.32-.95l-.8-.26a3.83 3.83 0 00-4.96 3L9.24 9H5.5a.5.5 0 100 1h3.57l-.62 3.63a2.83 2.83 0 01-4.24 1.96l-.45-.27a.5.5 0 10-.52.86l.46.27a3.83 3.83 0 005.74-2.65l.65-3.8h3.41a.5.5 0 000-1h-3.24l.62-3.65z",
    fill: primaryFill
  }));
};

export const FStop20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop20RegularIcon, 'FStop20Regular');

const FStop24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.44 6.57a3 3 0 013.94-2.33l.6.2a1 1 0 00.65-1.88l-.6-.21a5 5 0 00-6.56 3.88l-.73 4.27H7a1 1 0 000 2h3.4l-.69 4.04a3 3 0 01-4.4 2.13l-.08-.05a1 1 0 00-.96 1.76l.07.04a5 5 0 007.34-3.54l.75-4.38H16a1 1 0 100-2h-3.23l.67-3.93z",
    fill: primaryFill
  }));
};

export const FStop24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop24FilledIcon, 'FStop24Filled');

const FStop24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.2 6.53A3.25 3.25 0 0117.46 4l.6.2a.75.75 0 10.49-1.4l-.6-.21a4.75 4.75 0 00-6.23 3.69L11 10.5H6.75a.75.75 0 000 1.5h3.99l-.78 4.58a3.25 3.25 0 01-4.77 2.3l-.08-.04a.75.75 0 00-.72 1.32l.07.04a4.75 4.75 0 006.98-3.36l.82-4.84h3.99a.75.75 0 000-1.5h-3.73l.68-3.97z",
    fill: primaryFill
  }));
};

export const FStop24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop24RegularIcon, 'FStop24Regular');

const FStop28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.6 7.99A4 4 0 0120.93 5l.47.18a1 1 0 10.7-1.88l-.47-.17a6 6 0 00-8 4.46l-.86 4.4H7.75a1 1 0 100 2h4.63l-.98 5.01A4 4 0 016.07 22l-.47-.18a1 1 0 10-.7 1.88l.47.17a6 6 0 008-4.46l1.05-5.4h4.83a1 1 0 100-2h-4.44l.79-4.01z",
    fill: primaryFill
  }));
};

export const FStop28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop28FilledIcon, 'FStop28Filled');

const FStop28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.35 7.94a4.25 4.25 0 015.67-3.16l.47.17a.75.75 0 10.52-1.4l-.47-.18a5.75 5.75 0 00-7.66 4.28L13.03 12H7.75a.75.75 0 100 1.5h4.99l-1.1 5.56a4.25 4.25 0 01-5.66 3.16l-.47-.17a.75.75 0 00-.52 1.4l.47.18a5.75 5.75 0 007.66-4.28l1.14-5.85h4.99a.75.75 0 000-1.5h-4.7l.8-4.06z",
    fill: primaryFill
  }));
};

export const FStop28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FStop28RegularIcon, 'FStop28Regular');

const FastAcceleration20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.9 7.2a3.48 3.48 0 014.2 0l-1.08 1.08a2 2 0 00-2.04 0L8.9 7.2zM13 10a2 2 0 00-.28-1.02L13.8 7.9a3.48 3.48 0 010 4.2l-1.08-1.08A2 2 0 0013 10zm-2 2a2 2 0 001.02-.28l1.08 1.08a3.48 3.48 0 01-4.2 0l1.08-1.08A2 2 0 0011 12zm-2-2c0 .37.1.72.28 1.02L8.2 12.1a3.48 3.48 0 010-4.2l1.08 1.08A2 2 0 009 10zM6.1 5a6.98 6.98 0 00-1.43 8H3.5a.5.5 0 000 1h1.75c.26.36.54.7.85 1H1.5a.5.5 0 000 1h5.9a7 7 0 100-12H2.5a.5.5 0 000 1h3.6zM11 9a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const FastAcceleration20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastAcceleration20FilledIcon, 'FastAcceleration20Filled');

const FastAcceleration20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 4a6 6 0 11-3.3 11.01V15h-.02A6 6 0 0111 4zM5.25 14c.26.36.54.7.85 1H1.5a.5.5 0 000 1h5.9a7 7 0 100-12H2.5a.5.5 0 000 1h3.6a6.98 6.98 0 00-1.43 8H3.5a.5.5 0 000 1h1.75zM8.2 7.9a3.48 3.48 0 000 4.2l1.08-1.08a2 2 0 010-2.04L8.2 7.9zm.7-.7l1.08 1.08a2 2 0 012.04 0L13.1 7.2a3.48 3.48 0 00-4.2 0zm4.9.7l-1.08 1.08a2 2 0 010 2.04l1.08 1.08a3.48 3.48 0 000-4.2zm-.7 4.9l-1.08-1.08a2 2 0 01-2.04 0L8.9 12.8a3.48 3.48 0 004.2 0zM6.5 10a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm3.5 0a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const FastAcceleration20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastAcceleration20RegularIcon, 'FastAcceleration20Regular');

const FastAcceleration24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 4a8.5 8.5 0 11-4.82 15.5H1.75a.75.75 0 01-.1-1.5H7.02c-.4-.46-.73-.96-1.02-1.5H3.75a.75.75 0 01-.1-1.5H5.37a8.5 8.5 0 011.65-8H2.75a.75.75 0 01-.1-1.5H8.68A8.46 8.46 0 0113.5 4zm1.15 10.72a2.49 2.49 0 01-2.3 0l-1.09 1.1a3.98 3.98 0 004.5 0l-1.1-1.1zM9.5 12.5c0 .84.26 1.62.7 2.26l1.09-1.1a2.49 2.49 0 010-2.32l-1.1-1.09c-.43.65-.69 1.42-.69 2.25zm7.32-2.24l-1.1 1.1a2.49 2.49 0 010 2.3l1.1 1.1a3.98 3.98 0 000-4.5zM13.5 11.5a1 1 0 100 2 1 1 0 000-2zm0-3c-.83 0-1.6.26-2.25.7l1.1 1.08a2.49 2.49 0 012.32 0l1.09-1.08a3.98 3.98 0 00-2.26-.7z",
    fill: primaryFill
  }));
};

export const FastAcceleration24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastAcceleration24FilledIcon, 'FastAcceleration24Filled');

const FastAcceleration24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 4a8.5 8.5 0 11-4.82 15.5H1.75a.75.75 0 01-.1-1.5H7.02c-.4-.46-.73-.96-1.02-1.5H3.75a.75.75 0 01-.1-1.5H5.37a8.5 8.5 0 011.65-8H2.75a.75.75 0 01-.1-1.5H8.68A8.46 8.46 0 0113.5 4zm0 1.5a7 7 0 100 14 7 7 0 000-14zm0 1.5a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm1.15 7.72a2.49 2.49 0 01-2.3 0l-1.09 1.1a3.98 3.98 0 004.5 0l-1.1-1.1zM9.5 12.5c0 .84.26 1.62.7 2.26l1.09-1.1a2.49 2.49 0 010-2.32l-1.1-1.09c-.43.65-.69 1.42-.69 2.25zm7.32-2.24l-1.1 1.1a2.49 2.49 0 010 2.3l1.1 1.1a3.98 3.98 0 000-4.5zM13.5 11.5a1 1 0 100 2 1 1 0 000-2zm0-3c-.83 0-1.6.26-2.25.7l1.1 1.08a2.49 2.49 0 012.32 0l1.09-1.08a3.98 3.98 0 00-2.26-.7z",
    fill: primaryFill
  }));
};

export const FastAcceleration24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastAcceleration24RegularIcon, 'FastAcceleration24Regular');

const FastForward16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 4.46a1 1 0 011.58-.81l5 3.53a1 1 0 010 1.64l-5 3.53A1 1 0 018 11.54v-2.3l-4.42 3.11A1 1 0 012 11.54V4.46a1 1 0 011.58-.81L8 6.77v-2.3z",
    fill: primaryFill
  }));
};

export const FastForward16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward16FilledIcon, 'FastForward16Filled');

const FastForward16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.46a1 1 0 011.58-.81L8 6.77v-2.3a1 1 0 011.58-.82l5 3.53a1 1 0 010 1.64l-5 3.53A1 1 0 018 11.54v-2.3l-4.42 3.11A1 1 0 012 11.54V4.46zM8 8L3 4.46v7.08L8 8v-.02zm1 3.55L14.01 8 9 4.46v7.08z",
    fill: primaryFill
  }));
};

export const FastForward16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward16RegularIcon, 'FastForward16Regular');

const FastForward20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.02 5.49a1 1 0 011.59-.81l5.88 4.31c.68.5.68 1.52 0 2.02l-5.88 4.3a1 1 0 01-1.6-.8v-3.16l-5.4 3.97a1 1 0 01-1.6-.8V5.48a1 1 0 011.6-.81l5.4 3.97V5.49z",
    fill: primaryFill
  }));
};

export const FastForward20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward20FilledIcon, 'FastForward20Filled');

const FastForward20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.02 5.49a1 1 0 011.59-.81l5.88 4.31c.68.5.68 1.52 0 2.02l-5.88 4.3a1 1 0 01-1.6-.8v-3.16l-5.4 3.97a1 1 0 01-1.6-.8V5.48a1 1 0 011.6-.81l5.4 3.97V5.49zm6.88 4.3l-5.88-4.3v9.02l5.88-4.3c.13-.1.13-.31 0-.41zm-7 0L4.02 5.5v9.02l5.88-4.3c.13-.1.13-.31 0-.41z",
    fill: primaryFill
  }));
};

export const FastForward20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward20RegularIcon, 'FastForward20Regular');

const FastForward24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.97 4.36A1.5 1.5 0 0011.5 5.5v4L5.47 4.35A1.5 1.5 0 003 5.51V18.5c0 .88.7 1.48 1.46 1.5h.09c.32 0 .64-.12.92-.36l6.03-5.13v3.99a1.5 1.5 0 002.47 1.14l7.41-6.3c.82-.7.82-1.97 0-2.67l-7.4-6.3z",
    fill: primaryFill
  }));
};

export const FastForward24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward24FilledIcon, 'FastForward24Filled');

const FastForward24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 5.5a1.5 1.5 0 012.47-1.14l7.41 6.3c.82.7.82 1.97 0 2.67l-7.4 6.3a1.5 1.5 0 01-2.48-1.13v-4l-6.03 5.14A1.5 1.5 0 013 18.5v-13a1.5 1.5 0 012.47-1.14L11.5 9.5V5.5zm0 5.96l-7-5.96v13l7-5.96v-1.08zm8.91.35L13 5.5V18.5l7.41-6.31a.25.25 0 000-.38z",
    fill: primaryFill
  }));
};

export const FastForward24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward24RegularIcon, 'FastForward24Regular');

const FastForward28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.64 4.86A1.63 1.63 0 0013 6.13v4.57L5.64 4.86A1.62 1.62 0 003 6.13v15.74a1.62 1.62 0 002.64 1.27L13 17.3v4.57a1.63 1.63 0 002.64 1.27l9.63-7.64c.97-.77.97-2.23 0-3l-9.63-7.64z",
    fill: primaryFill
  }));
};

export const FastForward28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward28FilledIcon, 'FastForward28Filled');

const FastForward28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 10.7V6.13a1.63 1.63 0 012.64-1.27l9.63 7.64c.97.77.97 2.24 0 3l-9.63 7.64A1.63 1.63 0 0113 21.87V17.3l-7.36 5.84A1.63 1.63 0 013 21.87V6.13a1.62 1.62 0 012.64-1.27L13 10.7zm0 4.69V12.6L4.7 6.03A.12.12 0 004.64 6c-.02 0-.04 0-.07.02a.13.13 0 00-.05.04l-.02.07v15.74c0 .03 0 .05.02.07l.05.04.07.02.06-.03 8.3-6.58zm1.7-9.36a.12.12 0 00-.06-.03c-.02 0-.04 0-.07.02a.13.13 0 00-.05.04l-.02.07v15.74l.02.07.05.04.07.02.06-.03 9.64-7.64a.42.42 0 000-.66L14.7 6.03z",
    fill: primaryFill
  }));
};

export const FastForward28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FastForward28RegularIcon, 'FastForward28Regular');

const Fax16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5V6a2 2 0 00-2 2v4.5c0 .83.67 1.5 1.5 1.5h6c-.31-.42-.5-.94-.5-1.5v-5c0-.56.19-1.08.5-1.5H5V3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v1.55c.16-.03.33-.05.5-.05h.5V3.5c0-.83-.67-1.5-1.5-1.5h-5zm-1 7a.5.5 0 110-1 .5.5 0 010 1zm0 2a.5.5 0 110-1 .5.5 0 010 1zM7 8.5a.5.5 0 11-1 0 .5.5 0 011 0zM6.5 11a.5.5 0 110-1 .5.5 0 010 1zM10 7.5c0-.83.67-1.5 1.5-1.5h1c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-1a1.5 1.5 0 01-1.5-1.5v-5z",
    fill: primaryFill
  }));
};

export const Fax16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fax16FilledIcon, 'Fax16Filled');

const Fax16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5V6a2 2 0 00-2 2v4.5c0 .83.67 1.5 1.5 1.5h6c-.22-.3-.38-.63-.45-1H3.5a.5.5 0 01-.5-.5V8a1 1 0 011-1h5.05c.07-.37.23-.7.45-1H5V3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v1.55c.16-.03.33-.05.5-.05h.5V3.5c0-.83-.67-1.5-1.5-1.5h-5zm6 4c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1zM11 7.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-5zm-6 1a.5.5 0 11-1 0 .5.5 0 011 0zM4.5 11a.5.5 0 100-1 .5.5 0 000 1zM7 8.5a.5.5 0 11-1 0 .5.5 0 011 0zM6.5 11a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const Fax16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fax16RegularIcon, 'Fax16Regular');

const Fax20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V7h-1V4.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V8h5.5c-.31.42-.5.94-.5 1.5v6c0 .56.19 1.08.5 1.5h-7A1.5 1.5 0 013 15.5V10c0-1.1.9-2 2-2V4.5zm1.25 6.13a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm0 2.24a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm1.63-.5a.62.62 0 100 1.25.62.62 0 000-1.24zm.62-1.74a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm5-2.63c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-6c0-.83-.67-1.5-1.5-1.5h-2z",
    fill: primaryFill
  }));
};

export const Fax20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fax20FilledIcon, 'Fax20Filled');

const Fax20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V7h-1V4.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5V8h5.5c-.22.3-.38.63-.45 1H5a1 1 0 00-1 1v5.5c0 .28.22.5.5.5h6.55c.07.37.23.7.45 1h-7A1.5 1.5 0 013 15.5V10c0-1.1.9-2 2-2V4.5zm7 5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5v-6zm1.5-.5a.5.5 0 00-.5.5v6c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5h-2zm-7.88 1a.62.62 0 110 1.25.62.62 0 010-1.25zm0 2.25a.62.62 0 110 1.25.62.62 0 010-1.25zM8.5 13a.62.62 0 10-1.25 0 .62.62 0 001.25 0zm-.63-3a.62.62 0 110 1.25.62.62 0 010-1.25z",
    fill: primaryFill
  }));
};

export const Fax20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fax20RegularIcon, 'Fax20Regular');

const Feed16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h4C8.31 3 9 3.67 9 4.5V5h3.55c.73.03 1.45.55 1.45 1.5v3.04c0 .83-.67 1.5-1.5 1.5h-1.39l-.14.75a1.44 1.44 0 01-1.47 1.2l-6 .01A1.5 1.5 0 012 11.5v-7zm7 7c0 .6.87.69.99.1L10.88 7l.15-.78V6.2l.01-.06.02-.04c0-.03.01-.07.03-.1h-2.1v5.5zM4.47 5.99a.5.5 0 100-1 .5.5 0 000 1zm.01 1.5a.5.5 0 000 1h2a.5.5 0 100-1h-2zm0 2.51a.5.5 0 000 1h2a.5.5 0 00.26-.93h-.02A.5.5 0 006.6 10H6.5L6.48 10H4.5z",
    fill: primaryFill
  }));
};

export const Feed16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed16FilledIcon, 'Feed16Filled');

const Feed16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 7.49a.5.5 0 000 1h1.98a.5.5 0 00.5-.5.5.5 0 00-.5-.5H4.5zm0 2.51a.5.5 0 000 1h1.98a.5.5 0 000-1H4.5zm.48-4.51a.5.5 0 11-1 0 .5.5 0 011 0zM3.5 3C2.67 3 2 3.67 2 4.5v7c0 .83.67 1.5 1.5 1.5h6c.65 0 1.3-.39 1.47-1.21l.14-.75h1.39c.83 0 1.5-.67 1.5-1.5V6.51c0-.96-.72-1.48-1.45-1.51H8.99v-.5C9 3.67 8.32 3 7.5 3H3.5zM9 6h2.09a1.57 1.57 0 00-.06.23l-.15.78-.9 4.58c-.11.6-.99.51-.99-.1V6zm-1 5.5c0 .18.02.35.07.5H3.5a.5.5 0 01-.5-.5v-7c0-.28.22-.5.5-.5h4c.27 0 .5.22.5.5v7zm4.5-1.46h-1.2l.56-2.84.15-.78c.11-.6.99-.52.99.09v3.03a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const Feed16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed16RegularIcon, 'Feed16Regular');

const Feed20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.47 17H4a2 2 0 01-2-2V4.5C2 3.67 2.67 3 3.5 3h7c.83 0 1.5.67 1.5 1.5V6h4.48c.77.02 1.52.6 1.52 1.58v4.92c0 .83-.67 1.5-1.5 1.5h-2.1l-.43 1.82c-.19.82-.85 1.2-1.5 1.18zM15 7H12v8.48c0 .6.86.7 1 .12l1.94-8.37.07-.23zM5.5 7a.5.5 0 100-1 .5.5 0 000 1zM5 10c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5zm0 3.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const Feed20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed20FilledIcon, 'Feed20Filled');

const Feed20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 100-1 .5.5 0 000 1zM5 10c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3A.5.5 0 015 10zm.5 3a.5.5 0 000 1h3a.5.5 0 000-1h-3zM4 17h8.47c.65.02 1.31-.36 1.5-1.18L14.4 14h2.11c.83 0 1.5-.67 1.5-1.5V7.58c0-.98-.75-1.56-1.52-1.58H12V4.5c0-.83-.67-1.5-1.5-1.5h-7C2.67 3 2 3.67 2 4.5V15c0 1.1.9 2 2 2zM3 4.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v10.98c0 .2.03.36.08.52H4a1 1 0 01-1-1V4.5zM16.5 13h-1.87l1.28-5.54c.15-.64 1.09-.53 1.09.12v4.92a.5.5 0 01-.5.5zM12 7h3.01a1.8 1.8 0 00-.07.23L13 15.6c-.14.58-1 .48-1-.12V7z",
    fill: primaryFill
  }));
};

export const Feed20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed20RegularIcon, 'Feed20Regular');

const Feed24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 21c.94 0 1.75-.67 1.93-1.6l.48-2.4h2.84c.97 0 1.75-.78 1.75-1.75V9.26c0-1.24-1-2.25-2.25-2.26H14.5V5.25c0-1.24-1-2.25-2.25-2.25h-8C3.01 3 2 4 2 5.25v12.5C2 19.55 3.46 21 5.25 21H15zm2.52-12.18L15.46 19.1a.49.49 0 01-.96-.1V8.5h3.11c-.04.1-.07.2-.09.32zM5.78 8.5a.75.75 0 110-1.5.75.75 0 010 1.5zm-.75 7.25c0-.41.34-.75.75-.75h5a.75.75 0 110 1.5h-5a.75.75 0 01-.75-.75zM5.78 11h5a.75.75 0 110 1.5h-5a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const Feed24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed24FilledIcon, 'Feed24Filled');

const Feed24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.53 7.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.78 15a.75.75 0 000 1.5h5a.75.75 0 100-1.5h-5zm-.75-3.25c0-.41.34-.75.75-.75h5a.75.75 0 110 1.5h-5a.75.75 0 01-.75-.75zM15 21c.94 0 1.75-.67 1.93-1.6l.48-2.4h2.84c.97 0 1.75-.78 1.75-1.75V9.26c0-1.24-1-2.25-2.25-2.26H14.5V5.25c0-1.24-1-2.25-2.25-2.25h-8C3.01 3 2 4 2 5.25v12.5C2 19.55 3.46 21 5.25 21H15zM3.5 5.25c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v13.76c0 .17.02.33.06.49H5.25c-.97 0-1.75-.78-1.75-1.75V5.25zm11 3.25h3.11c-.04.1-.07.2-.09.32L15.46 19.1a.49.49 0 01-.96-.1V8.5zm4.5.61a.76.76 0 011.5.15v5.99c0 .14-.11.25-.25.25h-2.54L19 9.11z",
    fill: primaryFill
  }));
};

export const Feed24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed24RegularIcon, 'Feed24Regular');

const Feed28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 25H17.1c1.41 0 2.43-.48 2.75-1.96l.66-3.08h2.86a2.75 2.75 0 002.75-2.75v-6.7c0-1.68-1.36-2.58-2.67-2.52H16.4V5.75A2.75 2.75 0 0013.66 3H4.75A2.75 2.75 0 002 5.75v16c0 1.79 1.46 3.24 3.25 3.24zM16.41 9.48h4.86a2.9 2.9 0 00-.15.49l-2.74 12.74c-.25 1.17-1.97.99-1.97-.2V9.48zm-9.63.01a.75.75 0 110-1.5.75.75 0 010 1.5zm0 9.02h5a.75.75 0 110 1.5h-5a.75.75 0 010-1.5zm0-5.27h5a.75.75 0 110 1.5h-5a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const Feed28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed28FilledIcon, 'Feed28Filled');

const Feed28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.78 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zm0 9a.75.75 0 000 1.5h5a.75.75 0 100-1.5h-5zM6.03 14c0-.42.34-.76.75-.76h5a.75.75 0 110 1.5h-5a.75.75 0 01-.75-.75zM17.1 25H5.25A3.25 3.25 0 012 21.73V5.75A2.75 2.75 0 014.75 3h8.9a2.75 2.75 0 012.76 2.75v2.24h7.04c1.31-.06 2.68.84 2.68 2.52v6.7a2.75 2.75 0 01-2.75 2.75H20.5l-.66 3.08c-.32 1.48-1.34 1.95-2.75 1.95zM4.75 4.5c-.69 0-1.25.56-1.25 1.25v16c0 .96.78 1.74 1.75 1.74h9.83a2.66 2.66 0 01-.17-.98V5.75c0-.69-.56-1.25-1.25-1.25H4.75zm11.66 18.01c0 1.2 1.72 1.38 1.97.21l2.74-12.74c.04-.18.09-.34.15-.5h-4.86v13.03zm6.18-12.22l-1.76 8.17h2.55c.69 0 1.25-.56 1.25-1.25v-6.7c0-.63-.49-1-.99-1.02h-.14a.97.97 0 00-.91.8z",
    fill: primaryFill
  }));
};

export const Feed28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed28RegularIcon, 'Feed28Regular');

const Feed32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 29v-.02l.3.02a3.04 3.04 0 003-2.49l.64-3.51h2.81c1.8 0 3.25-1.46 3.25-3.25v-8.84a2.91 2.91 0 00-3-2.9V8h-7.73V6.25c0-1.8-1.46-3.25-3.25-3.25H5.25A3.25 3.25 0 002 6.25V24.5A4.5 4.5 0 006.5 29H20zm-.73-19h5.06c-.04.12-.08.25-.1.38l-2.9 15.77a1.04 1.04 0 01-2.06-.19V10zM7 10a1 1 0 110-2 1 1 0 010 2zm-1 6a1 1 0 011-1h7a1 1 0 110 2H7a1 1 0 01-1-1zm1 5h7a1 1 0 110 2H7a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const Feed32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed32FilledIcon, 'Feed32Filled');

const Feed32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 5C4.56 5 4 5.56 4 6.25V24.5A2.5 2.5 0 006.5 27h10.95a3.03 3.03 0 01-.18-1.04V6.25c0-.69-.56-1.25-1.25-1.25H5.25zM20 28.98V29H6.5A4.5 4.5 0 012 24.5V6.25C2 4.45 3.46 3 5.25 3h10.77c1.8 0 3.25 1.46 3.25 3.25V8h7.82C28.69 8 30 9.3 30 10.91v8.84c0 1.8-1.46 3.25-3.25 3.25h-2.81l-.65 3.51A3.04 3.04 0 0120 28.98zM24.33 10h-5.06v15.96a1.04 1.04 0 002.05.2l2.9-15.78.1-.38zm-.02 11h2.44c.69 0 1.25-.56 1.25-1.25v-8.84a.91.91 0 00-1.8-.17L24.3 21zM8 9a1 1 0 11-2 0 1 1 0 012 0zm-1 6a1 1 0 100 2h7a1 1 0 100-2H7zm-1 7a1 1 0 011-1h7a1 1 0 110 2H7a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const Feed32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed32RegularIcon, 'Feed32Regular');

const Feed48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M29.63 42h.25c1.82 0 3.4-1.27 3.79-3.06L34.73 34h5.02C42.1 34 44 32.1 44 29.75v-11.6A4.16 4.16 0 0040 14H28.5v-3.75C28.5 7.9 26.6 6 24.25 6h-16A4.25 4.25 0 004 10.25v25.5C4 39.2 6.8 42 10.25 42h19.38zM28.5 16.5h7.53c-.1.25-.19.5-.25.78L31.23 38.4a1.38 1.38 0 01-2.73-.29V16.5zm-15.5-1a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM11.25 22h10.5a1.25 1.25 0 110 2.5h-10.5a1.25 1.25 0 110-2.5zM10 31.25c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 110 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const Feed48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed48FilledIcon, 'Feed48Filled');

const Feed48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 8.5c-.97 0-1.75.78-1.75 1.75v25.5a3.75 3.75 0 003.75 3.75h16c-.16-.43-.25-.9-.25-1.38V10.25c0-.97-.78-1.75-1.75-1.75h-16zM29.63 42H10.25A6.25 6.25 0 014 35.75v-25.5C4 7.9 5.9 6 8.25 6h16c2.35 0 4.25 1.9 4.25 4.25V14H40c2.22.08 4 1.91 4 4.15v11.6C44 32.1 42.1 34 39.75 34h-5.02l-1.06 4.94a3.88 3.88 0 01-4.05 3.05zm-1.13-3.88a1.38 1.38 0 002.73.3l4.55-21.14c.06-.27.15-.53.25-.78H28.5v21.62zm9.73-20.31L35.27 31.5h4.48c.97 0 1.75-.78 1.75-1.75v-11.6a1.65 1.65 0 00-3.27-.34zM11.5 17a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM10 23.25c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 110 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25zM11.25 30a1.25 1.25 0 100 2.5h10.5a1.25 1.25 0 100-2.5h-10.5z",
    fill: primaryFill
  }));
};

export const Feed48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Feed48RegularIcon, 'Feed48Regular');

const Filmstrip20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zM3 6a1 1 0 011-1h1v2H3V6zm0 7h2v2H4a1 1 0 01-1-1v-1zm2-1H3v-1.5h2V12zm0-2.5H3V8h2v1.5zM16 15h-1v-2h2v1a1 1 0 01-1 1zm1-4.5V12h-2v-1.5h2zM17 8v1.5h-2V8h2zm0-2v1h-2V5h1a1 1 0 011 1z",
    fill: primaryFill
  }));
};

export const Filmstrip20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filmstrip20FilledIcon, 'Filmstrip20Filled');

const Filmstrip20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-1a1 1 0 00-1 1v1h2V5H4zm-1 9a1 1 0 001 1h1v-2H3v1zm2-3.5H3V12h2v-1.5zM5 8H3v1.5h2V8zm9 7V5H6v10h8zm1-2v2h1a1 1 0 001-1v-1h-2zm2-1v-1.5h-2V12h2zm0-2.5V8h-2v1.5h2zM17 7V6a1 1 0 00-1-1h-1v2h2z",
    fill: primaryFill
  }));
};

export const Filmstrip20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filmstrip20RegularIcon, 'Filmstrip20Regular');

const Filmstrip24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 6.25C22 5.01 21 4 19.75 4H4.25C3.01 4 2 5 2 6.25v11.5C2 18.99 3 20 4.25 20h15.5c1.24 0 2.25-1 2.25-2.25V6.25zm-2.25-.75c.41 0 .75.34.75.75V7.5H18v-2h1.75zM18 9h2.5v2.5H18V9zm0 4h2.5v2H18v-2zm0 3.5h2.5v1.25c0 .41-.34.75-.75.75H18v-2zM6 5.5v2H3.5V6.25c0-.41.34-.75.75-.75H6zm0 11v2H4.25a.75.75 0 01-.75-.75V16.5H6zM6 15H3.5v-2H6v2zm0-6v2.5H3.5V9H6z",
    fill: primaryFill
  }));
};

export const Filmstrip24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filmstrip24FilledIcon, 'Filmstrip24Filled');

const Filmstrip24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.75 4C20.99 4 22 5 22 6.25v11.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 20 2 19 2 17.75V6.25C2 5.01 3 4 4.25 4h15.5zm.75 2.25a.75.75 0 00-.75-.75H18v2h2.5V6.25zm0 2.75H18v2.5h2.5V9zm0 4H18v2h2.5v-2zm0 3.5H18v2h1.75c.41 0 .75-.34.75-.75V16.5zm-4 2v-13h-9v13h9zM4.25 5.5a.75.75 0 00-.75.75V7.5H6v-2H4.25zM6 18.5v-2H3.5v1.25c0 .41.34.75.75.75H6zM6 13H3.5v2H6v-2zm0-1.5V9H3.5v2.5H6z",
    fill: primaryFill
  }));
};

export const Filmstrip24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filmstrip24RegularIcon, 'Filmstrip24Regular');

const Filter12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 2.75c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 011 2.75zm2 3c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5A.75.75 0 013 5.75zM5.25 8a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5z",
    fill: primaryFill
  }));
};

export const Filter12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter12FilledIcon, 'Filter12Filled');

const Filter12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 2.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm2 3c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zM5 8a.5.5 0 000 1h2a.5.5 0 000-1H5z",
    fill: primaryFill
  }));
};

export const Filter12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter12RegularIcon, 'Filter12Regular');

const Filter16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.75 3.75c0-.41.34-.75.75-.75h11a.75.75 0 010 1.5h-11a.75.75 0 01-.75-.75zm2 4c0-.41.34-.75.75-.75h7a.75.75 0 010 1.5h-7a.75.75 0 01-.75-.75zm2 4c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Filter16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter16FilledIcon, 'Filter16Filled');

const Filter16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm2 4c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zm2 4c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const Filter16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter16RegularIcon, 'Filter16Regular');

const Filter20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.25 13.5a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5zm2-4.25a.75.75 0 010 1.5h-8.5a.75.75 0 010-1.5h8.5zm2-4.25a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5h12.5z",
    fill: primaryFill
  }));
};

export const Filter20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter20FilledIcon, 'Filter20Filled');

const Filter20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 13h5a.5.5 0 01.09 1H7.5a.5.5 0 01-.09-1h5.09-5zm-2-4h9a.5.5 0 01.09 1H5.5a.5.5 0 01-.09-1h9.09-9zm-2-4h13a.5.5 0 01.09 1H3.5a.5.5 0 01-.09-1H16.5h-13z",
    fill: primaryFill
  }));
};

export const Filter20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter20RegularIcon, 'Filter20Regular');

const Filter24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 16h4a1 1 0 01.12 2H10a1 1 0 01-.12-2H14h-4zm-2-5h8a1 1 0 01.12 2H8a1 1 0 01-.12-2H16 8zM5 6h14a1 1 0 01.12 2H5a1 1 0 01-.12-2H19 5z",
    fill: primaryFill
  }));
};

export const Filter24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter24FilledIcon, 'Filter24Filled');

const Filter24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 16a.75.75 0 010 1.5h-3a.75.75 0 010-1.5h3zm3-5a.75.75 0 010 1.5h-9a.75.75 0 010-1.5h9zm3-5a.75.75 0 010 1.5h-15a.75.75 0 010-1.5h15z",
    fill: primaryFill
  }));
};

export const Filter24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter24RegularIcon, 'Filter24Regular');

const Filter28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 19a1 1 0 110 2h-6a1 1 0 110-2h6zm4-6a1 1 0 110 2H7a1 1 0 110-2h14zm3-6a1 1 0 110 2H4a1 1 0 010-2h20z",
    fill: primaryFill
  }));
};

export const Filter28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter28FilledIcon, 'Filter28Filled');

const Filter28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.25 19a.75.75 0 010 1.5h-6.5a.75.75 0 010-1.5h6.5zm4-6a.75.75 0 010 1.5H6.75a.75.75 0 010-1.5h14.5zm3-6a.75.75 0 010 1.5H3.75a.75.75 0 010-1.5h20.5z",
    fill: primaryFill
  }));
};

export const Filter28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Filter28RegularIcon, 'Filter28Regular');

const FilterAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 9.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5a.5.5 0 00-.15-.35zM9.02 5a5.57 5.57 0 00.07 1.5H3.75a.75.75 0 010-1.5h5.27zm1.46 4.25a5.5 5.5 0 002.38 1.5H5.75a.75.75 0 010-1.5h4.73zm1.77 4.25a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5z",
    fill: primaryFill
  }));
};

export const FilterAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterAdd20FilledIcon, 'FilterAdd20Filled');

const FilterAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 9.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V5h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H15V3.5a.5.5 0 00-.15-.35zM9.02 5H3.41a.5.5 0 00.09 1h5.52a5.57 5.57 0 010-1zm1.24 4H5.4a.5.5 0 00.09 1h5.84c-.4-.28-.77-.62-1.08-1zM7.4 13h5.09a.5.5 0 01.09 1H7.5a.5.5 0 01-.09-1z",
    fill: primaryFill
  }));
};

export const FilterAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterAdd20RegularIcon, 'FilterAdd20Regular');

const FilterDismiss16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.26 9a5.52 5.52 0 001.95 1.5H3.5a.75.75 0 010-1.5h2.76zM5.02 5a5.57 5.57 0 00.07 1.5H1.5a.75.75 0 010-1.5h3.52zm.48 8a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3zm5-3a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L11.21 5.5l1.14 1.15a.5.5 0 01-.7.7L10.5 6.21 9.35 7.35a.5.5 0 11-.7-.7L9.79 5.5 8.65 4.35a.5.5 0 11.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FilterDismiss16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismiss16FilledIcon, 'FilterDismiss16Filled');

const FilterDismiss16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.26 9c.31.38.67.72 1.08 1H3.5a.5.5 0 010-1h2.76zM5.02 5a5.57 5.57 0 000 1H1.5a.5.5 0 010-1h3.52zm.48 8a.5.5 0 000 1h3a.5.5 0 000-1h-3zm5-3a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L11.21 5.5l1.14 1.15a.5.5 0 01-.7.7L10.5 6.21 9.35 7.35a.5.5 0 11-.7-.7L9.79 5.5 8.65 4.35a.5.5 0 11.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FilterDismiss16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismiss16RegularIcon, 'FilterDismiss16Regular');

const FilterDismiss20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.73 10.25A5.46 5.46 0 0014 11c0 .41-.34.75-.75.75h-8.5a.75.75 0 010-1.5h6.98zM9.03 6c.04.52.16 1.03.34 1.5H2.75a.75.75 0 010-1.5h6.27zM12 15.25a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h4.5c.41 0 .75-.34.75-.75zM14.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L15.21 5.5l1.14 1.15a.5.5 0 01-.7.7L14.5 6.21l-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FilterDismiss20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismiss20FilledIcon, 'FilterDismiss20Filled');

const FilterDismiss20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.2 7H2.42a.5.5 0 00.09 1h7.1c-.16-.32-.3-.65-.4-1zm2.8 8.5a.5.5 0 00-.5-.5H6.41a.5.5 0 00.09 1h5.09a.5.5 0 00.41-.5zm1.5-4.5H4.41a.5.5 0 00.09 1h9.09a.5.5 0 00-.09-1zm1-1a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm1.85-6.35c.2.2.2.5 0 .7L15.21 5.5l1.14 1.15a.5.5 0 01-.7.7L14.5 6.21l-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FilterDismiss20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismiss20RegularIcon, 'FilterDismiss20Regular');

const FilterDismiss24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 7.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7L18.21 7.5l1.64-1.65a.5.5 0 00-.7-.7L17.5 6.79l-1.65-1.64z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 11h4.02c.52.8 1.2 1.49 2.01 2H8a1 1 0 01-.12-2H8z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 6h6.17a6.52 6.52 0 00-.15 2H5a1 1 0 01-.12-2H5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.88 16H14a1 1 0 01.12 2H10a1 1 0 01-.12-2z",
    fill: primaryFill
  }));
};

export const FilterDismiss24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismiss24FilledIcon, 'FilterDismiss24Filled');

const FilterDismiss24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 7.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7L18.21 7.5l1.64-1.65a.5.5 0 00-.7-.7L17.5 6.79l-1.65-1.64z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13.35 12.5a6.54 6.54 0 01-1.33-1.5H7.5a.75.75 0 000 1.5h5.85z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11 7.5c0-.52.06-1.02.17-1.5H4.5a.75.75 0 000 1.5H11z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13.5 16a.75.75 0 010 1.5h-3a.75.75 0 010-1.5h3z",
    fill: primaryFill
  }));
};

export const FilterDismiss24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterDismiss24RegularIcon, 'FilterDismiss24Regular');

const FilterSync20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 11-.71-.71A3 3 0 0116 3.15V3c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 0113 7.85V8a.5.5 0 01-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.98 1.98 0 001.72.1 2 2 0 00.66-.44.5.5 0 11.71.71 3 3 0 01-1 .66zM14 10.98a5.46 5.46 0 01-2.27-.73H4.75a.75.75 0 000 1.5h8.5a.75.75 0 00.75-.77zM9.37 7.5c-.18-.47-.3-.98-.35-1.5H2.75a.75.75 0 000 1.5h6.62zm1.88 7a.75.75 0 010 1.5h-4.5a.75.75 0 010-1.5h4.5z",
    fill: primaryFill
  }));
};

export const FilterSync20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterSync20FilledIcon, 'FilterSync20Filled');

const FilterSync20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 11-.71-.71A3 3 0 0116 3.15V3c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 0113 7.85V8a.5.5 0 01-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.98 1.98 0 001.72.1 2 2 0 00.66-.44.5.5 0 11.71.71 3 3 0 01-1 .66zM2.5 7h6.7c.1.35.24.68.4 1H2.5a.5.5 0 01-.09-1h.09zm9 8a.5.5 0 01.09 1H6.5a.5.5 0 01-.09-1h5.09zm-7-4h9a.5.5 0 01.09 1H4.5a.5.5 0 01-.09-1h.09z",
    fill: primaryFill
  }));
};

export const FilterSync20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterSync20RegularIcon, 'FilterSync20Regular');

const FilterSync24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 7.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zM20.5 4c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4V4.5c0-.28.22-.5.5-.5zM15 9.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 11.77.65 3.5 3.5 0 01-5.18.19zM8 13h6.03c-.8-.51-1.5-1.2-2-2H7.87A1 1 0 008 13zM5 6h6.17a6.52 6.52 0 00-.15 2H5a1 1 0 01-.12-2H5zm4.88 10H14a1 1 0 01.12 2H10a1 1 0 01-.12-2z",
    fill: primaryFill
  }));
};

export const FilterSync24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterSync24FilledIcon, 'FilterSync24Filled');

const FilterSync24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 7.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zM20.5 4c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4V4.5c0-.28.22-.5.5-.5zM15 9.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 11.77.65 3.5 3.5 0 01-5.18.19zM7.5 12.5h5.85a6.54 6.54 0 01-1.33-1.5H7.5a.75.75 0 000 1.5zm3.5-5c0-.52.06-1.02.17-1.5H4.5a.75.75 0 000 1.5H11zm2.5 8.5a.75.75 0 010 1.5h-3a.75.75 0 010-1.5h3z",
    fill: primaryFill
  }));
};

export const FilterSync24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FilterSync24RegularIcon, 'FilterSync24Regular');

const Fingerprint20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.83 4.18c1.47-.72 4.65-1.4 8.26.95a.75.75 0 00.82-1.26C11.79 1.2 8.03 1.93 6.17 2.82a.75.75 0 10.66 1.36zm-1.71.27c.23.35.13.82-.22 1.04a5.1 5.1 0 00-1.25 1.39.75.75 0 11-1.3-.76c.28-.48.99-1.4 1.73-1.88a.75.75 0 011.04.21zm5.38-.16a.75.75 0 000 1.5c1.55 0 5.3 1.3 6.26 6.35a.75.75 0 101.48-.28C17.1 6 12.67 4.29 10.5 4.29zm-1.51.78a.75.75 0 01-.45.96C4.6 7.46 3.61 11.23 4 13.89a.75.75 0 11-1.48.22c-.44-3.1.69-7.74 5.52-9.5.39-.13.82.07.96.46zm-.87 3.92c-1.6 1.24-2.58 3.92-.95 7.17a.75.75 0 01-1.34.68c-1.92-3.82-.87-7.3 1.37-9.04a5.07 5.07 0 013.92-1.05 5.72 5.72 0 013.81 2.67.75.75 0 01-1.25.83 4.23 4.23 0 00-2.8-2.02A3.57 3.57 0 008.12 9zm7.63 2.97a.75.75 0 10-1.5.08c.1 1.91 1.29 2.94 2.02 3.17a.75.75 0 10.45-1.43 1.72 1.72 0 01-.5-.43 2.46 2.46 0 01-.47-1.4zm-4.5.54a.75.75 0 00-1.5 0c0 1.07.13 1.9.45 2.73.32.8.8 1.55 1.44 2.45a.75.75 0 101.22-.86 10.4 10.4 0 01-1.26-2.14 5.69 5.69 0 01-.35-2.18zm-1.13 4.64C8.05 13.4 8.78 11.58 9.5 11a1.43 1.43 0 012.3.72c.06.2.12.44.18.77l.04.17c.08.38.18.84.33 1.3.3.95.84 1.99 1.93 2.79a.75.75 0 00.89-1.21 3.93 3.93 0 01-1.4-2.04c-.12-.39-.2-.77-.28-1.15l-.04-.16c-.06-.3-.13-.64-.21-.91a2.93 2.93 0 00-4.68-1.45c-1.62 1.31-1.92 4.12.25 8.03a.75.75 0 001.31-.72z",
    fill: primaryFill
  }));
};

export const Fingerprint20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fingerprint20FilledIcon, 'Fingerprint20Filled');

const Fingerprint20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.72 3.95c1.53-.74 4.81-1.44 8.5.97a.5.5 0 10.55-.84c-4.03-2.63-7.7-1.9-9.49-1.03a.5.5 0 10.44.9zm-1.81.64a.5.5 0 01-.14.7 5.33 5.33 0 00-1.34 1.46.5.5 0 11-.86-.5c.27-.46.95-1.34 1.65-1.8a.5.5 0 01.69.14zm5.59-.05a.5.5 0 100 1c1.66 0 5.51 1.38 6.5 6.55a.5.5 0 101-.18c-1.1-5.72-5.43-7.37-7.5-7.37zM9.34 10.8c-.87.7-1.52 2.69.56 6.46a.5.5 0 11-.87.48c-2.15-3.88-1.78-6.52-.32-7.71A2.68 2.68 0 0113 11.35c.08.26.14.58.2.9l.04.15c.08.38.17.78.3 1.18.26.79.67 1.57 1.48 2.16a.5.5 0 01-.6.8 5.17 5.17 0 01-1.83-2.65c-.15-.46-.25-.9-.33-1.29l-.03-.16a9 9 0 00-.19-.8 1.68 1.68 0 00-2.7-.84zm6.16 1.17a.5.5 0 10-1 .06c.1 1.8 1.22 2.74 1.85 2.95a.5.5 0 00.3-.96c-.22-.07-1.07-.64-1.15-2.05zm-4.5.53a.5.5 0 10-1 0c0 1.05.13 1.85.44 2.64.3.77.77 1.5 1.4 2.4a.5.5 0 10.82-.58 10.63 10.63 0 01-1.3-2.19A5.94 5.94 0 0111 12.5zM7.97 8.79c-1.72 1.33-2.7 4.14-1.02 7.49a.5.5 0 01-.9.44C4.18 13 5.22 9.65 7.35 8a4.82 4.82 0 013.73-1 5.47 5.47 0 013.65 2.56.5.5 0 11-.84.55 4.48 4.48 0 00-2.97-2.12 3.82 3.82 0 00-2.95.8zm.49-3a.5.5 0 10-.35-.94c-4.68 1.7-5.79 6.19-5.35 9.22a.5.5 0 10.99-.14c-.4-2.74.62-6.65 4.7-8.14z",
    fill: primaryFill
  }));
};

export const Fingerprint20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fingerprint20RegularIcon, 'Fingerprint20Regular');

const Fingerprint24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.98 11.97c.6.61.93 1.34 1.16 2.33l.12.53.1.5c.12.68.2.98.3 1.22.29.64.8 1.3 1.54 1.97.4.37.43 1 .06 1.4a1 1 0 01-1.41.07 8.13 8.13 0 01-2.01-2.63 5.36 5.36 0 01-.37-1.21l-.18-1-.04-.16c-.17-.8-.38-1.3-.7-1.63-.6-.6-2.06-.44-2.41.12-.52.82-.66 2.24-.23 3.69.34 1.15.79 2.28 1.35 3.4a.99.99 0 01-.44 1.33 1 1 0 01-1.35-.44A22.25 22.25 0 019 17.72c-.58-1.96-.39-3.97.46-5.3 1.04-1.63 4.02-1.98 5.53-.45zm-2.5 2.13a1 1 0 011.03.97c.05 1.5.53 2.94 1.4 4.17l.18.25.3.4a1 1 0 01-1.5 1.3l-.08-.09-.3-.39a9.68 9.68 0 01-2-5.58 1 1 0 01.96-1.03zM8.57 9.2a6.27 6.27 0 017.01-.3c.96.62 1.7 1.35 2.18 2.18a1 1 0 11-1.72 1.01 4.63 4.63 0 00-1.54-1.5 4.28 4.28 0 00-4.75.22c-1.56 1.15-2.22 3.14-2.02 5.25.11 1.2.47 2.41 1.09 3.64a1 1 0 01-1.79.9 12.24 12.24 0 01-1.3-4.35c-.25-2.75.64-5.43 2.83-7.05zm10.57 5.16c.03.56.16 1 .4 1.37.22.33.4.5.48.52a1 1 0 11-.57 1.91 3 3 0 01-1.58-1.33 4.66 4.66 0 01-.73-2.37 1 1 0 112-.1zm-8.68-8.4a1 1 0 01-.5 1.33c-1.8.8-3.11 1.95-3.98 3.44a9.58 9.58 0 00-1.13 5.92 1 1 0 11-1.98.26c-.3-2.25.05-4.88 1.38-7.18a10.35 10.35 0 014.88-4.27 1 1 0 011.33.5zm2.46-1.03c1.9.04 3.77.9 5.62 2.55 1.87 1.66 3 3.92 3.37 6.74a1 1 0 01-1.98.26 8.6 8.6 0 00-2.72-5.5c-1.52-1.35-2.96-2.02-4.33-2.05a1 1 0 11.04-2zm-7.32.23a1 1 0 01-.08 1.41 7.22 7.22 0 00-1.64 2 1 1 0 01-1.73-.99 9.16 9.16 0 012.04-2.5 1 1 0 011.41.08zm6.89-3.13c2.24.1 4.32.6 5.86 1.78a1 1 0 11-1.22 1.59c-1.2-.93-2.89-1.29-4.74-1.37a7.83 7.83 0 00-4.55.97 1 1 0 01-1.05-1.7 9.79 9.79 0 015.7-1.27z",
    fill: primaryFill
  }));
};

export const Fingerprint24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fingerprint24FilledIcon, 'Fingerprint24Filled');

const Fingerprint24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.86 12.16c.56.57.87 1.27 1.1 2.23l.1.45.18.95c.1.44.16.7.26.9.3.68.83 1.37 1.6 2.07a.75.75 0 11-1.02 1.1 7.94 7.94 0 01-1.95-2.55 5.24 5.24 0 01-.35-1.18l-.21-1.1-.01-.06c-.18-.85-.4-1.39-.78-1.76-.7-.73-2.35-.54-2.8.15-.55.9-.7 2.4-.25 3.92.34 1.17.8 2.33 1.37 3.47a.75.75 0 11-1.34.67A22.27 22.27 0 019.3 17.7c-.56-1.91-.38-3.86.43-5.14.95-1.5 3.74-1.83 5.14-.4zm-2.37 2.31c.42-.01.76.31.78.73a7.93 7.93 0 001.44 4.3l.2.27.3.39a.75.75 0 01-1.12 1l-.07-.09-.3-.39a9.43 9.43 0 01-1.95-5.43.75.75 0 01.72-.78zM8.8 9.4a6.02 6.02 0 016.73-.28c.93.6 1.63 1.3 2.1 2.09a.75.75 0 01-1.3.76 4.87 4.87 0 00-1.62-1.6 4.53 4.53 0 00-5.02.24c-1.64 1.2-2.33 3.29-2.13 5.48a10.5 10.5 0 001.12 3.72.75.75 0 01-1.35.67 11.99 11.99 0 01-1.26-4.25c-.25-2.67.61-5.26 2.72-6.83zm9.17 4.3c.42-.02.77.3.79.71.03.6.18 1.1.44 1.5.22.33.42.52.57.6l.06.02a.75.75 0 01-.44 1.43c-.54-.16-1.01-.58-1.44-1.23a4.41 4.41 0 01-.69-2.24.75.75 0 01.71-.79zM10.51 6.1c.17.38 0 .82-.38 1-1.84.82-3.19 2-4.08 3.54a9.82 9.82 0 00-1.16 6.08.75.75 0 11-1.5.2c-.28-2.2.06-4.78 1.36-7.03a10.1 10.1 0 014.77-4.16c.38-.17.82 0 1 .37zm2.34-.79c1.83.04 3.66.88 5.46 2.5a10.34 10.34 0 013.3 6.57.75.75 0 11-1.49.2 8.85 8.85 0 00-2.8-5.66c-1.56-1.39-3.06-2.08-4.5-2.1a.75.75 0 11.03-1.5zm-6.87.02c.28.3.25.78-.06 1.06a7.46 7.46 0 00-1.69 2.07.75.75 0 11-1.3-.75 8.91 8.91 0 012-2.44.75.75 0 011.05.06zm6.59-2.97c2.2.1 4.03.7 5.53 1.86a.75.75 0 01-.92 1.2 8.02 8.02 0 00-4.68-1.56 8.71 8.71 0 00-4.72.98c-.38.21-.81.1-1.03-.25A.74.74 0 017 3.56a9.84 9.84 0 015.57-1.2z",
    fill: primaryFill
  }));
};

export const Fingerprint24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fingerprint24RegularIcon, 'Fingerprint24Regular');

const Fingerprint48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 9.9c2.32-1.34 5.6-2.02 9.02-1.88 3.43.14 6.83 1.08 9.4 2.8a1.5 1.5 0 101.66-2.5c-3.12-2.09-7.1-3.14-10.94-3.3-3.83-.15-7.7.59-10.64 2.28a1.5 1.5 0 001.5 2.6zm10.46.9a1.5 1.5 0 00-.42 2.97c5.7.8 9.07 4.03 11.1 7.34a21.99 21.99 0 012.84 7.62 1.5 1.5 0 002.97-.46c-.17-1.05-.9-4.9-3.25-8.73a18.01 18.01 0 00-13.24-8.75zm-6.88 10.5c-3.66 2.95-5.82 9.32-1.85 17.55a1.5 1.5 0 01-2.7 1.3c-4.45-9.21-2.3-17.2 2.67-21.19a11.3 11.3 0 018.7-2.47c3.17.45 6.23 2.3 8.64 5.63a1.5 1.5 0 01-2.43 1.76c-2-2.77-4.38-4.1-6.63-4.42a8.3 8.3 0 00-6.4 1.84zm4.65 19.54c-2.48-5.08-3.2-9.33-2.72-12.1a4.67 4.67 0 011.32-2.8c.57-.51 1.38-.8 2.53-.7 1.55.15 2.24.65 2.66 1.2.5.67.78 1.63 1.1 3.08l.12.54c.59 2.71 1.38 6.37 5.1 9.2a1.5 1.5 0 001.82-2.4c-2.82-2.14-3.4-4.79-4-7.54l-.11-.46c-.3-1.38-.7-2.96-1.64-4.22-1.03-1.37-2.57-2.17-4.77-2.38a6.15 6.15 0 00-4.8 1.43 7.63 7.63 0 00-2.3 4.55c-.6 3.63.37 8.54 2.99 13.91a1.5 1.5 0 002.7-1.31zM11.6 10.96a1.5 1.5 0 01-.1 2.12 17.98 17.98 0 00-3.32 4.16 1.5 1.5 0 01-2.6-1.48c.42-.76 1.74-2.92 3.9-4.9a1.5 1.5 0 012.12.1zm24.86 17.51a1.5 1.5 0 10-2.94.56c.56 2.97 1.93 5.45 4.43 7a1.5 1.5 0 001.58-2.56c-1.6-.99-2.62-2.62-3.07-5zm-12.33.03a1.5 1.5 0 011.62 1.37c.46 5.4 3.15 8.8 3.88 9.64a1.5 1.5 0 11-2.25 1.98 20.11 20.11 0 01-4.62-11.37 1.5 1.5 0 011.37-1.62zM20.1 14.23a1.5 1.5 0 00-1.19-2.75c-6.86 2.98-10 8.05-11.37 12.62a24.25 24.25 0 00-.8 9.6 1.5 1.5 0 002.97-.4c-.12-.87-.46-4.41.7-8.35 1.16-3.88 3.79-8.16 9.7-10.72z",
    fill: primaryFill
  }));
};

export const Fingerprint48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fingerprint48FilledIcon, 'Fingerprint48Filled');

const Fingerprint48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.9 9.82c2.39-1.46 5.8-2.23 9.36-2.11 3.55.11 7.1 1.12 9.76 3.05a1.25 1.25 0 101.46-2.02c-3.16-2.3-7.22-3.4-11.14-3.53-3.91-.13-7.84.7-10.74 2.47a1.25 1.25 0 101.3 2.14zM25.4 11a1.25 1.25 0 10-.3 2.48c7.83.93 12.93 6.97 14.42 15.48a1.25 1.25 0 002.46-.44c-1.62-9.25-7.35-16.43-16.58-17.52zm-6.7 10.07c-3.82 3.06-6 9.68-1.83 18.12a1.25 1.25 0 01-2.24 1.1c-4.58-9.26-2.42-17.23 2.5-21.17a11.03 11.03 0 018.63-2.37c3.12.49 6.15 2.37 8.52 5.78a1.25 1.25 0 11-2.06 1.42c-2.03-2.93-4.49-4.36-6.84-4.73a8.53 8.53 0 00-6.68 1.85zm4.67 20.12c-2.56-5.18-3.34-9.55-2.87-12.44a4.98 4.98 0 011.4-3 3.4 3.4 0 012.73-.77c1.63.16 2.38.7 2.85 1.33.55.74.83 1.77 1.16 3.24l.1.45c.6 2.78 1.4 6.46 5.28 9.25a1.25 1.25 0 101.46-2.02c-3.09-2.23-3.7-5.05-4.32-7.86l-.08-.36c-.31-1.4-.68-2.96-1.58-4.18-.98-1.33-2.46-2.13-4.63-2.33a5.9 5.9 0 00-4.64 1.4 7.44 7.44 0 00-2.2 4.46c-.58 3.6.42 8.52 3.1 13.93a1.25 1.25 0 002.24-1.1zM11.7 10.92c.45.52.4 1.31-.11 1.77a17.45 17.45 0 00-3.75 4.68 1.25 1.25 0 11-2.16-1.24 19.93 19.93 0 014.25-5.32c.52-.45 1.31-.4 1.77.11zm24.55 17.64a1.25 1.25 0 00-2.48.38 9.92 9.92 0 004.26 6.82 1.25 1.25 0 101.46-2.02 7.43 7.43 0 01-3.24-5.18zm-12.08-.06c.69-.05 1.29.47 1.34 1.16.3 4.07 1.8 7.52 4.2 10.27a1.25 1.25 0 11-1.9 1.64A19.75 19.75 0 0123 29.84a1.25 1.25 0 011.16-1.34zm-3.93-14.6a1.25 1.25 0 00-.96-2.3C10.29 15.37 5.82 23.8 7 33.9a1.25 1.25 0 102.48-.3c-1.07-9.1 2.9-16.4 10.74-19.7z",
    fill: primaryFill
  }));
};

export const Fingerprint48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fingerprint48RegularIcon, 'Fingerprint48Regular');

const Fire16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.11 6.19l-.02.03a3.08 3.08 0 00-.22.33 5.33 5.33 0 00-.74 4.06c.26 1.19.77 2.3 1.65 3.1A5.3 5.3 0 008.5 15c1.62 0 2.89-.54 3.75-1.47A5.12 5.12 0 0013.5 10c0-.86-.28-1.69-.67-2.46-.36-.74-.83-1.47-1.28-2.15l-.07-.1c-.47-.73-.9-1.4-1.19-2.03A2.77 2.77 0 0110 1.6.5.5 0 009.5 1c-.42 0-1.12.15-1.79.5a3.3 3.3 0 00-1.68 1.84c-.4 1.17.06 2.5.44 3.32.17.38.02.79-.26.93a.54.54 0 01-.73-.24l-.53-1.07a.5.5 0 00-.84-.1z",
    fill: primaryFill
  }));
};

export const Fire16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fire16FilledIcon, 'Fire16Filled');

const Fire16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.17 2.38c.28-.14.55-.24.8-.3.02.54.18 1.08.41 1.59a16.63 16.63 0 001.32 2.25c.46.7.9 1.38 1.24 2.06.35.7.56 1.38.56 2.02 0 1.15-.34 2.15-.99 2.85a3.92 3.92 0 01-3 1.15c-1.4 0-2.37-.4-3.05-1.03a4.84 4.84 0 01-1-5.43l.13.25c.38.76 1.3 1.07 2.07.7.84-.43 1.08-1.47.72-2.24-.37-.81-.66-1.81-.4-2.6.2-.58.65-1 1.19-1.27zm-4.06 3.8v.01l-.02.03a3.08 3.08 0 00-.22.33 5.33 5.33 0 00-.74 4.06c.26 1.19.77 2.3 1.65 3.1A5.3 5.3 0 008.5 15c1.62 0 2.89-.54 3.75-1.47A5.12 5.12 0 0013.5 10c0-.86-.28-1.69-.67-2.46-.36-.74-.83-1.47-1.28-2.15l-.07-.1c-.47-.73-.9-1.4-1.19-2.03A2.77 2.77 0 0110 1.6.5.5 0 009.5 1c-.42 0-1.12.15-1.79.5a3.3 3.3 0 00-1.68 1.84c-.4 1.17.06 2.5.44 3.32.17.38.02.79-.26.93a.54.54 0 01-.73-.24l-.53-1.07a.5.5 0 00-.84-.1z",
    fill: primaryFill
  }));
};

export const Fire16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fire16RegularIcon, 'Fire16Regular');

const Fire20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 11.75c0-.54.06-1.07.19-1.59a5.81 5.81 0 01.86-1.93.65.65 0 01.18-.17.5.5 0 01.48 0c.08.04.14.1.18.17l1.04 1.7c.05.08.1.14.19.18.08.04.16.06.26.07.18 0 .32-.07.42-.2a.76.76 0 00.06-.82c-.21-.46-.39-.91-.52-1.36a4.92 4.92 0 01.12-3.17c.22-.5.52-.92.92-1.27.39-.35.84-.64 1.36-.86A8.09 8.09 0 0111.5 2c.12 0 .23.04.32.12.12.1.18.23.18.38 0 .78.13 1.53.4 2.23.26.71.63 1.38 1.1 2l.87 1.13c.29.38.56.78.8 1.19.25.4.44.84.6 1.28.15.44.22.91.23 1.42a6.5 6.5 0 01-.8 3.1 6.57 6.57 0 01-2.12 2.27 5.74 5.74 0 01-4.71.65 5.6 5.6 0 01-1.44-.64 6.5 6.5 0 01-2.13-2.27 6.2 6.2 0 01-.8-3.1z",
    fill: primaryFill
  }));
};

export const Fire20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fire20FilledIcon, 'Fire20Filled');

const Fire20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 11.75c0-.54.06-1.07.19-1.59a5.81 5.81 0 01.86-1.93.65.65 0 01.18-.17.5.5 0 01.48 0c.08.04.14.1.18.17l1.04 1.7c.05.08.1.14.19.18.08.04.16.06.26.07.18 0 .32-.07.42-.2a.76.76 0 00.06-.82c-.21-.46-.39-.91-.52-1.36a4.92 4.92 0 01.12-3.17c.22-.5.52-.92.92-1.27.39-.35.84-.64 1.36-.86A8.09 8.09 0 0111.5 2c.12 0 .23.04.32.12.12.1.18.23.18.38 0 .78.13 1.53.4 2.23.26.71.63 1.38 1.1 2l.87 1.13c.29.38.56.78.8 1.19.25.4.44.84.6 1.28.15.44.22.91.23 1.42a6.5 6.5 0 01-.8 3.1 6.57 6.57 0 01-2.12 2.27 5.74 5.74 0 01-4.71.65 5.6 5.6 0 01-1.44-.64 6.5 6.5 0 01-2.13-2.27 6.2 6.2 0 01-.8-3.1zm11-.05c0-.4-.08-.8-.23-1.2-.15-.38-.34-.77-.57-1.14a11.4 11.4 0 00-.75-1.06c-.27-.34-.52-.66-.75-.98a8.76 8.76 0 01-1.14-1.98 7.79 7.79 0 01-.54-2.23c-.42.1-.8.25-1.15.43-.35.18-.66.4-.92.67s-.46.58-.6.94c-.14.36-.21.77-.22 1.22 0 .42.06.82.17 1.2.1.38.25.76.44 1.13.07.13.12.27.15.4l.06.45c0 .22-.04.42-.11.62a1.54 1.54 0 01-2.76.28 17.2 17.2 0 01-.6-.96 5.45 5.45 0 001.95 6.77 4.84 4.84 0 007.2-2.55c.23-.64.36-1.31.37-2.01z",
    fill: primaryFill
  }));
};

export const Fire20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fire20RegularIcon, 'Fire20Regular');

const Fire24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.16 9.32h-.01l-.01.02a1.94 1.94 0 00-.13.1c-.07.07-.18.16-.3.3-.24.24-.55.62-.83 1.12a7.06 7.06 0 00-.8 4.55c.27 2 1.1 3.67 2.53 4.83C8.02 21.4 9.94 22 12.25 22c2.39 0 4.3-.9 5.55-2.43a8.35 8.35 0 001.68-5.86c-.13-2.18-1.31-3.83-2.36-5.29l-.3-.42C15.68 6.4 14.78 4.9 15 2.83a.75.75 0 00-.75-.83c-.38 0-.82.12-1.24.3a6.82 6.82 0 00-3.72 3.96c-.49 1.4-.24 2.73.12 3.7.24.64-.02 1.27-.4 1.46a.7.7 0 01-.93-.31l-.81-1.54a.75.75 0 00-1.11-.25z",
    fill: primaryFill
  }));
};

export const Fire24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fire24FilledIcon, 'Fire24Filled');

const Fire24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.54 4.3c.32-.25.64-.44.93-.57.09 2.13 1.13 3.73 2.13 5.14l.27.38c1.08 1.52 2.01 2.82 2.11 4.54a6.86 6.86 0 01-1.33 4.83 5.43 5.43 0 01-4.4 1.88c-2.06 0-3.61-.53-4.7-1.42a5.83 5.83 0 01-1.98-3.87 5.56 5.56 0 01.86-4l.32.6a2.2 2.2 0 002.9.96c1.3-.62 1.58-2.21 1.17-3.33a3.94 3.94 0 01-.11-2.7 5.32 5.32 0 011.83-2.45zM6.16 9.31h-.01l-.01.02a1.94 1.94 0 00-.13.1c-.07.07-.18.16-.3.3-.24.24-.55.62-.83 1.12a7.06 7.06 0 00-.8 4.55c.27 2 1.1 3.67 2.53 4.83C8.02 21.4 9.94 22 12.25 22c2.39 0 4.3-.9 5.55-2.43a8.35 8.35 0 001.68-5.86c-.13-2.18-1.31-3.83-2.36-5.29l-.3-.42C15.68 6.4 14.78 4.9 15 2.83a.75.75 0 00-.75-.83c-.38 0-.82.12-1.24.3a6.82 6.82 0 00-3.72 3.96c-.49 1.4-.24 2.73.12 3.7.24.64-.02 1.27-.4 1.46a.7.7 0 01-.93-.31l-.81-1.54a.75.75 0 00-1.11-.25z",
    fill: primaryFill
  }));
};

export const Fire24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fire24RegularIcon, 'Fire24Regular');

const Fireplace20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a7 7 0 00-7 7v5a1 1 0 001 1h12a1 1 0 001-1V9a7 7 0 00-7-7zM4 9a6 6 0 1112 0v5h-3.5c.62-.62 1-1.48 1-2.5 0-1.13-.63-1.97-1.17-2.7l-.13-.16c-.6-.8-1.1-1.57-1.1-2.71a.5.5 0 00-.76-.43c-1.4.85-1.45 2.17-1.39 3l-.42-.37a.5.5 0 00-.66 0h-.01l-.02.02a2.23 2.23 0 00-.2.22A4.85 4.85 0 006.5 11.5c-.01 1.02.37 1.88 1 2.5H4V9zm-1.5 7a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const Fireplace20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace20FilledIcon, 'Fireplace20Filled');

const Fireplace20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 9a7 7 0 0114 0v5a1 1 0 01-1 1H4a1 1 0 01-1-1V9zm7-6a6 6 0 00-6 6v5h3.5c-.62-.62-1-1.48-1-2.5a4.85 4.85 0 011.34-3.35l.02-.01v-.01a.5.5 0 01.65-.02c.02-.28.08-.58.2-.9.25-.63.75-1.24 1.65-1.72a.5.5 0 01.74.44c0 1.14.5 1.9 1.1 2.7l.13.18c.54.72 1.17 1.56 1.17 2.69 0 1.02-.38 1.88-1 2.5H16V9a6 6 0 00-6-6zM8.22 9.25a3.85 3.85 0 00-.72 2.25c0 1.49 1.1 2.5 2.5 2.5s2.5-1.01 2.5-2.5c0-.79-.43-1.37-1.02-2.16l-.08-.1c-.48-.65-1-1.4-1.21-2.42a2.03 2.03 0 00-.66 1.88c0 .09.02.16.03.23v.05l.03.15c0 .05.02.15 0 .25 0 .05-.02.17-.12.28-.12.15-.3.2-.44.2a.59.59 0 01-.25-.09 2.72 2.72 0 01-.32-.27l-.24-.25zM2.5 16a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const Fireplace20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace20RegularIcon, 'Fireplace20Regular');

const Fireplace24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a9 9 0 00-9 9v6.25c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V11a9 9 0 00-9-9zm-7.5 9a7.5 7.5 0 1115 0v5.5h-4.3a4.16 4.16 0 001.3-3.01c0-1.73-.87-2.78-1.6-3.66l-.07-.09c-.74-.9-1.33-1.65-1.33-2.99a.75.75 0 00-.95-.72 2.5 2.5 0 00-1.74 1.55c-.23.57-.29 1.2-.33 1.66v.13l-.07.5a3.2 3.2 0 01-.53-.27.75.75 0 00-.89.1l-.01.01-.02.02a2.53 2.53 0 00-.23.25 5.57 5.57 0 00-1.23 3.5c0 1.19.49 2.25 1.3 3.02H4.5V11zm-1.75 8.5a.75.75 0 000 1.5h18.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const Fireplace24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace24FilledIcon, 'Fireplace24Filled');

const Fireplace24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 11a9 9 0 0118 0v6.25c0 .41-.34.75-.75.75H3.75a.75.75 0 01-.75-.75V11zm9-7.5A7.5 7.5 0 004.5 11v5.5h4.3a4.14 4.14 0 01-1.3-3.01 5.57 5.57 0 011.46-3.76l.02-.02L9 9.7a.75.75 0 011.06.03v-.05l.02-.16c.05-.52.13-1.27.47-1.94a2.9 2.9 0 012.04-1.56.75.75 0 01.92.73c0 1.34.59 2.1 1.33 3l.07.08c.73.88 1.6 1.93 1.6 3.66 0 1.17-.5 2.24-1.3 3.01h4.3V11A7.5 7.5 0 0012 3.5zm-2.47 7.96A4.07 4.07 0 009 13.49c0 1.47 1.23 2.76 3 2.76s3-1.31 3-2.76c0-1.19-.56-1.87-1.32-2.79a6.46 6.46 0 01-1.56-2.8c-.1.11-.17.23-.24.35-.2.4-.27.89-.32 1.42l-.01.13-.07.62c-.04.19-.1.56-.37.83a.99.99 0 01-.62.3 1.2 1.2 0 01-.57-.1l-.3-.16-.1.17zM2 20.25c0-.41.34-.75.75-.75h18.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Fireplace24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace24RegularIcon, 'Fireplace24Regular');

const Fireplace32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 14a12 12 0 1124 0v10a1 1 0 01-1 1H5a1 1 0 01-1-1V14zM16 4A10 10 0 006 14v9h5.28a6.68 6.68 0 01-1.78-4.53 8.5 8.5 0 011.63-5.03 5.38 5.38 0 01.32-.37l.02-.02v-.01h.01v-.01a1 1 0 011.14-.2c.52.25.86.36 1.07.4.03-.17.04-.38.06-.7v-.08c.03-.63.08-1.57.49-2.4.47-.98 1.36-1.72 2.82-2.03a1 1 0 011.2.98c0 2.01.88 3.26 1.9 4.56l.26.3c.95 1.19 2.08 2.6 2.08 4.61 0 1.66-.63 3.3-1.77 4.53H26v-9A10 10 0 0016 4zM2 28a1 1 0 011-1h26a1 1 0 110 2H3a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const Fireplace32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace32FilledIcon, 'Fireplace32Filled');

const Fireplace32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 14v10a1 1 0 001 1h22a1 1 0 001-1V14a12 12 0 00-24 0zm16.73 9a6.69 6.69 0 001.77-4.53c0-2.01-1.13-3.42-2.08-4.6l-.25-.31c-1.03-1.3-1.9-2.55-1.9-4.56a1 1 0 00-1.21-.98c-1.6.35-2.61 1.11-3.18 2.12-.53.94-.6 1.97-.62 2.67l-.01.28v.12l-.51-.31a1 1 0 00-1.26.13l-.01.02a4.13 4.13 0 00-.34.39 8.5 8.5 0 00-1.63 5.03c0 1.66.63 3.3 1.78 4.53H6v-9a10 10 0 0120 0v9h-5.27zM16 23c-2.76 0-4.5-2.2-4.5-4.53a6.5 6.5 0 01.95-3.42c.23.12.45.22.65.28.42.13 1.06.2 1.57-.26.42-.38.5-.92.53-1.19a9.7 9.7 0 00.05-1c.03-.68.1-1.27.37-1.76.14-.25.37-.52.76-.75a9.47 9.47 0 002.22 4.43l.17.22c1.04 1.3 1.73 2.17 1.73 3.45A4.44 4.44 0 0116 23zM2 28a1 1 0 011-1h26a1 1 0 110 2H3a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const Fireplace32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace32RegularIcon, 'Fireplace32Regular');

const Fireplace48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 4A18 18 0 006 22v13.25c0 .69.56 1.25 1.25 1.25h33.5c.69 0 1.25-.56 1.25-1.25V22A18 18 0 0024 4zM8.5 22a15.5 15.5 0 0131 0v12h-9.13a8.84 8.84 0 003.13-6.75c0-2.89-1.7-4.93-3.15-6.68l-.38-.46c-1.6-1.94-2.97-3.85-2.97-6.86a1.25 1.25 0 00-1.54-1.22c-2.16.53-3.43 1.68-4.12 3.11a9.73 9.73 0 00-.75 3.8V19c-.02.41-.03.72-.06.97a9.1 9.1 0 01-1.35-.77 1.25 1.25 0 00-1.53.13l-.02.02a3.9 3.9 0 00-.15.15l-.37.41a11.55 11.55 0 00-2.61 7.34A8.84 8.84 0 0017.64 34H8.5V22zM5.25 39.5a1.25 1.25 0 100 2.5h37.5a1.25 1.25 0 100-2.5H5.25z",
    fill: primaryFill
  }));
};

export const Fireplace48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace48FilledIcon, 'Fireplace48Filled');

const Fireplace48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 22a18 18 0 0136 0v13.25c0 .69-.56 1.25-1.25 1.25H7.25c-.69 0-1.25-.56-1.25-1.25V22zM24 6.5A15.5 15.5 0 008.5 22v12h9.14a8.84 8.84 0 01-3.14-6.75 11.55 11.55 0 013.1-7.86l.03-.04.01-.01h.01c.44-.42 1.06-.45 1.54-.13.45.3.8.5 1.05.62l.03-.6v-.35c.04-1.02.13-2.48.84-3.82.75-1.41 2.12-2.52 4.36-3.03A1.25 1.25 0 0127 13.25c0 3.01 1.37 4.92 2.97 6.86l.38.46c1.46 1.75 3.15 3.79 3.15 6.68A8.84 8.84 0 0130.37 34h9.13V22A15.5 15.5 0 0024 6.5zm-5.8 16.2a9.05 9.05 0 00-1.2 4.55c0 3.4 2.75 6.5 7 6.5 4.26 0 7-3.1 7-6.5 0-1.95-1.11-3.3-2.69-5.22l-.28-.34c-1.4-1.7-2.96-3.75-3.4-6.72-.69.36-1.07.82-1.31 1.27a6.28 6.28 0 00-.55 3c-.02.4-.03.83-.07 1.2-.05.39-.17 1.1-.72 1.6-.67.6-1.5.52-2.09.34a6.1 6.1 0 01-1.14-.51c-.17.23-.35.5-.54.83zM4 40.75c0-.69.56-1.25 1.25-1.25h37.5a1.25 1.25 0 110 2.5H5.25C4.56 42 4 41.44 4 40.75z",
    fill: primaryFill
  }));
};

export const Fireplace48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fireplace48RegularIcon, 'Fireplace48Regular');

const FixedWidth20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3c.28 0 .5.22.5.5V5h5.5V3.5a.5.5 0 011 0V5H16V3.5a.5.5 0 011 0v4a.5.5 0 01-1 0V6h-5.5v1.5a.5.5 0 01-1 0V6H4v1.5a.5.5 0 01-1 0v-4c0-.28.22-.5.5-.5zm6 6H5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h4.5V9zm1 8H15a2 2 0 002-2v-4a2 2 0 00-2-2h-4.5v8z",
    fill: primaryFill
  }));
};

export const FixedWidth20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FixedWidth20FilledIcon, 'FixedWidth20Filled');

const FixedWidth20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3c.28 0 .5.22.5.5V5h5.5V3.5a.5.5 0 011 0V5H16V3.5a.5.5 0 011 0v4a.5.5 0 01-1 0V6h-5.5v1.5a.5.5 0 01-1 0V6H4v1.5a.5.5 0 01-1 0v-4c0-.28.22-.5.5-.5zM3 11c0-1.1.9-2 2-2h10a2 2 0 012 2v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4zm7.5 5H15a1 1 0 001-1v-4a1 1 0 00-1-1h-4.5v6zm-1-6H5a1 1 0 00-1 1v4a1 1 0 001 1h4.5v-6z",
    fill: primaryFill
  }));
};

export const FixedWidth20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FixedWidth20RegularIcon, 'FixedWidth20Regular');

const FixedWidth24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 4c.41 0 .75.3.75.69V6h6.75V4.69c0-.38.34-.69.75-.69s.75.3.75.69V6h6.75V4.69c0-.38.34-.69.75-.69s.75.3.75.69V8.8c0 .38-.34.69-.75.69s-.75-.3-.75-.69V7.5h-6.75v1.31c0 .38-.34.69-.75.69s-.75-.3-.75-.69V7.5H4.5v1.31c0 .38-.34.69-.75.69S3 9.2 3 8.81V4.7c0-.38.34-.69.75-.69zm2 7A2.75 2.75 0 003 13.75v4a2.75 2.75 0 002.75 2.75h5.5V11h-5.5zm12.5 9.5h-5.5V11h5.5A2.75 2.75 0 0121 13.75v4a2.75 2.75 0 01-2.75 2.75z",
    fill: primaryFill
  }));
};

export const FixedWidth24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FixedWidth24FilledIcon, 'FixedWidth24Filled');

const FixedWidth24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4.69c0-.38-.34-.69-.75-.69S3 4.3 3 4.69V8.8c0 .38.34.69.75.69s.75-.3.75-.69V7.5h6.75v1.31c0 .38.34.69.75.69s.75-.3.75-.69V7.5h6.75v1.31c0 .38.34.69.75.69s.75-.3.75-.69V4.7c0-.38-.34-.69-.75-.69s-.75.3-.75.69V6h-6.75V4.69c0-.38-.34-.69-.75-.69s-.75.3-.75.69V6H4.5V4.69zM5.75 11A2.75 2.75 0 003 13.75v4a2.75 2.75 0 002.75 2.75h12.5A2.75 2.75 0 0021 17.75v-4A2.75 2.75 0 0018.25 11H5.75zm5.5 1.5V19h-5.5c-.69 0-1.25-.56-1.25-1.25v-4c0-.69.56-1.25 1.25-1.25h5.5zm1.5 6.5v-6.5h5.5c.69 0 1.25.56 1.25 1.25v4c0 .69-.56 1.25-1.25 1.25h-5.5z",
    fill: primaryFill
  }));
};

export const FixedWidth24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FixedWidth24RegularIcon, 'FixedWidth24Regular');

const Flag16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 10h9a.5.5 0 00.4-.8L11.12 6l2.3-3.2A.5.5 0 0013 2H3.5a.5.5 0 00-.5.5v11a.5.5 0 001 0V10z",
    fill: primaryFill
  }));
};

export const Flag16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag16FilledIcon, 'Flag16Filled');

const Flag16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 9V3h8.03l-1.94 2.7a.5.5 0 000 .6L12.03 9H4zm0 1h9a.5.5 0 00.4-.8L11.12 6l2.3-3.2A.5.5 0 0013 2H3.5a.5.5 0 00-.5.5v11a.5.5 0 001 0V10z",
    fill: primaryFill
  }));
};

export const Flag16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag16RegularIcon, 'Flag16Regular');

const Flag20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 13h11a.5.5 0 00.42-.78L13.1 8l2.82-4.22A.5.5 0 0015.5 3H4a.5.5 0 00-.5.5v14a.5.5 0 001 0V13z",
    fill: primaryFill
  }));
};

export const Flag20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag20FilledIcon, 'Flag20Filled');

const Flag20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 13h11a.5.5 0 00.42-.78L13.1 8l2.82-4.22A.5.5 0 0015.5 3H4a.5.5 0 00-.5.5v14a.5.5 0 001 0V13zm0-1V4h10.07l-2.49 3.72a.5.5 0 000 .56L14.57 12H4.5z",
    fill: primaryFill
  }));
};

export const Flag20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag20RegularIcon, 'Flag20Regular');

const Flag24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.75c0-.42.34-.75.75-.75h16.5c.62 0 .98.7.6 1.2L16.7 9.75l4.16 5.55c.38.5.02 1.2-.6 1.2H4.5v4.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1V3.75z",
    fill: primaryFill
  }));
};

export const Flag24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag24FilledIcon, 'Flag24Filled');

const Flag24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.75c0-.42.34-.75.75-.75h16.5c.62 0 .98.7.6 1.2L16.7 9.75l4.16 5.55c.38.5.02 1.2-.6 1.2H4.5v4.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1V3.75zm15.75.75H4.5V15h14.25l-3.6-4.8a.75.75 0 010-.9l3.6-4.8z",
    fill: primaryFill
  }));
};

export const Flag24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag24RegularIcon, 'Flag24Regular');

const Flag28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 18h17.75c.59 0 .95-.65.63-1.15l-4-6.35 4-6.35A.75.75 0 0023.25 3H4.75a.75.75 0 00-.75.75v20.5a.75.75 0 001.5 0V18z",
    fill: primaryFill
  }));
};

export const Flag28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag28FilledIcon, 'Flag28Filled');

const Flag28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 16.5v-12h16.4l-3.53 5.6a.75.75 0 000 .8l3.52 5.6H5.5zm0 1.5h17.75c.59 0 .95-.65.63-1.15l-4-6.35 4-6.35A.75.75 0 0023.25 3H4.75a.75.75 0 00-.75.75v20.5a.75.75 0 001.5 0V18z",
    fill: primaryFill
  }));
};

export const Flag28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag28RegularIcon, 'Flag28Regular');

const Flag48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 29h24.25c.96 0 1.56-1.03 1.09-1.87l-4.9-8.63 4.9-8.63A1.25 1.25 0 0036.75 8h-25.5C10.56 8 10 8.56 10 9.25v29.5a1.25 1.25 0 102.5 0V29z",
    fill: primaryFill
  }));
};

export const Flag48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag48FilledIcon, 'Flag48Filled');

const Flag48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 10.5h22.1l-4.19 7.38c-.21.39-.21.85 0 1.24l4.2 7.38H12.5v-16zm0 18.5h24.25c.96 0 1.56-1.03 1.09-1.87l-4.9-8.63 4.9-8.63A1.25 1.25 0 0036.75 8h-25.5C10.56 8 10 8.56 10 9.25v29.5a1.25 1.25 0 102.5 0V29z",
    fill: primaryFill
  }));
};

export const Flag48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flag48RegularIcon, 'Flag48Regular');

const FlagOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.3 10l4.85 4.85a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7L3 3.71v9.79a.5.5 0 001 0V10h5.3zm3.7 0h-.88l-8-8H13c.4 0 .64.46.4.8L11.12 6l2.3 3.2a.5.5 0 01-.41.8z",
    fill: primaryFill
  }));
};

export const FlagOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff16FilledIcon, 'FlagOff16Filled');

const FlagOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.3 10l4.85 4.85a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7L3 3.71v9.79a.5.5 0 001 0V10h5.3zm-1-1H4V4.7L8.3 9zm3.73 0h-.9l1 1H13a.5.5 0 00.4-.8L11.12 6l2.3-3.2A.5.5 0 0013 2H4.12l1 1h6.9L10.1 5.7a.5.5 0 000 .6L12.03 9z",
    fill: primaryFill
  }));
};

export const FlagOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff16RegularIcon, 'FlagOff16Regular');

const FlagOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.5 4.21V17.5a.5.5 0 001 0V13h7.8l4.85 4.85a.5.5 0 00.7-.7L3.77 3.05l-.92-.9zM15.5 13h-.38l-10-10H15.5c.4 0 .64.45.42.78L13.1 8l2.82 4.22a.5.5 0 01-.42.78z",
    fill: primaryFill
  }));
};

export const FlagOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff20FilledIcon, 'FlagOff20Filled');

const FlagOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.5 4.21V17.5a.5.5 0 001 0V13h7.8l4.85 4.85a.5.5 0 00.7-.7L3.77 3.05l-.92-.9zM11.3 12H4.5V5.2l6.8 6.8zm3.28 0h-.45l1 1h.38a.5.5 0 00.42-.78L13.1 8l2.82-4.22A.5.5 0 0015.5 3H5.12l1 1h8.45l-2.49 3.72a.5.5 0 000 .56L14.57 12z",
    fill: primaryFill
  }));
};

export const FlagOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff20RegularIcon, 'FlagOff20Regular');

const FlagOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 2.5l18 18a.75.75 0 01-1.06 1.06l-5.06-5.06H4.5v4.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1V5.12L1.44 3.56A.75.75 0 112.5 2.5zm2.62.5h15.13c.62 0 .98.7.6 1.2L16.7 9.75l4.16 5.55c.38.5.02 1.2-.6 1.2h-1.63L5.12 3z",
    fill: primaryFill
  }));
};

export const FlagOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff24FilledIcon, 'FlagOff24Filled');

const FlagOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 2.5l18 18a.75.75 0 01-1.06 1.06l-5.06-5.06H4.5v4.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1V5.12L1.44 3.56A.75.75 0 112.5 2.5zm2.62.5h15.13c.62 0 .98.7.6 1.2L16.7 9.75l4.16 5.55c.38.5.02 1.2-.6 1.2h-1.63l-1.5-1.5h1.63l-3.6-4.8a.75.75 0 010-.9l3.6-4.8H6.62L5.12 3zM4.5 6.62V15h8.38L4.5 6.62z",
    fill: primaryFill
  }));
};

export const FlagOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff24RegularIcon, 'FlagOff24Regular');

const FlagOff28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.4 1.55l.07-.08a.75.75 0 01.98-.07l.08.07 20 20a.75.75 0 01-.98 1.13l-.08-.07L17.94 18H5.5v6.25a.75.75 0 01-1.5.1V4.06L2.47 2.53a.75.75 0 01-.07-.98l.07-.08-.07.08zM7.06 3h16.19c.56 0 .9.58.68 1.06l-.05.09-4 6.35 4 6.35c.3.47 0 1.07-.53 1.14l-.1.01h-1.19l-15-15z",
    fill: primaryFill
  }));
};

export const FlagOff28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff28FilledIcon, 'FlagOff28Filled');

const FlagOff28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.4 1.55l.07-.08a.75.75 0 01.98-.07l.08.07 20 20a.75.75 0 01-.98 1.13l-.08-.07L17.94 18H5.5v6.25a.75.75 0 01-1.5.1V4.06L2.47 2.53a.75.75 0 01-.07-.98l.07-.08-.07.08zM7.06 3h16.19c.56 0 .9.58.68 1.06l-.05.09-4 6.35 4 6.35c.3.47 0 1.07-.53 1.14l-.1.01h-1.19l-1.5-1.5h1.33l-3.52-5.6a.75.75 0 01-.06-.7l.06-.1 3.52-5.6H8.56L7.06 3zM5.5 5.56V16.5h10.94L5.5 5.56z",
    fill: primaryFill
  }));
};

export const FlagOff28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff28RegularIcon, 'FlagOff28Regular');

const FlagOff48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 7.75l.08-.1a1.25 1.25 0 011.67-.15l.1.08 27.5 25.5a1.25 1.25 0 01-1.6 1.92l-.1-.08L27.77 29H12.5v9.75a1.25 1.25 0 01-2.5.13V12.52l-3.35-3.1a1.25 1.25 0 01-.15-1.67l.08-.1-.08.1zm5.38.25h24.87c.92 0 1.5.95 1.14 1.76l-.05.1-4.9 8.64 4.9 8.63c.45.8-.08 1.78-.97 1.86l-.12.01h-2.23L11.88 8z",
    fill: primaryFill
  }));
};

export const FlagOff48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff48FilledIcon, 'FlagOff48Filled');

const FlagOff48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 7.75l.08-.1a1.25 1.25 0 011.67-.15l.1.08 27.5 25.5a1.25 1.25 0 01-1.6 1.92l-.1-.08L27.77 29H12.5v9.75a1.25 1.25 0 01-2.5.13V12.52l-3.35-3.1a1.25 1.25 0 01-.15-1.67l.08-.1-.08.1zm5.38.25h24.87c.92 0 1.5.95 1.14 1.76l-.05.1-4.9 8.64 4.9 8.63c.45.8-.08 1.78-.97 1.86l-.12.01h-2.23l-2.7-2.5h2.78l-4.19-7.38c-.19-.34-.21-.75-.06-1.1l.06-.14 4.2-7.38H14.56L11.87 8zm13.2 18.5L12.5 14.84V26.5h12.57z",
    fill: primaryFill
  }));
};

export const FlagOff48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagOff48RegularIcon, 'FlagOff48Regular');

const FlagPride16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    fill: "#745125",
    d: "M3 3h10v1H3z"
  }), React.createElement("path", {
    fill: "#E62C46",
    d: "M3 4h10v1H3z"
  }), React.createElement("path", {
    fill: "#F36D38",
    d: "M3 5h10v1H3z"
  }), React.createElement("path", {
    fill: "#FFD23E",
    d: "M3 6h10v1H3z"
  }), React.createElement("path", {
    fill: "#61BC51",
    d: "M3 7h10v1H3z"
  }), React.createElement("path", {
    fill: "#1793E8",
    d: "M3 8h10v1H3z"
  }), React.createElement("path", {
    fill: "#B73FBB",
    d: "M3 9h10v1H3z"
  }), React.createElement("path", {
    d: "M2.5 2h11c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5H3v2.5a.5.5 0 01-1 0v-11c0-.28.22-.5.5-.5zM3 3v7h10V3H3z",
    fill: primaryFill
  }));
};

export const FlagPride16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagPride16FilledIcon, 'FlagPride16Filled');

const FlagPride20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    fill: "#745125",
    d: "M4 4h12v1H4z"
  }), React.createElement("path", {
    fill: "#E62C46",
    d: "M4 5h12v1H4z"
  }), React.createElement("path", {
    fill: "#F36D38",
    d: "M4 6h12v1H4z"
  }), React.createElement("path", {
    fill: "#FFD23E",
    d: "M4 7h12v1H4z"
  }), React.createElement("path", {
    fill: "#61BC51",
    d: "M4 8h12v1H4z"
  }), React.createElement("path", {
    fill: "#1793E8",
    d: "M4 9h12v1H4z"
  }), React.createElement("path", {
    fill: "#B73FBB",
    d: "M4 10h12v1H4z"
  }), React.createElement("path", {
    d: "M3.5 3h13c.28 0 .5.22.5.5v8a.5.5 0 01-.5.5H4v5.5a.5.5 0 01-1 0v-14c0-.28.22-.5.5-.5zM4 4v7h12V4H4z",
    fill: primaryFill
  }));
};

export const FlagPride20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagPride20FilledIcon, 'FlagPride20Filled');

const FlagPride24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    fill: "#745125",
    d: "M4 4.25h16v1.5H4z"
  }), React.createElement("path", {
    fill: "#E62C46",
    d: "M4 5.75h16v1.5H4z"
  }), React.createElement("path", {
    fill: "#F36D38",
    d: "M4 7.25h16V9H4z"
  }), React.createElement("path", {
    fill: "#FFD23E",
    d: "M4 9h16v1.5H4z"
  }), React.createElement("path", {
    fill: "#61BC51",
    d: "M4 10.5h16v1.75H4z"
  }), React.createElement("path", {
    fill: "#1793E8",
    d: "M4 12.25h16v1.5H4z"
  }), React.createElement("path", {
    fill: "#B73FBB",
    d: "M4 13.75h17v1.5H4z"
  }), React.createElement("path", {
    d: "M3.75 3a.75.75 0 00-.75.75v17.5a.75.75 0 001.5 0V16.5h15.75c.41 0 .75-.34.75-.75v-12a.75.75 0 00-.75-.75H3.75zm.75 1.5h15V15h-15V4.5z",
    fill: primaryFill
  }));
};

export const FlagPride24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagPride24FilledIcon, 'FlagPride24Filled');

const FlagPride28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    fill: "#745125",
    d: "M5 4.25h18V6H5z"
  }), React.createElement("path", {
    fill: "#E62C46",
    d: "M5 6h18v2H5z"
  }), React.createElement("path", {
    fill: "#F36D38",
    d: "M5 8h18v2H5z"
  }), React.createElement("path", {
    fill: "#FFD23E",
    d: "M5 10h18v1H5z"
  }), React.createElement("path", {
    fill: "#61BC51",
    d: "M5 11h18v2H5z"
  }), React.createElement("path", {
    fill: "#1793E8",
    d: "M5 13h18v2H5z"
  }), React.createElement("path", {
    fill: "#B73FBB",
    d: "M5 15h18v2H5z"
  }), React.createElement("path", {
    d: "M4.75 3a.75.75 0 00-.75.75v20.5a.75.75 0 001.5 0V18h17.75c.41 0 .75-.34.75-.75V3.75a.75.75 0 00-.75-.75H4.75zm.75 1.5h17v12h-17v-12z",
    fill: primaryFill
  }));
};

export const FlagPride28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagPride28FilledIcon, 'FlagPride28Filled');

const FlagPride48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    fill: "#745125",
    d: "M12 10h24v2H12z"
  }), React.createElement("path", {
    fill: "#E62C46",
    d: "M12 12h24v2H12z"
  }), React.createElement("path", {
    fill: "#F36D38",
    d: "M12 14h24v3H12z"
  }), React.createElement("path", {
    fill: "#FFD23E",
    d: "M12 17h24v3H12z"
  }), React.createElement("path", {
    fill: "#61BC51",
    d: "M12 20h24v3H12z"
  }), React.createElement("path", {
    fill: "#1793E8",
    d: "M12 23h24v2H12z"
  }), React.createElement("path", {
    fill: "#B73FBB",
    d: "M12 25h24v3H12z"
  }), React.createElement("path", {
    d: "M11.25 8C10.56 8 10 8.56 10 9.25v29.5a1.25 1.25 0 102.5 0V29h24.25c.69 0 1.25-.56 1.25-1.25V9.25C38 8.56 37.44 8 36.75 8h-25.5zM35.5 26.5h-23v-16h23v16z",
    fill: primaryFill
  }));
};

export const FlagPride48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlagPride48FilledIcon, 'FlagPride48Filled');

const Flash16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.87 1a1 1 0 00-.96.71L3.03 8.04c-.14.48.22.96.72.96h1.58l-1.28 4.39c-.38 1.31 1.33 2.2 2.18 1.13l6.6-8.3A.75.75 0 0012.26 5h-2.03l1-2.65A1 1 0 0010.27 1h-4.4z",
    fill: primaryFill
  }));
};

export const Flash16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash16FilledIcon, 'Flash16Filled');

const Flash16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.91 1.71A1 1 0 015.87 1h4.4a1 1 0 01.94 1.35L10.22 5h2.03c.63 0 .98.73.59 1.22l-6.6 8.3c-.86 1.07-2.57.18-2.19-1.13L5.33 9H3.75a.75.75 0 01-.72-.96L4.91 1.7zm5.37.29h-4.4l-1.8 6H6a.5.5 0 01.48.64l-1.47 5.03a.23.23 0 00.01.17c.02.05.06.1.12.12.05.03.11.04.16.03.04 0 .1-.03.15-.1L11.73 6H9.5a.5.5 0 01-.47-.68L10.28 2z",
    fill: primaryFill
  }));
};

export const Flash16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash16RegularIcon, 'Flash16Regular');

const Flash20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l8.67-8.86c.65-.68.19-1.82-.76-1.82H12.2l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2z",
    fill: primaryFill
  }));
};

export const Flash20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash20FilledIcon, 'Flash20Filled');

const Flash20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1 1.4L12.22 7h2.56c.95 0 1.4 1.14.77 1.81l-8.68 8.86c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM7.2 3a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 8.68-8.86a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21z",
    fill: primaryFill
  }));
};

export const Flash20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash20RegularIcon, 'Flash20Regular');

const Flash24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.43 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.67 1.33.9 2.12L8.59 21.54c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.56-.01c-1.21 0-2.05-1.2-1.65-2.34l3.33-9.32z",
    fill: primaryFill
  }));
};

export const Flash24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash24FilledIcon, 'Flash24Filled');

const Flash24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.43 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.67 1.33.9 2.12L8.59 21.54c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.56-.01c-1.21 0-2.05-1.2-1.65-2.34l3.33-9.32zm1.35.67l-3.26 9.16c-.06.16.06.33.23.33l2.5.01a.75.75 0 01.73.91L7.51 20.5 18.16 9.5h-4.41a.75.75 0 01-.71-.99L14.7 3.5H8.78z",
    fill: primaryFill
  }));
};

export const Flash24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash24RegularIcon, 'Flash24Regular');

const Flash28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.4 2.85c.2-.51.7-.85 1.25-.85h8.51c.93 0 1.58.92 1.26 1.8l-2.1 5.7h4.84c1.18 0 1.78 1.42.96 2.26L9.78 25.5c-1.14 1.18-3.1.12-2.75-1.48L8.7 16.5H5.92a1.92 1.92 0 01-1.8-2.6L8.42 2.84z",
    fill: primaryFill
  }));
};

export const Flash28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash28FilledIcon, 'Flash28Filled');

const Flash28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.4 2.85c.2-.51.7-.85 1.25-.85h8.51c.93 0 1.58.92 1.26 1.8l-2.1 5.7h4.84c1.18 0 1.78 1.42.96 2.26L9.78 25.5c-1.14 1.18-3.1.12-2.75-1.48L8.7 16.5H5.92a1.92 1.92 0 01-1.8-2.6L8.42 2.84zm1.36.65L5.53 14.43c-.1.28.1.57.39.57h3.7a.75.75 0 01.74.91L8.5 24.34v.09l.06.05c.03.02.06.02.08.02.01 0 .03 0 .07-.04L21.77 11h-5.52a.75.75 0 01-.7-1l2.38-6.5H9.76z",
    fill: primaryFill
  }));
};

export const Flash28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flash28RegularIcon, 'Flash28Regular');

const FlashAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.19-1.82-.76-1.82h-2.56l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const FlashAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAdd20FilledIcon, 'FlashAdd20Filled');

const FlashAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1.01 1.4L12.2 7h2.56c.95 0 1.4 1.14.77 1.81l-.24.25a5.54 5.54 0 00-1.38-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 2.88-2.94a5.58 5.58 0 00.05 1.37l-2.21 2.26c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM17 18.24a4.5 4.5 0 11-5-7.48 4.5 4.5 0 015 7.48zm-2.15-6.1a.5.5 0 00-.85.36V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5a.5.5 0 00-.15-.35z",
    fill: primaryFill
  }));
};

export const FlashAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAdd20RegularIcon, 'FlashAdd20Regular');

const FlashAuto20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l4.82-4.93 1.42-3.78a1.5 1.5 0 012.6-.37c.38-.68-.08-1.6-.93-1.6H12.2l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zm7.29 7c.2 0 .4.13.47.32l3 8a.5.5 0 11-.94.36l-1-2.68h-3.06l-1 2.68a.5.5 0 01-.94-.36l3-8A.5.5 0 0114.5 9zm1.15 5l-1.15-3.08L13.35 14h2.3z",
    fill: primaryFill
  }));
};

export const FlashAuto20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAuto20FilledIcon, 'FlashAuto20Filled');

const FlashAuto20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1 1.4L12.22 7h2.56c.85 0 1.3.92.93 1.6a1.5 1.5 0 00-.88-.57.07.07 0 00-.02-.02L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 6.4-6.55-.86 2.32-4.82 4.92c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM14.5 9c.2 0 .4.13.47.32l3 8a.5.5 0 11-.94.36l-1-2.68h-3.06l-1 2.68a.5.5 0 01-.94-.36l3-8A.5.5 0 0114.5 9zm1.15 5l-1.15-3.08L13.35 14h2.3z",
    fill: primaryFill
  }));
};

export const FlashAuto20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAuto20RegularIcon, 'FlashAuto20Regular');

const FlashAuto24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.43 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.67 1.33.9 2.12l-.67.7a1.75 1.75 0 00-3.11.29l-1.94 4.91-5.34 5.52c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.56-.01c-1.21 0-2.05-1.2-1.65-2.34l3.33-9.32zm10.76 8.64l3.75 9.5a.75.75 0 01-1.35.64l-.04-.09-1-2.52h-4.11l-1 2.52a.75.75 0 01-.87.45l-.1-.03a.75.75 0 01-.45-.87l.03-.1 3.75-9.5a.73.73 0 01.45-.43.77.77 0 01.54.02c.14.06.27.16.35.3l.05.11zm-2.16 6.03h2.93l-1.46-3.7-1.47 3.7z",
    fill: primaryFill
  }));
};

export const FlashAuto24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAuto24FilledIcon, 'FlashAuto24Filled');

const FlashAuto24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.42 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.66 1.33.9 2.12l-.67.7c-.3-.5-.8-.76-1.32-.81l.5-.51h-4.41a.75.75 0 01-.71-.99L14.7 3.5H8.78l-3.26 9.16c-.06.16.06.33.23.33l2.5.01a.75.75 0 01.73.91L7.51 20.5l7.86-8.1-1.44 3.63-5.34 5.52c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.57-.01c-1.2 0-2.04-1.2-1.64-2.34l3.32-9.32zm10.77 8.64l3.75 9.5a.75.75 0 01-1.35.64l-.04-.09-1-2.52h-4.1l-1 2.52a.75.75 0 01-.88.45l-.1-.03a.75.75 0 01-.45-.87l.03-.1 3.75-9.5a.73.73 0 01.45-.43.77.77 0 01.55.02c.14.06.26.16.34.3l.05.11zm-2.16 6.03h2.93l-1.46-3.7-1.47 3.7z",
    fill: primaryFill
  }));
};

export const FlashAuto24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashAuto24RegularIcon, 'FlashAuto24Regular');

const FlashCheckmark16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.87 1a1 1 0 00-.95.71L1.03 8.04c-.14.48.22.96.72.96h1.58l-1.28 4.39c-.38 1.31 1.33 2.2 2.18 1.13l1.3-1.64A5.5 5.5 0 0110.25 5H8.23l1-2.65A1 1 0 008.28 1h-4.4zM15 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85L9.5 11.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark16FilledIcon, 'FlashCheckmark16Filled');

const FlashCheckmark16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.91 1.71A1 1 0 013.87 1h4.4a1 1 0 01.94 1.35L8.21 5h2.04a5.47 5.47 0 00-2.88.98.5.5 0 01-.34-.66L8.27 2h-4.4L2.08 8H4a.5.5 0 01.48.64L3 13.67a.23.23 0 000 .17c.03.05.07.1.12.12.06.03.12.04.17.03.04 0 .1-.03.14-.1l1.7-2.13c.1.39.23.76.4 1.11l-1.31 1.65c-.86 1.07-2.56.18-2.18-1.13L3.33 9H1.75a.75.75 0 01-.72-.96L2.9 1.7zM15 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.85-1.85L9.5 11.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 00-.7-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark16RegularIcon, 'FlashCheckmark16Regular');

const FlashCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.18-1.82-.76-1.82H12.2l1.27-3.6c.23-.69-.28-1.4-1.01-1.4H7.21zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark20FilledIcon, 'FlashCheckmark20Filled');

const FlashCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.19 2.77c.13-.46.55-.77 1.02-.77h5.25c.73 0 1.24.71 1 1.4L12.2 7h2.57c.94 0 1.4 1.14.76 1.81l-.24.25a5.55 5.55 0 00-1.37-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.49-4.25a.06.06 0 00-.06-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c-.01.04.02.08.06.08h1.9a.5.5 0 01.5.62l-1.33 5.3v.04l.03.03.04.01h.01l.02-.02 2.89-2.95a5.57 5.57 0 00.05 1.38l-2.22 2.26c-.75.79-2.05.06-1.8-1L6.24 12H4.96c-.7 0-1.21-.68-1.02-1.36l2.25-7.87zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark20RegularIcon, 'FlashCheckmark20Regular');

const FlashCheckmark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.42 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.66 1.33.9 2.12l-.96.99a6.5 6.5 0 00-7.54 7.78l-2.56 2.65c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.57-.01c-1.2 0-2.04-1.2-1.64-2.34l3.32-9.32zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-2.15-2.35c.2.2.2.5 0 .7l-4 4a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 3.65-3.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const FlashCheckmark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark24FilledIcon, 'FlashCheckmark24Filled');

const FlashCheckmark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.42 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.66 1.33.9 2.12l-.96.99a6.53 6.53 0 00-2.04-.06l1.5-1.55h-4.4a.75.75 0 01-.71-.99L14.7 3.5H8.78l-3.26 9.16c-.06.16.06.33.23.33l2.5.01a.75.75 0 01.73.91L7.51 20.5l3.52-3.63a6.57 6.57 0 00.12 2.03l-2.56 2.65c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.57-.01c-1.2 0-2.04-1.2-1.64-2.34l3.32-9.32zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark24RegularIcon, 'FlashCheckmark24Regular');

const FlashCheckmark28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.4 2.85c.2-.51.7-.85 1.25-.85h8.52c.92 0 1.57.92 1.25 1.8l-2.1 5.7h4.84c1.18 0 1.78 1.42.96 2.26l-1.31 1.35a7.5 7.5 0 00-8.65 8.92L9.79 25.5c-1.14 1.18-3.11.12-2.76-1.48L8.7 16.5H5.92a1.92 1.92 0 01-1.79-2.6L8.41 2.84zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-2.65-2.85a.5.5 0 00-.7 0L19 22.29l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark28FilledIcon, 'FlashCheckmark28Filled');

const FlashCheckmark28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.4 2.85c.2-.51.7-.85 1.25-.85h8.52c.92 0 1.57.92 1.25 1.8l-2.1 5.7h4.84c1.18 0 1.78 1.42.96 2.26l-1.31 1.35a7.55 7.55 0 00-2.01-.08L21.77 11h-5.52a.75.75 0 01-.7-1l2.38-6.5H9.76L5.53 14.43c-.1.28.1.57.39.57h3.7a.75.75 0 01.74.91L8.5 24.34v.09l.06.05c.03.02.06.02.08.02.01 0 .03 0 .07-.04l4.3-4.44a7.6 7.6 0 00.15 2.01L9.78 25.5c-1.14 1.18-3.1.12-2.75-1.48L8.7 16.5H5.92a1.92 1.92 0 01-1.79-2.6L8.41 2.84zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-2.65-2.85a.5.5 0 00-.7 0L19 22.29l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const FlashCheckmark28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashCheckmark28RegularIcon, 'FlashCheckmark28Regular');

const FlashFlow16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.91 1.7a1 1 0 01.96-.72h4.4a1 1 0 01.94 1.35l-.99 2.65h2.03c.63 0 .98.73.59 1.22l-1.27 1.59-.23-.46a2.57 2.57 0 00-1.8-1.29h-.01a2.5 2.5 0 10-.48 3.42l.1.21.02.02.34.69-3.28 4.12c-.85 1.07-2.56.19-2.18-1.13l1.28-4.39H3.75a.75.75 0 01-.72-.96L4.91 1.7zm4 5.3a1.5 1.5 0 100 .99c.1 0 .18 0 .28.02.13.02.25.08.38.25l.98 1.96a1.58 1.58 0 001.08.75c.15.03.31.04.46.04a1.5 1.5 0 100-1c-.1 0-.18 0-.28-.02a.57.57 0 01-.38-.25l-.98-1.96a1.58 1.58 0 00-1.08-.75 2.6 2.6 0 00-.46-.04zM7.5 7a.5.5 0 110 1 .5.5 0 010-1zm6 3a.5.5 0 110 1 .5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const FlashFlow16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlow16FilledIcon, 'FlashFlow16Filled');

const FlashFlow16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.91 1.71A1 1 0 015.87 1h4.4a1 1 0 01.94 1.35L10.22 5h2.03c.63 0 .98.73.59 1.22L11.58 7.8l-.24-.47a2.94 2.94 0 00-.31-.45l.7-.88H9.5a2.51 2.51 0 00-.5-.5.5.5 0 01.03-.18L10.28 2h-4.4l-1.8 6h.97a2.5 2.5 0 001.14 1.63l-1.18 4.04a.23.23 0 000 .17c.03.05.07.1.13.12.05.03.11.04.16.03.04 0 .1-.03.15-.1l3.43-4.3.17-.13.1.21.02.02.35.7-3.29 4.13c-.85 1.07-2.56.18-2.18-1.13L5.33 9H3.75a.75.75 0 01-.72-.96L4.91 1.7zM7.5 6c.65 0 1.2.41 1.41 1 .15 0 .3 0 .46.03a1.58 1.58 0 011.08.75l.98 1.96c.13.17.25.23.38.25.1.02.18.02.27.02a1.5 1.5 0 110 1c-.14 0-.3 0-.45-.04a1.58 1.58 0 01-1.08-.75l-.98-1.96A.57.57 0 009.19 8c-.1-.02-.18-.02-.27-.02A1.5 1.5 0 117.5 6zM8 7.5a.5.5 0 10-1 0 .5.5 0 001 0zm6 3a.5.5 0 10-1 0 .5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const FlashFlow16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlow16RegularIcon, 'FlashFlow16Regular');

const FlashFlow20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l4.81-4.92-.25-.76h-.18a3 3 0 11.59-3A2.5 2.5 0 0114 10.37l1.52-1.55c.65-.68.19-1.82-.76-1.82h-2.56l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zm10.72 13.77A2.01 2.01 0 0019 14a2 2 0 00-3.73-1h-1.05a.5.5 0 01-.47-.34l-.55-1.63A1.5 1.5 0 0011.78 10H11a2 2 0 10-.27 1h1.05c.21 0 .4.14.47.34l.55 1.63V13a1.5 1.5 0 001.42 1H15a2 2 0 002.93 1.77zm-.44-.9a1 1 0 01-1.49-.86V14a1 1 0 012-.01V14a1 1 0 01-.51.87zM10 10a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const FlashFlow20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlow20FilledIcon, 'FlashFlow20Filled');

const FlashFlow20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1.01 1.4L12.2 7h2.56c.95 0 1.4 1.14.77 1.81L14 10.38a2.5 2.5 0 00-.63-.79l1.44-1.46a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.21a3 3 0 001 1.38l-1.14 4.54v.04l.03.03.04.01h.01l.03-.02 4.2-4.3c.34-.17.65-.4.9-.68h.18l.25.76-4.81 4.91c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zm12.52 12.25A2.01 2.01 0 0117 16a2 2 0 01-2-2h-.78a1.5 1.5 0 01-1.41-1l-.01-.03-.55-1.63a.5.5 0 00-.47-.34h-1.05a2 2 0 11.27-1h.78c.64 0 1.22.41 1.42 1.03l.55 1.63c.06.2.26.34.47.34h1.05a2 2 0 113.45 2.02zM17 15a1 1 0 001-1v-.01-.04a1 1 0 00-2 .05v.02a1 1 0 001 .98zm-8-4a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const FlashFlow20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlow20RegularIcon, 'FlashFlow20Regular');

const FlashFlow24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.43 2.83L4.1 12.15a1.75 1.75 0 001.65 2.34h1.57l-1.27 5.67c-.33 1.48 1.48 2.46 2.54 1.38l5.02-5.19a85.15 85.15 0 00-.55-2.12 3.74 3.74 0 01-6.56-2.48 3.75 3.75 0 017.2-1.47c.42.06.87.22 1.29.51.55.4.93.97 1.15 1.6.1.27.21.63.32 1.01l3.19-3.28c.77-.8.2-2.12-.9-2.12h-3.96l1.45-4.35c.27-.81-.33-1.65-1.18-1.65H8.6c-.53 0-1 .33-1.17.83zm4.07 8.92a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zm1.31 1a2.75 2.75 0 11.14-1.5h.3c.38 0 .79.1 1.15.36.37.26.64.64.8 1.13.2.48.45 1.46.65 2.27a89.58 89.58 0 01.35 1.44l.02.1c.08.22.18.32.25.37.07.05.16.08.28.08h.76a2.75 2.75 0 11.29 1.5h-1.05c-.38 0-.79-.1-1.15-.36a2.25 2.25 0 01-.83-1.22v-.03l-.03-.1a88.51 88.51 0 00-.34-1.42 22.53 22.53 0 00-.61-2.13c-.09-.26-.19-.36-.26-.41a.47.47 0 00-.28-.08h-.44zm7.44 5.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const FlashFlow24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlow24FilledIcon, 'FlashFlow24Filled');

const FlashFlow24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.43 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.67 1.33.9 2.12l-3.18 3.29a12.41 12.41 0 00-.57-1.57l2.26-2.34h-4.4a.75.75 0 01-.72-.99L14.7 3.5H8.78l-3.26 9.16c-.06.16.06.33.23.33h.96a3.76 3.76 0 002 2.18l-1.2 5.32 5.67-5.85a52.28 52.28 0 01.43 1.71l-5.02 5.19c-1.06 1.08-2.87.1-2.54-1.38l1.27-5.66-1.57-.01c-1.21 0-2.05-1.2-1.65-2.34l3.33-9.32zm5.38 9.92a2.75 2.75 0 11.14-1.5h.3c.38 0 .79.1 1.15.36.37.26.64.64.8 1.13.2.48.45 1.46.65 2.27a89.58 89.58 0 01.35 1.44l.02.1c.08.22.18.32.25.37.07.05.16.08.28.08h.76a2.75 2.75 0 11.29 1.5h-1.05c-.38 0-.79-.1-1.15-.36a2.25 2.25 0 01-.83-1.22v-.03l-.03-.1a88.51 88.51 0 00-.34-1.42 22.53 22.53 0 00-.61-2.13c-.09-.26-.19-.36-.26-.41a.47.47 0 00-.28-.08h-.44zm-1.31-1a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zm8.75 6.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const FlashFlow24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashFlow24RegularIcon, 'FlashFlow24Regular');

const FlashOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.86 12.56l5.29 5.3a.5.5 0 00.7-.71l-15-15a.5.5 0 10-.7.7l3.12 3.13-1.33 4.66c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l5-5.12zm3.67-3.74l-2.27 2.32L5.9 3.78l.29-1C6.32 2.3 6.74 2 7.21 2h5.25c.73 0 1.24.71 1 1.4L12.2 7h2.57c.94 0 1.4 1.14.76 1.81z",
    fill: primaryFill
  }));
};

export const FlashOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashOff20FilledIcon, 'FlashOff20Filled');

const FlashOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.27 5.98L2.15 2.85a.5.5 0 11.7-.7l15 15a.5.5 0 01-.7.7l-5.3-5.29-5 5.11c-.75.79-2.05.06-1.8-1L6.24 12H4.96c-.7 0-1.21-.68-1.02-1.36l1.33-4.66zm5.88 5.88L6.08 6.79 4.9 10.92c-.01.04.02.08.06.08h1.9a.5.5 0 01.5.62l-1.33 5.3v.04l.03.03.04.01h.01l.02-.02 5.02-5.12zm3.66-3.74l-2.26 2.3.7.72 2.28-2.32c.65-.68.18-1.82-.76-1.82H12.2l1.27-3.6c.23-.69-.28-1.4-1.01-1.4H7.21c-.47 0-.89.31-1.02.77L5.9 3.78l.81.8.44-1.53c0-.03.03-.05.06-.05h5.25c.04 0 .07.04.06.08l-1.5 4.25a.5.5 0 00.48.67h3.3l.02.04.01.05-.02.03z",
    fill: primaryFill
  }));
};

export const FlashOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashOff20RegularIcon, 'FlashOff20Regular');

const FlashOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.44 15.5l6.28 6.28a.75.75 0 001.06-1.06L3.28 2.22a.75.75 0 10-1.06 1.06L5.94 7 4.1 12.15a1.75 1.75 0 001.64 2.34h1.57l-1.27 5.67c-.33 1.48 1.5 2.46 2.55 1.38l5.85-6.04zm5.2-5.38l-3.12 3.22-9.47-9.47.37-1.04C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.66 1.33.9 2.12z",
    fill: primaryFill
  }));
};

export const FlashOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashOff24FilledIcon, 'FlashOff24Filled');

const FlashOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.94 7L2.22 3.28a.75.75 0 111.06-1.06l18.5 18.5a.75.75 0 01-1.06 1.06l-6.28-6.28-5.85 6.04c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.57-.01c-1.2 0-2.04-1.2-1.64-2.34L5.94 7zm7.44 7.44L7.1 8.17l-1.6 4.49c-.05.16.07.33.24.33l2.5.01a.75.75 0 01.73.91L7.51 20.5l5.87-6.05zm4.78-4.94l-2.7 2.78 1.06 1.06 3.13-3.22c.76-.8.2-2.12-.9-2.12h-3.96l1.45-4.35c.27-.81-.33-1.65-1.18-1.65H8.6c-.53 0-1 .33-1.18.83l-.37 1.04 1.18 1.18.55-1.55h5.93l-1.67 5.01a.75.75 0 00.7.99h4.42z",
    fill: primaryFill
  }));
};

export const FlashOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashOff24RegularIcon, 'FlashOff24Regular');

const FlashPlay20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.19-1.82-.76-1.82h-2.56l1.26-3.6c.23-.69-.28-1.4-1-1.4H7.2zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const FlashPlay20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashPlay20FilledIcon, 'FlashPlay20Filled');

const FlashPlay20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.2 2.77C6.31 2.31 6.73 2 7.2 2h5.25c.73 0 1.24.71 1.01 1.4L12.2 7h2.56c.95 0 1.4 1.14.77 1.81l-.24.25a5.54 5.54 0 00-1.38-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.5-4.25a.06.06 0 00-.07-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c0 .04.02.08.06.08h1.91a.5.5 0 01.49.62l-1.33 5.3v.04l.03.03.04.01h.01l.03-.02 2.88-2.94a5.58 5.58 0 00.05 1.37l-2.21 2.26c-.76.79-2.06.06-1.8-1L6.23 12H4.96c-.7 0-1.21-.68-1.02-1.36L6.2 2.77zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const FlashPlay20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashPlay20RegularIcon, 'FlashPlay20Regular');

const FlashSettings20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.21 2c-.47 0-.89.31-1.02.77l-2.25 7.87c-.2.68.32 1.36 1.02 1.36h1.27l-1.17 4.68c-.26 1.05 1.04 1.78 1.8 1l2.21-2.27a5.5 5.5 0 016.22-6.35l.24-.24c.65-.68.18-1.82-.76-1.82H12.2l1.27-3.6c.23-.69-.28-1.4-1.01-1.4H7.21zm4.86 9.44a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 000 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const FlashSettings20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashSettings20FilledIcon, 'FlashSettings20Filled');

const FlashSettings20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.19 2.77c.13-.46.55-.77 1.02-.77h5.25c.73 0 1.24.71 1 1.4L12.2 7h2.57c.94 0 1.4 1.14.76 1.81l-.24.25a5.55 5.55 0 00-1.37-.03l.9-.91a.06.06 0 00.01-.03v-.05a.08.08 0 00-.03-.03L14.77 8H11.5a.5.5 0 01-.47-.67l1.49-4.25a.06.06 0 00-.06-.08H7.21a.06.06 0 00-.06.05L4.9 10.92c-.01.04.02.08.06.08h1.9a.5.5 0 01.5.62l-1.33 5.3v.04l.03.03.04.01h.01l.02-.02 2.89-2.95a5.57 5.57 0 00.05 1.38l-2.22 2.26c-.75.79-2.05.06-1.8-1L6.24 12H4.96c-.7 0-1.21-.68-1.02-1.36l2.25-7.87zm5.88 8.67a2 2 0 01-1.43 2.48l-.46.12a4.7 4.7 0 000 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.29.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const FlashSettings20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashSettings20RegularIcon, 'FlashSettings20Regular');

const FlashSettings24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.42 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.66 1.33.9 2.12l-.96.99a6.5 6.5 0 00-7.54 7.78l-2.56 2.65c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.57-.01c-1.2 0-2.04-1.2-1.64-2.34l3.32-9.32zm6.86 11.15a2 2 0 01-1.44 2.5l-.59.14a5.73 5.73 0 000 1.8l.55.13a2 2 0 011.45 2.51l-.19.64c.44.38.94.7 1.49.92l.49-.52a2 2 0 012.9 0l.5.52a5.28 5.28 0 001.48-.9l-.2-.7a2 2 0 011.44-2.5l.59-.14a5.73 5.73 0 00-.01-1.8l-.54-.13a2 2 0 01-1.45-2.51l.19-.63c-.44-.39-.94-.7-1.49-.93l-.49.52a2 2 0 01-2.9 0l-.5-.52c-.54.22-1.04.53-1.48.91l.2.69zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19z",
    fill: primaryFill
  }));
};

export const FlashSettings24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashSettings24FilledIcon, 'FlashSettings24Filled');

const FlashSettings24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.42 2.83C7.6 2.33 8.07 2 8.6 2h6.46c.85 0 1.45.84 1.18 1.65L14.8 8h3.96c1.1 0 1.66 1.33.9 2.12l-.96.99a6.53 6.53 0 00-2.04-.06l1.5-1.55h-4.4a.75.75 0 01-.71-.99L14.7 3.5H8.78l-3.26 9.16c-.06.16.06.33.23.33l2.5.01a.75.75 0 01.73.91L7.51 20.5l3.52-3.63a6.57 6.57 0 00.12 2.03l-2.56 2.65c-1.06 1.08-2.88.1-2.55-1.38l1.27-5.66-1.57-.01c-1.2 0-2.04-1.2-1.64-2.34l3.32-9.32zm6.86 11.15a2 2 0 01-1.44 2.5l-.59.14a5.73 5.73 0 000 1.8l.55.13a2 2 0 011.45 2.51l-.19.64c.44.38.94.7 1.49.92l.49-.52a2 2 0 012.9 0l.5.52a5.28 5.28 0 001.48-.9l-.2-.7a2 2 0 011.44-2.5l.59-.14a5.73 5.73 0 00-.01-1.8l-.54-.13a2 2 0 01-1.45-2.51l.19-.63c-.44-.39-.94-.7-1.49-.93l-.49.52a2 2 0 01-2.9 0l-.5-.52c-.54.22-1.04.53-1.48.91l.2.69zM17.5 19c-.8 0-1.45-.67-1.45-1.5S16.7 16 17.5 16c.8 0 1.45.67 1.45 1.5S18.3 19 17.5 19z",
    fill: primaryFill
  }));
};

export const FlashSettings24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashSettings24RegularIcon, 'FlashSettings24Regular');

const Flashlight16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 1c.28 0 .5.22.5.5v1a.5.5 0 11-1 0v-1c0-.28.22-.5.5-.5zm2.65.15a.5.5 0 11.7.7l-1 1a.5.5 0 11-.7-.7l1-1zm-7.71.7a1.5 1.5 0 012.12 0l5.59 5.59a1.5 1.5 0 010 2.12l-.94.94L5.5 2.8l.94-.95zM5 3.71v3.58l-3.65 3.65a1.5 1.5 0 000 2.12l1.59 1.59a1.5 1.5 0 002.12 0L8.71 11h3.58L5 3.7zm1.85 6.14l-1 1a.5.5 0 01-.7-.7l1-1a.5.5 0 11.7.7zM14.5 5h-1a.5.5 0 010-1h1a.5.5 0 110 1z",
    fill: primaryFill
  }));
};

export const Flashlight16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flashlight16FilledIcon, 'Flashlight16Filled');

const Flashlight16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 1.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zm2.85-.35a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l1-1a.5.5 0 000-.7zm-8 8.7a.5.5 0 00-.7-.7l-1 1a.5.5 0 10.7.7l1-1zm1.71-8a1.5 1.5 0 00-2.12 0l-1.3 1.3A.5.5 0 005 3.5v3.8l-3.65 3.64a1.5 1.5 0 000 2.12l1.59 1.59a1.5 1.5 0 002.12 0L8.71 11h3.79a.5.5 0 00.35-.15l1.3-1.29a1.5 1.5 0 000-2.12L8.56 1.85zm-1.41.71c.2-.2.5-.2.7 0l5.59 5.59c.2.2.2.5 0 .7l-.94.94L6.2 3.5l.95-.94zM6 4.71L11.3 10H8.5a.5.5 0 00-.35.15l-3.8 3.79a.5.5 0 01-.7 0l-1.59-1.59a.5.5 0 010-.7l3.8-3.8A.5.5 0 006 7.5V4.7zm7.5.29h1a.5.5 0 000-1h-1a.5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const Flashlight16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flashlight16RegularIcon, 'Flashlight16Regular');

const Flashlight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.96 1.17c.27 0 .5.22.5.5v.83a.5.5 0 11-1 0v-.83c0-.28.22-.5.5-.5zm3.9.98c.19.2.19.5 0 .7l-1.5 1.5a.5.5 0 11-.71-.7l1.5-1.5c.2-.2.5-.2.7 0zM7 5.2v2.58l5.2 5.2h2.6L7 5.22zm8.7 7.29l1.1-1.09a2 2 0 000-2.82L11.4 3.2a2 2 0 00-2.82 0L7.5 4.29l8.2 8.2zm-4.7.7L6.8 9l-4.1 4.09a2 2 0 000 2.82L4.1 17.3a2 2 0 002.82 0L11 13.21zm-3.15-.35l-1 1a.5.5 0 01-.7-.7l1-1a.5.5 0 11.7.7zM17 6.05c0-.29.22-.5.5-.5h.83a.5.5 0 110 1h-.83a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const Flashlight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flashlight20FilledIcon, 'Flashlight20Filled');

const Flashlight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.46 1.67a.5.5 0 00-1 0v.83a.5.5 0 101 0v-.83zm3.4 1.18a.5.5 0 10-.71-.7l-1.5 1.5a.5.5 0 00.7.7l1.5-1.5zm-10 10a.5.5 0 00-.71-.7l-1 1a.5.5 0 10.7.7l1-1zM7 5v3.8l-4.3 4.29a2 2 0 000 2.82L4.1 17.3a2 2 0 002.82 0l4.3-4.3H15a.5.5 0 00.35-.14l1.44-1.44a2 2 0 000-2.82L11.41 3.2a2 2 0 00-2.82 0L7.15 4.65A.5.5 0 007 5zM9.3 3.9a1 1 0 011.4 0L16.1 9.3a1 1 0 010 1.42L15 11.79 8.2 5l1.1-1.08zM8 6.21L13.8 12h-2.6L8 8.8V6.2zm-.5 3.5l2.8 2.79-4.1 4.09a1 1 0 01-1.4 0L3.4 15.2a1 1 0 010-1.42L7.5 9.71zm10-4.17a.5.5 0 000 1h.83a.5.5 0 000-1h-.83z",
    fill: primaryFill
  }));
};

export const Flashlight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flashlight20RegularIcon, 'Flashlight20Regular');

const Flashlight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 1.25c.41 0 .75.34.75.75v1A.75.75 0 0116 3V2c0-.41.34-.75.75-.75zm3.72 1.22a.75.75 0 111.06 1.06l-2 2a.75.75 0 11-1.06-1.06l2-2zM8.25 6.31V9.2l6.56 6.56h2.88L8.25 6.31zM19.06 15l1.41-1.4c.88-.89.88-2.31 0-3.2l-6.88-6.87a2.25 2.25 0 00-3.18 0L9 4.93 19.06 15zM13 16.06L7.94 11l-4.91 4.9c-.88.89-.88 2.31 0 3.2l1.88 1.87c.88.88 2.3.88 3.18 0l4.91-4.9zm-3.47-1.59c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 11-1.06-1.06l1.5-1.5c.3-.3.77-.3 1.06 0zM22 8h-1a.75.75 0 010-1.5h1A.75.75 0 0122 8z",
    fill: primaryFill
  }));
};

export const Flashlight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flashlight24FilledIcon, 'Flashlight24Filled');

const Flashlight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 2A.75.75 0 0016 2v1a.75.75 0 001.5 0V2zm4.03.47a.75.75 0 00-1.06 0l-2 2a.75.75 0 001.06 1.06l2-2c.3-.3.3-.77 0-1.06zM8.03 17.03l1.5-1.5a.75.75 0 10-1.06-1.06l-1.5 1.5a.75.75 0 101.06 1.06zM8.25 6v4.69L3.03 15.9c-.88.88-.88 2.3 0 3.18l1.88 1.88c.88.88 2.3.88 3.18 0l5.22-5.22H18c.2 0 .39-.08.53-.22l1.94-1.94c.88-.88.88-2.3 0-3.18l-6.88-6.88a2.25 2.25 0 00-3.18 0L8.47 5.47a.75.75 0 00-.22.53zm3.22-1.4c.3-.3.77-.3 1.06 0l6.88 6.87c.3.3.3.77 0 1.06L18 13.93 10.06 6l1.41-1.4zM9.75 7.8l6.44 6.44H13.3l-3.56-3.56V7.8zM9 12.06L11.94 15l-4.91 4.9c-.3.3-.77.3-1.06 0l-1.88-1.87a.75.75 0 010-1.06L9 12.07zM21 8h1a.75.75 0 000-1.5h-1A.75.75 0 0021 8z",
    fill: primaryFill
  }));
};

export const Flashlight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flashlight24RegularIcon, 'Flashlight24Regular');

const FlashlightOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l15 15a.5.5 0 00.7-.7l-15-15zM16.8 11.4l-1.08 1.09L7.5 4.3l1.09-1.1a2 2 0 012.82 0L16.8 8.6a2 2 0 010 2.82zM6.8 9L11 13.2l-4.09 4.1a2 2 0 01-2.82 0L2.7 15.9a2 2 0 010-2.82L6.79 9zm.06 4.85l1-1a.5.5 0 10-.7-.7l-1 1a.5.5 0 10.7.7z",
    fill: primaryFill
  }));
};

export const FlashlightOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightOff20FilledIcon, 'FlashlightOff20Filled');

const FlashlightOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L7 7.71v1.08l-4.3 4.3a2 2 0 000 2.82L4.1 17.3a2 2 0 002.82 0l4.3-4.29h1.08l4.86 4.85a.5.5 0 00.7-.7l-15-15zm12.67 9.13l-1.06 1.06.65.65a.5.5 0 00.24-.14l1.44-1.44a2 2 0 000-2.82L11.41 3.2a2 2 0 00-2.82 0L7.15 4.65a.5.5 0 00-.14.24l.65.65L9.3 3.91a1 1 0 011.42 0l5.38 5.38a1 1 0 010 1.42l-.57.57zm-7.67 1.57a.5.5 0 10-.7-.7l-1 1a.5.5 0 10.7.7l1-1zM7.5 9.71l2.8 2.79-4.1 4.09a1 1 0 01-1.4 0L3.4 15.2a1 1 0 010-1.42L7.5 9.71z",
    fill: primaryFill
  }));
};

export const FlashlightOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightOff20RegularIcon, 'FlashlightOff20Regular');

const FlashlightOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 10-1.06 1.06l18.5 18.5a.75.75 0 001.06-1.06L3.28 2.22zM19.06 15l1.4-1.4c.89-.89.89-2.31 0-3.2L13.6 3.54a2.25 2.25 0 00-3.18 0L9 4.93 19.06 15zM13 16.06L7.94 11l-4.91 4.9c-.88.89-.88 2.31 0 3.2l1.88 1.87c.88.88 2.3.88 3.18 0l4.91-4.9zm-3.47-.53l-1.5 1.5a.75.75 0 11-1.06-1.06l1.5-1.5a.75.75 0 111.06 1.06z",
    fill: primaryFill
  }));
};

export const FlashlightOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightOff24FilledIcon, 'FlashlightOff24Filled');

const FlashlightOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.53 14.47c.3.3.3.77 0 1.06l-1.5 1.5a.75.75 0 01-1.06-1.06l1.5-1.5c.3-.3.77-.3 1.06 0zM3.28 2.22a.75.75 0 10-1.06 1.06l6.03 6.03v1.38L3.03 15.9c-.88.88-.88 2.3 0 3.18l1.88 1.88c.88.88 2.3.88 3.18 0l5.22-5.22h1.38l6.03 6.03a.75.75 0 001.06-1.06L3.28 2.22zM9 12.06L11.94 15l-4.91 4.9c-.3.3-.77.3-1.06 0l-1.88-1.87a.75.75 0 010-1.06L9 12.07zm8.84 2.03l1.57-1.56c.3-.3.3-.77 0-1.06l-6.88-6.88a.75.75 0 00-1.06 0L9.9 6.16 8.84 5.09l1.57-1.56c.88-.88 2.3-.88 3.18 0l6.88 6.88c.88.88.88 2.3 0 3.18l-1.57 1.57-1.06-1.07z",
    fill: primaryFill
  }));
};

export const FlashlightOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlashlightOff24RegularIcon, 'FlashlightOff24Regular');

const FlipHorizontal16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.88 12.65a.75.75 0 01-.63.35h-4.5a.75.75 0 01-.75-.75v-9.5a.75.75 0 011.43-.32l4.5 9.5c.1.23.1.5-.05.72zM10.5 6.1v5.41h2.56L10.5 6.09zM1.5 13a.5.5 0 01-.45-.72l5-10A.5.5 0 017 2.5v10a.5.5 0 01-.5.5h-5z",
    fill: primaryFill
  }));
};

export const FlipHorizontal16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal16FilledIcon, 'FlipHorizontal16Filled');

const FlipHorizontal16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.93 12.76a.5.5 0 01-.43.24h-5a.5.5 0 01-.5-.5v-10a.5.5 0 01.95-.22l5 10a.5.5 0 01-.02.48zM10 4.62V12h3.7L10 4.62zM1.5 13a.5.5 0 01-.45-.72l5-10A.5.5 0 017 2.5v10a.5.5 0 01-.5.5h-5z",
    fill: primaryFill
  }));
};

export const FlipHorizontal16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal16RegularIcon, 'FlipHorizontal16Regular');

const FlipHorizontal20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.88 15.66a.75.75 0 01-.63.34h-5.5a.75.75 0 01-.75-.75V2.75a.75.75 0 011.44-.3l5.5 12.5c.1.23.08.5-.06.71zM12.5 6.32v8.18h3.6l-3.6-8.18zM2.5 16a.5.5 0 01-.45-.71l6-13A.5.5 0 019 2.5v13a.5.5 0 01-.5.5h-6z",
    fill: primaryFill
  }));
};

export const FlipHorizontal20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal20FilledIcon, 'FlipHorizontal20Filled');

const FlipHorizontal20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.92 15.77a.5.5 0 01-.42.23h-6a.5.5 0 01-.5-.5v-13a.5.5 0 01.95-.2l6 13a.5.5 0 01-.03.47zM12 4.77V15h4.72L12 4.78zM2.5 16a.5.5 0 01-.45-.71l6-13A.5.5 0 019 2.5v13a.5.5 0 01-.5.5h-6z",
    fill: primaryFill
  }));
};

export const FlipHorizontal20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal20RegularIcon, 'FlipHorizontal20Regular');

const FlipHorizontal24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.84 19.55A1 1 0 0121 20h-7a1 1 0 01-1-1V3a1 1 0 011.92-.4l7 16a1 1 0 01-.08.95zM15 7.78V18h4.47L15 7.78zM2.5 20a.5.5 0 01-.45-.71l8-17a.5.5 0 01.95.21v17a.5.5 0 01-.5.5h-8z",
    fill: primaryFill
  }));
};

export const FlipHorizontal24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal24FilledIcon, 'FlipHorizontal24Filled');

const FlipHorizontal24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.88 19.66a.75.75 0 01-.63.34h-7.5a.75.75 0 01-.75-.75V2.75a.75.75 0 011.43-.31l7.5 16.5c.1.23.09.5-.05.72zM14.5 6.2V18.5h5.59L14.5 6.21zM2.5 20a.5.5 0 01-.45-.71l8-17a.5.5 0 01.95.21v17a.5.5 0 01-.5.5h-8z",
    fill: primaryFill
  }));
};

export const FlipHorizontal24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal24RegularIcon, 'FlipHorizontal24Regular');

const FlipHorizontal28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.84 23.54A1 1 0 0125 24h-9a1 1 0 01-1-1V3a1 1 0 011.91-.41l9 20a1 1 0 01-.07.95zM17 7.66V22h6.45L17 7.66zM2.75 24a.75.75 0 01-.68-1.07l9.5-20.5a.75.75 0 011.43.32v20.5c0 .41-.34.75-.75.75h-9.5z",
    fill: primaryFill
  }));
};

export const FlipHorizontal28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal28FilledIcon, 'FlipHorizontal28Filled');

const FlipHorizontal28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.88 23.65a.75.75 0 01-.63.35h-9.5a.75.75 0 01-.75-.75V2.75a.75.75 0 011.43-.32l9.5 20.5c.1.24.09.5-.05.72zM16.5 6.15V22.5h7.58L16.5 6.15zM2.75 24a.75.75 0 01-.68-1.07l9.5-20.5a.75.75 0 011.43.32v20.5c0 .41-.34.75-.75.75h-9.5z",
    fill: primaryFill
  }));
};

export const FlipHorizontal28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal28RegularIcon, 'FlipHorizontal28Regular');

const FlipHorizontal32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M29.8 27.43c-.23.36-.63.57-1.05.57h-10.5c-.69 0-1.25-.56-1.25-1.25V3.25a1.25 1.25 0 012.4-.51l10.5 23.5c.16.39.13.83-.1 1.19zM19.5 9.11V25.5h7.32L19.5 9.11zM3 28a1 1 0 01-.9-1.42l11-24A1 1 0 0115 3v24a1 1 0 01-1 1H3z",
    fill: primaryFill
  }));
};

export const FlipHorizontal32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal32FilledIcon, 'FlipHorizontal32Filled');

const FlipHorizontal32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M29.84 27.54A1 1 0 0129 28H18a1 1 0 01-1-1V3a1 1 0 011.9-.42l11 24a1 1 0 01-.06.96zM19 7.58V26h8.44L19 7.58zM3 28a1 1 0 01-.9-1.42l11-24A1 1 0 0115 3v24a1 1 0 01-1 1H3z",
    fill: primaryFill
  }));
};

export const FlipHorizontal32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal32RegularIcon, 'FlipHorizontal32Regular');

const FlipHorizontal48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M43.76 39.31a1.5 1.5 0 01-1.26.69h-15a1.5 1.5 0 01-1.5-1.5v-33a1.5 1.5 0 012.87-.62l15 33c.2.46.17 1-.1 1.43zM29 12.43V37h11.17L29 12.43zM5 40a1 1 0 01-.9-1.43l16-34A1 1 0 0122 5v34a1 1 0 01-1 1H5z",
    fill: primaryFill
  }));
};

export const FlipHorizontal48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal48FilledIcon, 'FlipHorizontal48Filled');

const FlipHorizontal48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M43.8 39.42c-.23.36-.62.58-1.05.58h-15.5c-.69 0-1.25-.56-1.25-1.25V5.25a1.25 1.25 0 012.38-.52l15.5 33.5c.18.38.15.83-.08 1.2zm-15.3-28.5V37.5h12.3L28.5 10.93zM5 40a1 1 0 01-.9-1.43l16-34A1 1 0 0122 5v34a1 1 0 01-1 1H5z",
    fill: primaryFill
  }));
};

export const FlipHorizontal48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipHorizontal48RegularIcon, 'FlipHorizontal48Regular');

const FlipVertical16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.65 1.12c.22.13.35.37.35.63v4.5c0 .41-.34.75-.75.75h-9.5a.75.75 0 01-.32-1.43l9.5-4.5c.23-.1.5-.1.72.05zM6.1 5.5h5.41V2.94L6.09 5.5zm6.91 9a.5.5 0 01-.72.45l-10-5A.5.5 0 012.5 9h10c.28 0 .5.22.5.5v5z",
    fill: primaryFill
  }));
};

export const FlipVertical16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical16FilledIcon, 'FlipVertical16Filled');

const FlipVertical16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.76 1.07c.15.1.24.26.24.43v5a.5.5 0 01-.5.5h-10a.5.5 0 01-.22-.95l10-5a.5.5 0 01.48.02zM4.62 6H12V2.3L4.62 6zM13 14.5a.5.5 0 01-.72.45l-10-5A.5.5 0 012.5 9h10c.28 0 .5.22.5.5v5z",
    fill: primaryFill
  }));
};

export const FlipVertical16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical16RegularIcon, 'FlipVertical16Regular');

const FlipVertical20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.66 2.12c.21.14.34.38.34.63v5.5c0 .41-.34.75-.75.75H2.75a.75.75 0 01-.3-1.44l12.5-5.5c.23-.1.5-.08.71.06zM6.32 7.5h8.18V3.9L6.32 7.5zm9.68 10a.5.5 0 01-.71.45l-13-6A.5.5 0 012.5 11h13c.28 0 .5.22.5.5v6z",
    fill: primaryFill
  }));
};

export const FlipVertical20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical20FilledIcon, 'FlipVertical20Filled');

const FlipVertical20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.77 2.08c.14.1.23.25.23.42v6a.5.5 0 01-.5.5h-13a.5.5 0 01-.2-.95l13-6a.5.5 0 01.47.03zM4.77 8H15V3.28L4.78 8zM16 17.5a.5.5 0 01-.71.45l-13-6A.5.5 0 012.5 11h13c.28 0 .5.22.5.5v6z",
    fill: primaryFill
  }));
};

export const FlipVertical20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical20RegularIcon, 'FlipVertical20Regular');

const FlipVertical24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.55 2.16A1 1 0 0120 3v7a1 1 0 01-1 1H3a1 1 0 01-.4-1.92l16-7a1 1 0 01.95.08zM7.78 9H18V4.53L7.78 9zM20 21.5a.5.5 0 01-.71.45l-17-8A.5.5 0 012.5 13h17c.28 0 .5.22.5.5v8z",
    fill: primaryFill
  }));
};

export const FlipVertical24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical24FilledIcon, 'FlipVertical24Filled');

const FlipVertical24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.66 2.12c.21.14.34.38.34.63v7.5c0 .41-.34.75-.75.75H2.75a.75.75 0 01-.31-1.43l16.5-7.5c.23-.1.5-.09.72.05zM6.2 9.5H18.5V3.91L6.21 9.5zM20 21.5a.5.5 0 01-.71.45l-17-8A.5.5 0 012.5 13h17c.28 0 .5.22.5.5v8z",
    fill: primaryFill
  }));
};

export const FlipVertical24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical24RegularIcon, 'FlipVertical24Regular');

const FlipVertical28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.54 2.16A1 1 0 0124 3v9a1 1 0 01-1 1H3a1 1 0 01-.41-1.91l20-9a1 1 0 01.95.07zM7.66 11H22V4.55L7.66 11zM24 25.25a.75.75 0 01-1.07.68l-20.5-9.5A.75.75 0 012.75 15h20.5c.41 0 .75.34.75.75v9.5z",
    fill: primaryFill
  }));
};

export const FlipVertical28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical28FilledIcon, 'FlipVertical28Filled');

const FlipVertical28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.65 2.12c.22.14.35.37.35.63v9.5c0 .41-.34.75-.75.75H2.75a.75.75 0 01-.32-1.43l20.5-9.5c.24-.1.5-.09.72.05zM6.15 11.5H22.5V3.92L6.15 11.5zM24 25.25a.75.75 0 01-1.07.68l-20.5-9.5A.75.75 0 012.75 15h20.5c.41 0 .75.34.75.75v9.5z",
    fill: primaryFill
  }));
};

export const FlipVertical28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical28RegularIcon, 'FlipVertical28Regular');

const FlipVertical32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M27.43 2.2c.36.23.57.63.57 1.05v10.5c0 .69-.56 1.25-1.25 1.25H3.25a1.25 1.25 0 01-.51-2.4l23.5-10.5c.39-.16.83-.13 1.19.1zM9.11 12.5H25.5V5.18L9.11 12.5zM28 29a1 1 0 01-1.42.9l-24-11A1 1 0 013 17h24a1 1 0 011 1v11z",
    fill: primaryFill
  }));
};

export const FlipVertical32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical32FilledIcon, 'FlipVertical32Filled');

const FlipVertical32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M27.54 2.16A1 1 0 0128 3v11a1 1 0 01-1 1H3a1 1 0 01-.42-1.9l24-11a1 1 0 01.96.06zM7.58 13H26V4.56L7.58 13zM28 29a1 1 0 01-1.42.9l-24-11A1 1 0 013 17h24a1 1 0 011 1v11z",
    fill: primaryFill
  }));
};

export const FlipVertical32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical32RegularIcon, 'FlipVertical32Regular');

const FlipVertical48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M39.31 4.24c.43.27.69.75.69 1.26v15c0 .83-.67 1.5-1.5 1.5h-33a1.5 1.5 0 01-.62-2.87l33-15c.46-.2 1-.17 1.43.1zM12.42 19H37V7.83L12.42 19zM40 43a1 1 0 01-1.43.9l-34-16A1 1 0 015 26h34a1 1 0 011 1v16z",
    fill: primaryFill
  }));
};

export const FlipVertical48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical48FilledIcon, 'FlipVertical48Filled');

const FlipVertical48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M39.42 4.2c.36.23.58.62.58 1.05v15.5c0 .69-.56 1.25-1.25 1.25H5.25a1.25 1.25 0 01-.53-2.38l33.5-15.5c.4-.18.84-.15 1.2.08zm-28.5 15.3H37.5V7.2L10.93 19.5zM40 43a1 1 0 01-1.43.9l-34-16A1 1 0 015 26h34a1 1 0 011 1v16z",
    fill: primaryFill
  }));
};

export const FlipVertical48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlipVertical48RegularIcon, 'FlipVertical48Regular');

const Flow16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5.5a2.5 2.5 0 01-4.95.5h-.32a1 1 0 00-.98.8l-.52 2.6A2 2 0 016.27 11h-.32a2.5 2.5 0 110-1h.32a1 1 0 00.98-.8l.52-2.6A2 2 0 019.73 5h.32a2.5 2.5 0 014.95.5z",
    fill: primaryFill
  }));
};

export const Flow16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flow16FilledIcon, 'Flow16Filled');

const Flow16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5.5a2.5 2.5 0 01-4.95.5h-.32a1 1 0 00-.98.8l-.52 2.6A2 2 0 016.27 11h-.32a2.5 2.5 0 110-1h.32a1 1 0 00.98-.8l.52-2.6A2 2 0 019.73 5h.32a2.5 2.5 0 014.95.5zm-1 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM3.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: primaryFill
  }));
};

export const Flow16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flow16RegularIcon, 'Flow16Regular');

const Flow20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 4a3 3 0 00-2.96 2.5A2.5 2.5 0 009.73 8.6l-.44 2.66a1.5 1.5 0 01-1.33 1.24 3 3 0 100 1 2.5 2.5 0 002.31-2.08l.44-2.66a1.5 1.5 0 011.33-1.24A3 3 0 1015 4z",
    fill: primaryFill
  }));
};

export const Flow20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flow20FilledIcon, 'Flow20Filled');

const Flow20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5a2 2 0 100 4 2 2 0 000-4zm-2.96 1.5a3 3 0 110 1 1.5 1.5 0 00-1.33 1.25l-.44 2.66a2.5 2.5 0 01-2.31 2.09 3 3 0 110-1 1.5 1.5 0 001.33-1.25l.44-2.66a2.5 2.5 0 012.31-2.09zM5 11a2 2 0 100 4 2 2 0 000-4z",
    fill: primaryFill
  }));
};

export const Flow20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flow20RegularIcon, 'Flow20Regular');

const Flowchart20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.5C3 3.67 3.67 3 4.5 3h2C7.33 3 8 3.67 8 4.5v2C8 7.33 7.33 8 6.5 8H6v3.84a1 1 0 01.2.16L8 13.8a1 1 0 01.16.2H12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 01-1.5-1.5V15H8.16a1 1 0 01-.16.2L6.2 17a1 1 0 01-1.4 0L3 15.2a1 1 0 010-1.4L4.8 12a1 1 0 01.2-.16V8h-.5A1.5 1.5 0 013 6.5v-2z",
    fill: primaryFill
  }));
};

export const Flowchart20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flowchart20FilledIcon, 'Flowchart20Filled');

const Flowchart20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v2C3 7.33 3.67 8 4.5 8H5v3.84a1 1 0 00-.2.16L3 13.8a1 1 0 000 1.4L4.8 17a1 1 0 001.4 0L8 15.2a1 1 0 00.16-.2H12v.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v.5H8.16a1 1 0 00-.16-.2L6.2 12a1 1 0 00-.2-.16V8h.5C7.33 8 8 7.33 8 6.5v-2C8 3.67 7.33 3 6.5 3h-2zM4 4.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2zm-.3 10l1.8-1.8 1.8 1.8-1.8 1.8-1.8-1.8zm9.8-1.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const Flowchart20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flowchart20RegularIcon, 'Flowchart20Regular');

const Flowchart24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.25C3 4 4 3 5.25 3h2.5C9 3 10 4 10 5.25v2.5C10 9 9 10 7.75 10h-.5v3.71c.05.03.1.07.13.12l2.8 2.79.11.13H14v-.5c0-1.24 1.01-2.25 2.25-2.25h2.5c1.24 0 2.25 1 2.25 2.25v2.5C21 20 20 21 18.75 21h-2.5C15.01 21 14 20 14 18.75v-.5H10.3c-.03.05-.07.1-.12.13l-2.79 2.8c-.48.48-1.28.48-1.76 0l-2.8-2.8a1.25 1.25 0 010-1.76l2.8-2.8.13-.11V10h-.5C4 10 3 9 3 7.74v-2.5z",
    fill: primaryFill
  }));
};

export const Flowchart24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flowchart24FilledIcon, 'Flowchart24Filled');

const Flowchart24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 3C4 3 3 4 3 5.25v2.5C3 9 4 10 5.25 10h.5v3.71c-.05.03-.1.07-.13.12l-2.8 2.79a1.25 1.25 0 000 1.77l2.8 2.79c.48.49 1.28.49 1.76 0l2.8-2.8.11-.13H14v.5C14 20 15.01 21 16.25 21h2.5c1.24 0 2.25-1 2.25-2.25v-2.5c0-1.24-1-2.25-2.25-2.25h-2.5C15.01 14 14 15 14 16.25v.5H10.3c-.03-.05-.07-.09-.12-.13l-2.79-2.8a1.26 1.26 0 00-.13-.11v-3.7h.5C9 10 10 9 10 7.74v-2.5C10 4 9 3 7.75 3h-2.5zM4.5 5.25c0-.42.33-.75.75-.75h2.5c.42 0 .75.33.75.75v2.5c0 .42-.33.75-.75.75h-2.5a.75.75 0 01-.75-.75v-2.5zM4.06 17.5l2.44-2.44 2.44 2.44-2.44 2.44-2.44-2.44zm12.2-2h2.49c.41 0 .75.34.75.75v2.5c0 .42-.34.75-.75.75h-2.5a.75.75 0 01-.75-.75v-2.5c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const Flowchart24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Flowchart24RegularIcon, 'Flowchart24Regular');

const FlowchartCircle20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm4-3.5v2c0 .28.22.5.5.5H7v1.8l-1.35 1.35a.5.5 0 000 .7l1.5 1.5c.2.2.5.2.7 0L9.21 13H11v.5c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v.5H9.2L8 10.8V9h.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const FlowchartCircle20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartCircle20FilledIcon, 'FlowchartCircle20Filled');

const FlowchartCircle20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5H8v1.8L9.2 12H11v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5V13H9.2l-1.35 1.35a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 010-.7L7 10.79V9h-.5a.5.5 0 01-.5-.5v-2zM2 10a8 8 0 1116 0 8 8 0 01-16 0zm8-7a7 7 0 100 14 7 7 0 000-14z",
    fill: primaryFill
  }));
};

export const FlowchartCircle20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartCircle20RegularIcon, 'FlowchartCircle20Regular');

const FlowchartCircle24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 12a10 10 0 1120 0 10 10 0 01-20 0zm4.5-4.75v2.5c0 .41.34.75.75.75h.5v2.69l-1.78 1.78c-.3.3-.3.77 0 1.06l2 2c.3.3.77.3 1.06 0l1.78-1.78h2.69v.5c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v.5h-2.69l-1.56-1.56V10.5h.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75z",
    fill: primaryFill
  }));
};

export const FlowchartCircle24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartCircle24FilledIcon, 'FlowchartCircle24Filled');

const FlowchartCircle24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.25 6.5a.75.75 0 00-.75.75v2.5c0 .41.34.75.75.75h.5v2.69l-1.78 1.78c-.3.3-.3.77 0 1.06l2 2c.3.3.77.3 1.06 0l1.78-1.78h2.69v.5c0 .41.34.75.75.75h2.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v.5h-2.69l-1.56-1.56V10.5h.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5zM2 12a10 10 0 1120 0 10 10 0 01-20 0zm10-8.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17z",
    fill: primaryFill
  }));
};

export const FlowchartCircle24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FlowchartCircle24RegularIcon, 'FlowchartCircle24Regular');

const Fluent20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.05a.5.5 0 01.44 0l5 2.5a.5.5 0 010 .9l-4.1 2.05 4.1 2.05a.5.5 0 010 .9L11 12.8v4.69a.5.5 0 01-.76.43l-5-3A.5.5 0 015 14.5V5c0-.19.1-.36.28-.45l5-2.5z",
    fill: primaryFill
  }));
};

export const Fluent20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent20FilledIcon, 'Fluent20Filled');

const Fluent20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.28 2.05a.5.5 0 01.44 0l5 2.5a.5.5 0 010 .9l-4.1 2.05 4.1 2.05a.5.5 0 010 .9L11 12.8v4.69a.5.5 0 01-.76.43l-5-3A.5.5 0 015 14.5V5c0-.19.1-.36.28-.45l5-2.5zM11 11.7L14.38 10 11 8.3v3.4zm-1-3.38L6.62 10 10 11.7V8.3zm0-1.62V3.31L6.62 5 10 6.7zm-4-.88v3.38L9.38 7.5 6 5.8zm0 5v3.4l4 2.4v-3.8l-4-2zm5-7.5v3.38L14.38 5 11 3.3z",
    fill: primaryFill
  }));
};

export const Fluent20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent20RegularIcon, 'Fluent20Regular');

const Fluent24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.41 2.5h.13l.11.02.07.03 6 3a.5.5 0 010 .9L13.62 9l5.1 2.55a.5.5 0 010 .9l-5.76 2.84.04 5.7a.5.5 0 01-.75.44l-6-3.5A.5.5 0 016 17.5V5.96l.02-.1.02-.06.01-.03a.5.5 0 01.06-.09l.07-.06.07-.05 6.08-3.04.08-.02z",
    fill: primaryFill
  }));
};

export const Fluent24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent24FilledIcon, 'Fluent24Filled');

const Fluent24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.41 2.5h.13l.11.02.07.03 6 3a.5.5 0 010 .9L13.62 9l5.1 2.55a.5.5 0 010 .9l-5.76 2.84.04 5.7a.5.5 0 01-.75.44l-6-3.5A.5.5 0 016 17.5V5.96l.02-.1.02-.06.01-.03a.5.5 0 01.06-.09l.07-.06.07-.05 6.08-3.04.08-.02zM7 12.82v4.4l5 2.92-.04-4.82L7 12.81zm.62-.8L12 14.2V9.83L7.61 12zm5.37-2.2v4.34L17.39 12l-4.39-2.2zM7 11.19l4.37-2.17L7 6.82v4.37zm5-7.38l-4.38 2.2 4.37 2.2v-4.4zm1 4.38L17.37 6 13 3.8v4.4z",
    fill: primaryFill
  }));
};

export const Fluent24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent24RegularIcon, 'Fluent24Regular');

const Fluent32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.55 2.1a1 1 0 01.9 0l8 4a1 1 0 010 1.8L19.24 11l6.2 3.1a1 1 0 010 1.8L18 19.61V29a1 1 0 01-1.49.87l-8-4.5A1 1 0 018 24.5V7a1 1 0 01.55-.9l8-4z",
    fill: primaryFill
  }));
};

export const Fluent32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent32FilledIcon, 'Fluent32Filled');

const Fluent32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.55 2.1a1 1 0 01.9 0l8 4a1 1 0 010 1.8L19.24 11l6.2 3.1a1 1 0 010 1.8L18 19.61V29a1 1 0 01-1.49.87l-8-4.5A1 1 0 018 24.5V7a1 1 0 01.55-.9l8-4zM18 17.39L22.76 15 18 12.62v4.76zm-2-8V4.62L11.24 7 16 9.38zm-6-.76v4.76L14.76 11 10 8.62zm0 8v7.3l6 3.37v-7.67l-6-3zm6 .76v-4.76L11.24 15 16 17.38zm2-12.76v4.76L22.76 7 18 4.62z",
    fill: primaryFill
  }));
};

export const Fluent32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent32RegularIcon, 'Fluent32Regular');

const Fluent48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.36 5h-.21l-.13.02-.2.05-12.2 6.1-.17.11-.16.16v.01l-.16.23-.03.07-.05.15-.05.23v23.12c0 .44.24.85.62 1.08l12 7c.84.48 1.89-.12 1.88-1.1l-.07-11.26 11.37-5.6c.93-.46.93-1.78 0-2.24l-9.75-4.88 9.76-4.89c.92-.46.92-1.77 0-2.23l-12.01-6-.18-.08-.26-.05z",
    fill: primaryFill
  }));
};

export const Fluent48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent48FilledIcon, 'Fluent48Filled');

const Fluent48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.36 5h-.21l-.13.02-.2.05-12.2 6.1-.17.11-.16.16v.01l-.16.23-.03.07-.05.15-.05.23v23.12c0 .44.24.85.62 1.08l12 7c.84.48 1.89-.12 1.88-1.1l-.07-11.26 11.37-5.6c.93-.46.93-1.78 0-2.24l-9.75-4.88 9.76-4.89c.92-.46.92-1.77 0-2.23l-12.01-6-.18-.08-.26-.05zM14.5 26.27l9.43 4.76.06 9.03-9.49-5.53v-8.26zm9.5 1.99l-7.96-4L24 20.3v7.95zm10.44-4.02l-7.94 3.91-.02-7.89 7.96 3.98zM14.5 22.23v-7.95l7.94 4-7.94 3.95zm9.49-5.97l-7.95-4L24 8.26l-.01 8zm2.5-.03V8.27l7.96 3.98-7.97 3.98z",
    fill: primaryFill
  }));
};

export const Fluent48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluent48RegularIcon, 'Fluent48Regular');

const Fluid16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 2.5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5v2C6 5.33 5.33 6 4.5 6h-2A1.5 1.5 0 011 4.5v-2zm7 7C8 8.67 8.67 8 9.5 8h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 018 13.5v-4zm-5 1V7h1v3.5c0 .28.22.5.5.5H7v1H4.5A1.5 1.5 0 013 10.5zM7 3v1h3.5c.28 0 .5.22.5.5V7h1V4.5c0-.83-.67-1.5-1.5-1.5H7z",
    fill: primaryFill
  }));
};

export const Fluid16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluid16FilledIcon, 'Fluid16Filled');

const Fluid16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 2.5C1 1.67 1.67 1 2.5 1h2C5.33 1 6 1.67 6 2.5v2C6 5.33 5.33 6 4.5 6h-2A1.5 1.5 0 011 4.5v-2zM2.5 2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2zM8 9.5C8 8.67 8.67 8 9.5 8h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 018 13.5v-4zM9.5 9a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-4zM3 10.5V7h1v3.5c0 .28.22.5.5.5H7v1H4.5A1.5 1.5 0 013 10.5zM7 3v1h3.5c.28 0 .5.22.5.5V7h1V4.5c0-.83-.67-1.5-1.5-1.5H7z",
    fill: primaryFill
  }));
};

export const Fluid16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluid16RegularIcon, 'Fluid16Regular');

const Fluid20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 5.54V3.5zM8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 00-.5-.5H8V4zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 014 13.5V8h1zm6.5 2c-.82 0-1.5.67-1.5 1.5v5c0 .83.68 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-5z",
    fill: primaryFill
  }));
};

export const Fluid20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluid20FilledIcon, 'Fluid20Filled');

const Fluid20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 4h5.5c.83 0 1.5.67 1.5 1.5V9h-1V5.5a.5.5 0 00-.5-.5H8V4zM5 8v5.5c0 .28.22.5.5.5H9v1H5.5A1.5 1.5 0 014 13.5V8h1zM2 3.5C2 2.67 2.67 2 3.5 2h2C6.33 2 7 2.67 7 3.5v2.04c0 .83-.67 1.5-1.5 1.5h-2A1.5 1.5 0 012 5.54V3.5zM3.5 3a.5.5 0 00-.5.5v2.04c0 .28.22.5.5.5h2a.5.5 0 00.5-.5V3.5a.5.5 0 00-.5-.5h-2zm6.5 8.5c0-.83.68-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5a1.5 1.5 0 01-1.5-1.5v-5zm1.5-.5a.5.5 0 00-.5.5v5c0 .28.23.5.5.5h5a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-5z",
    fill: primaryFill
  }));
};

export const Fluid20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluid20RegularIcon, 'Fluid20Regular');

const Fluid24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 5h5.75C17.98 5 19 6 19 7.25V11h-1.5V7.25a.75.75 0 00-.75-.75H11V5zm-4.5 6v5.75c0 .4.34.75.75.75H11V19H7.25C6.01 19 5 17.98 5 16.75V11h1.5zM2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5C10 8.99 9 10 7.75 10h-3.5C3.01 10 2 9 2 7.75v-3.5zm10 10c0-1.24 1-2.25 2.25-2.25h5.5c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C13.01 22 12 21 12 19.75v-5.5z",
    fill: primaryFill
  }));
};

export const Fluid24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluid24FilledIcon, 'Fluid24Filled');

const Fluid24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 5h5.75C17.98 5 19 6 19 7.25V11h-1.5V7.25a.75.75 0 00-.75-.75H11V5zm-4.5 6v5.75c0 .4.34.75.75.75H11V19H7.25C6.01 19 5 17.98 5 16.75V11h1.5zM2 4.25C2 3.01 3 2 4.25 2h3.5C8.99 2 10 3 10 4.25v3.5C10 8.99 9 10 7.75 10h-3.5C3.01 10 2 9 2 7.75v-3.5zm2.25-.75a.75.75 0 00-.75.75v3.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 00-.75-.75h-3.5zM12 14.25c0-1.24 1-2.25 2.25-2.25h5.5c1.24 0 2.25 1 2.25 2.25v5.5c0 1.24-1 2.25-2.25 2.25h-5.5C13.01 22 12 21 12 19.75v-5.5zm2.25-.75a.75.75 0 00-.75.75v5.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-5.5a.75.75 0 00-.75-.75h-5.5z",
    fill: primaryFill
  }));
};

export const Fluid24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fluid24RegularIcon, 'Fluid24Regular');

const Folder16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.2 4h-.02l-1.12-.89A.5.5 0 005.75 3H4a2 2 0 00-2 2v.5h3.56L7.2 4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.7 4L6.08 6.37a.5.5 0 01-.34.13H2V11c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H8.7z",
    fill: primaryFill
  }));
};

export const Folder16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder16FilledIcon, 'Folder16Filled');

const Folder16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5v6c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H7.18l-1.12-.89A.5.5 0 005.75 3H4a2 2 0 00-2 2zm1 0a1 1 0 011-1h1.57l.87.7-.88.8H3V5zm4.6 0H12a1 1 0 011 1v5a1 1 0 01-1 1H4a1 1 0 01-1-1V6.5h2.75a.5.5 0 00.34-.13L7.59 5z",
    fill: primaryFill
  }));
};

export const Folder16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder16RegularIcon, 'Folder16Regular');

const Folder20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.56 4.5h4.94a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H4.5A2.5 2.5 0 012 14.66V7.5H7.22c.3-.04.6-.16.83-.36l.1-.1 2.41-2.54zM7.16 3c.28 0 .54.07.77.21l.14.09 1.31.99-1.95 2.05-.06.06a.5.5 0 01-.22.1H2v-1A2.5 2.5 0 014.34 3h2.83z",
    fill: primaryFill
  }));
};

export const Folder20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder20FilledIcon, 'Folder20Filled');

const Folder20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.17 3c.27 0 .53.07.76.21l.14.09 1.6 1.2h5.83a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H4.5A2.5 2.5 0 012 14.66V5.5A2.5 2.5 0 014.34 3h2.83zm.99 4.03a1.5 1.5 0 01-.94.46l-.15.01H3v7c0 .78.6 1.42 1.36 1.5H15.5c.78 0 1.42-.6 1.5-1.36V7c0-.78-.6-1.42-1.36-1.5H9.62L8.16 7.03zM7.16 4H4.5c-.78 0-1.42.6-1.5 1.36V6.5h4.07a.5.5 0 00.3-.1l.06-.06L8.7 5.02 7.47 4.1a.5.5 0 00-.22-.1h-.08z",
    fill: primaryFill
  }));
};

export const Folder20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder20RegularIcon, 'Folder20Regular');

const Folder24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.82 6.5h5.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v9c0 1.2-.93 2.17-2.1 2.24l-.15.01H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96z",
    fill: primaryFill
  }));
};

export const Folder24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder24FilledIcon, 'Folder24Filled');

const Folder24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v9c0 1.2-.93 2.17-2.1 2.24l-.15.01H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm1.45 5.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h15.5c.38 0 .7-.28.74-.65l.01-.1v-9c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98zM8.2 5.5H4.25c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const Folder24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder24RegularIcon, 'Folder24Regular');

const Folder28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.82 6.5h7.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v13c0 1.2-.93 2.17-2.1 2.24l-.15.01H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96z",
    fill: primaryFill
  }));
};

export const Folder28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder28FilledIcon, 'Folder28Filled');

const Folder28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h9.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v13c0 1.2-.93 2.17-2.1 2.24l-.15.01H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm1.45 5.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v11.25c0 .38.28.7.65.74l.1.01h19.5c.38 0 .7-.28.74-.65l.01-.1v-13c0-.38-.28-.7-.65-.74l-.1-.01h-9.73l-2.37 1.98zM10.2 5.5H4.25c-.38 0-.7.28-.74.65l-.01.1V9h6.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const Folder28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder28RegularIcon, 'Folder28Regular');

const Folder32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.41 8h-.06l-2.23-1.78A1 1 0 0011.5 6H8a4 4 0 00-4 4v1h7.11l3.3-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.39 8l-5.22 4.74a1 1 0 01-.67.26H4v9a4 4 0 004 4h16a4 4 0 004-4V12a4 4 0 00-4-4h-6.61z",
    fill: primaryFill
  }));
};

export const Folder32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder32FilledIcon, 'Folder32Filled');

const Folder32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 10v12a4 4 0 004 4h16a4 4 0 004-4V12a4 4 0 00-4-4h-9.65l-2.23-1.78A1 1 0 0011.5 6H8a4 4 0 00-4 4zm2 0c0-1.1.9-2 2-2h3.15l1.74 1.39L11.1 11H6v-1zm9.19 0H24a2 2 0 012 2v10a2 2 0 01-2 2H8a2 2 0 01-2-2v-9h5.5a1 1 0 00.67-.26L15.2 10z",
    fill: primaryFill
  }));
};

export const Folder32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder32RegularIcon, 'Folder32Regular');

const Folder48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24.83 12.5h15.42c2 0 3.64 1.57 3.74 3.55l.01.2v19c0 2-1.57 3.64-3.55 3.74l-.2.01H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2V19H18.03c.97-.07 1.89-.5 2.55-1.23l.14-.17 4.11-5.1zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.44 2.14-3.2 3.96-.09.1c-.2.2-.46.33-.74.36l-.14.01H4v-3.75c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31z",
    fill: primaryFill
  }));
};

export const Folder48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder48FilledIcon, 'Folder48Filled');

const Folder48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.59 2.26c.19.17.42.27.67.3l.15.01h17.31c2 0 3.64 1.57 3.74 3.55l.01.2v19c0 2-1.57 3.64-3.55 3.74l-.2.01H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2v-22.5c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zm5.79 6l-2.13 2.61A3.75 3.75 0 0118.04 19l-.23.01H6.5v16.25c0 .65.5 1.18 1.12 1.24l.13.01h32.5c.65 0 1.18-.5 1.24-1.12l.01-.13v-19c0-.65-.5-1.18-1.12-1.24l-.13-.01h-17.4zm-5.79-3.5H7.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h11.31c.33 0 .64-.13.88-.36l.09-.1 1.63-2.01-2.53-2.22a1.25 1.25 0 00-.67-.3l-.15-.01z",
    fill: primaryFill
  }));
};

export const Folder48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Folder48RegularIcon, 'Folder48Regular');

const FolderAdd16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.2 3h-.02l-1.12-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2v.5h3.56L7.2 3zm1.5 0L6.08 5.37a.5.5 0 01-.34.13H2V10c0 1.1.9 2 2 2h1.2A5.5 5.5 0 0114 6.26V5a2 2 0 00-2-2H8.7zm1.8 12a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V10h1.5a.5.5 0 010 1H11v1.5a.5.5 0 01-1 0V11H8.5a.5.5 0 010-1H10V8.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const FolderAdd16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd16FilledIcon, 'FolderAdd16Filled');

const FolderAdd16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4v6c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H4a1 1 0 01-1-1V5.5h2.75a.5.5 0 00.34-.13L7.59 4H12a1 1 0 011 1v.6c.36.18.7.4 1 .66V5a2 2 0 00-2-2H7.18l-1.12-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2zm1 0a1 1 0 011-1h1.57l.87.7-.88.8H3V4zm7.5 11a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V10h1.5a.5.5 0 010 1H11v1.5a.5.5 0 01-1 0V11H8.5a.5.5 0 010-1H10V8.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const FolderAdd16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd16RegularIcon, 'FolderAdd16Regular');

const FolderAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zm8.44 10a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FolderAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd20FilledIcon, 'FolderAdd20Filled');

const FolderAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zm16 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FolderAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd20RegularIcon, 'FolderAdd20Regular');

const FolderAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 11a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 2h-.09a.5.5 0 00-.4.4l-.01.1V16h-2.6a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6c.05.2.2.36.41.4h.18a.5.5 0 00.4-.4l.01-.1V17h2.6a.5.5 0 00.4-.41v-.18a.5.5 0 00-.4-.4l-.1-.01H18v-2.6a.5.5 0 00-.41-.4h-.09zm2.25-6.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.5 6.5 0 00-9.98 8.2L4.25 20c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h5.93zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96z",
    fill: primaryFill
  }));
};

export const FolderAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd24FilledIcon, 'FolderAdd24Filled');

const FolderAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 11a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 2h-.09a.5.5 0 00-.4.4l-.01.1V16h-2.6a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01H17v2.6c.05.2.2.36.41.4h.18a.5.5 0 00.4-.4l.01-.1V17h2.6a.5.5 0 00.4-.41v-.18a.5.5 0 00-.4-.4l-.1-.01H18v-2.6a.5.5 0 00-.41-.4h-.09zM8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h7.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd24RegularIcon, 'FolderAdd24Regular');

const FolderAdd28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.5 15a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 2h-.09a.5.5 0 00-.4.4l-.01.1V20h-2.6a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01H21v2.6c.05.2.2.36.41.4h.18a.5.5 0 00.4-.4l.01-.1V21h2.6a.5.5 0 00.4-.41v-.18a.5.5 0 00-.4-.4l-.1-.01H22v-2.6a.5.5 0 00-.41-.4h-.09zm2.25-10.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v7.06a6.5 6.5 0 00-9.98 8.2L4.25 24c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h7.93zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96z",
    fill: primaryFill
  }));
};

export const FolderAdd28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd28FilledIcon, 'FolderAdd28Filled');

const FolderAdd28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.5 15a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm0 2h-.09a.5.5 0 00-.4.4l-.01.1V20h-2.6a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01H21v2.6c.05.2.2.36.41.4h.18a.5.5 0 00.4-.4l.01-.1V21h2.6a.5.5 0 00.4-.41v-.18a.5.5 0 00-.4-.4l-.1-.01H22v-2.6a.5.5 0 00-.41-.4h-.09zM10.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h9.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v7.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-9.73l-2.37 1.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v11.25c0 .38.28.7.65.74l.1.01h11.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h6.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderAdd28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd28RegularIcon, 'FolderAdd28Regular');

const FolderAdd48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M40.25 12.5c2 0 3.64 1.57 3.74 3.55l.01.2v7.8A12 12 0 0025.6 39l-17.85.01c-2 0-3.64-1.57-3.74-3.55l-.01-.2V19H18.03c.97-.07 1.89-.5 2.55-1.23l.14-.17 4.11-5.1h15.42zM36 23a10 10 0 110 20 10 10 0 010-20zm0 4a1 1 0 00-1 .88V32h-4a1 1 0 00-1 .88V33a1 1 0 00.88 1H35v4a1 1 0 00.88 1H36a1 1 0 001-.88V34h4a1 1 0 001-.88V33a1 1 0 00-.88-1H37v-4a1 1 0 00-.88-1H36zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.44 2.14-3.2 3.96-.09.1c-.2.2-.46.33-.74.36l-.14.01H4v-3.75c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31z",
    fill: primaryFill
  }));
};

export const FolderAdd48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd48FilledIcon, 'FolderAdd48Filled');

const FolderAdd48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.59 2.26c.19.17.42.27.67.3l.15.01h17.31c2 0 3.64 1.57 3.74 3.55l.01.2v7.8c-.75-.67-1.6-1.25-2.5-1.72v-6.08c0-.65-.5-1.18-1.12-1.24l-.13-.01h-17.4l-2.13 2.61A3.75 3.75 0 0118.04 19l-.23.01H6.5v16.25c0 .65.5 1.18 1.12 1.24l.13.01h16.77c.27.88.63 1.72 1.09 2.5H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2v-22.5c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zm0 2.5H7.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h11.31c.33 0 .64-.13.88-.36l.09-.1 1.63-2.01-2.53-2.22a1.25 1.25 0 00-.67-.3l-.15-.01zM36 23a10 10 0 110 20 10 10 0 010-20zm0 4a1 1 0 00-1 .88V32h-4a1 1 0 00-1 .88V33a1 1 0 00.88 1H35v4a1 1 0 00.88 1H36a1 1 0 001-.88V34h4a1 1 0 001-.88V33a1 1 0 00-.88-1H37v-4a1 1 0 00-.88-1H36z",
    fill: primaryFill
  }));
};

export const FolderAdd48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderAdd48RegularIcon, 'FolderAdd48Regular');

const FolderArrowLeft16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 3L5.56 4.5H2V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.32.11l1.1.89zM2 10V5.5h3.75a.5.5 0 00.34-.13L8.65 3H12a2 2 0 012 2v1.26A5.5 5.5 0 005.2 12H4a2 2 0 01-2-2zm8.5 5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L9.71 11h2.79a.5.5 0 000-1H9.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft16FilledIcon, 'FolderArrowLeft16Filled');

const FolderArrowLeft16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10V5.5h2.75a.5.5 0 00.39-.18L7.24 4H12a1 1 0 011 1v.6c.36.18.7.4 1 .66V5a2 2 0 00-2-2H7.18l-1.11-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2v6c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H4a1 1 0 01-1-1zm1-7h1.58l.71.57-.77.93H3V4a1 1 0 011-1zm6.5 12a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L9.71 11h2.79a.5.5 0 000-1H9.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft16RegularIcon, 'FolderArrowLeft16Regular');

const FolderArrowLeft20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.07 3.3l1.32.99-1.96 2.05a.5.5 0 01-.36.16H2v-1A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3zm.09 3.73c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94l-2.4 2.53zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft20FilledIcon, 'FolderArrowLeft20Filled');

const FolderArrowLeft20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3l1.6 1.2h5.83A2.5 2.5 0 0118 7v3.26a5.5 5.5 0 00-1-.66V7c0-.83-.67-1.5-1.5-1.5H9.62L8.16 7.03c-.29.3-.68.47-1.09.47H3v7c0 .83.67 1.5 1.5 1.5h4.7c.1.35.24.68.4 1H4.5A2.5 2.5 0 012 14.5v-9zM4.5 4C3.67 4 3 4.67 3 5.5v1h4.07a.5.5 0 00.36-.16L8.7 5.02 7.47 4.1a.5.5 0 00-.3-.1H4.5zm10 15a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.35-4.85a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 000-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft20RegularIcon, 'FolderArrowLeft20Regular');

const FolderArrowLeft24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.98 8.44a2.25 2.25 0 00-2.23-1.94h-5.93L9.65 9.98l-.16.12c-.32.22-.7.36-1.09.4H2v7.4A2.25 2.25 0 004.26 20h7.77A6.5 6.5 0 0122 11.8V8.61l-.02-.16zM9.49 4.4c-.37-.26-.82-.4-1.28-.4H4.1A2.25 2.25 0 002 6.26V9H8.31c.1-.02.2-.06.3-.11l.08-.06 3.06-2.56-2.1-1.75-.16-.12zM17.5 22a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm3-5a.5.5 0 000-1h-4.8l1.65-1.65a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L15.71 17h4.79z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft24FilledIcon, 'FolderArrowLeft24Filled');

const FolderArrowLeft24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 4.4c-.38-.26-.83-.4-1.3-.4H4.1A2.25 2.25 0 002 6.26V17.9A2.25 2.25 0 004.26 20h7.77c-.3-.46-.53-.97-.7-1.5H4.14a.75.75 0 01-.65-.75V10.5h4.9c.46-.05.9-.23 1.25-.52L12.02 8h7.83c.37.06.65.37.65.75v1.98c.55.29 1.06.65 1.5 1.08V8.6l-.02-.16a2.25 2.25 0 00-2.23-1.94h-7.73L9.65 4.52l-.16-.12zM4.24 5.5h4.06c.14.03.27.08.38.17l1.89 1.58-1.9 1.58-.08.06a.75.75 0 01-.4.11H3.5V6.15a.75.75 0 01.75-.65zM17.5 22a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm3-5a.5.5 0 000-1h-4.8l1.65-1.65a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L15.71 17h4.79z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft24RegularIcon, 'FolderArrowLeft24Regular');

const FolderArrowLeft28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.98 8.44a2.25 2.25 0 00-2.23-1.94h-7.93l-4.17 3.48-.16.12c-.32.22-.7.36-1.09.4H2v11.4A2.25 2.25 0 004.26 24h11.77A6.5 6.5 0 0126 15.8v-7.2l-.02-.16zM11.49 4.4c-.37-.26-.82-.4-1.28-.4H4.1A2.25 2.25 0 002 6.26V9H10.31c.1-.02.2-.06.3-.11l.08-.06 3.06-2.56-2.1-1.75-.16-.12zM21.5 26a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm3-5a.5.5 0 000-1h-4.8l1.65-1.65a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L19.71 21h4.79z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft28FilledIcon, 'FolderArrowLeft28Filled');

const FolderArrowLeft28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4.4c-.38-.26-.83-.4-1.3-.4H4.1A2.25 2.25 0 002 6.26V21.9A2.25 2.25 0 004.26 24h11.77c-.3-.46-.53-.97-.7-1.5H4.14a.75.75 0 01-.65-.75V10.5h6.9c.46-.05.9-.23 1.25-.52L14.02 8h9.83c.37.06.65.37.65.75v5.98c.55.29 1.06.65 1.5 1.08V8.6l-.02-.16a2.25 2.25 0 00-2.23-1.94h-9.73l-2.37-1.98-.16-.12zM4.24 5.5h6.06c.14.03.27.08.38.17l1.89 1.58-1.9 1.58-.08.06a.75.75 0 01-.4.11H3.5V6.15a.75.75 0 01.75-.65zM21.5 26a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm3-5a.5.5 0 000-1h-4.8l1.65-1.65a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L19.71 21h4.79z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft28RegularIcon, 'FolderArrowLeft28Regular');

const FolderArrowLeft32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.41 8h-.06l-2.23-1.78A1 1 0 0011.5 6H8a4 4 0 00-4 4v1h7.11l3.3-3zm2.98 0l-5.22 4.74a1 1 0 01-.67.26H4v9a4 4 0 004 4h6.51A8.99 8.99 0 0123 14c1.85 0 3.57.56 5 1.52V12a4 4 0 00-4-4h-6.61zM15.5 23a7.5 7.5 0 1015 0 7.5 7.5 0 00-15 0zm12.25 1h-7.69l2.72 2.72a.75.75 0 11-1.06 1.06l-4-4a.75.75 0 010-1.06l4-4a.75.75 0 111.06 1.06l-2.72 2.72h7.69a.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft32FilledIcon, 'FolderArrowLeft32Filled');

const FolderArrowLeft32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 10a4 4 0 014-4h3.5a1 1 0 01.62.22L14.35 8H24a4 4 0 014 4v3.52a8.97 8.97 0 00-2-1V12a2 2 0 00-2-2h-8.81l-3.02 2.74a1 1 0 01-.67.26H6v9c0 1.1.9 2 2 2h6.05c.08.7.24 1.36.46 2H8a4 4 0 01-4-4V10zm2 0v1h5.11l1.78-1.61L11.15 8H8a2 2 0 00-2 2zm9.5 13a7.5 7.5 0 1015 0 7.5 7.5 0 00-15 0zm12.25 1h-7.69l2.72 2.72a.75.75 0 11-1.06 1.06l-4-4a.75.75 0 010-1.06l4-4a.75.75 0 111.06 1.06l-2.72 2.72h7.69a.75.75 0 010 1.5z",
    fill: primaryFill
  }));
};

export const FolderArrowLeft32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowLeft32RegularIcon, 'FolderArrowLeft32Regular');

const FolderArrowRight16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 3l-1.11-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2v.5h3.56L7.18 3zM2 5.5V10c0 1.1.9 2 2 2h1.2A5.5 5.5 0 0114 6.26V5a2 2 0 00-2-2H8.65L6.1 5.37a.5.5 0 01-.34.13H2zm12 2.17a4.5 4.5 0 00-8 2.83 4.5 4.5 0 108-2.83zm-3.15 5.18a.5.5 0 01-.7-.7L11.29 11H8.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowRight16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight16FilledIcon, 'FolderArrowRight16Filled');

const FolderArrowRight16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5V10a1 1 0 001 1h1.02c.03.34.1.68.19 1H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.32.11l1.1.89H12a2 2 0 012 2v1.26a5.5 5.5 0 00-1-.66V5a1 1 0 00-1-1H7.23L6.14 5.32a.5.5 0 01-.39.18H3zM5.58 3H4a1 1 0 00-1 1v.5h2.52l.77-.93L5.58 3zm.45 8a4.47 4.47 0 004.47 4 4.5 4.5 0 10-4.47-4zm4.82 1.85a.5.5 0 01-.7-.7L11.29 11H8.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const FolderArrowRight16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight16RegularIcon, 'FolderArrowRight16Regular');

const FolderArrowRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight20FilledIcon, 'FolderArrowRight20Filled');

const FolderArrowRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zM14.5 10a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight20RegularIcon, 'FolderArrowRight20Regular');

const FolderArrowRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 11a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm2.25-4.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.5 6.5 0 00-9.98 8.2L4.25 20c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h5.93zm-1.96 7.05l-.07.04-.07.06-.06.07a.5.5 0 000 .56l.06.07L19.29 16h-5.38a.5.5 0 00-.4.41l-.01.09v.09c.05.2.2.36.41.4L14 17h5.3l-1.65 1.65-.06.07a.5.5 0 00.7.7l.06-.07 2.53-2.53.05-.06.03-.07.02-.06.02-.08v-.1l-.02-.08-.03-.08-.04-.07-.04-.06-2.52-2.51-.07-.06a.5.5 0 00-.49-.04zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96z",
    fill: primaryFill
  }));
};

export const FolderArrowRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight24FilledIcon, 'FolderArrowRight24Filled');

const FolderArrowRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 11a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h7.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm9.6 9.55l-.08.04-.07.06-.06.07a.5.5 0 000 .56l.06.07L19.29 16h-5.38a.5.5 0 00-.4.41l-.01.09v.09c.05.2.2.36.41.4L14 17h5.3l-1.65 1.65-.06.07a.5.5 0 00.7.7l.06-.07 2.53-2.53.05-.06.03-.07.02-.06.02-.08v-.1l-.02-.08-.03-.08-.04-.07-.04-.06-2.52-2.51-.07-.06a.5.5 0 00-.49-.04zM8.2 5.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderArrowRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight24RegularIcon, 'FolderArrowRight24Regular');

const FolderArrowRight28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.5 15a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm2.25-8.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v7.06a6.5 6.5 0 00-9.98 8.2L4.25 24c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h7.93zm-1.96 11.05l-.07.04-.07.06-.06.07a.5.5 0 000 .56l.06.07L23.29 20H18.4a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01h4.8l-1.65 1.65-.06.07a.5.5 0 00.7.7l.06-.07 2.54-2.54.03-.04.04-.08.03-.08V20.39l-.03-.08-.04-.08-.04-.05-2.53-2.53-.07-.06a.5.5 0 00-.49-.04zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96z",
    fill: primaryFill
  }));
};

export const FolderArrowRight28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight28FilledIcon, 'FolderArrowRight28Filled');

const FolderArrowRight28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.5 15a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM10.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h9.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v7.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-9.73l-2.37 1.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v11.25c0 .38.28.7.65.74l.1.01h11.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm11.6 13.55l-.08.04-.07.06-.06.07a.5.5 0 000 .56l.06.07L23.29 20H18.4a.5.5 0 00-.4.41v.18c.04.2.2.36.4.4l.1.01h4.8l-1.65 1.65-.06.07a.5.5 0 00.7.7l.06-.07 2.54-2.54.03-.04.04-.08.03-.08V20.39l-.03-.08-.04-.08-.04-.05-2.53-2.53-.07-.06a.5.5 0 00-.49-.04zM10.2 5.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h6.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderArrowRight28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight28RegularIcon, 'FolderArrowRight28Regular');

const FolderArrowRight48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M40.25 12.5c2 0 3.64 1.57 3.74 3.55l.01.2v7.8A12 12 0 0025.6 39l-17.85.01c-2 0-3.64-1.57-3.74-3.55l-.01-.2V19H18.03c.97-.07 1.89-.5 2.55-1.23l.14-.17 4.11-5.1h15.42zM36 23a10 10 0 110 20 10 10 0 010-20zm0 4.63l-.11.08-.1.08-.08.1a1 1 0 000 1.22l.08.1L38.6 32h-7.71a1 1 0 00-.87.88L30 33v.12a1 1 0 00.88.87L31 34h7.59l-2.8 2.8-.08.09a1 1 0 001.4 1.4l.1-.08 4.5-4.5.07-.09.05-.06.05-.08.03-.06.04-.1.02-.09.02-.11L42 33v-.08l-.02-.12-.03-.11-.02-.06-.05-.11-.05-.08-.04-.06-.04-.04-.04-.05-4.5-4.5-.1-.08a1 1 0 00-1.11-.08zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.44 2.14-3.2 3.96-.09.1c-.2.2-.46.33-.74.36l-.14.01H4v-3.75c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31z",
    fill: primaryFill
  }));
};

export const FolderArrowRight48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight48FilledIcon, 'FolderArrowRight48Filled');

const FolderArrowRight48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.59 2.26c.19.17.42.27.67.3l.15.01h17.31c2 0 3.64 1.57 3.74 3.55l.01.2v7.8c-.75-.67-1.6-1.25-2.5-1.72v-6.08c0-.65-.5-1.18-1.12-1.24l-.13-.01h-17.4l-2.13 2.61A3.75 3.75 0 0118.04 19l-.23.01H6.5v16.25c0 .65.5 1.18 1.12 1.24l.13.01h16.77c.27.88.63 1.72 1.09 2.5H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2v-22.5c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zm0 2.5H7.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h11.31c.33 0 .64-.13.88-.36l.09-.1 1.63-2.01-2.53-2.22a1.25 1.25 0 00-.67-.3l-.15-.01zM36 23a10 10 0 110 20 10 10 0 010-20zm0 4.63l-.11.08-.1.08-.08.1a1 1 0 000 1.22l.08.1L38.6 32h-7.71a1 1 0 00-.87.88L30 33v.12a1 1 0 00.88.87L31 34h7.59l-2.8 2.8-.08.09a1 1 0 001.4 1.4l.1-.08 4.5-4.5.05-.06.07-.1.05-.07.03-.06.04-.1.02-.09.02-.11L42 33v-.08l-.02-.12-.03-.11-.02-.06-.05-.11-.05-.08-.04-.06-.04-.04-.04-.05-4.5-4.5-.1-.08a1 1 0 00-1.11-.08z",
    fill: primaryFill
  }));
};

export const FolderArrowRight48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowRight48RegularIcon, 'FolderArrowRight48Regular');

const FolderArrowUp16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 3L5.56 4.5H2V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.32.11l1.1.89zM2 10V5.5h3.75a.5.5 0 00.34-.13L8.65 3H12a2 2 0 012 2v1.26A5.5 5.5 0 005.2 12H4a2 2 0 01-2-2zm13 .5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35A.5.5 0 0010.5 8a.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L10 9.71v2.79a.5.5 0 001 0V9.7l1.15 1.15a.5.5 0 00.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowUp16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp16FilledIcon, 'FolderArrowUp16Filled');

const FolderArrowUp16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5V10a1 1 0 001 1h1.02c.03.34.1.68.19 1H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.32.11l1.1.89H12a2 2 0 012 2v1.26a5.5 5.5 0 00-1-.66V5a1 1 0 00-1-1H7.23L6.14 5.32a.5.5 0 01-.39.18H3zM5.58 3H4a1 1 0 00-1 1v.5h2.52l.77-.93L5.58 3zM15 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35A.5.5 0 0010.5 8a.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L10 9.71v2.79a.5.5 0 001 0V9.7l1.15 1.15a.5.5 0 00.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowUp16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp16RegularIcon, 'FolderArrowUp16Regular');

const FolderArrowUp20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.07 3.3l1.32.99-1.96 2.05a.5.5 0 01-.36.16H2v-1A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3zm.09 3.73l2.4-2.53h4.94A2.5 2.5 0 0118 6.84v3.42A5.5 5.5 0 009.6 17H4.5A2.5 2.5 0 012 14.5v-7h5.07c.41 0 .8-.17 1.09-.47zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 13.71v2.79a.5.5 0 101 0v-2.8l1.15 1.15a.5.5 0 10.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowUp20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp20FilledIcon, 'FolderArrowUp20Filled');

const FolderArrowUp20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3h2.67c.32 0 .64.1.9.3l1.6 1.2h5.83A2.5 2.5 0 0118 7v3.26a5.5 5.5 0 00-1-.66V7c0-.83-.67-1.5-1.5-1.5H9.62L8.16 7.03c-.29.3-.68.47-1.09.47H3v7c0 .83.67 1.5 1.5 1.5h4.7c.1.35.24.68.4 1H4.5A2.5 2.5 0 012 14.5v-9A2.5 2.5 0 014.5 3zM3 5.5v1h4.07a.5.5 0 00.36-.16L8.7 5.02 7.47 4.1a.5.5 0 00-.3-.1H4.5C3.67 4 3 4.67 3 5.5zm16 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.15-2.35a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-2 2a.5.5 0 00.7.7L14 13.71v2.79a.5.5 0 101 0v-2.8l1.15 1.15a.5.5 0 10.7-.7l-2-2z",
    fill: primaryFill
  }));
};

export const FolderArrowUp20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp20RegularIcon, 'FolderArrowUp20Regular');

const FolderArrowUp24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.75 6.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.5 6.5 0 00-9.98 8.2L4.25 20c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h5.93zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zM23 16.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-6-1.8v4.8a.5.5 0 001 0v-4.8l1.65 1.65a.5.5 0 00.7-.7l-2.5-2.5a.5.5 0 00-.7 0l-2.5 2.5a.5.5 0 00.7.7L17 14.71z",
    fill: primaryFill
  }));
};

export const FolderArrowUp24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp24FilledIcon, 'FolderArrowUp24Filled');

const FolderArrowUp24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h7.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01zm14.8 11a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-6-1.8v4.8a.5.5 0 001 0v-4.8l1.65 1.65a.5.5 0 00.7-.7l-2.5-2.5a.5.5 0 00-.7 0l-2.5 2.5a.5.5 0 00.7.7L17 14.71z",
    fill: primaryFill
  }));
};

export const FolderArrowUp24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp24RegularIcon, 'FolderArrowUp24Regular');

const FolderArrowUp28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.75 6.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v5.65A7.5 7.5 0 0014.5 24H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h7.93zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zM27 19.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-7-2.8v6.8a.5.5 0 001 0v-6.8l2.15 2.15a.5.5 0 00.7-.7l-3-3a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-3 3a.5.5 0 00.7.7L20 16.71z",
    fill: primaryFill
  }));
};

export const FolderArrowUp28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp28FilledIcon, 'FolderArrowUp28Filled');

const FolderArrowUp28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h9.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v5.65c-.44-.48-.95-.9-1.5-1.24V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-9.73l-2.37 1.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v11.25c0 .38.28.7.65.74l.1.01h9.37c.24.54.53 1.04.88 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h6.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01zm16.8 14a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-7-2.8v6.8a.5.5 0 001 0v-6.8l2.15 2.15a.5.5 0 00.7-.7l-3-3a.5.5 0 00-.35-.15.5.5 0 00-.35.15l-3 3a.5.5 0 00.7.7L20 16.71z",
    fill: primaryFill
  }));
};

export const FolderArrowUp28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp28RegularIcon, 'FolderArrowUp28Regular');

const FolderArrowUp48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M40.25 12.5c2 0 3.64 1.57 3.74 3.55l.01.2v7.37A13 13 0 0023.46 39H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2V19H18.03c.97-.07 1.89-.5 2.55-1.23l.14-.17 4.11-5.1h15.42zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.44 2.14-3.2 3.96-.09.1c-.2.2-.46.33-.74.36l-.14.01H4v-3.75c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zM46 33a11 11 0 11-22 0 11 11 0 0122 0zm-11-8a1 1 0 00-.7.3l-5 5a1 1 0 001.4 1.4l3.3-3.29V40a1 1 0 102 0V28.41l3.3 3.3a1 1 0 001.4-1.42l-5-5A1 1 0 0035 25z",
    fill: primaryFill
  }));
};

export const FolderArrowUp48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp48FilledIcon, 'FolderArrowUp48Filled');

const FolderArrowUp48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.59 2.26c.19.17.42.27.67.3l.15.01h17.31c2 0 3.64 1.57 3.74 3.55l.01.2v7.37c-.75-.72-1.6-1.36-2.5-1.88v-5.49c0-.65-.5-1.18-1.12-1.24l-.13-.01h-17.4l-2.13 2.61A3.75 3.75 0 0118.04 19l-.23.01H6.5v16.25c0 .65.5 1.18 1.12 1.24l.13.01h14.73c.24.87.57 1.71.98 2.5H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2v-22.5c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zm0 2.5H7.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h11.31c.33 0 .64-.13.88-.36l.09-.1 1.63-2.01-2.53-2.22a1.25 1.25 0 00-.67-.3l-.15-.01zM46 33a11 11 0 11-22 0 11 11 0 0122 0zm-11-8a1 1 0 00-.7.3l-5 5a1 1 0 001.4 1.4l3.3-3.29V40a1 1 0 102 0V28.41l3.3 3.3a1 1 0 001.4-1.42l-5-5A1 1 0 0035 25z",
    fill: primaryFill
  }));
};

export const FolderArrowUp48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderArrowUp48RegularIcon, 'FolderArrowUp48Regular');

const FolderBriefcase20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.07 3.3l1.32.99-1.96 2.05a.5.5 0 01-.36.16H2v-1A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3zm.09 3.73l2.4-2.53h4.94A2.5 2.5 0 0118 6.84v4.33a3 3 0 00-1-.17v-1a1 1 0 00-1-1h-4a1 1 0 00-1 1v1a3 3 0 00-3 3v3H4.5A2.5 2.5 0 012 14.5v-7h5.07c.41 0 .8-.17 1.09-.47zM11 12a2 2 0 00-2 2v3c0 1.1.9 2 2 2h6a2 2 0 002-2v-3a2 2 0 00-2-2h-1v-1.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V12h-1zm2 0v-1h2v1h-2z",
    fill: primaryFill
  }));
};

export const FolderBriefcase20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderBriefcase20FilledIcon, 'FolderBriefcase20Filled');

const FolderBriefcase20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17H8v-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v4a3 3 0 011 .17V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zm9 5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V12h1a2 2 0 012 2v3a2 2 0 01-2 2h-6a2 2 0 01-2-2v-3c0-1.1.9-2 2-2h1v-1.5zm3 .5h-2v1h2v-1z",
    fill: primaryFill
  }));
};

export const FolderBriefcase20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderBriefcase20RegularIcon, 'FolderBriefcase20Regular');

const FolderGlobe16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 3h.03L5.56 4.5H2V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.31.11L7.18 3zm-1.1 2.37L8.7 3H12a2 2 0 012 2v1.26A5.5 5.5 0 005.2 12H4a2 2 0 01-2-2V5.5h3.75a.5.5 0 00.34-.13zm5.28 8.6a8.3 8.3 0 00.63-2.97H9c.05 1.2.3 2.24.63 2.98.42.92.8 1.02.86 1.02.06 0 .44-.1.86-1.02zm-2.47.73A4.5 4.5 0 016.03 11H8c.06 1.48.39 2.8.88 3.7zM6.03 10H8c.06-1.48.39-2.8.88-3.7A4.5 4.5 0 006.03 10zm4.47-4c-.06 0-.44.1-.86 1.02A8.3 8.3 0 009.01 10H12a8.3 8.3 0 00-.63-2.98C10.94 6.1 10.56 6 10.5 6zm1.61.3c1.54.59 2.67 2 2.86 3.7H13a8.83 8.83 0 00-.88-3.7zm2.86 4.7a4.5 4.5 0 01-2.86 3.7c.5-.9.82-2.22.88-3.7h1.98z",
    fill: primaryFill
  }));
};

export const FolderGlobe16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderGlobe16FilledIcon, 'FolderGlobe16Filled');

const FolderGlobe16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.31.11L7.18 3H12a2 2 0 012 2v1.26a5.5 5.5 0 00-1-.66V5a1 1 0 00-1-1H7.6L6.08 5.37a.5.5 0 01-.34.13H3V10a1 1 0 001 1h1.02c.03.34.1.68.19 1H4a2 2 0 01-2-2zm2-7a1 1 0 00-1 1v.5h2.56l.88-.8-.87-.7H4zm7.36 10.98a8.3 8.3 0 00.63-2.98H9c.05 1.2.3 2.24.63 2.98.42.92.8 1.02.86 1.02.06 0 .44-.1.86-1.02zm-2.47.72A4.5 4.5 0 016.03 11H8c.06 1.48.39 2.8.88 3.7zM6.03 10H8c.06-1.48.39-2.8.88-3.7A4.5 4.5 0 006.03 10zm4.47-4c-.06 0-.44.1-.86 1.02A8.3 8.3 0 009.01 10H12a8.3 8.3 0 00-.63-2.98C10.94 6.1 10.56 6 10.5 6zm1.61.3c1.54.59 2.67 2 2.86 3.7H13a8.83 8.83 0 00-.88-3.7zm2.86 4.7a4.5 4.5 0 01-2.86 3.7c.5-.9.82-2.22.88-3.7h1.98z",
    fill: primaryFill
  }));
};

export const FolderGlobe16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderGlobe16RegularIcon, 'FolderGlobe16Regular');

const FolderGlobe20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zm2.45 9.5a8.9 8.9 0 01.54-2.85c.17-.42.35-.72.53-.91.19-.2.33-.24.42-.24.1 0 .23.05.42.24.18.19.36.5.53.91.3.73.5 1.72.54 2.85h-2.98zm-.39-3.22l.2-.46a4.5 4.5 0 00-2.8 3.68h1.99c.05-1.23.27-2.36.61-3.22zm3.76 0a5.29 5.29 0 00-.21-.46c1.51.6 2.62 2 2.8 3.68H17a9.92 9.92 0 00-.61-3.22zm.61 4.22h1.98a4.5 4.5 0 01-2.8 3.68 9.92 9.92 0 00.82-3.68zm-2.07 3.76c-.19.2-.33.24-.42.24-.1 0-.23-.05-.42-.24-.18-.19-.36-.5-.53-.91a8.9 8.9 0 01-.54-2.85h2.98a8.9 8.9 0 01-.54 2.85c-.17.42-.35.72-.53.91zM10.02 15a4.5 4.5 0 002.8 3.68l-.2-.46a9.92 9.92 0 01-.61-3.22h-1.98z",
    fill: primaryFill
  }));
};

export const FolderGlobe20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderGlobe20FilledIcon, 'FolderGlobe20Filled');

const FolderGlobe20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zM13.01 14a8.9 8.9 0 01.54-2.85c.17-.42.35-.72.53-.91.19-.2.33-.24.42-.24.1 0 .23.05.42.24.18.19.36.5.53.91.3.73.5 1.72.54 2.85h-2.98zm-.39-3.22l.2-.46a4.5 4.5 0 00-2.8 3.68h1.99c.05-1.23.27-2.36.61-3.22zm3.76 0a5.29 5.29 0 00-.21-.46c1.51.6 2.62 2 2.8 3.68H17a9.92 9.92 0 00-.61-3.22zm.61 4.22h1.98a4.5 4.5 0 01-2.8 3.68 9.92 9.92 0 00.82-3.68zm-2.07 3.76c-.19.2-.33.24-.42.24-.1 0-.23-.05-.42-.24-.18-.19-.36-.5-.53-.91a8.9 8.9 0 01-.54-2.85h2.98a8.9 8.9 0 01-.54 2.85c-.17.42-.35.72-.53.91zM10.02 15a4.5 4.5 0 002.8 3.68l-.2-.46a9.92 9.92 0 01-.61-3.22h-1.98z",
    fill: primaryFill
  }));
};

export const FolderGlobe20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderGlobe20RegularIcon, 'FolderGlobe20Regular');

const FolderLink20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h2.26a4.5 4.5 0 013.74-7h5c.93 0 1.79.28 2.5.76V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zM8 14.5a2.5 2.5 0 012.5-2.5h1a.5.5 0 000-1h-1a3.5 3.5 0 100 7h1a.5.5 0 000-1h-1A2.5 2.5 0 018 14.5zm10 0a2.5 2.5 0 00-2.5-2.5h-1a.5.5 0 010-1h1a3.5 3.5 0 110 7h-1a.5.5 0 010-1h1a2.5 2.5 0 002.5-2.5zm-8 0c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const FolderLink20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink20FilledIcon, 'FolderLink20Filled');

const FolderLink20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h2.26c-.2-.3-.38-.64-.5-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v3.26c.36.12.7.3 1 .5V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zm5 9a2.5 2.5 0 012.5-2.5h1a.5.5 0 000-1h-1a3.5 3.5 0 100 7h1a.5.5 0 000-1h-1A2.5 2.5 0 018 14.5zm10 0a2.5 2.5 0 00-2.5-2.5h-1a.5.5 0 010-1h1a3.5 3.5 0 110 7h-1a.5.5 0 010-1h1a2.5 2.5 0 002.5-2.5zm-8 0c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const FolderLink20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink20RegularIcon, 'FolderLink20Regular');

const FolderLink24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 14.5a3.75 3.75 0 01.2 7.5h-1.2a.75.75 0 01-.1-1.49h.1l1-.01a2.25 2.25 0 00.15-4.5h-1.15a.75.75 0 01-.1-1.5h1.1zm-4.5 0a.75.75 0 01.1 1.5h-1.1a2.25 2.25 0 00-.15 4.5h1.15a.75.75 0 01.1 1.5h-1.1a3.75 3.75 0 01-.2-7.5h1.2zm6-8c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v6.59a4.74 4.74 0 00-3.75-1.84h-5.5A4.75 4.75 0 008.33 20H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h5.93zm-1.5 11a.75.75 0 01.1 1.5h-5.6a.75.75 0 01-.1-1.5h5.6zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96z",
    fill: primaryFill
  }));
};

export const FolderLink24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink24FilledIcon, 'FolderLink24Filled');

const FolderLink24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 14.5a3.75 3.75 0 01.2 7.5h-1.2a.75.75 0 01-.1-1.49h.1l1-.01a2.25 2.25 0 00.15-4.5h-1.15a.75.75 0 01-.1-1.5h1.1zm-4.5 0a.75.75 0 01.1 1.5h-1.1a2.25 2.25 0 00-.15 4.5h1.15a.75.75 0 01.1 1.5h-1.1a3.75 3.75 0 01-.2-7.5h1.2zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v6.59c-.4-.53-.91-.96-1.5-1.27V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h3.76c.02.53.14 1.03.32 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm10.04 13.5a.75.75 0 01.1 1.5h-5.6a.75.75 0 01-.1-1.5h5.6zM8.21 5.5H4.25c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderLink24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink24RegularIcon, 'FolderLink24Regular');

const FolderLink28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.25 18.5a3.75 3.75 0 01.2 7.5h-1.2a.75.75 0 01-.1-1.49h.1l1-.01a2.25 2.25 0 00.15-4.5h-1.15a.75.75 0 01-.1-1.5h1.1zm-4.5 0a.75.75 0 01.1 1.5h-1.1a2.25 2.25 0 00-.15 4.5h1.15a.75.75 0 01.1 1.5h-1.1a3.75 3.75 0 01-.2-7.5h1.2zm6-12c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v10.59a4.74 4.74 0 00-3.75-1.84h-5.5a4.75 4.75 0 00-4.42 6.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h7.93zm-1.5 15a.75.75 0 01.1 1.5h-5.6a.75.75 0 01-.1-1.5h5.6zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96z",
    fill: primaryFill
  }));
};

export const FolderLink28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink28FilledIcon, 'FolderLink28Filled');

const FolderLink28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.25 18.5a3.75 3.75 0 01.2 7.5h-1.2a.75.75 0 01-.1-1.49h.1l1-.01a2.25 2.25 0 00.15-4.5h-1.15a.75.75 0 01-.1-1.5h1.1zm-4.5 0a.75.75 0 01.1 1.5h-1.1a2.25 2.25 0 00-.15 4.5h1.15a.75.75 0 01.1 1.5h-1.1a3.75 3.75 0 01-.2-7.5h1.2zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.37 1.98h9.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v10.59c-.4-.53-.91-.96-1.5-1.27V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-9.73l-2.37 1.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v11.25c0 .38.28.7.65.74l.1.01h7.76c.02.53.14 1.03.32 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm12.04 17.5a.75.75 0 01.1 1.5h-5.6a.75.75 0 01-.1-1.5h5.6zm-12.04-16H4.25c-.38 0-.7.28-.74.65l-.01.1V9h6.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderLink28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink28RegularIcon, 'FolderLink28Regular');

const FolderLink48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24.83 12.5h15.42c2 0 3.64 1.57 3.74 3.55l.01.2v13.54A7.88 7.88 0 0038 27H28c-4.42 0-8 3.7-8 8.25 0 1.35.31 2.62.87 3.75H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2V19H18.03c.97-.07 1.89-.5 2.55-1.23l.14-.17 4.11-5.1zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.44 2.14-3.2 3.96-.09.1c-.2.2-.46.33-.74.36l-.14.01H4v-3.75c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zm11.19 20a6.25 6.25 0 100 12.5h1.5a1.25 1.25 0 100-2.5h-1.5a3.75 3.75 0 110-7.5h1.5a1.25 1.25 0 100-2.5h-1.5zm9.5 0a6.25 6.25 0 110 12.5h-1.5a1.25 1.25 0 110-2.5h1.5a3.75 3.75 0 100-7.5h-1.5a1.25 1.25 0 110-2.5h1.5zM27 35.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 110 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const FolderLink48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink48FilledIcon, 'FolderLink48Filled');

const FolderLink48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.59 2.26c.19.17.42.27.67.3l.15.01h17.31c2 0 3.64 1.57 3.74 3.55l.01.2v13.54a8.06 8.06 0 00-2.5-1.96V16.25c0-.65-.5-1.18-1.12-1.24l-.13-.01h-17.4l-2.13 2.61A3.75 3.75 0 0118.04 19l-.23.01H6.5v16.25c0 .65.5 1.18 1.12 1.24l.13.01h12.34c.13.89.4 1.73.78 2.5H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2v-22.5c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zm0 2.5H7.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h11.31c.33 0 .64-.13.88-.36l.09-.1 1.63-2.01-2.53-2.22a1.25 1.25 0 00-.67-.3l-.15-.01zM28.25 29a6.25 6.25 0 100 12.5h1.5a1.25 1.25 0 100-2.5h-1.5a3.75 3.75 0 110-7.5h1.5a1.25 1.25 0 100-2.5h-1.5zm9.5 0a6.25 6.25 0 110 12.5h-1.5a1.25 1.25 0 110-2.5h1.5a3.75 3.75 0 100-7.5h-1.5a1.25 1.25 0 110-2.5h1.5zM27 35.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 110 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const FolderLink48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderLink48RegularIcon, 'FolderLink48Regular');

const FolderMail16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.2 3h-.02l-1.12-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2v.5h3.56L7.2 3zm1.5 0L6.08 5.37a.5.5 0 01-.34.13H2V10c0 1.1.9 2 2 2h1V9.5A2.5 2.5 0 017.5 7h6c.17 0 .34.02.5.05V5a2 2 0 00-2-2H8.7zM6 9.3l4.5 2.63L15 9.5V9.5c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3zM15 10.64l-4.26 2.3a.5.5 0 01-.5 0L6 10.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-2.86z",
    fill: primaryFill
  }));
};

export const FolderMail16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail16FilledIcon, 'FolderMail16Filled');

const FolderMail16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4v6c0 1.1.9 2 2 2h1v-1H4a1 1 0 01-1-1V5.5h2.75a.5.5 0 00.34-.13L7.59 4H12a1 1 0 011 1v2h.5c.17 0 .34.02.5.05V5a2 2 0 00-2-2H7.18l-1.12-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2zm1 0a1 1 0 011-1h1.57l.87.7-.88.8H3V4zm3.01 5.3l4.5 2.63L15 9.5V9.5c0-.83-.67-1.5-1.5-1.5h-6c-.76 0-1.4.57-1.49 1.3zM15 10.64l-4.26 2.3a.5.5 0 01-.5 0L6 10.44v3.05c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-2.86z",
    fill: primaryFill
  }));
};

export const FolderMail16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail16RegularIcon, 'FolderMail16Regular');

const FolderMail20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 4.5h-4.94l-2.4 2.53-.11.1c-.23.2-.52.33-.83.36l-.15.01H2v7.16A2.5 2.5 0 004.5 17H9v-3.5a2.5 2.5 0 012.5-2.5h6c.17 0 .34.02.5.05V6.84l-.02-.17A2.5 2.5 0 0015.5 4.5zM7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v1h5.15a.5.5 0 00.22-.1l.06-.06L9.4 4.3 8.06 3.3l-.14-.09zm6.58 12.72l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const FolderMail20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail20FilledIcon, 'FolderMail20Filled');

const FolderMail20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v9.16A2.5 2.5 0 004.5 17H9v-1H4.36A1.5 1.5 0 013 14.5v-7H7.22c.36-.04.69-.2.94-.47L9.62 5.5h6.02A1.5 1.5 0 0117 7v4h.5c.17 0 .34.02.5.05V6.84l-.02-.17A2.5 2.5 0 0015.5 4.5H9.67l-1.6-1.2-.14-.09zM4.5 4h2.75a.5.5 0 01.22.1l1.22.92-1.26 1.32-.06.06a.5.5 0 01-.3.1H3V5.36A1.5 1.5 0 014.5 4zm10.01 11.93l-4.5-2.63c.1-.73.73-1.3 1.49-1.3h6c.83 0 1.5.67 1.5 1.5l-4.49 2.43zm.23 1.01l4.26-2.3v2.86c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3.05l4.25 2.48c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const FolderMail20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail20RegularIcon, 'FolderMail20Regular');

const FolderMail24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.75 6.5h-5.93L9.65 9.98l-.16.12c-.32.22-.7.36-1.09.4H2v7.4A2.25 2.25 0 004.26 20H11v-4a3 3 0 013-3h7a3 3 0 011 .17V8.6l-.02-.16a2.25 2.25 0 00-2.23-1.94zM9.49 4.4c-.37-.26-.82-.4-1.28-.4H4.1A2.25 2.25 0 002 6.26V9H8.31c.1-.02.2-.06.3-.11l.08-.06 3.06-2.56-2.1-1.75-.16-.12zm8.02 14.53l-5.5-3.2A2 2 0 0114 14h7a2 2 0 012 1.97l-5.49 2.96zm.23 1.01L23 17.11V21a2 2 0 01-2 2h-7a2 2 0 01-2-2v-4.13l5.25 3.06c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const FolderMail24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail24FilledIcon, 'FolderMail24Filled');

const FolderMail24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 4.4c-.38-.26-.83-.4-1.3-.4H4.1A2.25 2.25 0 002 6.26V17.9A2.25 2.25 0 004.26 20H11v-1.5H4.15a.75.75 0 01-.65-.75V10.5h4.9c.46-.05.9-.23 1.25-.52L12.02 8h7.83c.37.06.65.37.65.75V13h.5a3 3 0 011 .17V8.6l-.02-.16a2.25 2.25 0 00-2.23-1.94h-7.73L9.65 4.52l-.16-.12zM4.24 5.5h4.06c.14.03.27.08.38.17l1.89 1.58-1.9 1.58-.08.06a.75.75 0 01-.4.11H3.5V6.15a.75.75 0 01.75-.65zm13.26 13.43l-5.5-3.2A2 2 0 0114 14h7a2 2 0 012 1.97l-5.49 2.96zm.23 1.01L23 17.11V21a2 2 0 01-2 2h-7a2 2 0 01-2-2v-4.13l5.25 3.06c.15.09.33.1.49.01z",
    fill: primaryFill
  }));
};

export const FolderMail24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail24RegularIcon, 'FolderMail24Regular');

const FolderMail28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.82 6.5h7.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v6.59a3.49 3.49 0 00-1.5-.34h-8a3.5 3.5 0 00-3.5 3.5V24H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm6.29 12a2.5 2.5 0 00-2.5 2.5v.2l6.5 3.24L27 18.7v-.19a2.5 2.5 0 00-2.5-2.5h-8zM27 19.8l-6.28 3.15a.5.5 0 01-.44 0L14 19.8v4.69a2.5 2.5 0 002.5 2.5h8a2.5 2.5 0 002.5-2.5v-4.7z",
    fill: primaryFill
  }));
};

export const FolderMail28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail28FilledIcon, 'FolderMail28Filled');

const FolderMail28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4.4c-.38-.26-.83-.4-1.3-.4H4.1A2.25 2.25 0 002 6.26V21.9A2.25 2.25 0 004.26 24H13v-1.5H4.15a.75.75 0 01-.65-.75V10.5h6.9c.46-.05.9-.23 1.25-.52L14.02 8h9.83c.37.06.65.37.65.75V15c.54 0 1.05.12 1.5.34V8.6l-.02-.16a2.25 2.25 0 00-2.23-1.94h-9.73l-2.37-1.98-.16-.12zM4.24 5.5h6.06c.14.03.27.08.38.17l1.89 1.58-1.9 1.58-.08.06a.75.75 0 01-.4.11H3.5V6.15a.75.75 0 01.75-.65zm9.75 13a2.5 2.5 0 012.5-2.5h8a2.5 2.5 0 012.5 2.5v.2l-6.5 3.24L14 18.7v-.19zm6.72 4.45L27 19.8v4.69a2.5 2.5 0 01-2.5 2.5h-8a2.5 2.5 0 01-2.5-2.5v-4.7l6.28 3.15c.14.07.3.07.44 0z",
    fill: primaryFill
  }));
};

export const FolderMail28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderMail28RegularIcon, 'FolderMail28Regular');

const FolderOpen16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3a2 2 0 00-2 2v6c0 .41.13.8.34 1.12l1.47-5.04A1.5 1.5 0 014.25 6H13a2 2 0 00-2-2H6.17l-1.1-.9a.5.5 0 00-.32-.1H3zm11.94 4.64a.5.5 0 00-.48-.64H4.25a.5.5 0 00-.48.36l-1.46 5a.5.5 0 00.48.64h9.46a1.5 1.5 0 001.44-1.08l1.25-4.28z",
    fill: primaryFill
  }));
};

export const FolderOpen16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpen16FilledIcon, 'FolderOpen16Filled');

const FolderOpen16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 6a2 2 0 00-2-2H6.17l-1.1-.9a.5.5 0 00-.32-.1H3a2 2 0 00-2 2v6c0 1.1.9 2 2 2h9.25a1.5 1.5 0 001.44-1.08l1.17-4A1.5 1.5 0 0013.42 6H13zM3 4h1.58l1.1.89c.1.07.2.1.32.1h5a1 1 0 011 1V6H4.25a1.5 1.5 0 00-1.44 1.08L2 9.86V5a1 1 0 011-1zm.77 3.36A.5.5 0 014.25 7h9.17a.5.5 0 01.48.64l-1.17 4a.5.5 0 01-.48.36H3.08a.5.5 0 01-.48-.64l1.17-4z",
    fill: primaryFill
  }));
};

export const FolderOpen16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpen16RegularIcon, 'FolderOpen16Regular');

const FolderOpen20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h2.66c.33 0 .64.1.9.3l1.6 1.2h4.84A2.5 2.5 0 0117 7H5.82c-.71 0-1.33.51-1.47 1.22L2.77 16.3A2.5 2.5 0 012 14.5v-9zm1.77 10.9c-.06.32.18.6.5.6h10.91c.72 0 1.34-.5 1.47-1.21l1.4-7.2a.5.5 0 00-.5-.59H5.83a.5.5 0 00-.49.4l-1.56 8z",
    fill: primaryFill
  }));
};

export const FolderOpen20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpen20FilledIcon, 'FolderOpen20Filled');

const FolderOpen20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7.07V7a2.5 2.5 0 00-2.5-2.5H9.66l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.46 17h10.72c.72 0 1.34-.5 1.47-1.21l1.36-7A1.5 1.5 0 0017 7.07zM4.5 4h2.66c.11 0 .22.04.3.1L9.2 5.4c.08.06.19.1.3.1h5c.82 0 1.5.67 1.5 1.5H5.82c-.71 0-1.33.51-1.47 1.22l-1.3 6.67a1.5 1.5 0 01-.05-.4V5.5C3 4.67 3.67 4 4.5 4zm.83 4.4a.5.5 0 01.5-.4h10.7a.5.5 0 01.5.6l-1.36 7a.5.5 0 01-.49.4H4.46a.5.5 0 01-.49-.6l1.36-7z",
    fill: primaryFill
  }));
};

export const FolderOpen20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpen20RegularIcon, 'FolderOpen20Regular');

const FolderOpen24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.25C2 5 3 4 4.25 4h3.96c.52 0 1.03.18 1.43.52l2.39 1.98h5.72c1.24 0 2.25 1 2.25 2.25v.75H6.42c-1.03 0-1.93.7-2.18 1.7l-1.92 7.7c.04-.16 0 .01 0 0-.2-.33-.32-.73-.32-1.15V6.25zm1.74 13.13a.5.5 0 00.49.62h14.24c.8 0 1.5-.55 1.7-1.33l1.76-7.05a.5.5 0 00-.48-.62H6.42a.75.75 0 00-.73.57l-1.95 7.8z",
    fill: primaryFill
  }));
};

export const FolderOpen24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpen24FilledIcon, 'FolderOpen24Filled');

const FolderOpen24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 9.5v-.75c0-1.24-1-2.25-2.25-2.25h-5.72L9.64 4.52c-.4-.34-.9-.52-1.43-.52H4.25C3.01 4 2 5 2 6.25v11.5C2 18.99 3 20 4.25 20H18.47c.8 0 1.5-.55 1.7-1.33l1.75-7a1.75 1.75 0 00-1.7-2.17H20zm-15.75-4h3.96c.17 0 .34.06.48.17l2.58 2.16c.14.1.3.17.48.17h6c.41 0 .75.34.75.75v.75H6.42c-1.03 0-1.93.7-2.18 1.7l-.74 2.98V6.25c0-.41.34-.75.75-.75zm1.45 6.07a.75.75 0 01.72-.57h13.8c.16 0 .28.15.24.31l-1.75 7a.25.25 0 01-.24.19H4.28a.25.25 0 01-.24-.31l1.66-6.62z",
    fill: primaryFill
  }));
};

export const FolderOpen24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpen24RegularIcon, 'FolderOpen24Regular');

const FolderOpenVertical20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.14 2.87c-.1.2-.14.4-.14.63v10.63a2.5 2.5 0 001.6 2.33l4.36 1.68c.35.14.72.13 1.04.02V6.56a1.5 1.5 0 00-.96-1.39l-5.9-2.3zm.8-.76l5.47 2.13A2.5 2.5 0 0112 6.57V16h1.5c.83 0 1.5-.67 1.5-1.5v-2.94l.96-3.82c.02-.12.04-.24.04-.36V3.5c0-.83-.67-1.5-1.5-1.5h-9c-.2 0-.4.04-.57.11z",
    fill: primaryFill
  }));
};

export const FolderOpenVertical20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpenVertical20FilledIcon, 'FolderOpenVertical20Filled');

const FolderOpenVertical20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h9c.83 0 1.5.67 1.5 1.5v3.88c0 .12-.02.24-.04.36L15 11.56v2.94c0 .83-.67 1.5-1.5 1.5H12v.74a1.5 1.5 0 01-2.04 1.4L5.6 16.46A2.5 2.5 0 014 14.13V3.5zM7.19 3l3.21 1.24A2.5 2.5 0 0112 6.57V15h1.5a.5.5 0 00.5-.5v-3l.01-.12L15 7.5a.5.5 0 00.01-.12V3.5a.5.5 0 00-.5-.5H7.19zM5 3.96v10.17c0 .62.38 1.17.96 1.4l4.36 1.68a.5.5 0 00.68-.47V6.57a1.5 1.5 0 00-.96-1.4L5.68 3.5a.5.5 0 00-.68.47z",
    fill: primaryFill
  }));
};

export const FolderOpenVertical20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderOpenVertical20RegularIcon, 'FolderOpenVertical20Regular');

const FolderPeople20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.56 4.5h4.94a2.5 2.5 0 012.48 2.17l.01.17L18 7v4.38a2.24 2.24 0 00-2.76.2 2.75 2.75 0 10-4.54 3A2.31 2.31 0 009 17H4.5A2.5 2.5 0 012 14.66V7.5H7.22c.3-.04.6-.16.83-.36l.1-.1 2.41-2.54zM7.16 3c.28 0 .54.07.77.21l.14.09 1.31.99-1.95 2.05-.06.06a.5.5 0 01-.22.1H2v-1A2.5 2.5 0 014.34 3h2.83zm7.72 11.5zm-2.13 0a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM13 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 00-1.29-1.31H11.3A1.3 1.3 0 0010 16.81c0 1.1.86 2.19 3 2.19zm3.5-.5h-.02c.35-.51.52-1.1.52-1.69 0-.48-.15-.93-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87zm.25-4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const FolderPeople20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPeople20FilledIcon, 'FolderPeople20Filled');

const FolderPeople20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.17 3c.27 0 .53.07.76.21l.14.09 1.6 1.2h5.83a2.5 2.5 0 012.48 2.17l.01.17L18 7v4.38c-.3-.2-.63-.33-1-.37V7c0-.78-.6-1.42-1.36-1.5H9.62L8.16 7.03a1.5 1.5 0 01-.94.46l-.15.01H3v7c0 .78.6 1.42 1.36 1.5h4.79A2.33 2.33 0 009 17H4.5A2.5 2.5 0 012 14.66V5.5A2.5 2.5 0 014.34 3h2.83zm0 1H4.5c-.78 0-1.42.6-1.5 1.36V6.5h4.07a.5.5 0 00.3-.1l.06-.06L8.7 5.02 7.47 4.1a.5.5 0 00-.22-.1h-.08zm5.58 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM13 19c2.14 0 3-1.1 3-2.19a1.3 1.3 0 00-1.29-1.31H11.3A1.3 1.3 0 0010 16.81c0 1.1.86 2.19 3 2.19zm3.5-.5h-.02c.35-.51.52-1.1.52-1.69 0-.48-.15-.93-.4-1.31h1.33c.6 0 1.07.5 1.07 1.13 0 .93-.71 1.87-2.5 1.87zm.25-4a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const FolderPeople20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPeople20RegularIcon, 'FolderPeople20Regular');

const FolderPeople24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.82 6.5h5.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v4.55a2.74 2.74 0 00-3.15.46 3.25 3.25 0 10-5.43 3.26c-1.43.15-2.42 1.45-2.42 2.86V20H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm7.54 13a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm0 6c2.68 0 3.75-1.57 3.75-3.13 0-1.03-.72-1.87-1.6-1.87h-4.3c-.88 0-1.6.84-1.6 1.88 0 1.56 1.07 3.12 3.75 3.12zm6.75-7.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM19.92 22c.4-.66.58-1.4.58-2.13 0-.47-.11-.95-.32-1.37h1.54c.7 0 1.28.59 1.28 1.31 0 1.1-.85 2.19-3 2.19h-.08z",
    fill: primaryFill
  }));
};

export const FolderPeople24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPeople24FilledIcon, 'FolderPeople24Filled');

const FolderPeople24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v4.55a2.74 2.74 0 00-1.5-.29V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h7.08A3.02 3.02 0 0011 20H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01zM15.76 17a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm0 6c2.68 0 3.75-1.57 3.75-3.13 0-1.03-.72-1.87-1.6-1.87h-4.3c-.88 0-1.6.84-1.6 1.88 0 1.56 1.07 3.12 3.75 3.12zm6.75-7.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM19.92 22c.4-.66.58-1.4.58-2.13 0-.47-.11-.95-.32-1.37h1.54c.7 0 1.28.59 1.28 1.31 0 1.1-.85 2.19-3 2.19h-.08z",
    fill: primaryFill
  }));
};

export const FolderPeople24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPeople24RegularIcon, 'FolderPeople24Regular');

const FolderPerson16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 4h.03L5.56 5.5H2V5c0-1.1.9-2 2-2h1.75a.5.5 0 01.31.11L7.18 4zm-1.1 2.37L8.7 4H12a2 2 0 012 2v.34a3 3 0 10-4.73 3.67A2.5 2.5 0 007.04 13H4a2 2 0 01-2-2V6.5h3.75a.5.5 0 00.34-.13zM13.5 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const FolderPerson16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPerson16FilledIcon, 'FolderPerson16Filled');

const FolderPerson16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5v6c0 1.1.9 2 2 2h3.04a3.29 3.29 0 01.01-1H4a1 1 0 01-1-1V6.5h2.75a.5.5 0 00.34-.13L7.59 5h3.91A3 3 0 0114 6.34V6a2 2 0 00-2-2H7.18l-1.12-.89A.5.5 0 005.75 3H4a2 2 0 00-2 2zm1 0a1 1 0 011-1h1.57l.87.7-.88.8H3V5zm10.5 3a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const FolderPerson16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPerson16RegularIcon, 'FolderPerson16Regular');

const FolderPerson20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 4.5h-4.94l-2.4 2.53-.11.1c-.23.2-.52.33-.83.36l-.15.01H2v7.16A2.5 2.5 0 004.5 17h6.54a2.5 2.5 0 012.23-2.99A2.99 2.99 0 0115.5 9a3 3 0 012.5 1.34v-3.5l-.02-.17A2.5 2.5 0 0015.5 4.5zM7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v1h5.15a.5.5 0 00.22-.1l.06-.06L9.4 4.3 8.06 3.3l-.14-.09zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const FolderPerson20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPerson20FilledIcon, 'FolderPerson20Filled');

const FolderPerson20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v9.16A2.5 2.5 0 004.5 17h6.54a3.3 3.3 0 01.01-1H4.36A1.5 1.5 0 013 14.5v-7H7.22c.36-.04.69-.2.94-.47L9.62 5.5h6.02A1.5 1.5 0 0117 7v2.4c.4.23.74.56 1 .94v-3.5l-.02-.17A2.5 2.5 0 0015.5 4.5H9.67l-1.6-1.2-.14-.09zM4.5 4h2.75a.5.5 0 01.22.1l1.22.92-1.26 1.32-.06.06a.5.5 0 01-.3.1H3V5.36A1.5 1.5 0 014.5 4zm13 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const FolderPerson20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderPerson20RegularIcon, 'FolderPerson20Regular');

const FolderProhibited16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 3h.03L5.56 4.5H2V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.31.11L7.18 3zm-1.1 2.37L8.7 3H12a2 2 0 012 2v1.26A5.5 5.5 0 005.2 12H4a2 2 0 01-2-2V5.5h3.75a.5.5 0 00.34-.13zM10.5 15a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.8-2.4l4.9-4.9a3.5 3.5 0 00-4.9 4.9zm.7.7a3.5 3.5 0 004.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const FolderProhibited16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited16FilledIcon, 'FolderProhibited16Filled');

const FolderProhibited16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10V4c0-1.1.9-2 2-2h1.75a.5.5 0 01.31.11L7.18 3H12a2 2 0 012 2v1.26a5.5 5.5 0 00-1-.66V5a1 1 0 00-1-1H7.6L6.08 5.37a.5.5 0 01-.34.13H3V10a1 1 0 001 1h1.02c.03.34.1.68.19 1H4a2 2 0 01-2-2zm2-7a1 1 0 00-1 1v.5h2.56l.88-.8-.87-.7H4zm6.5 12a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-2.8-2.4l4.9-4.9a3.5 3.5 0 00-4.9 4.9zm.7.7a3.5 3.5 0 004.9-4.9l-4.9 4.9z",
    fill: primaryFill
  }));
};

export const FolderProhibited16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited16RegularIcon, 'FolderProhibited16Regular');

const FolderProhibited20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zm-.56 10a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.5-3.5a3.5 3.5 0 00-2.8 5.6l4.9-4.9a3.48 3.48 0 00-2.1-.7zm0 7a3.5 3.5 0 002.8-5.6l-4.9 4.9c.59.44 1.31.7 2.1.7z",
    fill: primaryFill
  }));
};

export const FolderProhibited20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited20FilledIcon, 'FolderProhibited20Filled');

const FolderProhibited20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5A2.5 2.5 0 014.5 3h2.67c.32 0 .64.1.9.3l1.6 1.2h5.83A2.5 2.5 0 0118 7v3.26a5.5 5.5 0 00-1-.66V7c0-.83-.67-1.5-1.5-1.5H9.62L8.16 7.03c-.29.3-.68.47-1.09.47H3v7c0 .83.67 1.5 1.5 1.5h4.7c.1.35.24.68.4 1H4.5A2.5 2.5 0 012 14.5v-9zM4.5 4C3.67 4 3 4.67 3 5.5v1h4.07a.5.5 0 00.36-.16L8.7 5.02 7.47 4.1a.5.5 0 00-.3-.1H4.5zM10 14.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm4.5-3.5a3.5 3.5 0 00-2.8 5.6l4.9-4.9a3.48 3.48 0 00-2.1-.7zm2.8 1.4l-4.9 4.9a3.5 3.5 0 004.9-4.9z",
    fill: primaryFill
  }));
};

export const FolderProhibited20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited20RegularIcon, 'FolderProhibited20Regular');

const FolderProhibited24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 11a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm3.3 3.25l-5.55 5.56a4 4 0 005.56-5.56zM19.76 6.5c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.5 6.5 0 00-9.98 8.2L4.25 20c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48h5.93zm-2.25 6a4 4 0 00-3.3 6.25l5.55-5.56a3.98 3.98 0 00-2.25-.69zM8.2 4c.47 0 .92.14 1.3.4l.15.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96z",
    fill: primaryFill
  }));
};

export const FolderProhibited24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited24FilledIcon, 'FolderProhibited24Filled');

const FolderProhibited24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 11a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm3.3 3.25l-5.55 5.56a4 4 0 005.56-5.56zM8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h7.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm9.3 8.5a4 4 0 00-3.3 6.25l5.55-5.56a3.98 3.98 0 00-2.25-.69zm-9.3-7H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01z",
    fill: primaryFill
  }));
};

export const FolderProhibited24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited24RegularIcon, 'FolderProhibited24Regular');

const FolderProhibited28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.82 6.5h7.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v6.65A7.5 7.5 0 0013.87 24H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V10.5H10.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM10.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zM20.5 27a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0-1.5a4.98 4.98 0 01-2.97-.97l7-7a5 5 0 01-4.03 7.97zm2.97-9.03l-7 7a5 5 0 017-7z",
    fill: primaryFill
  }));
};

export const FolderProhibited28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited28FilledIcon, 'FolderProhibited28Filled');

const FolderProhibited28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h9.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v6.65c-.44-.48-.95-.9-1.5-1.25v-5.4c0-.38-.28-.7-.65-.74l-.1-.01h-9.73l-2.37 1.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v11.25c0 .38.28.7.65.74l.1.01h9.02c.14.53.35 1.03.6 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 21.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h5.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h6.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01zM20.5 27a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0-1.5a4.98 4.98 0 01-2.97-.97l7-7a5 5 0 01-4.03 7.97zm2.97-9.03l-7 7a5 5 0 017-7z",
    fill: primaryFill
  }));
};

export const FolderProhibited28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited28RegularIcon, 'FolderProhibited28Regular');

const FolderProhibited48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M36 23a10 10 0 110 20 10 10 0 010-20zm6.11 5.65L31.65 39.11a7.5 7.5 0 0010.46-10.46zM40.25 12.5c2 0 3.64 1.57 3.74 3.55l.01.2v7.8A12 12 0 0025.6 39l-17.85.01c-2 0-3.64-1.57-3.74-3.55l-.01-.2V19H18.03c.97-.07 1.89-.5 2.55-1.23l.14-.17 4.11-5.1h15.42zM36 25.5a7.5 7.5 0 00-6.11 11.85l10.46-10.46A7.47 7.47 0 0036 25.5zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.44 2.14-3.2 3.96-.09.1c-.2.2-.46.33-.74.36l-.14.01H4v-3.75c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31z",
    fill: primaryFill
  }));
};

export const FolderProhibited48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited48FilledIcon, 'FolderProhibited48Filled');

const FolderProhibited48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M36 23a10 10 0 110 20 10 10 0 010-20zm6.11 5.65L31.65 39.11a7.5 7.5 0 0010.46-10.46zM17.06 9c.83 0 1.64.28 2.3.78l.17.15 2.59 2.26c.19.17.42.27.67.3l.15.01h17.31c2 0 3.64 1.57 3.74 3.55l.01.2v7.8c-.75-.67-1.6-1.25-2.5-1.72v-6.08c0-.65-.5-1.18-1.12-1.24l-.13-.01h-17.4l-2.13 2.61A3.75 3.75 0 0118.04 19l-.23.01H6.5v16.25c0 .65.5 1.18 1.12 1.24l.13.01h16.77c.27.88.63 1.72 1.09 2.5H7.75c-2 0-3.64-1.57-3.74-3.55l-.01-.2v-22.5c0-2 1.57-3.64 3.55-3.74l.2-.01h9.31zM36 25.5a7.5 7.5 0 00-6.11 11.85l10.46-10.46A7.47 7.47 0 0036 25.5zm-18.94-14H7.75c-.65 0-1.18.5-1.24 1.12l-.01.13v3.75h11.31c.33 0 .64-.13.88-.36l.09-.1 1.63-2.01-2.53-2.22a1.25 1.25 0 00-.67-.3l-.15-.01z",
    fill: primaryFill
  }));
};

export const FolderProhibited48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderProhibited48RegularIcon, 'FolderProhibited48Regular');

const FolderSwap16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 4L5.56 5.5H2V5c0-1.1.9-2 2-2h1.75a.5.5 0 01.32.11l1.1.89zM2 11V6.5h3.75a.5.5 0 00.34-.13L8.65 4H12a2 2 0 012 2v2.88l-.44-.44a1.5 1.5 0 00-2.56 1 1.5 1.5 0 00-2.56-1l-2 2a1.5 1.5 0 000 2.13l.44.43H4a2 2 0 01-2-2zm6.71 1l1.15 1.15a.5.5 0 01-.71.7l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L8.72 11h4.58l-1.14-1.14a.5.5 0 11.7-.7l2 1.99a.5.5 0 010 .7l-2 2a.5.5 0 11-.7-.7L13.29 12H8.71z",
    fill: primaryFill
  }));
};

export const FolderSwap16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwap16FilledIcon, 'FolderSwap16Filled');

const FolderSwap16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 11V6.5h2.75a.5.5 0 00.39-.18L7.24 5H12a1 1 0 011 1v2.09c.2.07.4.19.56.35l.44.44V6a2 2 0 00-2-2H7.18l-1.11-.89A.5.5 0 005.75 3H4a2 2 0 00-2 2v6c0 1.1.9 2 2 2h2.88l-.44-.43a1.5 1.5 0 01-.36-.57H4a1 1 0 01-1-1zm1-7h1.58l.71.57-.77.93H3V5a1 1 0 011-1zm5.86 5.86a.5.5 0 00-.71-.7l-2 1.99a.5.5 0 000 .7l2 2a.5.5 0 10.7-.7L8.72 12h4.58l-1.14 1.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 00-.7.7L13.29 11H8.71l1.15-1.14z",
    fill: primaryFill
  }));
};

export const FolderSwap16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwap16RegularIcon, 'FolderSwap16Regular');

const FolderSwap20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.56 4.5h4.94a2.5 2.5 0 012.48 2.17l.01.17L18 7v6.88l-1.44-1.44A1.5 1.5 0 0014.08 14h-1.16a1.5 1.5 0 00-2.48-1.56l-2 2a1.5 1.5 0 000 2.13l.44.43H4.5A2.5 2.5 0 012 14.66V7.5H7.22c.3-.04.6-.16.83-.36l.1-.1 2.41-2.54zM7.16 3c.28 0 .54.07.77.21l.14.09 1.31.99-1.95 2.05-.06.06a.5.5 0 01-.22.1H2v-1A2.5 2.5 0 014.34 3h2.83zm4.7 10.86a.5.5 0 00-.71-.7l-2 1.99a.5.5 0 000 .7l2 2a.5.5 0 10.7-.7L10.72 16h5.58l-1.14 1.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 10-.7.7L16.29 15h-5.58l1.15-1.14z",
    fill: primaryFill
  }));
};

export const FolderSwap20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwap20FilledIcon, 'FolderSwap20Filled');

const FolderSwap20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v9.16A2.5 2.5 0 004.5 17h4.38l-.44-.43a1.5 1.5 0 01-.36-.57H4.36A1.5 1.5 0 013 14.5v-7H7.22c.36-.04.69-.2.94-.47L9.62 5.5h6.02A1.5 1.5 0 0117 7v5.88l1 1V6.84l-.02-.17A2.5 2.5 0 0015.5 4.5H9.67l-1.6-1.2-.14-.09zM4.5 4h2.75a.5.5 0 01.22.1l1.22.92-1.26 1.32-.06.06a.5.5 0 01-.3.1H3V5.36A1.5 1.5 0 014.5 4zm7.36 9.86a.5.5 0 00-.71-.7l-2 1.99a.5.5 0 000 .7l2 2a.5.5 0 10.7-.7L10.72 16h5.58l-1.14 1.15a.5.5 0 10.7.7l2-2a.5.5 0 000-.7l-2-2a.5.5 0 10-.7.7L16.29 15h-5.58l1.15-1.14z",
    fill: primaryFill
  }));
};

export const FolderSwap20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwap20RegularIcon, 'FolderSwap20Regular');

const FolderSwap24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.82 6.5h5.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v8.28l-2.01-2.01A1.75 1.75 0 0017.17 17h-2.33A1.75 1.75 0 0012 15.02l-2.5 2.5a1.75 1.75 0 000 2.48H4.26c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm5.57 12.79a.75.75 0 00-1.06-1.06l-2.5 2.5a.75.75 0 000 1.06l2.5 2.5a.75.75 0 101.06-1.07l-1.22-1.22h6.88l-1.22 1.22a.75.75 0 101.06 1.06l2.5-2.5a.75.75 0 000-1.06l-2.5-2.5a.75.75 0 00-1.06 1.06L19.44 18h-6.87l1.21-1.21z",
    fill: primaryFill
  }));
};

export const FolderSwap24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwap24FilledIcon, 'FolderSwap24Filled');

const FolderSwap24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v8.28l-1.5-1.5V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h4.77a1.75 1.75 0 00.5 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01zm5.58 11.29a.75.75 0 00-1.06-1.06l-2.5 2.5a.75.75 0 000 1.06l2.5 2.5a.75.75 0 101.06-1.07l-1.22-1.22h6.88l-1.22 1.22a.75.75 0 101.06 1.06l2.5-2.5a.75.75 0 000-1.06l-2.5-2.5a.75.75 0 00-1.06 1.06L19.44 18h-6.87l1.21-1.21z",
    fill: primaryFill
  }));
};

export const FolderSwap24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSwap24RegularIcon, 'FolderSwap24Regular');

const FolderSync16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.2 3h-.02l-1.12-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2v.5h3.56L7.2 3zm1.5 0L6.08 5.37a.5.5 0 01-.34.13H2V10c0 1.1.9 2 2 2h1.2A5.5 5.5 0 0114 6.26V5a2 2 0 00-2-2H8.7zM6 10.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 01-.71-.71A3 3 0 0112 8.15V8c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 019 12.85V13a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H10a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const FolderSync16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSync16FilledIcon, 'FolderSync16Filled');

const FolderSync16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4v6c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H4a1 1 0 01-1-1V5.5h2.75a.5.5 0 00.34-.13L7.59 4H12a1 1 0 011 1v.6c.36.18.7.4 1 .66V5a2 2 0 00-2-2H7.18l-1.12-.89A.5.5 0 005.75 2H4a2 2 0 00-2 2zm1 0a1 1 0 011-1h1.57l.87.7-.88.8H3V4zm3 6.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 01-.71-.71A3 3 0 0112 8.15V8c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 019 12.85V13a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H10a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const FolderSync16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSync16RegularIcon, 'FolderSync16Regular');

const FolderSync20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 4.29L8.07 3.3a1.5 1.5 0 00-.9-.3H4.5A2.5 2.5 0 002 5.5v1h5.07a.5.5 0 00.36-.16L9.4 4.3zm1.17.21l-2.4 2.53c-.29.3-.68.47-1.09.47H2v7A2.5 2.5 0 004.5 17h5.1a5.5 5.5 0 018.4-6.74V6.84a2.5 2.5 0 00-2.5-2.34h-4.94zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const FolderSync20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSync20FilledIcon, 'FolderSync20Filled');

const FolderSync20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3A2.5 2.5 0 002 5.5v9A2.5 2.5 0 004.5 17h5.1c-.16-.32-.3-.65-.4-1H4.5A1.5 1.5 0 013 14.5v-7h4.07c.41 0 .8-.17 1.09-.47L9.62 5.5h5.88c.83 0 1.5.67 1.5 1.5v2.6c.36.18.7.4 1 .66V7a2.5 2.5 0 00-2.5-2.5H9.67l-1.6-1.2a1.5 1.5 0 00-.9-.3H4.5zM3 5.5C3 4.67 3.67 4 4.5 4h2.67c.1 0 .21.04.3.1l1.22.92-1.26 1.32a.5.5 0 01-.36.16H3v-1zM14.5 19a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.5-7v.15a3.01 3.01 0 00-3.62.48.5.5 0 00.7.7 2 2 0 012.39-.33H15a.5.5 0 000 1h1.5a.5.5 0 00.5-.5V12a.5.5 0 00-1 0zm-1.55 5.25a3 3 0 002.17-.88.5.5 0 00-.7-.7 2 2 0 01-2.39.33H14a.5.5 0 000-1h-1.5a.5.5 0 00-.5.5V17a.5.5 0 001 0v-.15a3.01 3.01 0 001.45.4z",
    fill: primaryFill
  }));
};

export const FolderSync20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSync20RegularIcon, 'FolderSync20Regular');

const FolderSync24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.82 6.5h5.93c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06A6.5 6.5 0 0012.02 20H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V10.5h6.4c.4-.04.77-.18 1.1-.4l.15-.12 4.17-3.48zM8.21 4c.46 0 .9.14 1.28.4l.16.12 2.1 1.75-3.06 2.56-.09.06a.75.75 0 01-.29.1l-.1.01H2V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zM12 16.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM15 18.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const FolderSync24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSync24FilledIcon, 'FolderSync24Filled');

const FolderSync24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 4c.47 0 .92.14 1.3.4l.15.12 2.37 1.98h7.73c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v3.06a6.52 6.52 0 00-1.5-1.08V8.75c0-.38-.28-.7-.65-.74l-.1-.01h-7.73L9.65 9.98c-.36.3-.8.47-1.25.51l-.2.01H3.5v7.25c0 .38.28.7.65.74l.1.01h7.06c.18.53.42 1.04.71 1.5H4.25c-1.2 0-2.17-.93-2.24-2.1L2 17.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h3.96zm0 1.5H4.26c-.38 0-.7.28-.74.65l-.01.1V9h4.7c.15 0 .28-.04.4-.11l.09-.06 1.89-1.58-1.9-1.58a.75.75 0 00-.37-.16l-.1-.01zm3.8 11a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM15 18.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const FolderSync24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderSync24RegularIcon, 'FolderSync24Regular');

const FolderZip16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4h-.35L6.1 6.37a.5.5 0 01-.34.13H2V11c0 1.1.9 2 2 2h6v-2h-.5a.5.5 0 010-1h.5V9h-.5a.5.5 0 010-1h.5V7h-.5a.5.5 0 01-.5-.5V4zm2 9h1a2 2 0 002-2V6a2 2 0 00-2-2v2.5a.5.5 0 01-.5.5H11v2h.5a.5.5 0 110 1H11v3zm-1-9h1v2h-1V4zM2 5.5V5c0-1.1.9-2 2-2h1.75a.5.5 0 01.32.11l1.1.89h.01L5.56 5.5H2z",
    fill: primaryFill
  }));
};

export const FolderZip16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZip16FilledIcon, 'FolderZip16Filled');

const FolderZip16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.18 4l-1.11-.89A.5.5 0 005.75 3H4a2 2 0 00-2 2v6c0 1.1.9 2 2 2h8a2 2 0 002-2V6a2 2 0 00-2-2H7.18zM4 4h1.58l.71.57-.77.93H3V5a1 1 0 011-1zm-1 7V6.5h2.75a.5.5 0 00.39-.18L7.24 5H9v1.5c0 .28.22.5.5.5h.5v1h-.5a.5.5 0 100 1h.5v1h-.5a.5.5 0 000 1h.5v1H4a1 1 0 01-1-1zm8 1v-2h.5a.5.5 0 100-1H11V7h.5a.5.5 0 00.5-.5V5a1 1 0 011 1v5a1 1 0 01-1 1h-1zm-1-7h1v1h-1V5z",
    fill: primaryFill
  }));
};

export const FolderZip16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZip16RegularIcon, 'FolderZip16Regular');

const FolderZip20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 4.5h-1.44l-2.4 2.53-.11.1c-.23.2-.52.33-.83.36l-.15.01H2v7.16A2.5 2.5 0 004.5 17H13v-1.94a.52.52 0 010-.12V14h-.5a.5.5 0 010-1h.5v-2h-.5a.5.5 0 010-1h.5V9h-.5a.5.5 0 01-.5-.5v-4zm2 0h-1V8h1V4.5zm1 0h.5a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H14v-1.5h.5a.5.5 0 000-1H14v-.96a.48.48 0 000-.09v-.95h.5a.5.5 0 100-1H14V9h.5a.5.5 0 00.5-.5v-4zM7.93 3.21A1.5 1.5 0 007.17 3H4.34A2.5 2.5 0 002 5.5v1h5.15a.5.5 0 00.22-.1l.06-.06L9.4 4.3 8.06 3.3l-.14-.09z",
    fill: primaryFill
  }));
};

export const FolderZip20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZip20FilledIcon, 'FolderZip20Filled');

const FolderZip20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.17 3c.27 0 .53.07.76.21l.14.09 1.6 1.2h5.83a2.5 2.5 0 012.48 2.17l.01.17L18 7v7.5a2.5 2.5 0 01-2.34 2.5H4.5A2.5 2.5 0 012 14.66V5.5A2.5 2.5 0 014.34 3h2.83zM14 5.5h-1V8h1V5.5zm-2 0H9.62L8.16 7.03a1.5 1.5 0 01-.94.46l-.15.01H3v7c0 .78.6 1.42 1.36 1.5H13v-.94a.51.51 0 010-.12V14h-.5a.5.5 0 110-1h.5v-2h-.5a.5.5 0 010-1h.5V9h-.5a.5.5 0 01-.5-.5v-3zm2 9h.5a.5.5 0 010 1H14v.5h1.5c.78 0 1.42-.6 1.5-1.36V7c0-.78-.6-1.42-1.36-1.5H15v3a.5.5 0 01-.5.5H14v2.5h.5a.5.5 0 010 1H14v.96a.48.48 0 010 .08v.96zM7.17 4H4.5c-.78 0-1.42.6-1.5 1.36V6.5h4.07a.5.5 0 00.3-.1l.06-.06L8.7 5.02 7.47 4.1a.5.5 0 00-.22-.1h-.08z",
    fill: primaryFill
  }));
};

export const FolderZip20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZip20RegularIcon, 'FolderZip20Regular');

const FolderZip24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6.5h-.18L9.65 9.98l-.16.12c-.32.22-.7.36-1.09.4H2v7.4A2.25 2.25 0 004.26 20H15.5v-3.5h-.25a.75.75 0 010-1.5h.25v-1.5h-.25a.75.75 0 010-1.5h.25v-1h-.75a.75.75 0 01-.75-.75V6.5zm1.5 0H17v2.75h-1.5V6.5zm3 0h1.25c1.14 0 2.08.84 2.23 1.94l.01.16.01.15v9c0 1.2-.93 2.17-2.1 2.24l-.15.01H17v-2h.25a.75.75 0 000-1.5H17V15h.25a.75.75 0 000-1.5H17V11h.75c.41 0 .75-.34.75-.75V6.5zm-9-2.1c-.38-.26-.83-.4-1.3-.4H4.1A2.25 2.25 0 002 6.26V9H8.31c.1-.02.2-.06.3-.11l.08-.06 3.06-2.56-2.1-1.75-.16-.12z",
    fill: primaryFill
  }));
};

export const FolderZip24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZip24FilledIcon, 'FolderZip24Filled');

const FolderZip24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 4.4c-.38-.26-.83-.4-1.3-.4H4.1A2.25 2.25 0 002 6.26V17.9A2.25 2.25 0 004.26 20H19.9a2.25 2.25 0 002.1-2.25V8.6l-.02-.16a2.25 2.25 0 00-2.23-1.94h-7.73L9.65 4.52l-.16-.12zm4 3.6v2.25c0 .4.33.75.75.75H15v1h-.25a.75.75 0 000 1.5H15V15h-.25a.75.75 0 000 1.5H15v2H4.15a.75.75 0 01-.65-.75V10.5h4.9c.46-.05.9-.23 1.25-.52L12.02 8h1.48zm3 10h.25a.75.75 0 000-1.5h-.25V15h.25a.75.75 0 000-1.5h-.25V11h.75c.41 0 .75-.34.75-.75V8h1.85c.37.06.65.37.65.75v9.1a.75.75 0 01-.75.65H16.5V18zm0-10v1.5H15V8h1.5zM4.25 5.5h4.06c.14.03.27.08.38.17l1.89 1.58-1.9 1.58-.08.06a.75.75 0 01-.4.11H3.5V6.15a.75.75 0 01.75-.65z",
    fill: primaryFill
  }));
};

export const FolderZip24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FolderZip24RegularIcon, 'FolderZip24Regular');

const FontDecrease20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.24 2.18a.75.75 0 00-.98 1.14l1.75 1.5c.28.24.7.24.98 0l1.75-1.5a.75.75 0 10-.98-1.14L15.5 3.26l-1.26-1.08zM10 4c-.3 0-.58.19-.7.47l-4.25 10.5a.75.75 0 101.4.56L7.87 12h4.26l1.42 3.53a.75.75 0 101.4-.56L10.7 4.47A.75.75 0 0010 4zm0 2.75l1.52 3.75H8.48L10 6.75z",
    fill: primaryFill
  }));
};

export const FontDecrease20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontDecrease20FilledIcon, 'FontDecrease20Filled');

const FontDecrease20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.15 2.15c.2-.2.5-.2.7 0l1.65 1.64 1.65-1.64a.5.5 0 11.7.7l-2 2a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7zM10 4c.2 0 .39.12.46.31l4.5 11a.5.5 0 11-.92.38l-1.54-3.76V12h-5v-.07L5.96 15.7a.5.5 0 11-.92-.38l4.5-11A.5.5 0 0110 4zm-2.12 7h4.24L10 5.82 7.88 11z",
    fill: primaryFill
  }));
};

export const FontDecrease20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontDecrease20RegularIcon, 'FontDecrease20Regular');

const FontDecrease24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.62 2.22a1 1 0 10-1.24 1.56l2.5 2a1 1 0 001.24 0l2.5-2a1 1 0 00-1.24-1.56l-1.88 1.5-1.88-1.5zM12 4a1 1 0 01.92.6l6 14a1 1 0 01-1.84.8L15.2 15H8.8l-1.88 4.4a1 1 0 01-1.84-.8l6-14A1 1 0 0112 4zm0 3.54L9.66 13h4.68L12 7.54z",
    fill: primaryFill
  }));
};

export const FontDecrease24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontDecrease24FilledIcon, 'FontDecrease24Filled');

const FontDecrease24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 2.2a.75.75 0 00-1 1.1L18 5.8c.28.26.72.26 1 0l2.75-2.5a.75.75 0 10-1-1.1L18.5 4.24 16.25 2.2zM12 4c.3 0 .58.19.7.47l5.75 14.5a.75.75 0 01-1.4.56L15.25 15h-6.5l-1.8 4.53a.75.75 0 11-1.4-.56l5.75-14.5A.75.75 0 0112 4zm0 2.78L9.34 13.5h5.32L12 6.78z",
    fill: primaryFill
  }));
};

export const FontDecrease24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontDecrease24RegularIcon, 'FontDecrease24Regular');

const FontIncrease20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.24 4.82a.75.75 0 01-.98-1.14l1.75-1.5c.28-.24.7-.24.98 0l1.75 1.5a.75.75 0 11-.98 1.14L15.5 3.74l-1.26 1.08zM10 3.75c-.3 0-.58.18-.7.47l-4.5 11a.75.75 0 001.4.56l1.44-3.53h4.72l1.45 3.53a.75.75 0 101.38-.56l-4.5-11a.75.75 0 00-.69-.47zm0 2.73l1.75 4.27h-3.5L10 6.48z",
    fill: primaryFill
  }));
};

export const FontIncrease20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontIncrease20FilledIcon, 'FontIncrease20Filled');

const FontIncrease20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.85 4.85a.5.5 0 01-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 01-.7.7L15.5 3.21l-1.65 1.64zM10 4a.5.5 0 00-.46.31l-4.5 11a.5.5 0 10.92.38l1.54-3.76V12h5v-.07l1.54 3.76a.5.5 0 10.92-.38l-4.5-11A.5.5 0 0010 4zm0 1.82L12.12 11H7.88L10 5.82z",
    fill: primaryFill
  }));
};

export const FontIncrease20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontIncrease20RegularIcon, 'FontIncrease20Regular');

const FontIncrease24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.62 5.78a1 1 0 01-1.24-1.56l2.5-2a1 1 0 011.24 0l2.5 2a1 1 0 01-1.24 1.56l-1.88-1.5-1.88 1.5zm-3.7-1.17a1 1 0 00-1.84 0l-6 14a1 1 0 001.84.78L8.8 15h6.4l1.88 4.4a1 1 0 001.84-.8l-6-14zM12 7.54L14.34 13H9.66L12 7.54z",
    fill: primaryFill
  }));
};

export const FontIncrease24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontIncrease24FilledIcon, 'FontIncrease24Filled');

const FontIncrease24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.2 5.75c.27.31.75.33 1.05.05l2.25-2.04 2.25 2.04a.75.75 0 001-1.1L19 2.2a.75.75 0 00-1 0l-2.75 2.5a.75.75 0 00-.05 1.05zM12 4c.3 0 .58.19.7.47l5.75 14.5a.75.75 0 01-1.4.56L15.25 15h-6.5l-1.8 4.53a.75.75 0 11-1.4-.56l5.75-14.5A.75.75 0 0112 4zm-2.66 9.5h5.32L12 6.78 9.34 13.5z",
    fill: primaryFill
  }));
};

export const FontIncrease24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontIncrease24RegularIcon, 'FontIncrease24Regular');

const FontSpaceTrackingIn16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 9c.3 0 .58-.18.7-.47l2.24-5.5a.75.75 0 00-1.38-.56l-1.56 3.8-1.56-3.8a.75.75 0 10-1.38.56l2.25 5.5c.11.29.39.47.69.47zM6.2 2.47a.75.75 0 00-1.4 0l-2.24 5.5a.75.75 0 001.38.56l.43-1.03h2.26l.43 1.03a.75.75 0 001.38-.56L6.2 2.47zm-.7 2.26L6.02 6H4.98l.52-1.27zm.03 5.49a.75.75 0 00-1.09 1.03H2.68a.75.75 0 100 1.5h1.76a.75.75 0 001.09 1.03l1.25-1.25a.75.75 0 000-1.06l-1.25-1.25zm6 3.56c-.3.3-.77.3-1.06 0l-1.25-1.25a.75.75 0 010-1.06l1.25-1.25a.75.75 0 011.11 1h1.74a.75.75 0 110 1.5h-1.79c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn16FilledIcon, 'FontSpaceTrackingIn16Filled');

const FontSpaceTrackingIn16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.96 2.3a.5.5 0 00-.92 0l-1.66 4-.01.02-.83 1.99a.5.5 0 10.92.38L4.16 7h2.67l.7 1.7a.5.5 0 00.93-.4l-.81-1.94a.5.5 0 00-.04-.1L5.96 2.31zM5.5 3.8L6.42 6H4.58l.92-2.2zm-.15 6.35a.5.5 0 10-.7.7l.64.65H2.5a.5.5 0 000 1h2.8l-.65.65a.5.5 0 10.7.7l1.5-1.5a.5.5 0 000-.7l-1.5-1.5zM10.5 9a.5.5 0 00.46-.3l2.5-6a.5.5 0 10-.92-.4L10.5 7.2 8.46 2.3a.5.5 0 10-.92.4l2.5 6c.08.18.26.3.46.3zm.85 4.85a.5.5 0 01-.7 0l-1.5-1.5a.5.5 0 010-.7l1.5-1.5a.5.5 0 11.7.7l-.64.65h2.79a.5.5 0 010 1h-2.8l.65.65c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn16RegularIcon, 'FontSpaceTrackingIn16Regular');

const FontSpaceTrackingIn20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.7 2.48a.75.75 0 00-1.4 0l-3.25 8.5a.75.75 0 001.4.53l.77-2.01h3.56l.77 2.01a.75.75 0 001.4-.53L7.7 2.48zM8.2 8H5.8L7 4.85 8.2 8zm-1.46 5.19a.75.75 0 10-.99 1.12l.5.44h-2.5a.75.75 0 000 1.5h2.5l-.5.44a.75.75 0 101 1.12l2-1.75a.75.75 0 000-1.13l-2-1.74zM13 12c.31 0 .59-.2.7-.48l3.25-8.5a.75.75 0 10-1.4-.53L13 9.15 10.45 2.5a.75.75 0 00-1.4.53l3.25 8.5c.11.29.39.48.7.48zm1.31 5.74a.75.75 0 01-1.05.07l-2-1.74a.75.75 0 010-1.13l2-1.75a.75.75 0 11.98 1.12l-.5.44h2.51a.75.75 0 010 1.5h-2.5l.5.44c.3.27.34.74.06 1.05z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn20FilledIcon, 'FontSpaceTrackingIn20Filled');

const FontSpaceTrackingIn20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 12c.2 0 .38-.12.46-.32l3.5-9.02a.5.5 0 10-.93-.36L13 10.12 9.95 2.3a.5.5 0 00-.93.36l3.5 9.02c.08.2.27.32.47.32zM7.46 2.3a.5.5 0 00-.93 0l-2.34 6v.03l-1.17 3a.5.5 0 10.93.35L5.01 9h4l1.04 2.68a.5.5 0 10.93-.36L9.83 8.37a.5.5 0 00-.04-.11L7.47 2.3zM8.61 8H5.4L7 3.86 8.61 8zM6.5 13.12a.5.5 0 10-.65.76L7.14 15H3.5a.5.5 0 000 1h3.65l-1.3 1.12a.5.5 0 10.64.76l2.33-2a.5.5 0 000-.76l-2.33-2zm7.72 4.7a.5.5 0 01-.7.06l-2.34-2a.5.5 0 010-.76l2.33-2a.5.5 0 11.65.76L12.85 15h3.65a.5.5 0 010 1h-3.65l1.3 1.12c.21.18.24.5.06.7z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn20RegularIcon, 'FontSpaceTrackingIn20Regular');

const FontSpaceTrackingIn24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.61 16.21l.1.08 2 2a1 1 0 01.08 1.32l-.08.1-2 2a1 1 0 01-1.5-1.32l.08-.1.3-.3L4 20a1 1 0 01-.12-2h3.7l-.29-.3a1 1 0 01-.08-1.31l.08-.1a1 1 0 011.32-.08zm6.78 0a1 1 0 011.22 0l.1.08.08.1a1 1 0 010 1.22l-.08.1-.3.29H20a1 1 0 01.12 2H16.4l.3.3.08.09a1 1 0 01-1.4 1.4l-.1-.08-2-2-.08-.1a1 1 0 010-1.22l.08-.1 2-2 .1-.08zM9.12 2.45l.06.1.06.12 4.3 11a1 1 0 01-1.81.83l-.05-.1-1.11-2.85H6.04l-1.1 2.84a1 1 0 01-1.2.6l-.1-.03a1 1 0 01-.6-1.18l.03-.11 4.3-11a1 1 0 011.75-.22zm10.02.08a1 1 0 011.85.72l-.04.11-4.3 11-.05.12a1 1 0 01-1.76 0l-.05-.12-4.3-11-.04-.1a1 1 0 01.5-1.14l.1-.05.11-.04a1 1 0 011.14.5l.05.1 3.37 8.63 3.37-8.62.05-.11zM8.3 5.77L6.82 9.55h2.96L8.3 5.77z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn24FilledIcon, 'FontSpaceTrackingIn24Filled');

const FontSpaceTrackingIn24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.45 16.15l.08.07 2.25 2.25c.27.27.3.68.07.98l-.07.08-2.25 2.25a.75.75 0 01-1.13-.98l.07-.08.97-.97H3.75a.75.75 0 01-.1-1.5h4.79l-.97-.97a.75.75 0 01-.07-.98l.07-.08a.75.75 0 01.98-.07zm7.1 0c.26-.2.62-.2.89-.01l.09.08.07.08c.2.26.2.62.01.89l-.08.09-.97.97h4.69a.75.75 0 01.1 1.5h-4.79l.97.97.07.08a.75.75 0 01-1.05 1.05l-.08-.07-2.25-2.25-.07-.08a.75.75 0 01-.01-.89l.08-.09 2.25-2.25.08-.07zM8.84 2.28l.06.1.05.1 4.5 11.5a.75.75 0 01-1.35.64l-.05-.1-1.23-3.15H5.68l-1.23 3.15a.75.75 0 01-.88.46l-.1-.03a.75.75 0 01-.45-.88l.03-.1 4.5-11.5a.75.75 0 011.29-.2zm10.76.1a.75.75 0 011.38.55l-.03.1-4.5 11.5-.05.1a.75.75 0 01-1.3 0l-.05-.1-4.5-11.5-.03-.1a.75.75 0 01.36-.83l.1-.05.1-.03c.32-.08.65.07.82.36l.05.1 3.8 9.71 3.8-9.71.05-.1zM8.25 4.81L6.27 9.87h3.96L8.25 4.8z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn24RegularIcon, 'FontSpaceTrackingIn24Regular');

const FontSpaceTrackingIn28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.5 17a1 1 0 00.92-.61l5.5-13a1 1 0 00-1.84-.78L18.5 13.43 13.92 2.61a1 1 0 10-1.84.78l5.5 13a1 1 0 00.92.61zM10.42 2.61a1 1 0 00-1.84 0l-5.5 13a1 1 0 101.84.78L6.35 13h6.3l1.43 3.39a1 1 0 101.84-.78l-5.5-13zm1.38 8.4H7.2l2.3-5.44L11.8 11zm-2.16 8.22a1 1 0 00-1.28 1.54l.88.73H4a1 1 0 100 2h5.24l-.88.73a1 1 0 001.28 1.54l3-2.5a1 1 0 000-1.54l-3-2.5zm10.13 6.41a1 1 0 01-1.41.13l-3-2.5a1 1 0 010-1.54l3-2.5a1 1 0 011.28 1.54l-.88.73h5.21a1 1 0 110 2h-5.2l.87.73a1 1 0 01.13 1.41z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn28FilledIcon, 'FontSpaceTrackingIn28Filled');

const FontSpaceTrackingIn28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.5 17c.3 0 .57-.18.69-.46l5.75-13.5a.75.75 0 10-1.38-.58L18.5 14.34 13.44 2.46a.75.75 0 10-1.38.58l5.75 13.5c.12.28.39.46.69.46zM10.19 2.46a.75.75 0 00-1.38 0l-3.83 8.98-.01.03-1.91 4.49a.75.75 0 001.38.58l1.72-4.04h6.67l1.73 4.04a.75.75 0 101.38-.58l-1.88-4.41a.75.75 0 00-.08-.18l-3.8-8.91zm2 8.54H6.8l2.7-6.34L12.2 11zm-2.16 8.22a.75.75 0 00-1.06 1.06l1.47 1.47H3.75a.75.75 0 100 1.5h6.69l-1.47 1.47a.75.75 0 101.06 1.06l2.75-2.75c.3-.3.3-.77 0-1.06l-2.75-2.75zm9 6.56c-.3.3-.77.3-1.06 0l-2.75-2.75a.75.75 0 010-1.06l2.75-2.75a.75.75 0 111.06 1.06l-1.47 1.47h6.7a.75.75 0 110 1.5h-6.7l1.47 1.47c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingIn28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingIn28RegularIcon, 'FontSpaceTrackingIn28Regular');

const FontSpaceTrackingOut16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.7 8.53a.75.75 0 01-1.4 0l-2.24-5.5a.75.75 0 111.38-.56L11 6.27l1.56-3.8a.75.75 0 011.39.56l-2.26 5.5zM5 2c.3 0 .58.18.7.47l2.24 5.5a.75.75 0 01-1.38.56L6.13 7.5H3.87l-.43 1.03a.75.75 0 01-1.38-.56l2.25-5.5A.75.75 0 015 2zm.52 4L5 4.73 4.48 6h1.04zm5.95 4.22c.3-.3.77-.3 1.06 0l1.25 1.25a.75.75 0 010 1.06l-1.25 1.25a.75.75 0 01-1.09-1.03H4.56a.75.75 0 01-1.09 1.03l-1.25-1.25a.75.75 0 010-1.06l1.25-1.25a.75.75 0 011.09 1.03h6.88a.75.75 0 01.03-1.03z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut16FilledIcon, 'FontSpaceTrackingOut16Filled');

const FontSpaceTrackingOut16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.46 8.7a.5.5 0 01-.92 0l-2.5-6a.5.5 0 11.92-.4L11 7.2l2.04-4.9a.5.5 0 01.92.4l-2.5 6zM5 2c.2 0 .38.12.46.3l1.65 3.96a.5.5 0 01.04.1l.81 1.95a.5.5 0 11-.92.38L6.34 7H3.66l-.7 1.7a.5.5 0 01-.93-.4l.83-1.98V6.3l1.67-4A.5.5 0 015 2zm.92 4L5 3.8 4.08 6h1.84zm5.73 4.15c.2-.2.5-.2.7 0l1.5 1.5a.5.5 0 010 .7l-1.5 1.5a.5.5 0 11-.7-.7l.64-.65H3.71l.64.65a.5.5 0 11-.7.7l-1.5-1.5a.5.5 0 010-.7l1.5-1.5a.5.5 0 01.7.7l-.64.65h8.58l-.64-.65a.5.5 0 010-.7z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut16RegularIcon, 'FontSpaceTrackingOut16Regular');

const FontSpaceTrackingOut20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2c.31 0 .59.2.7.48l3.25 8.5a.75.75 0 01-1.4.53L7.78 9.5H4.22l-.77 2.01a.75.75 0 01-1.4-.53l3.25-8.5A.75.75 0 016 2zM4.8 8h2.4L6 4.85 4.8 8zm9.88 5.26a.75.75 0 011.06-.07l2 1.74a.75.75 0 010 1.13l-2 1.75a.75.75 0 11-.99-1.12l.5-.44H4.75l.5.44a.75.75 0 11-1 1.12l-2-1.74a.75.75 0 010-1.13l2-1.75a.75.75 0 011 1.12l-.5.44h10.5l-.5-.44a.75.75 0 01-.07-1.05zm.02-1.74a.75.75 0 01-1.4 0l-3.25-8.5a.75.75 0 011.4-.53L14 9.15l2.55-6.66a.75.75 0 011.4.53l-3.25 8.5z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut20FilledIcon, 'FontSpaceTrackingOut20Filled');

const FontSpaceTrackingOut20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.46 11.68a.5.5 0 01-.93 0l-3.51-9.02a.5.5 0 11.93-.36l3.04 7.82 3.04-7.82a.5.5 0 01.94.36l-3.51 9.02zM6 1.98c.21 0 .4.13.47.32l2.32 5.96a.5.5 0 01.04.11l1.15 2.95a.5.5 0 11-.93.36L8 9H4l-1.04 2.68a.5.5 0 01-.93-.36l1.16-3 .01-.02 2.34-6A.5.5 0 016 1.98zM4.4 8H7.6l-1.6-4.14L4.4 8zm10.39 5.18a.5.5 0 01.7-.06l2.33 2a.5.5 0 010 .76l-2.33 2a.5.5 0 01-.65-.76l1.3-1.12H3.85l1.31 1.12a.5.5 0 11-.65.76l-2.33-2a.5.5 0 010-.76l2.33-2a.5.5 0 11.65.76L3.85 15h12.3l-1.3-1.12a.5.5 0 01-.06-.7z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut20RegularIcon, 'FontSpaceTrackingOut20Regular');

const FontSpaceTrackingOut24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.39 16.21a1 1 0 011.22 0l.1.08.08.1a1 1 0 010 1.22l-.08.1-.3.29H18.6l-.3-.3a1 1 0 01-.08-1.31l.08-.1a1 1 0 011.32-.08l.1.08 2 2a1 1 0 01.08 1.32l-.08.1-2 2a1 1 0 01-1.5-1.32l.08-.1.3-.29H5.4l.3.3.08.09a1 1 0 01-1.4 1.4l-.1-.08-2-2-.08-.1a1 1 0 010-1.22l.08-.1 2-2 .1-.08zm3.73-13.8l.06.11.06.12 4.3 11a1 1 0 01-1.81.83l-.05-.1-1.11-2.84H5.04l-1.1 2.83a1 1 0 01-1.2.6l-.1-.03a1 1 0 01-.6-1.18l.03-.11 4.3-11a1 1 0 011.75-.22zm11.97.12a1 1 0 011.85.72l-.04.11-4.3 11-.05.12a1 1 0 01-1.76 0l-.05-.12-4.3-11-.04-.1a1 1 0 01.5-1.14l.1-.05.11-.04a1 1 0 011.14.5l.05.1 3.37 8.63 3.37-8.62.05-.11zM7.3 5.74L5.82 9.53h2.96L7.3 5.74z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut24FilledIcon, 'FontSpaceTrackingOut24Filled');

const FontSpaceTrackingOut24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.45 16.15l.08.07 2.25 2.25c.27.27.3.68.07.98l-.07.08-2.25 2.25a.75.75 0 01-1.13-.98l.07-.08.97-.97H4.56l.97.97.07.08a.75.75 0 01-1.05 1.05l-.08-.07-2.25-2.25-.07-.08a.75.75 0 01-.01-.89l.08-.09 2.25-2.25.08-.07c.26-.2.62-.2.89-.01l.1.08.06.08c.2.26.2.62.01.89l-.08.09-.97.97h14.88l-.97-.97a.75.75 0 01-.07-.98l.07-.08a.75.75 0 01.98-.07zM7.84 2.28l.06.1.05.1 4.5 11.5a.75.75 0 01-1.35.64l-.05-.1-1.23-3.15H4.68l-1.23 3.15a.75.75 0 01-.88.46l-.1-.03a.75.75 0 01-.45-.88l.03-.1 4.5-11.5a.75.75 0 011.29-.2zm12.76.1a.75.75 0 011.38.55l-.03.1-4.5 11.5-.05.1a.75.75 0 01-1.3 0l-.05-.1-4.5-11.5-.03-.1a.75.75 0 01.36-.83l.1-.05.1-.03c.32-.08.65.07.82.36l.05.1 3.8 9.71 3.8-9.71.05-.1zM7.25 4.81L5.27 9.87h3.96L7.25 4.8z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut24RegularIcon, 'FontSpaceTrackingOut24Regular');

const FontSpaceTrackingOut28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.42 16.39a1 1 0 01-1.84 0l-5.5-13a1 1 0 011.84-.78l4.58 10.82 4.58-10.82a1 1 0 011.84.78l-5.5 13zM8.5 2a1 1 0 01.92.61l5.5 13a1 1 0 11-1.84.78L11.65 13h-6.3L3.92 16.4a1 1 0 01-1.84-.78l5.5-13A1 1 0 018.5 2zm-2.3 9h4.6L8.5 5.57 6.2 11zm15.03 8.36a1 1 0 011.41-.13l3 2.5a1 1 0 010 1.54l-3 2.5a1 1 0 01-1.28-1.54l.88-.73H5.76l.88.73a1 1 0 01-1.28 1.54l-3-2.5a1 1 0 010-1.54l3-2.5a1 1 0 011.28 1.54l-.88.73h16.48l-.88-.73a1 1 0 01-.13-1.41z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut28FilledIcon, 'FontSpaceTrackingOut28Filled');

const FontSpaceTrackingOut28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.19 16.54a.75.75 0 01-1.38 0l-5.75-13.5a.75.75 0 111.38-.58l5.06 11.88 5.06-11.88a.75.75 0 111.38.58l-5.75 13.5zM8.49 2c.3 0 .58.18.7.46l3.8 8.91.07.18 1.88 4.4a.75.75 0 01-1.38.6l-1.73-4.05H5.16l-1.72 4.04a.75.75 0 11-1.38-.58l1.9-4.49.02-.03L7.8 2.46A.75.75 0 018.5 2zm-2.7 9h5.4L8.5 4.66 5.8 11zm16.18 8.22c.3-.3.77-.3 1.06 0l2.75 2.75c.3.3.3.77 0 1.06l-2.75 2.75a.75.75 0 11-1.06-1.06l1.47-1.47H4.56l1.47 1.47a.75.75 0 01-1.06 1.06l-2.75-2.75a.75.75 0 010-1.06l2.75-2.75a.75.75 0 111.06 1.06l-1.47 1.47h18.88l-1.47-1.47a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const FontSpaceTrackingOut28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FontSpaceTrackingOut28RegularIcon, 'FontSpaceTrackingOut28Regular');

const Food16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 1.5a.5.5 0 00-1 0v3c0 1.2.86 2.22 2 2.45v7.55a.5.5 0 001 0V6.95A2.5 2.5 0 008 4.5v-3a.5.5 0 00-1 0v3c0 .65-.42 1.2-1 1.41V1.5a.5.5 0 00-1 0v4.41c-.58-.2-1-.76-1-1.41v-3zm7 13V8H9.5a.5.5 0 01-.5-.5v-4c0-.66.33-1.28.77-1.73A2.5 2.5 0 0111.5 1c.28 0 .5.22.5.5v13a.5.5 0 01-1 0z",
    fill: primaryFill
  }));
};

export const Food16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Food16FilledIcon, 'Food16Filled');

const Food16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 1c.28 0 .5.22.5.5v3c0 .65.42 1.2 1 1.41V1.5a.5.5 0 011 0v4.41c.58-.2 1-.76 1-1.41v-3a.5.5 0 011 0v3a2.5 2.5 0 01-2 2.45v7.55a.5.5 0 01-1 0V6.95A2.5 2.5 0 013 4.5v-3c0-.28.22-.5.5-.5zm6.98 1.48c.16-.16.34-.28.52-.37V7h-1V3.5c0-.34.17-.72.48-1.02zM11 8v6.5a.5.5 0 001 0v-13a.5.5 0 00-.5-.5 2.5 2.5 0 00-1.73.77A2.5 2.5 0 009 3.5v4c0 .28.22.5.5.5H11z",
    fill: primaryFill
  }));
};

export const Food16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Food16RegularIcon, 'Food16Regular');

const Food20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 3a.5.5 0 01.5.41V6.5a2.5 2.5 0 01-2 2.45v7.55a.5.5 0 01-1 .09V8.95a2.5 2.5 0 01-2-2.28V3.5a.5.5 0 011-.09V6.5c0 .65.42 1.2 1 1.41V3.5a.5.5 0 011-.09v4.5a1.5 1.5 0 001-1.26V3.5c0-.28.22-.5.5-.5zm5 0a.5.5 0 01.5.41V16.5a.5.5 0 01-1 .09V11h-1.5a.5.5 0 01-.5-.41V5.5A2.5 2.5 0 0114.5 3z",
    fill: primaryFill
  }));
};

export const Food20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Food20FilledIcon, 'Food20Filled');

const Food20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 3a.5.5 0 01.5.41V6.5a2.5 2.5 0 01-2 2.45v7.55a.5.5 0 01-1 .09V8.95a2.5 2.5 0 01-2-2.28V3.5a.5.5 0 011-.09V6.5c0 .65.42 1.2 1 1.41V3.5a.5.5 0 011-.09v4.5a1.5 1.5 0 001-1.26V3.5c0-.28.22-.5.5-.5zm5 0a.5.5 0 01.5.41V16.5a.5.5 0 01-1 .09V11h-1.5a.5.5 0 01-.5-.41V5.5A2.5 2.5 0 0114.5 3zm-.5 7V4.09a1.5 1.5 0 00-1 1.26V10h1V4.09 10z",
    fill: primaryFill
  }));
};

export const Food20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Food20RegularIcon, 'Food20Regular');

const Food24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 3a1 1 0 011 .88V20a1 1 0 01-2 .12V15h-1a1 1 0 01-1-.88V8c0-2.2 1.5-5 3-5zm-6 0a1 1 0 011 .88V9a4 4 0 01-3 3.87V20a1 1 0 01-2 .12v-7.25a4 4 0 01-3-3.66V4a1 1 0 012-.12V9a2 2 0 001 1.73V4a1 1 0 012-.12V10.73a2 2 0 001-1.56V4a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const Food24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Food24FilledIcon, 'Food24Filled');

const Food24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 3.25c.38 0 .7.28.74.65L19 4v16a.75.75 0 01-1.5.1V15h-2.25a.75.75 0 01-.74-.65l-.01-.1V7a3.75 3.75 0 013.75-3.75zm-6 0c.38 0 .7.28.74.65L13 4v4a4 4 0 01-3.25 3.93V20a.75.75 0 01-1.5.1v-8.17a4 4 0 01-3.24-3.72L5 8V4a.75.75 0 011.5-.1V8a2.5 2.5 0 001.75 2.39V4a.75.75 0 011.5-.1V10.39a2.5 2.5 0 001.74-2.2L11.5 8V4c0-.41.34-.75.75-.75zM17.5 13.5V4.88A2.25 2.25 0 0016 6.83v6.67h1.5V4.88v8.62z",
    fill: primaryFill
  }));
};

export const Food24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Food24RegularIcon, 'Food24Regular');

const FoodApple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.16 2.97a.5.5 0 00-.32-.94 3.18 3.18 0 00-1.86 1.9c-.05.11-.1.23-.13.34A4 4 0 006.2 2.14c-.58.01-1.05.48-1.06 1.06A3.99 3.99 0 006.3 6.14l.03.03A4 4 0 003.2 9.76v.07a8.5 8.5 0 001 4.75l.36.66a.5.5 0 00.03.05l1 1.4a2.69 2.69 0 004.09.34.46.46 0 01.64 0 2.69 2.69 0 004.09-.34l1-1.4a.51.51 0 00.03-.05l.36-.66a8.5 8.5 0 001-4.75v-.07a4 4 0 00-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34zm-5.25 6c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 01-.99.12c-.13-1.06 0-1.86.31-2.45.32-.6.8-.93 1.28-1.08a.5.5 0 01.32.94z",
    fill: primaryFill
  }));
};

export const FoodApple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodApple20FilledIcon, 'FoodApple20Filled');

const FoodApple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.22 8.34a.5.5 0 01-.31.63c-.28.1-.54.27-.72.6-.18.36-.31.93-.2 1.87a.5.5 0 01-.99.12c-.13-1.06 0-1.86.3-2.45.33-.6.82-.93 1.3-1.08a.5.5 0 01.62.31zm4.94-5.37a.5.5 0 00-.32-.94 3.18 3.18 0 00-1.86 1.9c-.05.11-.1.23-.13.34A4 4 0 006.2 2.14c-.58.01-1.05.48-1.06 1.06a3.99 3.99 0 001.2 2.97A4 4 0 003.2 9.76v.07a8.5 8.5 0 001 4.75l.36.66a.5.5 0 00.03.05l1 1.4a2.69 2.69 0 004.09.34.46.46 0 01.64 0 2.69 2.69 0 004.09-.34l1-1.4a.51.51 0 00.03-.05l.36-.66a8.5 8.5 0 001-4.75v-.07a4 4 0 00-4.64-3.63l-1.66.28c.01-.68.13-1.45.4-2.1.28-.67.7-1.15 1.26-1.34zM8.72 6.28l-.16-.03a2.98 2.98 0 01-2.42-3.02c0-.05.04-.09.09-.1a2.99 2.99 0 013.08 3.1c0 .04-.04.08-.09.08-.17 0-.34 0-.5-.03zm-.33.96l.17.03.78.13a4 4 0 001.32 0l1.66-.28a3 3 0 013.49 2.72v.07a7.5 7.5 0 01-.9 4.2l-.33.62-.99 1.38c-.6.85-1.82.95-2.56.21a1.46 1.46 0 00-2.06 0c-.74.74-1.96.64-2.56-.21l-.99-1.38-.34-.63a7.5 7.5 0 01-.9-4.19l.01-.07a3 3 0 013.49-2.72l.71.12z",
    fill: primaryFill
  }));
};

export const FoodApple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodApple20RegularIcon, 'FoodApple20Regular');

const FoodApple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.47 3.42A5.18 5.18 0 006.9 7.3a5.12 5.12 0 00-3.66 4.22c-.33 2.35.15 4.75 1.37 6.8l.35.58.04.07 1.42 1.9a3.46 3.46 0 005.28.34.44.44 0 01.62 0 3.46 3.46 0 005.28-.34l1.42-1.9a.74.74 0 00.04-.07l.35-.59a10.46 10.46 0 001.37-6.8 5.12 5.12 0 00-6.1-4.3l-1.9.4h-.01a8.7 8.7 0 01.39-2.34c.29-.87.7-1.4 1.14-1.58a.75.75 0 10-.58-1.38c-1.05.44-1.65 1.48-1.98 2.48l-.05.15a5.19 5.19 0 00-4.92-2.8c-.7.04-1.25.59-1.29 1.28zm2.93 7.81c-.35.07-.67.32-.87.78-.2.48-.27 1.18-.05 2.06a.75.75 0 01-1.46.36 4.74 4.74 0 01.13-3A2.7 2.7 0 018.1 9.75a.75.75 0 11.3 1.47z",
    fill: primaryFill
  }));
};

export const FoodApple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodApple24FilledIcon, 'FoodApple24Filled');

const FoodApple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.4 11.23a.75.75 0 00-.3-1.47 2.7 2.7 0 00-1.95 1.66 4.74 4.74 0 00-.13 3.01.75.75 0 101.46-.36A3.27 3.27 0 017.53 12c.2-.46.52-.7.87-.78zM5.47 3.42A5.18 5.18 0 006.9 7.3a5.12 5.12 0 00-3.66 4.22c-.33 2.35.15 4.75 1.37 6.8l.35.58.04.07 1.42 1.9a3.46 3.46 0 005.28.34.44.44 0 01.62 0 3.46 3.46 0 005.28-.34l1.42-1.9a.74.74 0 00.04-.07l.35-.59a10.46 10.46 0 001.37-6.8 5.12 5.12 0 00-6.1-4.3l-1.9.4h-.01a8.7 8.7 0 01.39-2.34c.29-.87.7-1.4 1.14-1.58a.75.75 0 10-.58-1.38c-1.05.44-1.65 1.48-1.98 2.48l-.05.15a5.19 5.19 0 00-4.92-2.8c-.7.04-1.25.59-1.29 1.28zm1.5.2a3.68 3.68 0 013.79 3.8c-.19 0-.37 0-.55-.03l-.61-.12a3.67 3.67 0 01-2.64-3.64zm2.06 5.06l.2.04c.25.07.49.12.73.15l.97.2c.7.15 1.43.15 2.14 0l1.9-.39a3.62 3.62 0 014.32 3.04 8.96 8.96 0 01-1.18 5.83l-.33.55-1.4 1.88a1.96 1.96 0 01-2.98.19c-.77-.8-2.03-.8-2.8 0-.84.87-2.26.78-2.99-.2L6.22 18.1l-.33-.55a8.96 8.96 0 01-1.18-5.83 3.62 3.62 0 014.32-3.04z",
    fill: primaryFill
  }));
};

export const FoodApple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodApple24RegularIcon, 'FoodApple24Regular');

const FoodCake12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.93 1.65c-.18.3-.29.64-.3.88-.02.43.04.85.3 1.16.28.33.68.44 1.07.44.4 0 .8-.12 1.07-.45.26-.32.33-.73.3-1.15a2.06 2.06 0 00-.3-.87C6.87 1.36 6.53 1 6 1s-.88.36-1.07.65zM3.5 5C2.67 5 2 5.67 2 6.5l1.87 1.46c.08.07.2.07.3 0l1.1-.78c.44-.31 1.02-.31 1.46 0l1.1.79c.1.06.22.06.3 0L10 6.5V6.5C10 5.67 9.33 5 8.5 5h-5zm5.25 3.75L10 7.77V10h.5a.5.5 0 010 1h-9a.5.5 0 010-1H2V7.77l1.25.98c.44.34 1.05.35 1.5.03L5.85 8c.1-.06.2-.06.3 0l1.1.8c.45.31 1.06.3 1.5-.04z",
    fill: primaryFill
  }));
};

export const FoodCake12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake12FilledIcon, 'FoodCake12Filled');

const FoodCake12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 1c-.53 0-.88.36-1.06.65-.19.3-.3.64-.3.88-.03.43.03.85.3 1.16.27.33.67.44 1.06.44.4 0 .8-.12 1.07-.45.26-.32.33-.73.3-1.15a2.06 2.06 0 00-.3-.87C6.89 1.36 6.54 1 6 1zm-.37 1.6c0-.07.05-.26.15-.42.1-.16.19-.18.22-.18.04 0 .12.02.22.19s.15.35.16.4c.02.3-.04.41-.08.45-.02.03-.1.09-.3.09-.22 0-.28-.06-.3-.08-.02-.03-.08-.15-.07-.46zM10 10V6.5C10 5.67 9.33 5 8.5 5h-5C2.67 5 2 5.67 2 6.5V10h-.5a.5.5 0 000 1h9a.5.5 0 000-1H10zM3.5 6h5c.28 0 .5.22.5.5v.79l-.87.67a.25.25 0 01-.3 0l-1.1-.78c-.44-.31-1.02-.31-1.46 0l-1.1.79a.25.25 0 01-.3 0L3 7.28V6.5c0-.28.22-.5.5-.5zM3 8.55l.25.2c.44.34 1.04.35 1.5.03L5.85 8c.1-.06.2-.06.3 0l1.1.8c.45.31 1.06.3 1.5-.04l.25-.2V10H3V8.55z",
    fill: primaryFill
  }));
};

export const FoodCake12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake12RegularIcon, 'FoodCake12Regular');

const FoodCake16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.81 1.67C7.08 1.32 7.48 1 8 1c.52 0 .92.32 1.19.67.26.35.45.81.5 1.26a2 2 0 01-.26 1.38C9.13 4.75 8.64 5 8 5c-.64 0-1.13-.25-1.43-.7a2 2 0 01-.27-1.37c.06-.45.25-.9.51-1.26zM2.03 7.65A2 2 0 014 6h8a2 2 0 011.99 1.8 30.48 30.48 0 01-1.43 1.32c-.43.37-.88.73-1.27 1-.2.13-.38.23-.53.3a.78.78 0 01-.26.08c-.26 0-.43-.17-.82-.59C9.34 9.54 8.84 9 8 9s-1.34.54-1.68.9v.01c-.39.42-.56.59-.82.59l-.06-.01-.18-.07a4.1 4.1 0 01-.51-.3c-.4-.27-.85-.63-1.29-1A32.88 32.88 0 012.01 7.8a2 2 0 01.02-.15zM2 9.15a15.74 15.74 0 002.2 1.79c.21.15.43.29.64.38.2.1.43.18.66.18.73 0 1.2-.51 1.5-.84l.06-.07c.35-.39.58-.59.94-.59s.59.2.94.59l.06.07c.3.33.77.84 1.5.84.24 0 .47-.08.68-.17.21-.1.44-.23.66-.38.45-.3.93-.7 1.38-1.07l.78-.7V13h.5a.5.5 0 010 1h-13a.5.5 0 010-1H2V9.16z",
    fill: primaryFill
  }));
};

export const FoodCake16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake16FilledIcon, 'FoodCake16Filled');

const FoodCake16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.81 1.67C7.08 1.32 7.48 1 8 1c.52 0 .92.32 1.19.67.26.35.45.81.5 1.26a2 2 0 01-.26 1.38C9.13 4.75 8.64 5 8 5c-.64 0-1.13-.25-1.43-.7a2 2 0 01-.27-1.37c.06-.45.25-.9.51-1.26zm.6 2.08c.07.12.23.25.59.25s.52-.13.6-.25c.1-.14.14-.38.1-.68-.04-.3-.15-.6-.31-.8C8.23 2.05 8.09 2 8 2c-.08 0-.23.05-.39.27-.16.2-.27.5-.31.8-.04.3 0 .54.1.68zM2 8c0-1.1.9-2 2-2h8a2 2 0 012 2v5h.5a.5.5 0 010 1h-13a.5.5 0 010-1H2V8zm1 5h10v-2.98l-.28.25a8.2 8.2 0 01-1.05.81c-.34.22-.76.42-1.17.42-.73 0-1.2-.51-1.5-.84l-.06-.07C8.6 10.2 8.36 10 8 10s-.59.2-.94.59l-.06.07c-.3.33-.77.84-1.5.84-.4 0-.8-.21-1.14-.42A8.9 8.9 0 013 10v3zm0-4.4a16.64 16.64 0 00.97.92c.3.27.63.53.92.71.32.2.52.27.61.27.26 0 .43-.17.82-.59C6.66 9.54 7.16 9 8 9s1.34.54 1.68.9v.01c.39.42.56.59.82.59.11 0 .33-.07.64-.27.3-.18.62-.44.92-.7A14.38 14.38 0 0013 8.6V8a1 1 0 00-1-1H4a1 1 0 00-1 1v.6z",
    fill: primaryFill
  }));
};

export const FoodCake16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake16RegularIcon, 'FoodCake16Regular');

const FoodCake20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67.64 0 1.22-.2 1.6-.7.37-.47.49-1.11.44-1.83a3.56 3.56 0 00-.47-1.43C11.28 2.55 10.77 2 10 2zM3 9.78l3.2 2.94a1 1 0 001.43-.07l.86-.98a2 2 0 013 0l.86.98a1 1 0 001.43.07l3.2-2.94A2 2 0 0015 8H5a2 2 0 00-1.99 1.79zM17 11.14l-2.54 2.33a2 2 0 01-2.85-.15l-.86-.97a1 1 0 00-1.5 0l-.86.97a2 2 0 01-2.85.15L3 11.14V16h-.5a.5.5 0 000 1h15a.5.5 0 000-1H17v-4.86z",
    fill: primaryFill
  }));
};

export const FoodCake20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake20FilledIcon, 'FoodCake20Filled');

const FoodCake20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c-.77 0-1.28.53-1.57 1.02-.3.5-.45 1.07-.47 1.44-.04.74.07 1.39.44 1.86.38.49.96.67 1.6.67.64 0 1.22-.2 1.6-.7.37-.47.49-1.11.44-1.83a3.56 3.56 0 00-.47-1.43C11.28 2.55 10.77 2 10 2zM8.96 4.51c0-.2.11-.63.33-.99.22-.37.46-.54.7-.54.25 0 .5.17.72.55.21.37.32.8.33.98.04.6-.07.96-.23 1.16-.14.18-.38.31-.81.31-.45 0-.69-.12-.82-.3-.15-.18-.26-.54-.22-1.17zM5 8a2 2 0 00-2 2v6h-.5a.5.5 0 000 1h15a.5.5 0 000-1H17v-6a2 2 0 00-2-2H5zm11 8H4v-3.88l1.54 1.38a2 2 0 002.83-.16l.88-1a1 1 0 011.5 0l.88 1a2 2 0 002.83.16L16 12.12V16zm0-5.22l-2.21 1.97a1 1 0 01-1.42-.08l-.87-.99a2 2 0 00-3 0l-.87 1a1 1 0 01-1.42.07L4 10.78V10a1 1 0 011-1h10a1 1 0 011 1v.78z",
    fill: primaryFill
  }));
};

export const FoodCake20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake20RegularIcon, 'FoodCake20Regular');

const FoodCake24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 7c1.71 0 2-1.34 2-2.44 0-1.1-.74-3.06-2-3.06s-2 1.95-2 3.06c0 1.1.29 2.44 2 2.44zm-8.5 3.25C3.5 9.01 4.5 8 5.75 8h12.5c1.24 0 2.25 1 2.25 2.25v.88l-3.63 2.72c-.4.3-.95.33-1.39.08l-2.04-1.2c-.9-.53-2-.5-2.88.06L8.8 13.92c-.41.27-.94.27-1.35 0L3.5 11.42v-1.16zm0 2.94v5.31h-.75a.75.75 0 000 1.5h18.5a.75.75 0 000-1.5h-.75V13l-2.73 2.05c-.9.67-2.1.73-3.05.17l-2.04-1.2c-.4-.24-.91-.23-1.3.03L9.6 15.18c-.9.59-2.06.59-2.97.01l-3.14-2z",
    fill: primaryFill
  }));
};

export const FoodCake24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake24FilledIcon, 'FoodCake24Filled');

const FoodCake24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 1c-.95 0-1.59.68-1.94 1.28a4.15 4.15 0 00-.56 1.97c0 .5.06 1.17.43 1.75.41.63 1.1 1 2.07 1 .96 0 1.66-.37 2.07-1 .37-.58.43-1.26.43-1.75 0-.6-.2-1.35-.56-1.97C13.59 1.68 12.95 1 12 1zm-1 3.25c0-.3.12-.8.36-1.21.25-.42.49-.54.64-.54.15 0 .4.12.64.54.24.4.36.9.36 1.21 0 .41-.06.73-.2.93-.08.14-.26.32-.8.32s-.72-.18-.8-.32c-.14-.2-.2-.52-.2-.93zm9.5 6v8.25h.75a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5h.75v-8.25C3.5 9.01 4.5 8 5.75 8h12.5c1.24 0 2.25 1 2.25 2.25zm-15.5 0v2.1l2.45 1.57c.41.27.94.27 1.35 0l1.75-1.13c.88-.56 2-.58 2.9-.05l2 1.2c.43.25.96.23 1.37-.05L19 12.36v-2.11a.75.75 0 00-.75-.75H5.75a.75.75 0 00-.75.75zm12.68 4.87c-.89.62-2.06.67-2.99.11l-2-1.2c-.42-.24-.93-.23-1.33.02l-1.74 1.13c-.91.59-2.08.59-2.99 0L5 14.13v4.37h14v-4.3l-1.32.92z",
    fill: primaryFill
  }));
};

export const FoodCake24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCake24RegularIcon, 'FoodCake24Regular');

const FoodCarrot20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7L14 5.29V2.5a.5.5 0 10-1 0v2.88a3.66 3.66 0 00-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.42.62 2.05.18l8.93-6.18A3.57 3.57 0 0014.63 7h2.87a.5.5 0 100-1h-2.8l3.15-3.15z",
    fill: primaryFill
  }));
};

export const FoodCarrot20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCarrot20FilledIcon, 'FoodCarrot20Filled');

const FoodCarrot20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 00-.7-.7L14 5.29V2.5a.5.5 0 00-1 0v2.88a3.66 3.66 0 00-4.64 1.2l-6.09 8.95c-.42.63-.34 1.47.2 2 .55.55 1.41.62 2.05.18l8.93-6.18A3.57 3.57 0 0014.63 7h2.87a.5.5 0 000-1h-2.8l3.15-3.15zM9.2 7.14a2.64 2.64 0 014.04-.39 2.58 2.58 0 01-.35 3.96L3.95 16.9a.6.6 0 01-.77-.07.59.59 0 01-.07-.75l6.08-8.94z",
    fill: primaryFill
  }));
};

export const FoodCarrot20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCarrot20RegularIcon, 'FoodCarrot20Regular');

const FoodCarrot24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 2.75a.75.75 0 00-1.5 0v4.01a4.56 4.56 0 00-6.3 1.22l-7.35 10.8c-.55.82-.45 1.92.26 2.61.71.71 1.84.8 2.67.23l10.78-7.46A4.45 4.45 0 0017.24 8h4.01a.75.75 0 000-1.5h-2.69l3.22-3.22a.75.75 0 00-1.06-1.06L17.5 5.44V2.75z",
    fill: primaryFill
  }));
};

export const FoodCarrot24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCarrot24FilledIcon, 'FoodCarrot24Filled');

const FoodCarrot24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 2.75a.75.75 0 00-1.5 0v4.01a4.56 4.56 0 00-6.3 1.22l-7.34 10.8c-.56.82-.45 1.92.25 2.61.71.71 1.84.8 2.67.23l10.79-7.46A4.45 4.45 0 0017.24 8h4.01a.75.75 0 000-1.5h-2.69l3.22-3.22a.75.75 0 00-1.06-1.06L17.5 5.44V2.75zm-6.54 6.06a3.04 3.04 0 014.65-.44 2.97 2.97 0 01-.4 4.56L4.4 20.4a.58.58 0 01-.73-.06.56.56 0 01-.07-.72l7.35-10.8z",
    fill: primaryFill
  }));
};

export const FoodCarrot24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodCarrot24RegularIcon, 'FoodCarrot24Regular');

const FoodChickenLeg16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5a4 4 0 00-7.94-.68c-.2.62-.38 1.1-.54 1.45L4.15 8.15A.5.5 0 004.5 9h.08l-1.49 1.48h-.01a.25.25 0 01-.08.02 2 2 0 00-1.22 3.59c.05.03.1.08.13.13A2 2 0 005.5 13l.01-.08v-.01L7 11.43v.07a.5.5 0 00.85.35l2.36-2.35c.37-.17.88-.37 1.56-.57A4 4 0 0015 5zM5.99 9H7v1.01l-2.2 2.2c-.23.23-.3.54-.3.79a1 1 0 01-1.8.6c-.08-.1-.2-.22-.3-.3a1 1 0 01.6-1.8c.25 0 .56-.07.8-.3L5.99 9z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg16FilledIcon, 'FoodChickenLeg16Filled');

const FoodChickenLeg16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5a4 4 0 00-7.94-.68c-.2.62-.38 1.1-.54 1.45L4.15 8.15A.5.5 0 004.5 9h.08l-1.49 1.48h-.01a.25.25 0 01-.08.02 2 2 0 00-1.22 3.59c.05.03.1.08.13.13A2 2 0 005.5 13l.01-.08v-.01L7 11.43v.07a.5.5 0 00.85.35l2.36-2.35c.37-.17.88-.37 1.56-.57A4 4 0 0015 5zm-8 5.01l-2.2 2.2c-.23.23-.3.54-.3.79a1 1 0 01-1.8.6c-.08-.1-.2-.22-.3-.3a1 1 0 01.6-1.8c.25 0 .56-.07.8-.3L5.99 9H7v1.01zM11 2a3 3 0 01.5 5.96c-.78.24-1.36.47-1.79.66a.5.5 0 00-.14.1L8 10.3V8.5a.5.5 0 00-.5-.5H5.7l1.6-1.59a.5.5 0 00.1-.14 14.19 14.19 0 00.64-1.75A3 3 0 0111 2z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg16RegularIcon, 'FoodChickenLeg16Regular');

const FoodChickenLeg20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 7a5 5 0 00-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 00.35.85h.39l-2 2a2 2 0 00-1.15 3.55c.08.06.15.13.2.21A2 2 0 006.5 16.1l2-2v.4a.5.5 0 00.85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A4.97 4.97 0 0018 7zM7.3 11.5h1.2v1.19l-2.78 2.78a.75.75 0 00-.22.53 1 1 0 01-1.78.63c-.1-.13-.22-.25-.35-.35A1 1 0 014 14.5c.18 0 .37-.06.51-.21l2.8-2.79z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg20FilledIcon, 'FoodChickenLeg20Filled');

const FoodChickenLeg20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 7a5 5 0 00-9.93-.87c-.42 1.5-.83 2.29-1.04 2.63l-1.88 1.89a.5.5 0 00.35.85h.39l-2 2a2 2 0 00-1.15 3.55c.08.06.15.13.2.21A2 2 0 006.5 16.1l2-2v.4a.5.5 0 00.85.35l1.88-1.87c.34-.21 1.15-.63 2.7-1.07A4.97 4.97 0 0018 7zm-9.5 5.69l-2.78 2.78a.75.75 0 00-.22.53 1 1 0 01-1.78.63c-.1-.13-.22-.25-.35-.35A1 1 0 014 14.5c.18 0 .37-.06.51-.21l2.8-2.79H8.5v1.19zM13 3a4 4 0 011.37 7.76 11.6 11.6 0 00-3.8 1.47L9.49 13.3v-2.23a.5.5 0 00-.15-.35l-.06-.06a.5.5 0 00-.35-.15H6.71l1.07-1.07a11.53 11.53 0 001.28-3.1 3.97 3.97 0 01.23-.82A4 4 0 0113 3z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg20RegularIcon, 'FoodChickenLeg20Regular');

const FoodChickenLeg24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 8a6 6 0 00-11.9-1.1 15.12 15.12 0 01-1.36 3.3l-2.52 2.52a.75.75 0 00.28 1.24L4.46 16a2.5 2.5 0 00-1.42 4.53c.17.12.31.26.43.43A2.5 2.5 0 008 19.53l2.04-2.04a.75.75 0 001.24.29l2.52-2.52c.48-.29 1.48-.8 3.32-1.36A6 6 0 0022 8zM8.58 14H10v1.41l-3.12 3.12c-.29.3-.38.67-.38.97a1 1 0 01-1.81.58c-.21-.3-.48-.56-.77-.77a1 1 0 01.58-1.81c.3 0 .67-.09.96-.38L8.58 14z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg24FilledIcon, 'FoodChickenLeg24Filled');

const FoodChickenLeg24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 8a6 6 0 00-11.9-1.1 15.13 15.13 0 01-1.36 3.3l-2.52 2.52a.75.75 0 00.28 1.24L4.46 16a2.5 2.5 0 00-1.42 4.53c.17.12.31.26.43.43A2.5 2.5 0 008 19.53l2.04-2.04a.75.75 0 001.24.29l2.52-2.52c.48-.29 1.48-.8 3.32-1.36A6 6 0 0022 8zm-12 7.41l-3.12 3.12c-.29.3-.38.67-.38.97a1 1 0 01-1.81.58c-.21-.3-.48-.56-.77-.77a1 1 0 01.58-1.81c.3 0 .67-.09.96-.38L8.58 14H10v1.41zM16 3.5a4.5 4.5 0 01.72 8.95 16.28 16.28 0 00-3.91 1.68l-1.31 1.3v-2.18a.75.75 0 00-.75-.75H8.56l1.3-1.3a16.12 16.12 0 001.71-4A4.5 4.5 0 0116 3.5z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg24RegularIcon, 'FoodChickenLeg24Regular');

const FoodChickenLeg32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M30 10.5a8.5 8.5 0 00-16.86-1.53 21.28 21.28 0 01-1.86 4.34l-3.99 3.98A1 1 0 008 19h.1l-3.02 3.02a3.5 3.5 0 00-1.71 6.26c.13.1.26.22.36.36a3.5 3.5 0 006.25-1.74L13 23.88V24a1 1 0 001.7.7l4-3.98c.65-.4 1.99-1.09 4.37-1.86A8.5 8.5 0 0030 10.5zM10.94 19H13v2.05l-4.68 4.68c-.21.21-.32.49-.32.77a1.5 1.5 0 01-2.69.92 3.98 3.98 0 00-.73-.73A1.5 1.5 0 015.5 24c.28 0 .55-.11.75-.31L10.94 19z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg32FilledIcon, 'FoodChickenLeg32Filled');

const FoodChickenLeg32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M30 10.5a8.5 8.5 0 00-16.86-1.53 21.28 21.28 0 01-1.86 4.34l-3.99 3.98A1 1 0 008 19h.1l-3.02 3.02a3.5 3.5 0 00-1.71 6.26c.13.1.26.22.36.36a3.5 3.5 0 006.25-1.74L13 23.88V24a1 1 0 001.7.7l4-3.98c.65-.4 1.99-1.09 4.37-1.86A8.5 8.5 0 0030 10.5zM13 21.05l-4.68 4.68c-.21.21-.32.49-.32.77a1.5 1.5 0 01-2.69.92 3.98 3.98 0 00-.73-.73A1.5 1.5 0 015.5 24c.28 0 .55-.11.75-.31L10.94 19H13v2.05zM21.5 4a6.5 6.5 0 011.01 12.93c-2.67.87-4.19 1.67-4.97 2.15a1 1 0 00-.18.14L15 21.6V18a1 1 0 00-1-1h-3.59l2.36-2.36a1 1 0 00.14-.18 22.68 22.68 0 002.19-5.08A6.5 6.5 0 0121.5 4z",
    fill: primaryFill
  }));
};

export const FoodChickenLeg32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodChickenLeg32RegularIcon, 'FoodChickenLeg32Regular');

const FoodEgg16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.7 8.22a.73.73 0 01.2-.37.38.38 0 01.11-.07.5.5 0 00.19-.99c-.4-.08-.76.13-.98.33-.24.23-.43.54-.5.9a.5.5 0 10.97.2zM3.51 5.83c-1.79 1.42-1.83 3.84-1 5.46a3.61 3.61 0 003.28 2.07l.92-.02c.69-.03.82-.04 1.78.35 1.28.52 2.65.37 3.79-.35 1.03-.65 1.62-2.15 1.52-3.37-.06-.65 0-.91.07-1.21.05-.27.12-.56.12-1.18 0-1.32-.39-2.16-.78-2.84a5.32 5.32 0 00-2.01-2.13 4.54 4.54 0 00-4.33-.11A5.31 5.31 0 004.6 4.74c-.24.41-.48.61-1.08 1.09zM11.6 8.3a3.3 3.3 0 11-6.6 0 3.3 3.3 0 016.6 0z",
    fill: primaryFill
  }));
};

export const FoodEgg16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEgg16FilledIcon, 'FoodEgg16Filled');

const FoodEgg16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.7 8.22a.73.73 0 01.2-.36.38.38 0 01.11-.08.5.5 0 00.19-.99c-.4-.08-.76.13-.98.34-.24.22-.43.53-.5.88a.5.5 0 10.97.21zm.6 3.38a3.3 3.3 0 100-6.6 3.3 3.3 0 000 6.6zm0-1a2.3 2.3 0 110-4.6 2.3 2.3 0 010 4.6zM9.2 2c.79.06 1.53.29 2.07.63a5.38 5.38 0 012.02 2.12c.39.67.79 1.53.79 2.85 0 .62-.07.93-.13 1.2v.04c-.05.21-.1.4-.05.91a4.2 4.2 0 01-.35 1.98c-.27.62-.7 1.2-1.28 1.57-1.19.74-2.62.9-3.96.37-.59-.24-.77-.29-.97-.3H6.87L6 13.4a3.84 3.84 0 01-3.46-2.16C1.68 9.6 1.7 7.1 3.59 5.61a3 3 0 00.88-.87c.31-.52.61-.93.98-1.29s.78-.65 1.3-.94a4.47 4.47 0 012.45-.5zm-.06 1a3.47 3.47 0 00-1.9.39c-.47.26-.8.5-1.09.77-.28.28-.53.62-.82 1.1-.28.46-.57.7-1.12 1.13-1.41 1.12-1.48 3.04-.79 4.38.46.88 1.31 1.62 2.58 1.62.36 0 .62 0 .83-.02H7.4c.38.02.7.13 1.29.37 1.03.4 2.12.29 3.05-.29.36-.23.68-.63.9-1.12.2-.49.3-1.03.26-1.5-.05-.61 0-.9.07-1.2v-.06a4.37 4.37 0 00-.55-3.32 4.4 4.4 0 00-1.69-1.78A3.53 3.53 0 009.13 3z",
    fill: primaryFill
  }));
};

export const FoodEgg16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEgg16RegularIcon, 'FoodEgg16Regular');

const FoodEgg20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.47 9.6a.5.5 0 00.14-.98 2.14 2.14 0 00-2.35 2.16.5.5 0 001 0c0-.8.7-1.24 1.2-1.17zM3.99 7.14c-2.41 1.91-2.48 5.15-1.34 7.32a4.89 4.89 0 004.42 2.77c.54 0 .94-.01 1.24-.03.94-.03 1.11-.04 2.42.48a5.6 5.6 0 005.12-.47c1.39-.87 2.19-2.88 2.05-4.52-.08-.98 0-1.36.09-1.86.06-.33.13-.7.17-1.34a7.1 7.1 0 00-1.05-3.81 7.63 7.63 0 00-2.72-2.85 6.18 6.18 0 00-5.86-.15 7.15 7.15 0 00-3.07 3 5.1 5.1 0 01-1.47 1.46zm10.91 3.33a4.5 4.5 0 11-8.99 0 4.5 4.5 0 018.99 0z",
    fill: primaryFill
  }));
};

export const FoodEgg20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEgg20FilledIcon, 'FoodEgg20Filled');

const FoodEgg20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.06 9.58a.5.5 0 10.14-1c-.94-.12-1.78.6-1.78 1.64a.5.5 0 001 0c0-.46.32-.68.64-.64zm.35 5.38a4.5 4.5 0 100-8.99 4.5 4.5 0 000 9zm0-1a3.5 3.5 0 110-6.99 3.5 3.5 0 010 7zm1.22-11.89c1.04.07 2.02.38 2.72.83a7.6 7.6 0 012.7 2.83 7.1 7.1 0 011.05 3.82 9.84 9.84 0 01-.21 1.53c-.06.32-.1.66-.04 1.38.07.85-.1 1.78-.46 2.6a4.54 4.54 0 01-1.68 2.07 5.71 5.71 0 01-5.22.48c-.8-.33-1.08-.4-1.38-.42a6.7 6.7 0 00-.65 0c-.3.02-.67.03-1.18.03a5.05 5.05 0 01-4.56-2.84C1.59 12.2 1.62 8.9 4.1 6.94c.75-.6.98-.8 1.24-1.22.42-.7.82-1.25 1.3-1.73A7.7 7.7 0 018.4 2.74a5.9 5.9 0 013.23-.67zm-.07 1c-.9-.06-1.85.1-2.68.55a6.7 6.7 0 00-1.53 1.09c-.4.39-.75.86-1.14 1.52-.37.6-.73.9-1.49 1.5-2 1.59-2.1 4.31-1.11 6.19a4.05 4.05 0 003.67 2.3l1.14-.02h.02c.27-.01.5-.02.73 0 .48.02.89.16 1.7.48 1.46.58 3 .41 4.31-.4.54-.34 1-.92 1.3-1.61.3-.7.43-1.46.38-2.13a5.82 5.82 0 01.08-1.87c.06-.3.12-.63.16-1.19a6.12 6.12 0 00-.91-3.26 6.6 6.6 0 00-2.37-2.48 4.99 4.99 0 00-2.26-.67z",
    fill: primaryFill
  }));
};

export const FoodEgg20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEgg20RegularIcon, 'FoodEgg20Regular');

const FoodEgg24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 12.25c0-.41.34-.75.75-.75a.75.75 0 000-1.5C11.01 10 10 11 10 12.25a.75.75 0 001.5 0zM13.5 2a8.38 8.38 0 00-7.29 4.5c-.24.43-.6.8-1.05 1.1A7.38 7.38 0 002 13.76C2 17.7 4.97 21 8.75 21c.32 0 .64-.02.95-.07.87-.13 1.8 0 2.57.38A6.75 6.75 0 0021.9 14a3.14 3.14 0 01-.03-1.07c.1-.54.14-1.1.14-1.66C22 6.22 18.26 2 13.5 2zm3.75 10.5a4.75 4.75 0 11-9.5 0 4.75 4.75 0 019.5 0z",
    fill: primaryFill
  }));
};

export const FoodEgg24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEgg24FilledIcon, 'FoodEgg24Filled');

const FoodEgg24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 12.25c0-.41.34-.75.75-.75a.75.75 0 000-1.5C11.01 10 10 11 10 12.25a.75.75 0 001.5 0zM7 12.5a5.5 5.5 0 1111 0 5.5 5.5 0 01-11 0zm5.5-4a4 4 0 100 8 4 4 0 000-8zm-6.29-2A8.38 8.38 0 0113.5 2c4.76 0 8.5 4.22 8.5 9.28 0 .56-.05 1.12-.14 1.66-.05.34-.04.7.03 1.08a6.75 6.75 0 01-9.62 7.3 4.4 4.4 0 00-2.57-.4c-.3.06-.63.08-.95.08C4.97 21 2 17.7 2 13.75a7.38 7.38 0 013.16-6.14c.45-.3.81-.68 1.05-1.12zm7.29-3a6.88 6.88 0 00-5.97 3.72A4.8 4.8 0 016 8.85a5.88 5.88 0 00-2.5 4.9c0 3.23 2.4 5.75 5.25 5.75.25 0 .5-.02.73-.05a5.9 5.9 0 013.45.51 5.25 5.25 0 007.48-5.67 4.64 4.64 0 01-.03-1.6c.08-.46.12-.93.12-1.41 0-4.37-3.2-7.78-7-7.78z",
    fill: primaryFill
  }));
};

export const FoodEgg24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodEgg24RegularIcon, 'FoodEgg24Regular');

const FoodFish20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.63 3.7c-1.5 1.5-1.76 3.87-1.72 5.67a.4.4 0 01-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52.35.1.65.21.9.33.26.12.42.22.5.3.09.09.2.25.31.5.12.26.23.57.33.91.21.69.38 1.48.51 2.18.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 01.4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25.2-1.17.17-2.37.08-3.32a3 3 0 00-2.73-2.73 12.7 12.7 0 00-3.32.08c-1.17.2-2.35.65-3.25 1.54zm4.62.8a.75.75 0 110 1.5.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const FoodFish20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodFish20FilledIcon, 'FoodFish20Filled');

const FoodFish20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.91 9.35c-.04-1.76.24-3.76 1.43-4.95.7-.7 1.66-1.08 2.71-1.26a11.7 11.7 0 013.06-.07c.98.09 1.73.84 1.82 1.82.09.9.11 2-.07 3.06a4.97 4.97 0 01-1.26 2.71c-1.19 1.2-3.19 1.47-4.95 1.43a1.4 1.4 0 00-1.43 1.3c-.1 1.47-.4 3.17-1.11 4.52-.04.07-.07.08-.08.09a.1.1 0 01-.06 0c-.07-.02-.16-.1-.2-.25-.13-.7-.3-1.54-.53-2.28a8.35 8.35 0 00-.38-1.03c-.13-.3-.3-.58-.5-.8-.21-.2-.5-.36-.8-.5-.3-.14-.66-.27-1.03-.38-.74-.22-1.57-.4-2.28-.54-.16-.03-.23-.13-.25-.2a.1.1 0 010-.06c.01 0 .03-.04.09-.07a11.53 11.53 0 014.52-1.11 1.4 1.4 0 001.3-1.43zm.72-5.66c-1.5 1.5-1.76 3.88-1.72 5.68a.4.4 0 01-.37.41c-1.52.1-3.39.41-4.92 1.23-.52.27-.7.8-.58 1.27.12.45.5.83 1.02.92.7.14 1.5.3 2.18.52.35.1.65.21.9.33.26.12.42.22.5.3.09.09.2.25.31.5.12.26.23.57.33.9.21.7.38 1.5.51 2.19.1.52.47.9.93 1.02.47.13 1-.06 1.27-.57.82-1.54 1.12-3.4 1.23-4.93a.4.4 0 01.4-.37c1.8.05 4.19-.22 5.69-1.72.89-.9 1.33-2.08 1.54-3.25.2-1.17.17-2.37.08-3.32a3 3 0 00-2.73-2.73 12.7 12.7 0 00-3.32.08c-1.17.2-2.35.65-3.25 1.54zm4.62.8a.75.75 0 110 1.51.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const FoodFish20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodFish20RegularIcon, 'FoodFish20Regular');

const FoodFish24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.36 4.1c-1 1-1.58 2.34-1.91 3.68A16.66 16.66 0 008 11.72c0 .18-.14.33-.32.33-1.77 0-4.01.22-5.83 1.09-.68.32-.97 1-.82 1.63.13.6.61 1.09 1.26 1.25.8.19 1.72.44 2.52.72.4.15.76.3 1.05.44.3.15.49.28.58.37.1.1.22.28.37.58.15.29.3.65.44 1.05.28.8.53 1.72.72 2.52.16.65.65 1.13 1.25 1.26.64.14 1.3-.14 1.63-.82.87-1.82 1.08-4.06 1.1-5.82 0-.18.14-.33.32-.33 1.2 0 2.6-.1 3.95-.43a7.77 7.77 0 003.67-1.91 7.4 7.4 0 001.92-4.06c.25-1.45.2-2.92.1-4.09a3.77 3.77 0 00-3.41-3.4 15.68 15.68 0 00-4.1.09 7.4 7.4 0 00-4.05 1.91zM16 5a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const FoodFish24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodFish24FilledIcon, 'FoodFish24Filled');

const FoodFish24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.51 11.72c0-1.13.1-2.4.4-3.58a6.3 6.3 0 011.5-2.98 5.93 5.93 0 013.26-1.5c1.27-.21 2.6-.18 3.69-.08 1.1.11 1.95.96 2.06 2.07.1 1.09.14 2.42-.08 3.69a5.93 5.93 0 01-1.5 3.25 6.3 6.3 0 01-2.97 1.52c-1.19.3-2.46.38-3.6.38-1 0-1.81.82-1.82 1.82 0 1.7-.22 3.66-.93 5.17a.25.25 0 01-.08-.14c-.2-.82-.46-1.8-.77-2.66-.15-.44-.32-.86-.5-1.22s-.4-.71-.66-.97a3.76 3.76 0 00-.97-.65c-.36-.19-.78-.36-1.22-.5a28.5 28.5 0 00-2.66-.78.25.25 0 01-.14-.08c1.51-.71 3.48-.92 5.18-.93 1 0 1.82-.82 1.81-1.83zm.85-7.62c-1 1-1.58 2.34-1.91 3.68A16.66 16.66 0 008 11.73c0 .17-.14.32-.32.32-1.77 0-4.01.22-5.83 1.09-.68.32-.97 1-.82 1.63.13.6.61 1.09 1.26 1.25.8.19 1.72.44 2.52.72.4.15.76.3 1.05.44.3.15.49.28.58.37.1.1.22.28.37.58.15.29.3.65.44 1.05.28.8.53 1.72.72 2.52.16.65.65 1.13 1.25 1.26.64.14 1.3-.14 1.63-.82.87-1.82 1.08-4.06 1.1-5.82 0-.18.14-.33.32-.33 1.2 0 2.6-.1 3.95-.43a7.77 7.77 0 003.67-1.91 7.4 7.4 0 001.92-4.06c.25-1.45.2-2.92.1-4.09a3.77 3.77 0 00-3.41-3.4 15.68 15.68 0 00-4.1.09 7.4 7.4 0 00-4.05 1.91zM16 5a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const FoodFish24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodFish24RegularIcon, 'FoodFish24Regular');

const FoodGrains20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.43 2.21a.65.65 0 00-.86 0 5.72 5.72 0 00-1.92 4.35c0 .18.1.34.24.43A7.4 7.4 0 019.63 8.4a.5.5 0 00.74 0 7.4 7.4 0 011.74-1.42.5.5 0 00.24-.43c.02-1.59-.62-3.2-1.92-4.35zm-7.41 10a.66.66 0 01.6-.72A6.36 6.36 0 0110 15.33a6.36 6.36 0 016.38-3.84c.36.03.64.35.6.72A6.37 6.37 0 0110.64 18h-.46c-.06 0-.12 0-.18-.02a.66.66 0 01-.18.02h-.46a6.37 6.37 0 01-6.34-5.8zM10 10.83a6.36 6.36 0 00-6.38-3.84.66.66 0 00-.6.72c.08.9.35 1.75.76 2.5a.5.5 0 00.44.26c2.1.01 4.02.92 5.36 2.39.11.12.27.18.42.16a.5.5 0 00.42-.16 7.36 7.36 0 015.36-2.4.5.5 0 00.44-.25c.41-.75.68-1.6.76-2.5a.66.66 0 00-.6-.72A6.36 6.36 0 0010 10.83z",
    fill: primaryFill
  }));
};

export const FoodGrains20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodGrains20FilledIcon, 'FoodGrains20Filled');

const FoodGrains20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.43 2.21a.65.65 0 00-.86 0 5.73 5.73 0 00-1.74 5.74 7.11 7.11 0 00-4.2-.96.66.66 0 00-.61.72 6.99 6.99 0 001.65 3.77c-.35-.02-.7-.02-1.05 0a.66.66 0 00-.6.73A6.37 6.37 0 009.36 18h1.28c3.3 0 6.04-2.51 6.34-5.8a.66.66 0 00-.6-.71c-.35-.03-.7-.03-1.05-.01a6.99 6.99 0 001.65-3.77.66.66 0 00-.6-.72 7.1 7.1 0 00-4.21.96c.52-2-.06-4.24-1.74-5.74zM10 14.43a7.15 7.15 0 00-3.47-2.6 6.17 6.17 0 01-2.47-3.86c1.54-.05 3 .5 4.12 1.45.76.64.97 1.23 1.15 1.76l.22.54a.5.5 0 00.9 0l.22-.54c.18-.53.4-1.12 1.15-1.76a6.12 6.12 0 014.12-1.45 6.17 6.17 0 01-2.5 3.9A7.15 7.15 0 0010 14.42zM9.36 17a5.37 5.37 0 01-5.3-4.53 6.13 6.13 0 015.5 3.13.5.5 0 00.88 0 6.13 6.13 0 015.5-3.13 5.37 5.37 0 01-5.3 4.53H9.36zM10 9.82a4.74 4.74 0 010-6.64 4.74 4.74 0 010 6.64z",
    fill: primaryFill
  }));
};

export const FoodGrains20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodGrains20RegularIcon, 'FoodGrains20Regular');

const FoodGrains24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.61 2.29a.93.93 0 00-1.22 0A7.2 7.2 0 008.9 7.57c0 .19.11.36.28.45a9.06 9.06 0 012.4 1.83c.22.24.62.24.84 0a9.04 9.04 0 012.4-1.83.5.5 0 00.28-.45 7.2 7.2 0 00-2.49-5.28zM12 18.04a8.16 8.16 0 018.17-4.06c.49.07.85.5.81 1A7.6 7.6 0 0113.41 22H10.6a7.6 7.6 0 01-7.57-7.01.94.94 0 01.81-1A8.16 8.16 0 0112 18.03zm7.65-5.11a9.9 9.9 0 00-5.13 1.16 8.61 8.61 0 00-2.32 1.78c-.1.11-.3.11-.4 0a8.6 8.6 0 00-2.32-1.78 9.9 9.9 0 00-5.11-1.16 8.66 8.66 0 01-1.35-3.8.96.96 0 01.87-1.04c2.46-.2 4.5.28 6.34 1.84.83.7 1.4 1.54 1.77 2.26.38-.72.94-1.56 1.77-2.26 1.83-1.56 3.9-2.04 6.35-1.84.53.04.92.5.88 1.04a8.66 8.66 0 01-1.35 3.8z",
    fill: primaryFill
  }));
};

export const FoodGrains24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodGrains24FilledIcon, 'FoodGrains24Filled');

const FoodGrains24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.39 2.29a7.23 7.23 0 00-2.37 6.78 8.5 8.5 0 00-5.13-.98.96.96 0 00-.87 1.04 8.97 8.97 0 002.06 4.78c-.41 0-.83.02-1.25.07-.5.07-.85.5-.81 1A7.6 7.6 0 0010.59 22h2.82a7.6 7.6 0 007.57-7.01.94.94 0 00-.81-1 8.8 8.8 0 00-1.23-.08A8.97 8.97 0 0021 9.13a.96.96 0 00-.88-1.04 8.55 8.55 0 00-5.14.98A7.23 7.23 0 0012.6 2.3a.93.93 0 00-1.22 0zm.61 9.44a5.74 5.74 0 010-7.96 5.74 5.74 0 010 7.96zm0 5.6a9.02 9.02 0 00-4.23-2.97 7.75 7.75 0 01-3.18-4.8 6.43 6.43 0 014.68 1.51c1.02.87 1.48 1.93 1.81 2.72l.25.55a.75.75 0 001.34 0l.25-.55c.34-.79.79-1.85 1.81-2.72a6.46 6.46 0 014.7-1.52 7.75 7.75 0 01-3.17 4.8A9.02 9.02 0 0012 17.33zm.64 1.71c1.4-2.33 4-3.78 6.78-3.62a6.1 6.1 0 01-6 5.08h-2.83a6.1 6.1 0 01-6.01-5.08 7.45 7.45 0 016.78 3.62.75.75 0 001.28 0z",
    fill: primaryFill
  }));
};

export const FoodGrains24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodGrains24RegularIcon, 'FoodGrains24Regular');

const FoodPizza20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.96c0-1.1.9-2.03 2.03-1.96 4.45.28 8.35 1.77 11.4 4.7.87.82.7 2.17-.2 2.86l-.25.19-.4-.44V9.3A16.37 16.37 0 004.88 4.5H4v-.55zM4 5.5V16.5a1.5 1.5 0 002.4 1.2L8 16.5a1 1 0 002 0v-2a.5.5 0 011-.06V15a1 1 0 002 0v-2.24c.82-.6 2.09-1.56 3.19-2.4l-.33-.37A15.37 15.37 0 004.87 5.5H4zm4.25 2.74a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.97 2a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-2.96 2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const FoodPizza20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodPizza20FilledIcon, 'FoodPizza20Filled');

const FoodPizza20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 9a.75.75 0 100-1.49.75.75 0 000 1.5zm3.72 1.26a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 13.5a.75.75 0 100-1.5.75.75 0 000 1.5zM4 3.96c0-1.1.9-2.02 2.03-1.95 4.45.27 8.35 1.77 11.4 4.68.87.83.7 2.18-.2 2.87-1.24.96-3.12 2.4-4.23 3.2v1.75c0 .71-.55 1.5-1.5 1.5-.18 0-.34-.03-.5-.08V16c0 .71-.55 1.49-1.5 1.49-.75 0-1.25-.5-1.42-1.05L6.4 17.7A1.5 1.5 0 014 16.5V3.96zm7 10.55c0 .25.2.5.5.5s.5-.25.5-.5v-2a.5.5 0 01.21-.4c.78-.57 2.1-1.58 3.28-2.48A15.43 15.43 0 005 5.52V16.5c0 .41.47.65.8.4l2.4-1.8a.5.5 0 01.8.4v.5c0 .26.2.5.5.5a.5.5 0 00.5-.5v-1.5a.5.5 0 011 0zm5.62-5.74c.46-.36.5-1 .12-1.35C13.88 4.69 10.22 3.27 5.97 3a.93.93 0 00-.97.96v.56c4.33.03 8.4 1.69 11.3 4.5l.32-.25z",
    fill: primaryFill
  }));
};

export const FoodPizza20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodPizza20RegularIcon, 'FoodPizza20Regular');

const FoodPizza24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4.66a2.6 2.6 0 012.82-2.64 20.78 20.78 0 0113.45 6.82 2.6 2.6 0 01-.48 3.85l-.43.3-.36-.53v-.02A17.55 17.55 0 005.74 5.17H5v-.5zm13.77 8.65l.38.57-3.95 2.86-.2.15V19a1 1 0 11-2 0v-.06a.5.5 0 00-1 .06v1.5a1 1 0 01-2 .1l-1.43 1.04A2.25 2.25 0 015 19.81V6.67h.75c5.36 0 10.1 2.62 13.02 6.64zM9 11a1 1 0 100-2 1 1 0 000 2zm4 3a1 1 0 100-2 1 1 0 000 2zm-4 3a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const FoodPizza24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodPizza24FilledIcon, 'FoodPizza24Filled');

const FoodPizza24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 11a1 1 0 100-2 1 1 0 000 2zm5 2a1 1 0 11-2 0 1 1 0 012 0zm-5 3.99a1 1 0 100-2 1 1 0 000 2zM5 4.66a2.6 2.6 0 012.82-2.64 20.78 20.78 0 0113.44 6.82 2.6 2.6 0 01-.48 3.85l-5.28 3.83V18.24a1.75 1.75 0 01-2.06 1.73c-.2.82-.93 1.52-1.94 1.52-.7 0-1.26-.33-1.61-.81l-1.33.95A2.25 2.25 0 015 19.81V4.66zm2.67-1.15c-.6-.06-1.17.44-1.17 1.15v.53c5.25.22 9.91 2.74 12.98 6.59l.42-.3c.58-.42.65-1.18.25-1.63A19.28 19.28 0 007.66 3.5zM6.5 19.8c0 .61.69.97 1.19.6.72-.51 1.5-1.07 2.12-1.53a.75.75 0 011.2.61c0 .27.2.5.49.5.3 0 .5-.23.5-.5v-1.25a.75.75 0 011.5 0 .25.25 0 10.5 0v-.62-1.49c0-.24.12-.46.31-.6l3.96-2.87A16.04 16.04 0 006.5 6.69V19.8z",
    fill: primaryFill
  }));
};

export const FoodPizza24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodPizza24RegularIcon, 'FoodPizza24Regular');

const FoodToast16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.85 6.5c0-.28.22-.5.5-.5h3.2c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3.2a.5.5 0 01-.5-.5v-3zm1 2.5h2.2V7h-2.2v2zM1.27 4.01A3.29 3.29 0 014.2 2H12c1.44 0 3 1.19 3 3 0 1.06-.6 1.95-1 2.4-.01.55.01 1.28.04 2.06v.23c.03.8.06 1.62.06 2.31 0 .64-.06 1.24-.5 1.61-.2.2-.46.28-.72.33-.26.05-.56.06-.88.06H4c-.94 0-1.55-.28-1.87-.8A2.1 2.1 0 011.9 12V7.42a2.97 2.97 0 01-.63-3.4zM4.2 3c-.87 0-1.66.6-2.02 1.41-.35.8-.26 1.72.54 2.4.12.1.18.24.18.39v4.87c0 .27 0 .46.1.61.05.1.24.32 1 .32h6c.31 0 .53-.01.68-.04.14-.03.18-.07.2-.08 0-.01.04-.05.07-.2.04-.15.05-.36.05-.68v-1.57c-.01-1.11-.02-2.26 0-3.04a.5.5 0 01.15-.34l.23-.23c.2-.18.36-.34.52-.57.19-.28.34-.65.34-1.25 0-.66-.3-1.14-.73-1.48A2.55 2.55 0 0010 3H4.2z",
    fill: primaryFill
  }));
};

export const FoodToast16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToast16FilledIcon, 'FoodToast16Filled');

const FoodToast16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.85 6.5c0-.28.22-.5.5-.5h3.2c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3.2a.5.5 0 01-.5-.5v-3zm1 2.5h2.2V7h-2.2v2zM1.27 4.01A3.29 3.29 0 014.2 2H12c1.44 0 3 1.19 3 3 0 1.06-.6 1.95-1 2.4-.01.55.01 1.28.04 2.06v.23c.03.8.06 1.62.06 2.31 0 .64-.06 1.24-.5 1.61-.2.2-.46.28-.72.33-.26.05-.56.06-.88.06H4c-.94 0-1.55-.28-1.87-.8A2.1 2.1 0 011.9 12V7.42a2.97 2.97 0 01-.63-3.4zM4.2 3c-.87 0-1.66.6-2.02 1.41-.35.8-.26 1.72.54 2.4.12.1.18.24.18.39v4.87c0 .27 0 .46.1.61.05.1.24.32 1 .32h6c.31 0 .53-.01.68-.04.14-.03.18-.07.2-.08 0-.01.04-.05.07-.2.04-.15.05-.36.05-.68v-1.57c-.01-1.11-.02-2.26 0-3.04a.5.5 0 01.15-.34l.23-.23c.2-.18.36-.34.52-.57.19-.28.34-.65.34-1.25 0-.66-.3-1.14-.73-1.48A2.55 2.55 0 0010 3H4.2zm7.73 9.88l-.02.12H12c.31 0 .53-.01.7-.04.16-.03.22-.07.25-.1.05-.05.15-.2.15-.86 0-.67-.03-1.48-.05-2.28l-.01-.23c-.03-.86-.06-1.7-.04-2.3a.5.5 0 01.16-.35c.3-.29.84-1.03.84-1.84 0-.98-.71-1.71-1.5-1.93.44.48.74 1.13.74 1.93s-.21 1.37-.52 1.82c-.22.32-.5.59-.71.78l-.02.02v2.77L12 12c0 .33-.01.63-.07.88z",
    fill: primaryFill
  }));
};

export const FoodToast16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToast16RegularIcon, 'FoodToast16Regular');

const FoodToast20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.78 7.45a.5.5 0 00-.5.5v4.1c0 .27.22.5.5.5h4.34a.5.5 0 00.5-.5v-4.1a.5.5 0 00-.5-.5H6.78zm.5 1h3.34v3.1H7.28v-3.1zM5.45 2.5c-1.63 0-3 1.1-3.6 2.48-.6 1.33-.49 3 .81 4.22v5.98c0 .3-.01.87.28 1.36.36.6 1.08.96 2.26.96h10.18c.41 0 .78-.02 1.1-.07.3-.06.6-.17.85-.39.5-.43.59-1.13.59-1.95 0-.88-.04-1.92-.07-2.93a66.88 66.88 0 01-.07-2.97 4.68 4.68 0 001.28-3 3.73 3.73 0 00-3.68-3.69H5.45zm7.38 1c.63 0 1.39.3 2 .82.6.51.99 1.18 1 1.85-.05.75-.21 1.24-.41 1.58-.16.27-.35.48-.56.69l-.16.15a13.81 13.81 0 00-.31.3l-.14.13v.2c-.04 1-.03 2.44-.02 3.84v.01l.01 2.02c0 .4-.02.7-.06.9-.04.2-.1.28-.14.32-.04.04-.12.1-.32.13a9.84 9.84 0 01-.89.06H5.2c-1 0-1.29-.29-1.4-.47-.14-.23-.14-.51-.14-.84V8.99a.5.5 0 00-.18-.39 2.65 2.65 0 01-.72-3.22 3.05 3.05 0 012.7-1.88h7.37z",
    fill: primaryFill
  }));
};

export const FoodToast20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToast20FilledIcon, 'FoodToast20Filled');

const FoodToast20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.23 7.95c0-.27.22-.5.5-.5h4.34c.28 0 .5.23.5.5v4.1a.5.5 0 01-.5.5H6.73a.5.5 0 01-.5-.5v-4.1zm1 3.6h3.34v-3.1H7.23v3.1zM1.79 4.98A4.05 4.05 0 015.4 2.5h9.93A3.73 3.73 0 0119 6.18c0 1.33-.76 2.46-1.28 3.01 0 .7.02 1.66.06 2.67v.3c.04 1 .08 2.05.08 2.93 0 .82-.1 1.52-.59 1.95-.24.22-.54.33-.86.39-.31.05-.68.07-1.1.07H5.16c-1.18 0-1.9-.35-2.26-.96a2.53 2.53 0 01-.28-1.45V9.2a3.64 3.64 0 01-.82-4.22zM5.4 3.5c-1.16 0-2.21.8-2.7 1.88a2.65 2.65 0 00.73 3.22c.12.1.18.24.18.38v6.21c0 .33 0 .6.14.84.1.18.4.47 1.4.47h7.63c.4 0 .68-.02.89-.06.2-.03.28-.09.32-.13.05-.04.1-.12.14-.32.04-.2.06-.5.06-.9v-2c-.02-1.42-.03-2.87 0-3.87a.5.5 0 01.15-.34l.3-.3c.24-.21.44-.4.63-.68.25-.35.46-.86.5-1.73 0-.67-.39-1.34-1-1.85a3.28 3.28 0 00-1.99-.82H5.4zm9.71 12.69l-.08.31h.3c.4 0 .69-.02.9-.06.23-.04.33-.1.4-.15.12-.1.24-.36.24-1.2 0-.86-.04-1.89-.07-2.9l-.01-.3c-.04-1.1-.07-2.16-.05-2.92a.5.5 0 01.15-.35 3.73 3.73 0 001.12-2.44 2.73 2.73 0 00-2.65-2.68l.06.06a3.52 3.52 0 011.35 2.62v.03a4.24 4.24 0 01-.67 2.26c-.26.38-.58.67-.84.91l-.07.07c-.02.97-.02 2.3 0 3.6v2.04c0 .42-.02.8-.08 1.1z",
    fill: primaryFill
  }));
};

export const FoodToast20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToast20RegularIcon, 'FoodToast20Regular');

const FoodToast24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 9a.75.75 0 00-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75h-4.5zM9 13.5v-3h3v3H9zM2 7.75A4.75 4.75 0 016.75 3h10.5a4.75 4.75 0 013.5 7.96v7.79c0 1.24-1 2.25-2.25 2.25h-13c-1.24 0-2.25-1-2.25-2.25v-7.79A4.74 4.74 0 012 7.75zM6.75 4.5a3.25 3.25 0 00-2.23 5.61c.15.14.23.34.23.54v8.1c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-7.7c0-.24.12-.47.33-.61a3.25 3.25 0 00-1.83-5.94h-8z",
    fill: primaryFill
  }));
};

export const FoodToast24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToast24FilledIcon, 'FoodToast24Filled');

const FoodToast24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 9a.75.75 0 00-.75.75v4.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-4.5a.75.75 0 00-.75-.75h-4.5zM9 13.5v-3h3v3H9zM2 7.75A4.75 4.75 0 016.75 3h10.5a4.75 4.75 0 013.5 7.96v7.79c0 1.24-1 2.25-2.25 2.25h-13c-1.24 0-2.25-1-2.25-2.25v-7.79A4.74 4.74 0 012 7.75zM6.75 4.5a3.25 3.25 0 00-2.23 5.61c.15.14.23.34.23.54v8.1c0 .41.34.75.75.75h10c.41 0 .75-.34.75-.75v-7.7c0-.24.12-.47.33-.61a3.25 3.25 0 00-1.83-5.94h-8zM19.5 7.75c0 1.49-.68 2.81-1.75 3.68v7.32c0 .26-.05.52-.13.75h.88c.41 0 .75-.34.75-.75v-8.1c0-.2.08-.4.23-.54a3.24 3.24 0 00-1.08-5.4c.69.82 1.1 1.88 1.1 3.04z",
    fill: primaryFill
  }));
};

export const FoodToast24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FoodToast24RegularIcon, 'FoodToast24Regular');

const Form20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 10a.5.5 0 100-1 .5.5 0 000 1zm.5 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm2.5-1a.5.5 0 000 1h9a.5.5 0 000-1h-9zm1 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 13.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm1-4c0 .28.22.5.5.5h5a.5.5 0 000-1h-5a.5.5 0 00-.5.5zm.5 3.5a.5.5 0 000 1h5a.5.5 0 000-1h-5z",
    fill: primaryFill
  }));
};

export const Form20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form20FilledIcon, 'Form20Filled');

const Form20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm1 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 110-1 .5.5 0 010 1zM8 13.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1 0a.5.5 0 10-1 0 .5.5 0 001 0zm2-4c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 3.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 6c0-1.1.9-2 2-2h8a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2V6z",
    fill: primaryFill
  }));
};

export const Form20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form20RegularIcon, 'Form20Regular');

const Form24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 10a.75.75 0 100 1.5.75.75 0 000-1.5zm-.75 6.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25zm3 4.5a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM8.25 14a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM12 10.75c0 .41.34.75.75.75h4.5a.75.75 0 000-1.5h-4.5a.75.75 0 00-.75.75zm.75 4.75a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM6 6.25c0 .41.34.75.75.75h10.5a.75.75 0 000-1.5H6.75a.75.75 0 00-.75.75z",
    fill: primaryFill
  }));
};

export const Form24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form24FilledIcon, 'Form24Filled');

const Form24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM8.25 10a.75.75 0 100 1.5.75.75 0 000-1.5zm0 4a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-.75 2.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm4.5-5.5c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zm.75 4.75a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM6 6.75c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H6.75A.75.75 0 016 6.75zM6.25 3A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25zM4.5 6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v11.5c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V6.25z",
    fill: primaryFill
  }));
};

export const Form24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form24RegularIcon, 'Form24Regular');

const Form28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 11.5a1 1 0 100 2 1 1 0 000-2zm-1 8a1 1 0 112 0 1 1 0 01-2 0zM3 6.75A3.75 3.75 0 016.75 3h14.5A3.75 3.75 0 0125 6.75v14.5A3.75 3.75 0 0121.25 25H6.75A3.75 3.75 0 013 21.25V6.75zm3 5.75a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM8.5 17a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm4.5-4.75c0 .41.34.75.75.75h7.5a.75.75 0 000-1.5h-7.5a.75.75 0 00-.75.75zm.75 6.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zM6 6.75c0 .41.34.75.75.75h14.5a.75.75 0 000-1.5H6.75a.75.75 0 00-.75.75z",
    fill: primaryFill
  }));
};

export const Form28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form28FilledIcon, 'Form28Filled');

const Form28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1a1 1 0 100 2 1 1 0 000-2zm0 5.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-1 2.5a1 1 0 112 0 1 1 0 01-2 0zm5.5-7.25c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zm.75 6.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zM6 7.25c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H6.75A.75.75 0 016 7.25zM6.75 3A3.75 3.75 0 003 6.75v14.5A3.75 3.75 0 006.75 25h14.5A3.75 3.75 0 0025 21.25V6.75A3.75 3.75 0 0021.25 3H6.75zM4.5 6.75c0-1.24 1-2.25 2.25-2.25h14.5c1.24 0 2.25 1 2.25 2.25v14.5c0 1.24-1 2.25-2.25 2.25H6.75c-1.24 0-2.25-1-2.25-2.25V6.75z",
    fill: primaryFill
  }));
};

export const Form28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form28RegularIcon, 'Form28Regular');

const Form48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.5 21.5a2 2 0 11-4 0 2 2 0 014 0zm-2 13a2 2 0 100-4 2 2 0 000 4zM6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 016 35.75v-23.5zm15 9.25a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zM16.5 37a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-3.25-26a1.25 1.25 0 100 2.5h21.5a1.25 1.25 0 100-2.5h-21.5zM23 21.75c0 .69.56 1.25 1.25 1.25h10.5a1.25 1.25 0 100-2.5h-10.5c-.69 0-1.25.56-1.25 1.25zM24.25 31a1.25 1.25 0 100 2.5h10.5a1.25 1.25 0 100-2.5h-10.5z",
    fill: primaryFill
  }));
};

export const Form48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form48FilledIcon, 'Form48Filled');

const Form48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 21.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.5 0a2 2 0 10-4 0 2 2 0 004 0zm-2 15.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-2.5a2 2 0 110-4 2 2 0 010 4zM13.25 12a1.25 1.25 0 100 2.5h21.5a1.25 1.25 0 100-2.5h-21.5zM23 21.75c0-.69.56-1.25 1.25-1.25h10.5a1.25 1.25 0 110 2.5h-10.5c-.69 0-1.25-.56-1.25-1.25zM24.25 31a1.25 1.25 0 100 2.5h10.5a1.25 1.25 0 100-2.5h-10.5zm-12-25A6.25 6.25 0 006 12.25v23.5C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5C42 8.8 39.2 6 35.75 6h-23.5zM8.5 12.25a3.75 3.75 0 013.75-3.75h23.5a3.75 3.75 0 013.75 3.75v23.5a3.75 3.75 0 01-3.75 3.75h-23.5a3.75 3.75 0 01-3.75-3.75v-23.5z",
    fill: primaryFill
  }));
};

export const Form48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Form48RegularIcon, 'Form48Regular');

const FormMultiple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 11a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6 3h6a3 3 0 013 3v6a2.99 2.99 0 01-3 3H6a2.99 2.99 0 01-3-3V6a3 3 0 013-3zm-.5 3a.5.5 0 000 1h7a.5.5 0 000-1h-7zm1 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm3-2a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5.76 16A3 3 0 008 17h4.5a4.5 4.5 0 004.5-4.5V8a3 3 0 00-1-2.24v6.74c0 .12 0 .24-.02.36A3.5 3.5 0 0112.5 16H5.76z",
    fill: primaryFill
  }));
};

export const FormMultiple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple20FilledIcon, 'FormMultiple20Filled');

const FormMultiple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 6a.5.5 0 000 1h7a.5.5 0 000-1h-7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 110-1 .5.5 0 010 1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.5 10a.5.5 0 000 1h3a.5.5 0 000-1h-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 6a3 3 0 013-3h6a3 3 0 013 3v6a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm3-2a2 2 0 00-2 2v6a2 2 0 002 2h6a2 2 0 002-2V6a2 2 0 00-2-2H6z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 17a3 3 0 01-2.24-1h6.74a3.5 3.5 0 003.5-3.5V5.76A3 3 0 0117 8v4.5a4.5 4.5 0 01-4.5 4.5H8z",
    fill: primaryFill
  }));
};

export const FormMultiple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple20RegularIcon, 'FormMultiple20Regular');

const FormMultiple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.25 11.5a.75.75 0 100 1.5.75.75 0 000-1.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25v9c0 1.8 1.46 3.25 3.25 3.25h9c1.8 0 3.25-1.46 3.25-3.25v-9c0-1.8-1.46-3.25-3.25-3.25h-9zM5 12.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm5.5 0c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75zM5 7.75c0-.41.34-.75.75-.75h10a.75.75 0 010 1.5h-10A.75.75 0 015 7.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.75 21c-1.15 0-2.16-.6-2.74-1.5h9.74a3.75 3.75 0 003.75-3.75V6.01c.9.58 1.5 1.59 1.5 2.74v7c0 2.9-2.35 5.25-5.25 5.25h-7z",
    fill: primaryFill
  }));
};

export const FormMultiple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple24FilledIcon, 'FormMultiple24Filled');

const FormMultiple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm2.25-.75a.75.75 0 100 1.5.75.75 0 000-1.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11.5 12.25c0-.41.34-.75.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6 7.75c0-.41.34-.75.75-.75h8a.75.75 0 010 1.5h-8A.75.75 0 016 7.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25v9c0 1.8 1.46 3.25 3.25 3.25h9c1.8 0 3.25-1.46 3.25-3.25v-9c0-1.8-1.46-3.25-3.25-3.25h-9zM4.5 6.25c0-.97.78-1.75 1.75-1.75h9c.97 0 1.75.78 1.75 1.75v9A1.75 1.75 0 0115.25 17h-9a1.75 1.75 0 01-1.75-1.75v-9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.75 21c-1.15 0-2.16-.6-2.74-1.5h9.74a3.75 3.75 0 003.75-3.75V6.01c.9.58 1.5 1.59 1.5 2.74v7c0 2.9-2.35 5.25-5.25 5.25h-7z",
    fill: primaryFill
  }));
};

export const FormMultiple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple24RegularIcon, 'FormMultiple24Regular');

const FormMultiple28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 6c.9.58 1.5 1.6 1.5 2.75v10.5c0 2.9-2.35 5.25-5.25 5.25H8.75c-1.15 0-2.17-.6-2.74-1.5h13.24A3.75 3.75 0 0023 19.25v-13-.24z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.5 13.5a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M18.75 3H6.25A3.25 3.25 0 003 6.25v12.5C3 20.55 4.46 22 6.25 22h12.5c1.8 0 3.25-1.46 3.25-3.25V6.25C22 4.45 20.54 3 18.75 3zM6 14.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm7-.25c0-.41.34-.75.75-.75h5a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75zm-7-5c0-.41.34-.75.75-.75h12a.75.75 0 010 1.5h-12A.75.75 0 016 9.25z",
    fill: primaryFill
  }));
};

export const FormMultiple28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple28FilledIcon, 'FormMultiple28Filled');

const FormMultiple28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 6c.9.58 1.5 1.6 1.5 2.75v10.5c0 2.9-2.35 5.25-5.25 5.25H8.75c-1.15 0-2.17-.6-2.74-1.5h13.24A3.75 3.75 0 0023 19.25v-13-.24z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6 14.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M13 14.25c0-.41.34-.75.75-.75h5a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M6 9.25c0-.41.34-.75.75-.75h12a.75.75 0 010 1.5h-12A.75.75 0 016 9.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M18.75 3C20.55 3 22 4.46 22 6.25v12.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 18.75V6.25C3 4.45 4.46 3 6.25 3h12.5zm0 17.5a1.75 1.75 0 001.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v12.5a1.75 1.75 0 001.75 1.75h12.5z",
    fill: primaryFill
  }));
};

export const FormMultiple28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple28RegularIcon, 'FormMultiple28Regular');

const FormMultiple48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 25.5a2 2 0 11-4 0 2 2 0 014 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.75 5A5.75 5.75 0 005 10.75v21.5A5.75 5.75 0 0010.75 38h21.5A5.75 5.75 0 0038 32.25v-21.5A5.75 5.75 0 0032.25 5h-21.5zM19 25.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-9-10.25c0-.69.56-1.25 1.25-1.25h20.5a1.25 1.25 0 110 2.5h-20.5c-.69 0-1.25-.56-1.25-1.25zm12.25 9.25h9.5a1.25 1.25 0 110 2.5h-9.5a1.25 1.25 0 110-2.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M15.25 42.5c-1.97 0-3.71-1-4.75-2.5h21.75A7.75 7.75 0 0040 32.25v-21.5-.25a5.74 5.74 0 012.5 4.75v17c0 5.66-4.59 10.25-10.25 10.25h-17z",
    fill: primaryFill
  }));
};

export const FormMultiple48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple48FilledIcon, 'FormMultiple48Filled');

const FormMultiple48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 25.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.5 0a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10 15.25c0-.69.56-1.25 1.25-1.25h20.5a1.25 1.25 0 110 2.5h-20.5c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M22.25 24.5a1.25 1.25 0 100 2.5h9.5a1.25 1.25 0 100-2.5h-9.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.75 5A5.75 5.75 0 005 10.75v21.5A5.75 5.75 0 0010.75 38h21.5A5.75 5.75 0 0038 32.25v-21.5A5.75 5.75 0 0032.25 5h-21.5zM7.5 10.75c0-1.8 1.46-3.25 3.25-3.25h21.5c1.8 0 3.25 1.46 3.25 3.25v21.5a3.24 3.24 0 01-3.25 3.25h-21.5a3.24 3.24 0 01-3.25-3.25v-21.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M15.25 42.5c-1.97 0-3.71-1-4.75-2.5h21.75A7.75 7.75 0 0040 32.25v-21.5-.25a5.74 5.74 0 012.5 4.75v17c0 5.66-4.59 10.25-10.25 10.25h-17z",
    fill: primaryFill
  }));
};

export const FormMultiple48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormMultiple48RegularIcon, 'FormMultiple48Regular');

const FormNew20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9.5a.5.5 0 11-1 0 .5.5 0 011 0zM6.5 14a.5.5 0 100-1 .5.5 0 000 1zM3 6a3 3 0 013-3h8a3 3 0 013 3v3.6c-.75-.38-1.6-.6-2.5-.6h-5a.5.5 0 000 1h1.84a5.5 5.5 0 00-1.74 7H6a3 3 0 01-3-3V6zm2.5-1a.5.5 0 000 1h9a.5.5 0 000-1h-9zm1 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 13.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm11 1a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FormNew20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew20FilledIcon, 'FormNew20Filled');

const FormNew20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h3.6c-.16-.32-.3-.65-.4-1H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v3.2c.35.1.68.24 1 .4V6a3 3 0 00-3-3H6zm3.5 7h1.84c.9-.63 1.98-1 3.16-1h-5a.5.5 0 000 1zm-4-5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm1 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-1a.5.5 0 110-1 .5.5 0 010 1zm0 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-2a.5.5 0 110 1 .5.5 0 010-1zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const FormNew20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew20RegularIcon, 'FormNew20Regular');

const FormNew24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 10.75a.75.75 0 111.5 0 .75.75 0 01-1.5 0zm.75 4.75a.75.75 0 100 1.5.75.75 0 000-1.5zM3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v5.77a6.46 6.46 0 00-3.05-1 .75.75 0 00-.7-1.02h-4.5a.75.75 0 000 1.5H15a6.5 6.5 0 00-2.98 9.5H6.25A3.25 3.25 0 013 17.75V6.25zm3 4.5a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0zM8.25 14a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM6 6.25c0 .41.34.75.75.75h10.5a.75.75 0 000-1.5H6.75a.75.75 0 00-.75.75zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-5 .5v2.5a.5.5 0 11-1 0V18h-2.5a.5.5 0 010-1H17v-2.5a.5.5 0 111 0V17h2.5a.5.5 0 010 1H18z",
    fill: primaryFill
  }));
};

export const FormNew24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew24FilledIcon, 'FormNew24Filled');

const FormNew24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h5.77c-.3-.46-.53-.97-.7-1.5H6.24c-.97 0-1.75-.78-1.75-1.75V6.25c0-.97.78-1.75 1.75-1.75h11.5c.97 0 1.75.78 1.75 1.75v5.06c.53.18 1.04.42 1.5.71V6.25C21 4.45 19.54 3 17.75 3H6.25zm11.25 8c.15 0 .3 0 .45.02a.75.75 0 00-.7-1.02h-4.5a.75.75 0 000 1.5H15c.77-.32 1.61-.5 2.5-.5zM6.75 6a.75.75 0 000 1.5h10.5a.75.75 0 000-1.5H6.75zM6 10.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM8.25 10a.75.75 0 100 1.5.75.75 0 000-1.5zm0 4a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-.75 2.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-5 .5v2.5a.5.5 0 11-1 0V18h-2.5a.5.5 0 010-1H17v-2.5a.5.5 0 111 0V17h2.5a.5.5 0 010 1H18z",
    fill: primaryFill
  }));
};

export const FormNew24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew24RegularIcon, 'FormNew24Regular');

const FormNew28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 12.5a1 1 0 112 0 1 1 0 01-2 0zm1 6a1 1 0 100 2 1 1 0 000-2zM3 6.75A3.75 3.75 0 016.75 3h14.5A3.75 3.75 0 0125 6.75v7.75a7.47 7.47 0 00-4.5-1.5h.75a.75.75 0 000-1.5h-7.5a.75.75 0 000 1.5h6.75a7.5 7.5 0 00-6 12H6.75A3.75 3.75 0 013 21.25V6.75zm3 5.75a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM8.5 17a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM6 6.75c0 .41.34.75.75.75h14.5a.75.75 0 000-1.5H6.75a.75.75 0 00-.75.75zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-6-4a.5.5 0 00-1 0V20h-3.5a.5.5 0 000 1H20v3.5a.5.5 0 001 0V21h3.5a.5.5 0 000-1H21v-3.5z",
    fill: primaryFill
  }));
};

export const FormNew28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew28FilledIcon, 'FormNew28Filled');

const FormNew28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.75A3.75 3.75 0 016.75 3h14.5A3.75 3.75 0 0125 6.75v7.75a7.49 7.49 0 00-1.5-.88V6.75c0-1.24-1-2.25-2.25-2.25H6.75c-1.24 0-2.25 1-2.25 2.25v14.5c0 1.24 1 2.25 2.25 2.25h6.87c.24.54.53 1.04.88 1.5H6.75A3.75 3.75 0 013 21.25V6.75zM21.25 13a.75.75 0 000-1.5h-7.5a.75.75 0 000 1.5h7.5zM6 7.25c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H6.75A.75.75 0 016 7.25zM8.5 10a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm-1 2.5a1 1 0 112 0 1 1 0 01-2 0zm-1.5 7a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm2.5-1a1 1 0 100 2 1 1 0 000-2zm18.5 2a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-6-4a.5.5 0 00-1 0V20h-3.5a.5.5 0 000 1H20v3.5a.5.5 0 001 0V21h3.5a.5.5 0 000-1H21v-3.5z",
    fill: primaryFill
  }));
};

export const FormNew28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew28RegularIcon, 'FormNew28Regular');

const FormNew48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 23.5a2 2 0 100-4 2 2 0 000 4zm2 9a2 2 0 11-4 0 2 2 0 014 0zM6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v11.8a12.92 12.92 0 00-6.03-2.01 1.25 1.25 0 00-1.22-1.54h-10.5a1.25 1.25 0 100 2.5h5.74a13 13 0 00-5.95 19H12.25A6.25 6.25 0 016 35.75v-23.5zm15 9.25a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zM16.5 37a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-3.25-26a1.25 1.25 0 100 2.5h21.5a1.25 1.25 0 100-2.5h-21.5zM46 35a11 11 0 11-22 0 11 11 0 0122 0zm-10-7a1 1 0 10-2 0v6h-6a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6v-6z",
    fill: primaryFill
  }));
};

export const FormNew48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew48FilledIcon, 'FormNew48Filled');

const FormNew48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.25 6A6.25 6.25 0 006 12.25v23.5C6 39.2 8.8 42 12.25 42h11.8c-.5-.78-.92-1.62-1.25-2.5H12.25a3.75 3.75 0 01-3.75-3.75v-23.5a3.75 3.75 0 013.75-3.75h23.5a3.75 3.75 0 013.75 3.75V22.8c.88.33 1.72.74 2.5 1.24V12.25C42 8.8 39.2 6 35.75 6h-23.5zM35 22c.33 0 .65.01.97.04a1.25 1.25 0 00-1.22-1.54h-10.5a1.25 1.25 0 100 2.5h5.74c1.54-.64 3.23-1 5.01-1zm-23-8.75c0-.69.56-1.25 1.25-1.25h21.5a1.25 1.25 0 110 2.5h-21.5c-.69 0-1.25-.56-1.25-1.25zm9 8.25a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.5 0a2 2 0 10-4 0 2 2 0 004 0zm-2 15.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-2.5a2 2 0 110-4 2 2 0 010 4zM46 35a11 11 0 11-22 0 11 11 0 0122 0zm-10-7a1 1 0 10-2 0v6h-6a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6v-6z",
    fill: primaryFill
  }));
};

export const FormNew48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FormNew48RegularIcon, 'FormNew48Regular');

const Fps12020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2.75a.75.75 0 00-1.4-.39 1.71 1.71 0 01-.1.16l-.33.41c-.3.33-.72.68-1.2.87a.75.75 0 00.56 1.4c.36-.15.69-.34.97-.55v4.6a.75.75 0 001.5 0v-6.5zm8 1.75a2.5 2.5 0 115 0v3a2.5 2.5 0 01-5 0v-3zm3.5 0a1 1 0 10-2 0v3a1 1 0 102 0v-3zM3 12.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4v2h1.5a.5.5 0 010 1H4v1.5a.5.5 0 01-1 0v-5zm5 0c0-.28.22-.5.5-.5H10a2 2 0 010 4H9v1.5a.5.5 0 01-1 0v-5zM9 15h1a1 1 0 100-2H9v2zm5.75-3a1.75 1.75 0 000 3.5h.5a.75.75 0 010 1.5h-.76a.49.49 0 01-.49-.49v-.01a.5.5 0 00-1 0v.01c0 .82.67 1.49 1.49 1.49h.76a1.75 1.75 0 100-3.5h-.5a.75.75 0 010-1.5h.76c.27 0 .49.22.49.49v.01a.5.5 0 101 0v-.01c0-.82-.67-1.49-1.49-1.49h-.76zM7.99 4.37v.01a.75.75 0 01-1.48-.25c-.07.41 0 0 0 0a1.71 1.71 0 01.1-.37A2.7 2.7 0 019.25 2c.96 0 1.73.38 2.22 1 .48.61.65 1.4.52 2.13-.14.81-.6 1.3-1.15 1.63a6.7 6.7 0 01-1.48.59c-.45.16-.76.33-.98.57-.11.13-.22.3-.3.58h3.17a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75c0-1.01.27-1.77.76-2.33.48-.53 1.09-.8 1.59-.98l.45-.16c.32-.1.56-.2.79-.32.24-.14.37-.3.42-.59a1.2 1.2 0 00-.22-.94c-.18-.23-.5-.43-1.04-.43-.62 0-.9.25-1.06.45a1.25 1.25 0 00-.2.43z",
    fill: primaryFill
  }));
};

export const Fps12020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps12020FilledIcon, 'Fps12020Filled');

const Fps12020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 10a.5.5 0 01-.5-.5V3.93c-.33.34-.75.7-1.24 1a.5.5 0 11-.52-.86 5.58 5.58 0 001.83-1.82.5.5 0 01.93.26V9.5a.5.5 0 01-.5.5zM12 4.5a2.5 2.5 0 015 0v3a2.5 2.5 0 01-5 0v-3zm4 0a1.5 1.5 0 00-3 0v3a1.5 1.5 0 003 0v-3zm-13 8c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4v2h1.5a.5.5 0 010 1H4v1.5a.5.5 0 01-1 0v-5zm5 0c0-.28.22-.5.5-.5H10a2 2 0 110 4H9v1.5a.5.5 0 01-1 0v-5zM9 15h1a1 1 0 100-2H9v2zm5.75-3a1.75 1.75 0 100 3.5h.5a.75.75 0 010 1.5h-.76a.49.49 0 01-.49-.49v-.01a.5.5 0 00-1 0v.01c0 .82.67 1.49 1.49 1.49h.76a1.75 1.75 0 100-3.5h-.5a.75.75 0 010-1.5h.76c.27 0 .49.22.49.49v.01a.5.5 0 001 0v-.01c0-.82-.67-1.49-1.49-1.49h-.76zM6.99 4.08a.5.5 0 01-.57.41C5.94 4.41 6 3.92 6 3.92v-.04a1.66 1.66 0 01.09-.28c.06-.18.17-.41.34-.65A2.44 2.44 0 018.5 2c.86 0 1.59.3 2.05.88.46.58.59 1.36.44 2.2a2.12 2.12 0 01-1 1.49c-.34.21-.75.38-1.1.52l-.33.14c-.46.2-.84.4-1.1.72-.2.24-.36.56-.43 1.05h3.47a.5.5 0 010 1h-4a.5.5 0 01-.5-.5c0-.97.25-1.67.69-2.19.42-.5.98-.79 1.47-1l.43-.18c.33-.13.6-.25.85-.4.3-.2.5-.43.57-.81.11-.66-.01-1.13-.24-1.42-.23-.3-.63-.5-1.27-.5-.7 0-1.06.29-1.26.55a1.5 1.5 0 00-.25.53z",
    fill: primaryFill
  }));
};

export const Fps12020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps12020RegularIcon, 'Fps12020Regular');

const Fps12024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.26 3.03a1 1 0 01.76.97v8a1 1 0 01-2 0V6.5l-.47.33a1 1 0 01-1.1-1.66 6.55 6.55 0 001.69-1.63v-.01a1 1 0 011.12-.5zM18 3a3 3 0 00-3 3v4a3 3 0 006 0V6a3 3 0 00-3-3zm-1 3a1 1 0 112 0v4a1 1 0 01-2 0V6zM4 15.75c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5H5.5V18h1.75a.75.75 0 010 1.5H5.5v1.73a.75.75 0 01-1.5 0v-5.48zm6.25-.75a.75.75 0 00-.75.75v5.5a.75.75 0 001.5 0V19.5h.75a2.25 2.25 0 100-4.5h-1.5zm1.5 3H11v-1.5h.75a.75.75 0 010 1.5zm3.5-.88c0-1.17.95-2.12 2.13-2.12H18a2 2 0 012 2 .75.75 0 01-1.5 0 .5.5 0 00-.5-.5h-.63a.62.62 0 100 1.25h.5a2.13 2.13 0 010 4.25h-.62a2 2 0 01-2-2 .75.75 0 011.5 0c0 .28.22.5.5.5h.63a.62.62 0 100-1.25h-.5a2.13 2.13 0 01-2.13-2.13zM8.13 6.19a1 1 0 001.29-.54l.03-.05c.04-.06.1-.14.2-.22.16-.16.49-.37 1.1-.37.42 0 .75.13.94.3.19.15.31.37.31.7 0 .55-.17.86-.42 1.12-.3.32-.73.56-1.33.9a6.9 6.9 0 00-1.8 1.33A3.82 3.82 0 007.5 12a1 1 0 001 1H13a1 1 0 100-2H9.72c.07-.12.15-.22.23-.32.3-.33.72-.6 1.3-.92l.1-.06c.51-.3 1.16-.66 1.67-1.19C13.6 7.9 14 7.1 14 6c0-.91-.38-1.7-1.01-2.23A3.44 3.44 0 0010.75 3c-1.14 0-1.94.42-2.45.89a3.11 3.11 0 00-.73.99s-.2.52 0 0a1 1 0 00.56 1.3z",
    fill: primaryFill
  }));
};

export const Fps12024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps12024FilledIcon, 'Fps12024Filled');

const Fps12024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3.75a.75.75 0 00-1.36-.44l-.02.02a6.36 6.36 0 01-.18.25c-.13.16-.31.4-.54.64a7.3 7.3 0 01-1.54 1.39.75.75 0 00.78 1.28c.48-.29.95-.7 1.36-1.1v6.46a.75.75 0 001.5 0v-8.5zm3.49 1.64A.75.75 0 018 5.13V5.1A1.36 1.36 0 018.04 5l.08-.26c.08-.2.21-.46.43-.72A3.04 3.04 0 0111 3a3 3 0 013 3c0 1.02-.36 1.78-.9 2.36-.47.52-1.09.9-1.6 1.23l-.1.06c-.58.36-1.04.67-1.37 1.06-.19.22-.34.47-.43.79h3.65a.75.75 0 010 1.5h-4.5a.75.75 0 01-.75-.75c0-1.07.35-1.88.88-2.5.5-.6 1.17-1.03 1.72-1.37l.03-.02c.58-.36 1.03-.65 1.36-1 .3-.34.51-.74.51-1.36 0-.83-.67-1.5-1.5-1.5-.78 0-1.13.28-1.3.48a1.12 1.12 0 00-.21.4zM17.99 3A3 3 0 0015 6v4a3 3 0 006 0V6a3 3 0 00-3-3zM16.5 6a1.5 1.5 0 113 0v4a1.5 1.5 0 11-3 0V6zM4 15.75c0-.41.34-.75.75-.75h3a.75.75 0 010 1.5H5.5V18h1.75a.75.75 0 010 1.5H5.5v1.73a.75.75 0 01-1.5 0v-5.48zm6.25-.75a.75.75 0 00-.75.75v5.5a.75.75 0 001.5 0V19.5h.75a2.25 2.25 0 100-4.5h-1.5zm1.5 3H11v-1.5h.75a.75.75 0 010 1.5zm3.5-.88c0-1.17.95-2.12 2.13-2.12H18a2 2 0 012 2 .75.75 0 01-1.5 0 .5.5 0 00-.5-.5h-.63a.62.62 0 100 1.25h.5a2.13 2.13 0 010 4.25h-.62a2 2 0 01-2-2 .75.75 0 011.5 0c0 .28.22.5.5.5h.63a.62.62 0 100-1.25h-.5a2.13 2.13 0 01-2.13-2.13z",
    fill: primaryFill
  }));
};

export const Fps12024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps12024RegularIcon, 'Fps12024Regular');

const Fps24020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.99 4.38a.75.75 0 01-1.48-.25v-.05a1.92 1.92 0 01.1-.32A2.7 2.7 0 014.25 2c.96 0 1.73.38 2.22 1 .48.61.65 1.4.52 2.13-.14.81-.6 1.3-1.15 1.63a6.71 6.71 0 01-1.48.59c-.45.16-.76.33-.98.57-.11.13-.22.3-.3.58h3.17a.75.75 0 010 1.5h-4a.75.75 0 01-.75-.75c0-1.01.27-1.77.76-2.33.48-.53 1.09-.8 1.59-.98l.45-.16c.32-.1.56-.2.79-.32.24-.14.37-.3.42-.59a1.2 1.2 0 00-.22-.94c-.18-.23-.5-.43-1.04-.43-.62 0-.9.25-1.06.45a1.25 1.25 0 00-.2.43zm0 0zm0 0zM16.5 2A2.5 2.5 0 0014 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0016.5 2zm1 5.5a1 1 0 11-2 0v-3a1 1 0 112 0v3zM3.5 12a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm.5 3v-2h1a1 1 0 110 2H9zm4-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zM8.75 2c.41 0 .75.34.75.75V5.5H11V2.75a.75.75 0 011.5 0V9.5a.75.75 0 01-1.5 0V7H8.75A.75.75 0 018 6.25v-3.5c0-.41.34-.75.75-.75zM2.99 4.38z",
    fill: primaryFill
  }));
};

export const Fps24020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps24020FilledIcon, 'Fps24020Filled');

const Fps24020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.09v-.03l.04-.12c.04-.11.1-.25.2-.39.2-.26.55-.55 1.26-.55.64 0 1.04.2 1.27.5.23.3.35.76.24 1.42-.07.38-.26.61-.57.8-.24.16-.52.28-.85.41l-.43.18c-.5.21-1.05.5-1.47 1A3.27 3.27 0 002 9.5a.5.5 0 00.5.5h4a.5.5 0 000-1H3.03c.07-.49.23-.81.43-1.05.26-.32.64-.52 1.1-.72.1-.05.2-.1.32-.14.36-.14.77-.3 1.1-.52.49-.31.89-.76 1.01-1.49.15-.84.02-1.62-.44-2.2C6.1 2.29 5.36 2 4.5 2a2.44 2.44 0 00-2.49 1.88v.03S2 4 2 3.92a.5.5 0 00.98.18zm10 .41a2.5 2.5 0 015 0v3a2.5 2.5 0 01-5 0v-3zm4 3v-3a1.5 1.5 0 00-3 0v3a1.5 1.5 0 003 0zm-14 5c0-.28.22-.5.5-.5h3a.5.5 0 010 1H4v2h1.5a.5.5 0 010 1H4v1.5a.5.5 0 01-1 0v-5zm5 0c0-.28.22-.5.5-.5H10a2 2 0 110 4H9v1.5a.5.5 0 01-1 0v-5zM9 15h1a1 1 0 100-2H9v2zm5.75-3a1.75 1.75 0 100 3.5h.5a.75.75 0 010 1.5h-.76a.49.49 0 01-.49-.49v-.01a.5.5 0 00-1 0v.01c0 .82.67 1.49 1.49 1.49h.76a1.75 1.75 0 100-3.5h-.5a.75.75 0 010-1.5h.76c.27 0 .49.22.49.49v.01a.5.5 0 001 0v-.01c0-.82-.67-1.49-1.49-1.49h-.76zM9 2.5a.5.5 0 00-1 0v4a.5.5 0 00.5.5H11v2.5a.5.5 0 001 0v-7a.5.5 0 00-1 0V6H9V2.5z",
    fill: primaryFill
  }));
};

export const Fps24020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps24020RegularIcon, 'Fps24020Regular');

const Fps24024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.15 6.18a1 1 0 001.29-.54l.03-.05c.03-.06.1-.14.19-.23.17-.15.5-.36 1.1-.36.43 0 .75.13.95.3.18.15.3.37.3.7 0 .55-.17.86-.42 1.12-.3.32-.72.56-1.32.9a6.9 6.9 0 00-1.8 1.33A3.83 3.83 0 001.53 12a1 1 0 001 1h4.5a1 1 0 000-2H3.74c.07-.12.14-.22.23-.32.3-.33.71-.6 1.3-.92l.1-.06c.5-.3 1.15-.66 1.66-1.19.6-.61.98-1.42.98-2.51 0-.91-.38-1.7-1-2.23A3.44 3.44 0 004.76 3c-1.14 0-1.94.42-2.45.89a3.11 3.11 0 00-.72.97v.01s-.22.53 0 0a1 1 0 00.55 1.3zM16 6A3 3 0 1122 6v4a3 3 0 11-6 0V6zm3-1a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1zM4.76 15a.75.75 0 00-.75.75v5.48a.75.75 0 101.5 0V19.5h1.75a.75.75 0 000-1.5H5.52v-1.5h2.24a.75.75 0 000-1.5h-3zm4.74.75c0-.41.34-.75.75-.75h1.5a2.25 2.25 0 010 4.5h-.75v1.75a.75.75 0 11-1.5 0v-5.5zm1.5 2.25h.75a.75.75 0 000-1.5h-.75V18zm6.37-3a2.12 2.12 0 000 4.25h.5a.62.62 0 010 1.25h-.63a.5.5 0 01-.5-.5.75.75 0 10-1.5 0c0 1.1.9 2 2 2h.63a2.12 2.12 0 000-4.25h-.5a.62.62 0 010-1.25H18c.28 0 .5.22.5.5a.75.75 0 101.5 0 2 2 0 00-2-2h-.62zM15.01 4a1 1 0 10-2 0l.02 3H11V4a1 1 0 10-2 0v4a1 1 0 001 1h3.02v3a1 1 0 102 0V7.4a1 1 0 000-.09L15 4z",
    fill: primaryFill
  }));
};

export const Fps24024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps24024FilledIcon, 'Fps24024Filled');

const Fps24024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.63 5.99c.4.07.78-.2.86-.6v-.01l.03-.1c.03-.07.09-.19.18-.3.17-.2.52-.48 1.3-.48.83 0 1.5.67 1.5 1.5 0 .62-.2 1.02-.5 1.35-.34.36-.8.65-1.37 1.01l-.03.02c-.55.34-1.21.76-1.72 1.36A3.72 3.72 0 002 12.25c0 .41.34.75.75.75h4.5a.75.75 0 000-1.5H3.6c.09-.32.24-.57.43-.79.33-.4.8-.7 1.37-1.06l.1-.06c.51-.32 1.12-.7 1.6-1.23.54-.58.9-1.34.9-2.36a3 3 0 00-3-3c-1.22 0-2 .47-2.45 1.02A2.62 2.62 0 002 5.11v.01c-.07.41.2.8.62.87zm13.37 0a3 3 0 016 0v4.02a3 3 0 01-6 0V6zm3-1.49c-.83 0-1.5.67-1.5 1.5v4a1.5 1.5 0 103 0V6c0-.83-.67-1.5-1.5-1.5zM4.74 15a.75.75 0 00-.75.75v5.48a.75.75 0 001.5 0V19.5h1.75a.75.75 0 000-1.5H5.5v-1.5h2.25a.75.75 0 000-1.5h-3zm4.75.75c0-.41.34-.75.75-.75h1.5a2.25 2.25 0 110 4.5H11v1.75a.75.75 0 01-1.5 0v-5.5zM11 18h.75a.75.75 0 100-1.5H11V18zm6.38-3a2.13 2.13 0 000 4.25h.5a.62.62 0 110 1.25h-.63a.5.5 0 01-.5-.5.75.75 0 00-1.5 0c0 1.1.9 2 2 2h.63a2.13 2.13 0 000-4.25h-.5a.62.62 0 110-1.25H18c.28 0 .5.22.5.5a.75.75 0 001.5 0 2 2 0 00-2-2h-.63zM14.25 3c.41 0 .75.34.75.75v8.5a.75.75 0 01-1.5 0V9H9.75A.75.75 0 019 8.25v-4.5a.75.75 0 111.5 0V7.5h3V3.75c0-.41.33-.75.75-.75z",
    fill: primaryFill
  }));
};

export const Fps24024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps24024RegularIcon, 'Fps24024Regular');

const Fps3016FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 3a2 2 0 114 0v3a2 2 0 11-4 0V3zm2.5 3V3a.5.5 0 00-1 0v3a.5.5 0 001 0zM1 10.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1H2v1h1.5a.5.5 0 010 1H2v1.5a.5.5 0 01-1 0v-4zm5 0c0-.28.22-.5.5-.5h1.75a1.75 1.75 0 110 3.5H7v1a.5.5 0 01-1 0v-4zm1 2h1.25a.75.75 0 000-1.5H7v1.5zm5.5-2.5a1.5 1.5 0 000 3h1a.5.5 0 010 1h-2a.5.5 0 000 1h2a1.5 1.5 0 000-3h-1a.5.5 0 010-1h2a.5.5 0 000-1h-2zm-7-6.75V3a.5.5 0 00-.77-.42c-.07.04-.14.1-.2.15C4.36 2.86 4.2 3 4 3c-.55 0-1.02-.47-.76-.96A2 2 0 017 3v.25a2 2 0 01-.44 1.25A2 2 0 017 5.75V6a2 2 0 01-3.76.96C2.98 6.47 3.44 6 4 6c.2 0 .36.14.53.27l.2.15A.5.5 0 005.5 6v-.25a.5.5 0 00-.5-.5.75.75 0 010-1.5.5.5 0 00.5-.5z",
    fill: primaryFill
  }));
};

export const Fps3016Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3016FilledIcon, 'Fps3016Filled');

const Fps3016RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 1a2 2 0 00-2 2v3a2 2 0 104 0V3a2 2 0 00-2-2zm0 6a1 1 0 01-1-1V3a1 1 0 112 0v3a1 1 0 01-1 1zm-8.5 3a.5.5 0 00-.5.5v4a.5.5 0 001 0V13h1.5a.5.5 0 000-1H2v-1h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v4a.5.5 0 001 0v-1h1.25a1.75 1.75 0 100-3.5H6.5zm1.75 2.5H7V11h1.25a.75.75 0 010 1.5zm2.75-1c0-.83.67-1.5 1.5-1.5h2a.5.5 0 010 1h-2a.5.5 0 000 1h1a1.5 1.5 0 010 3h-2a.5.5 0 010-1h2a.5.5 0 000-1h-1a1.5 1.5 0 01-1.5-1.5zM5 4a1 1 0 10-.92-1.39c-.09.2-.26.39-.48.39-.33 0-.6-.27-.51-.6a2 2 0 113.23 2.1A2 2 0 015 8a2 2 0 01-1.91-1.4c-.1-.33.18-.6.51-.6.22 0 .4.19.48.39A1 1 0 105 5a.5.5 0 110-1z",
    fill: primaryFill
  }));
};

export const Fps3016Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3016RegularIcon, 'Fps3016Regular');

const Fps3020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 2A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm0 6.5a1 1 0 01-1-1v-3a1 1 0 112 0v3a1 1 0 01-1 1zm-9 3.5a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zm-6.5-8.5c.63 0 1-.46 1-.88 0-.4-.37-.87-1-.87-.26 0-.48.08-.64.2-.2.15-.41.3-.65.3-.62 0-1.09-.58-.7-1.06A2.54 2.54 0 016.5 2C7.88 2 9 3.06 9 4.38a2.3 2.3 0 01-.66 1.6A2.37 2.37 0 016.62 10h-.25c-.78 0-1.47-.38-1.9-.96-.36-.48.1-1.04.7-1.04.25 0 .47.16.67.32.15.11.33.18.53.18h.25a.87.87 0 100-1.75H6.5a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const Fps3020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3020FilledIcon, 'Fps3020Filled');

const Fps3020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 2A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm0 7A1.5 1.5 0 0111 7.5v-3a1.5 1.5 0 013 0v3c0 .83-.67 1.5-1.5 1.5zm-9 3a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zM6.75 3h-.5c-.49 0-.91.28-1.12.69-.08.17-.24.31-.44.31-.36 0-.65-.32-.5-.65A2.25 2.25 0 016.25 2h.5a2.25 2.25 0 011.41 4 2.25 2.25 0 01-1.41 4h-.5c-.92 0-1.71-.55-2.06-1.35-.15-.33.14-.65.5-.65.2 0 .36.14.44.31.2.41.63.69 1.12.69h.5a1.25 1.25 0 000-2.5H6.5a.5.5 0 010-1h.25a1.25 1.25 0 000-2.5z",
    fill: primaryFill
  }));
};

export const Fps3020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3020RegularIcon, 'Fps3020Regular');

const Fps3024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 15a2.25 2.25 0 01.15 4.5H11v1.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.5c0-.38.28-.7.65-.74l.1-.01h1.5zm0 1.5H11V18h.75a.75.75 0 00.1-1.5h-.1zM18 15a2 2 0 012 2 .75.75 0 01-1.5.1V17a.5.5 0 00-.41-.5h-.72a.62.62 0 00-.09 1.24l.1.01h.5a2.13 2.13 0 01.15 4.24l-.16.01h-.62a2 2 0 01-2-2 .75.75 0 011.5-.1v.1c0 .25.18.45.41.5h.72a.62.62 0 00.09-1.24l-.1-.01h-.5a2.13 2.13 0 01-.15-4.24l.16-.01H18zM7.75 15a.75.75 0 01.1 1.5H5.5V18h1.75a.75.75 0 01.1 1.5H5.5v1.73c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.48c0-.38.28-.7.65-.74l.1-.01h3zM15 3a3 3 0 013 2.82V10a3 3 0 01-6 .18V6a3 3 0 013-3zm0 2a1 1 0 00-1 .88V10a1 1 0 002 .12V6a1 1 0 00-1-1zM8 7a1 1 0 10-.5-1.86l-.12.06c-.24.15-.48.3-.76.3-.83 0-1.46-.78-.93-1.42A3 3 0 1110.24 8a3 3 0 11-4.54 3.92c-.54-.64.1-1.42.92-1.42.28 0 .52.15.76.3l.11.06A1 1 0 118 7z",
    fill: primaryFill
  }));
};

export const Fps3024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3024FilledIcon, 'Fps3024Filled');

const Fps3024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.13 4.5h-.25c-.45 0-.85.22-1.1.55-.18.24-.44.45-.74.45-.54 0-.96-.49-.7-.97A2.87 2.87 0 017.87 3h.25a2.88 2.88 0 011.93 5 2.87 2.87 0 01-1.93 5h-.25c-1.1 0-2.07-.62-2.55-1.53-.25-.48.17-.97.71-.97.3 0 .56.21.74.45.25.34.65.55 1.1.55h.25a1.37 1.37 0 100-2.75H8a.75.75 0 010-1.5h.13a1.38 1.38 0 000-2.75zM14 17.25c0-1.24-1-2.25-2.25-2.25h-1.6a.75.75 0 00-.65.75v5.6c.06.37.37.65.75.65h.1a.75.75 0 00.65-.75V19.5h.9a2.25 2.25 0 002.1-2.25zm-3-.75h.85a.75.75 0 01-.1 1.5H11v-1.5zm9 .5a2 2 0 00-2-2h-.78a2.13 2.13 0 00.16 4.25h.59a.63.63 0 01-.1 1.25h-.71a.5.5 0 01-.41-.5v-.1a.75.75 0 00-1.5.1c0 1.1.9 2 2 2h.78a2.13 2.13 0 00-.16-4.25h-.59a.63.63 0 01.1-1.25h.71a.5.5 0 01.41.5v.1A.75.75 0 0020 17zM8.5 15.75a.75.75 0 00-.75-.75h-3.1a.75.75 0 00-.65.75v5.58c.06.37.37.65.75.65h.1a.75.75 0 00.65-.75V19.5h1.85a.75.75 0 00-.1-1.5H5.5v-1.5h2.35a.75.75 0 00.65-.75zM18 5.82A3 3 0 0015 3h-.18A3 3 0 0012 6v4.18A3 3 0 0014.83 13L15 13h.17A3 3 0 0018 10V5.83zM15 4.5c.83 0 1.5.67 1.5 1.5v4.15a1.5 1.5 0 01-1.35 1.34l-.16.01h-.14A1.5 1.5 0 0113.5 10V5.86A1.5 1.5 0 0115 4.5z",
    fill: primaryFill
  }));
};

export const Fps3024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3024RegularIcon, 'Fps3024Regular');

const Fps3028FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 3A3.5 3.5 0 0014 6.5v5a3.5 3.5 0 107 0v-5A3.5 3.5 0 0017.5 3zm0 10a1.5 1.5 0 01-1.5-1.5v-5a1.5 1.5 0 013 0v5c0 .83-.67 1.5-1.5 1.5zm.5 6.85c0-1.3 1.05-2.35 2.35-2.35h1.15a2 2 0 012 2 .75.75 0 01-1.5 0 .5.5 0 00-.5-.5h-1.15a.85.85 0 00-.85.85V20a1 1 0 001 1h.5a2.5 2.5 0 012.5 2.5v.15c0 1.3-1.05 2.35-2.35 2.35h-.65a2.5 2.5 0 01-2.5-2.5.75.75 0 011.5 0 1 1 0 001 1h.65c.47 0 .85-.38.85-.85v-.15a1 1 0 00-1-1h-.5A2.5 2.5 0 0118 20v-.15zM5.75 17.5a.75.75 0 00-.75.75v7a.75.75 0 001.5 0V22.5h1.75a.75.75 0 000-1.5H6.5v-2h2.75a.75.75 0 000-1.5h-3.5zm5.75.75c0-.41.34-.75.75-.75h2.25a2.5 2.5 0 010 5H13v2.75a.75.75 0 01-1.5 0v-7zM13 21h1.5a1 1 0 100-2H13v2zM9.5 10a1.5 1.5 0 11-1.08 2.54c-.27-.27-.6-.54-.98-.54-.74 0-1.32.68-.93 1.31A3.5 3.5 0 1011.95 9 3.49 3.49 0 009.5 3a3.5 3.5 0 00-3 1.69c-.38.63.2 1.31.94 1.31.39 0 .71-.27.98-.54A1.5 1.5 0 0111 6.5c0 .83-.67 1.5-1.5 1.5a1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const Fps3028Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3028FilledIcon, 'Fps3028Filled');

const Fps3028RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 3A3.5 3.5 0 0014 6.5v5a3.5 3.5 0 107 0v-5A3.5 3.5 0 0017.5 3zm0 10.5a2 2 0 01-2-2v-5a2 2 0 114 0v5a2 2 0 01-2 2zm.5 6.35c0-1.3 1.05-2.35 2.35-2.35h1.15a2 2 0 012 2 .75.75 0 01-1.5 0 .5.5 0 00-.5-.5h-1.15a.85.85 0 00-.85.85V20a1 1 0 001 1h.5a2.5 2.5 0 012.5 2.5v.15c0 1.3-1.05 2.35-2.35 2.35h-.65a2.5 2.5 0 01-2.5-2.5.75.75 0 011.5 0 1 1 0 001 1h.65c.47 0 .85-.38.85-.85v-.15a1 1 0 00-1-1h-.5A2.5 2.5 0 0118 20v-.15zM5.75 17.5a.75.75 0 00-.75.75v7a.75.75 0 001.5 0V22.5h1.75a.75.75 0 000-1.5H6.5v-2h2.75a.75.75 0 000-1.5h-3.5zm5.75.75c0-.41.34-.75.75-.75h2.25a2.5 2.5 0 010 5H13v2.75a.75.75 0 01-1.5 0v-7zM13 21h1.5a1 1 0 100-2H13v2zM9.62 4.5h-.25c-.73 0-1.36.42-1.67 1.03-.13.26-.37.47-.66.47-.54 0-.98-.48-.76-.98A3.38 3.38 0 019.38 3h.24a3.37 3.37 0 012.13 6 3.37 3.37 0 01-2.13 6h-.25a3.38 3.38 0 01-3.09-2.02c-.22-.5.22-.98.76-.98.29 0 .53.21.66.47.3.61.94 1.03 1.67 1.03h.25a1.87 1.87 0 000-3.75H9.5a.75.75 0 010-1.5h.12a1.87 1.87 0 100-3.75z",
    fill: primaryFill
  }));
};

export const Fps3028Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3028RegularIcon, 'Fps3028Regular');

const Fps3048FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 14.5c1.78 0 3-1.35 3-2.75S17.78 9 16 9c-1.32 0-2.37.76-2.8 1.88-.22.59-.71 1.12-1.35 1.12-1.03 0-1.92-.84-1.62-1.83A6.06 6.06 0 0116 6c3.31 0 6 2.57 6 5.75 0 1.68-.76 3.2-1.96 4.25A5.63 5.63 0 0122 20.25 5.88 5.88 0 0116 26a6.06 6.06 0 01-5.77-4.17c-.3-1 .59-1.83 1.62-1.83.64 0 1.13.53 1.35 1.12A2.92 2.92 0 0016 23c1.78 0 3-1.35 3-2.75s-1.22-2.75-3-2.75a1.5 1.5 0 110-3zm8-2.5a6 6 0 0112 0v8a6 6 0 01-12 0v-8zm3 8a3 3 0 106 0v-8a3 3 0 10-6 0v8zM9.25 30C8.56 30 8 30.56 8 31.25v11.54a1.25 1.25 0 102.5 0V38.5h4.25a1.25 1.25 0 100-2.5H10.5v-3.5h5.26a1.25 1.25 0 100-2.5H9.25zm11.5 0c-.69 0-1.25.56-1.25 1.25v11.54a1.25 1.25 0 102.5 0V38.5h2.25a4.25 4.25 0 000-8.5h-3.5zm3.5 6H22v-3.5h2.25a1.75 1.75 0 110 3.5zm10.4-3.5a1.66 1.66 0 100 3.31h1.26a4.1 4.1 0 010 8.19h-1.66a3.75 3.75 0 01-3.75-3.75 1.25 1.25 0 112.5 0c0 .69.56 1.25 1.25 1.25h1.66a1.6 1.6 0 000-3.19h-1.25a4.16 4.16 0 110-8.31h1.59A3.75 3.75 0 0140 33.75a1.25 1.25 0 11-2.5 0c0-.69-.56-1.25-1.25-1.25h-1.6z",
    fill: primaryFill
  }));
};

export const Fps3048Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3048FilledIcon, 'Fps3048Filled');

const Fps3048RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M30 6a6 6 0 00-6 6v8a6 6 0 0012 0v-8a6 6 0 00-6-6zm0 17.5a3.5 3.5 0 01-3.5-3.5v-8a3.5 3.5 0 117 0v8a3.5 3.5 0 01-3.5 3.5zM9.25 30C8.56 30 8 30.56 8 31.25v11.54a1.25 1.25 0 102.5 0V38.5h4.25a1.25 1.25 0 100-2.5H10.5v-3.5h5.26a1.25 1.25 0 100-2.5H9.25zm11.5 0c-.69 0-1.25.56-1.25 1.25v11.54a1.25 1.25 0 102.5 0V38.5h2.25a4.25 4.25 0 000-8.5h-3.5zm3.5 6H22v-3.5h2.25a1.75 1.75 0 110 3.5zM33 34.16c0-.92.74-1.66 1.66-1.66h1.59c.69 0 1.25.56 1.25 1.25a1.25 1.25 0 102.5 0A3.75 3.75 0 0036.25 30h-1.6a4.16 4.16 0 100 8.31h1.26a1.6 1.6 0 010 3.19h-1.66c-.69 0-1.25-.56-1.25-1.25a1.25 1.25 0 10-2.5 0A3.75 3.75 0 0034.25 44h1.66a4.1 4.1 0 100-8.19h-1.25c-.92 0-1.66-.74-1.66-1.65zM19.5 11.63c0 1.57-1.41 3.12-3.5 3.12a1.25 1.25 0 000 2.5c2.09 0 3.5 1.55 3.5 3.13 0 1.57-1.41 3.12-3.5 3.12-1.67 0-2.94-1-3.35-2.44-.17-.57-.63-1.06-1.22-1.06-.8 0-1.49.63-1.33 1.41.55 2.66 3.12 4.59 5.9 4.59 3.31 0 6-2.52 6-5.63 0-1.76-.87-3.34-2.23-4.37A5.49 5.49 0 0022 11.62C22 8.53 19.31 6 16 6c-2.78 0-5.35 1.93-5.9 4.59-.16.78.53 1.41 1.33 1.41.6 0 1.05-.49 1.22-1.06A3.37 3.37 0 0116 8.5c2.09 0 3.5 1.55 3.5 3.13z",
    fill: primaryFill
  }));
};

export const Fps3048Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps3048RegularIcon, 'Fps3048Regular');

const Fps6016FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2.75a.5.5 0 011 0V3A.75.75 0 007 3v-.25a2 2 0 10-4 0V6a2 2 0 101.5-1.94V2.75zM4.5 6a.5.5 0 111 0 .5.5 0 01-1 0zM10 1a2 2 0 00-2 2v3a2 2 0 104 0V3a2 2 0 00-2-2zm.5 5a.5.5 0 01-1 0V3a.5.5 0 011 0v3zm-9 4a.5.5 0 00-.5.5v4a.5.5 0 001 0V13h1.5a.5.5 0 000-1H2v-1h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v4a.5.5 0 001 0v-1h1.25a1.75 1.75 0 100-3.5H6.5zm1.75 2.5H7V11h1.25a.75.75 0 010 1.5zm2.75-1c0-.83.67-1.5 1.5-1.5h2a.5.5 0 010 1h-2a.5.5 0 000 1h1a1.5 1.5 0 010 3h-2a.5.5 0 010-1h2a.5.5 0 000-1h-1a1.5 1.5 0 01-1.5-1.5z",
    fill: primaryFill
  }));
};

export const Fps6016Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6016FilledIcon, 'Fps6016Filled');

const Fps6016RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a1 1 0 00-1 1v1.27A2 2 0 113 6V3a2 2 0 114 0 .5.5 0 01-1 0 1 1 0 00-1-1zm0 5a1 1 0 100-2 1 1 0 000 2zm-3.5 3a.5.5 0 00-.5.5v4a.5.5 0 001 0V13h1.5a.5.5 0 000-1H2v-1h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v4a.5.5 0 001 0v-1h1.25a1.75 1.75 0 100-3.5H6.5zm1.75 2.5H7V11h1.25a.75.75 0 010 1.5zm2.75-1c0-.83.67-1.5 1.5-1.5h2a.5.5 0 010 1h-2a.5.5 0 000 1h1a1.5 1.5 0 010 3h-2a.5.5 0 010-1h2a.5.5 0 000-1h-1a1.5 1.5 0 01-1.5-1.5zM8 3a2 2 0 114 0v3a2 2 0 11-4 0V3zm3 0a1 1 0 10-2 0v3a1 1 0 002 0V3z",
    fill: primaryFill
  }));
};

export const Fps6016Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6016RegularIcon, 'Fps6016Regular');

const Fps6020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 004 4.5v3A2.5 2.5 0 106.5 5h-.1c-.32 0-.62.06-.9.17V4.5a1 1 0 011-1h.25c.41 0 .75.34.75.75a.75.75 0 001.5 0C9 3.01 8 2 6.75 2H6.5zm-1 5.5v-.1c0-.5.4-.9.9-.9h.1a1 1 0 11-1 1zm6-3a1 1 0 112 0v3a1 1 0 11-2 0v-3zm1-2.5A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm-9 10a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.75c.83 0 1.5.67 1.5 1.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5h-.75a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.75a1.5 1.5 0 01-1.5-1.5.5.5 0 011 0c0 .28.22.5.5.5h.75a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75z",
    fill: primaryFill
  }));
};

export const Fps6020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6020FilledIcon, 'Fps6020Filled');

const Fps6020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 2A2.5 2.5 0 0010 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0012.5 2zm0 7A1.5 1.5 0 0111 7.5v-3a1.5 1.5 0 013 0v3c0 .83-.67 1.5-1.5 1.5zm-9 3a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.76c.82 0 1.49.67 1.49 1.49v.01a.5.5 0 01-1 0v-.01a.49.49 0 00-.49-.49h-.76a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.76c-.82 0-1.49-.67-1.49-1.49v-.01a.5.5 0 011 0v.01c0 .27.22.49.49.49h.76a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75zM4 4.5v3a2.5 2.5 0 101-2v-1a1.5 1.5 0 113 0 .5.5 0 001 0 2.5 2.5 0 00-5 0zM6.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const Fps6020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6020RegularIcon, 'Fps6020Regular');

const Fps6024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 15a2.25 2.25 0 01.15 4.5H11v1.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.5c0-.38.28-.7.65-.74l.1-.01h1.5zM18 15a2 2 0 012 2 .75.75 0 01-1.5.1V17a.5.5 0 00-.41-.5h-.72a.62.62 0 00-.09 1.24l.1.01h.5a2.13 2.13 0 01.15 4.24l-.16.01h-.62a2 2 0 01-2-2 .75.75 0 011.5-.1v.1c0 .25.18.45.41.5h.72a.62.62 0 00.09-1.24l-.1-.01h-.5a2.13 2.13 0 01-.15-4.24l.16-.01H18zM7.75 15a.75.75 0 01.1 1.5H5.5V18h1.75a.75.75 0 01.1 1.5H5.5v1.73c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.48c0-.38.28-.7.65-.74l.1-.01h3zm4 1.5H11V18h.75a.75.75 0 00.1-1.5h-.1zM8.25 3A2.75 2.75 0 0111 5.75a1 1 0 01-2 .12v-.12c0-.38-.28-.7-.65-.74L8.25 5H8a1 1 0 00-1 .88v1.29A3 3 0 115 10V6a3 3 0 012.83-3H8.25zM15 3a3 3 0 013 2.82V10a3 3 0 01-6 .18V6a3 3 0 013-3zM8 9a1 1 0 100 2 1 1 0 000-2zm7-4a1 1 0 00-1 .88V10a1 1 0 002 .12V6a1 1 0 00-1-1z",
    fill: primaryFill
  }));
};

export const Fps6024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6024FilledIcon, 'Fps6024Filled');

const Fps6024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 15a2.25 2.25 0 01.15 4.5H11v1.75c0 .38-.28.7-.65.74h-.1a.75.75 0 01-.74-.64l-.01-.1v-5.5c0-.38.28-.7.65-.74l.1-.01h1.5zM18 15a2 2 0 012 2 .75.75 0 01-1.5.1V17a.5.5 0 00-.41-.5h-.72a.62.62 0 00-.09 1.24h.6a2.13 2.13 0 01.15 4.25h-.78a2 2 0 01-2-2 .75.75 0 011.5-.1v.1c0 .25.18.46.41.5h.72a.62.62 0 00.09-1.23l-.1-.01h-.5a2.13 2.13 0 01-.15-4.25H18zM7.75 15a.75.75 0 01.1 1.5H5.5V18h1.75a.75.75 0 01.1 1.5H5.5v1.73c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.48c0-.38.28-.7.65-.74l.1-.01h3zm4 1.5H11V18h.75a.75.75 0 00.1-1.5h-.1zM8 3a3 3 0 013 2.82v.35a.75.75 0 01-1.5.1V5.85a1.5 1.5 0 00-3 0V7.4A3 3 0 115 10.18V6a3 3 0 013-3zm7 0a3 3 0 013 2.82V10a3 3 0 01-2.82 3h-.37a3 3 0 01-2.8-2.82L12 10V6a3 3 0 012.82-3H15zM8 8.5c-.78 0-1.42.6-1.5 1.35V10A1.5 1.5 0 108 8.5zm7-4c-.78 0-1.42.6-1.5 1.35V10c0 .78.6 1.42 1.35 1.5H15.15a1.5 1.5 0 001.34-1.35l.01-.15V6c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const Fps6024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6024RegularIcon, 'Fps6024Regular');

const Fps6028FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 4.75c-.83 0-1.5.67-1.5 1.5v2.09a3.5 3.5 0 11-2 3.16V6.25a3.5 3.5 0 117 0v.25a1 1 0 11-2 0v-.25c0-.83-.67-1.5-1.5-1.5zm0 8.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM14 6.5a3.5 3.5 0 117 0v5a3.5 3.5 0 11-7 0v-5zm5 0a1.5 1.5 0 00-3 0v5a1.5 1.5 0 003 0v-5zm1.35 11A2.35 2.35 0 0018 19.85V20a2.5 2.5 0 002.5 2.5h.5a1 1 0 011 1v.15c0 .47-.38.85-.85.85h-.65a1 1 0 01-1-1 .75.75 0 00-1.5 0 2.5 2.5 0 002.5 2.5h.65c1.3 0 2.35-1.05 2.35-2.35v-.15A2.5 2.5 0 0021 21h-.5a1 1 0 01-1-1v-.15c0-.47.38-.85.85-.85h1.15c.28 0 .5.22.5.5a.75.75 0 001.5 0 2 2 0 00-2-2h-1.15zM5 18.25c0-.41.34-.75.75-.75h3.5a.75.75 0 010 1.5H6.5v2h1.75a.75.75 0 010 1.5H6.5v2.75a.75.75 0 01-1.5 0v-7zm7.25-.75a.75.75 0 00-.75.75v7a.75.75 0 001.5 0V22.5h1.5a2.5 2.5 0 000-5h-2.25zM14.5 21H13v-2h1.5a1 1 0 110 2z",
    fill: primaryFill
  }));
};

export const Fps6028Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6028FilledIcon, 'Fps6028Filled');

const Fps6028RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 3A3.5 3.5 0 0014 6.5v5a3.5 3.5 0 107 0v-5A3.5 3.5 0 0017.5 3zm2 8.5a2 2 0 11-4 0v-5a2 2 0 114 0v5zM6 11.5v-5a3.5 3.5 0 117 0 .75.75 0 01-1.5 0 2 2 0 10-4 0v2.13A3.5 3.5 0 116 11.5zm1.5 0a2 2 0 104 0 2 2 0 00-4 0zm12.85 6A2.35 2.35 0 0018 19.85V20a2.5 2.5 0 002.5 2.5h.5a1 1 0 011 1v.15c0 .47-.38.85-.85.85h-.65a1 1 0 01-1-1 .75.75 0 00-1.5 0 2.5 2.5 0 002.5 2.5h.65c1.3 0 2.35-1.05 2.35-2.35v-.15A2.5 2.5 0 0021 21h-.5a1 1 0 01-1-1v-.15c0-.47.38-.85.85-.85h1.15c.28 0 .5.22.5.5a.75.75 0 001.5 0 2 2 0 00-2-2h-1.15zM5 18.25c0-.41.34-.75.75-.75h3.5a.75.75 0 010 1.5H6.5v2h1.75a.75.75 0 010 1.5H6.5v2.75a.75.75 0 01-1.5 0v-7zm7.25-.75a.75.75 0 00-.75.75v7a.75.75 0 001.5 0V22.5h1.5a2.5 2.5 0 000-5h-2.25zM14.5 21H13v-2h1.5a1 1 0 110 2z",
    fill: primaryFill
  }));
};

export const Fps6028Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6028RegularIcon, 'Fps6028Regular');

const Fps6048FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M30 6a6 6 0 00-6 6v8a6 6 0 0012 0v-8a6 6 0 00-6-6zm3 14a3 3 0 11-6 0v-8a3 3 0 116 0v8zM8 31.25c0-.69.56-1.25 1.25-1.25h6.5a1.25 1.25 0 110 2.5H10.5V36h4.25a1.25 1.25 0 110 2.5H10.5v4.29a1.25 1.25 0 11-2.5 0V31.25zM20.75 30c-.69 0-1.25.56-1.25 1.25v11.54a1.25 1.25 0 102.5 0V38.5h2.25a4.25 4.25 0 000-8.5h-3.5zm3.5 6H22v-3.5h2.25a1.75 1.75 0 110 3.5zM33 34.16c0-.92.74-1.66 1.66-1.66h1.59c.69 0 1.25.56 1.25 1.25a1.25 1.25 0 102.5 0A3.75 3.75 0 0036.25 30h-1.6a4.16 4.16 0 100 8.31h1.26a1.6 1.6 0 010 3.19h-1.66c-.69 0-1.25-.56-1.25-1.25a1.25 1.25 0 10-2.5 0A3.75 3.75 0 0034.25 44h1.66a4.1 4.1 0 100-8.19h-1.25c-.92 0-1.66-.74-1.66-1.65zM13 12a3 3 0 116 0 1.5 1.5 0 003 0 6 6 0 00-12 0v8.25a6 6 0 103-5.45V12zm0 8a3 3 0 116 0 3 3 0 01-6 0z",
    fill: primaryFill
  }));
};

export const Fps6048Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6048FilledIcon, 'Fps6048Filled');

const Fps6048RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 12a6 6 0 0112 0v8a6 6 0 01-12 0v-8zm9.5 0a3.5 3.5 0 10-7 0v8a3.5 3.5 0 107 0v-8zm-23.48 8.46a6 6 0 102.48-5.33V12a3.5 3.5 0 117 0 1.25 1.25 0 102.5 0 6 6 0 00-12 0v8.25c0 .07 0 .14.02.2zM16 23.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zM9.25 30C8.56 30 8 30.56 8 31.25v11.54a1.25 1.25 0 102.5 0V38.5h4.25a1.25 1.25 0 100-2.5H10.5v-3.5h5.26a1.25 1.25 0 100-2.5H9.25zm11.5 0c-.69 0-1.25.56-1.25 1.25v11.54a1.25 1.25 0 102.5 0V38.5h2.25a4.25 4.25 0 000-8.5h-3.5zm3.5 6H22v-3.5h2.25a1.75 1.75 0 110 3.5zM33 34.16c0-.92.74-1.66 1.66-1.66h1.59c.69 0 1.25.56 1.25 1.25a1.25 1.25 0 102.5 0A3.75 3.75 0 0036.25 30h-1.6a4.16 4.16 0 100 8.31h1.26a1.6 1.6 0 010 3.19h-1.66c-.69 0-1.25-.56-1.25-1.25a1.25 1.25 0 10-2.5 0A3.75 3.75 0 0034.25 44h1.66a4.1 4.1 0 100-8.19h-1.25c-.92 0-1.66-.74-1.66-1.65z",
    fill: primaryFill
  }));
};

export const Fps6048Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps6048RegularIcon, 'Fps6048Regular');

const Fps96020FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 10A2.5 2.5 0 007 7.5v-3A2.5 2.5 0 104.5 7h.1c.32 0 .62-.06.9-.17v.67a1 1 0 01-1 1h-.25a.75.75 0 01-.75-.75.75.75 0 00-1.5 0C2 8.99 3 10 4.25 10h.25zm1-5.5v.1c0 .5-.4.9-.9.9h-.1a1 1 0 111-1zm5-2.5A2.5 2.5 0 008 4.5v3A2.5 2.5 0 1010.5 5h-.1c-.32 0-.62.06-.9.17V4.5a1 1 0 011-1h.25c.41 0 .75.34.75.75a.75.75 0 001.5 0C13 3.01 12 2 10.75 2h-.25zm-1 5.5v-.1c0-.5.4-.9.9-.9h.1a1 1 0 11-1 1zm6-3a1 1 0 112 0v3a1 1 0 11-2 0v-3zm1-2.5A2.5 2.5 0 0014 4.5v3a2.5 2.5 0 005 0v-3A2.5 2.5 0 0016.5 2zm-13 10a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm2.5 2a1 1 0 01-1 1H9v-2h1a1 1 0 011 1zm2-.25c0-.97.78-1.75 1.75-1.75h.75c.83 0 1.5.67 1.5 1.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5h-.75a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.75a1.5 1.5 0 01-1.5-1.5.5.5 0 011 0c0 .28.22.5.5.5h.75a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75z",
    fill: primaryFill
  }));
};

export const Fps96020Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps96020FilledIcon, 'Fps96020Filled');

const Fps96020RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7.5a2.5 2.5 0 01-5 0 .5.5 0 011 0 1.5 1.5 0 103 0v-1a2.5 2.5 0 111-2v3zm-1-3a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM10.5 2A2.5 2.5 0 008 4.5v3a2.5 2.5 0 101-2v-1a1.5 1.5 0 113 0 .5.5 0 001 0A2.5 2.5 0 0010.5 2zm0 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm6-6c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 003 0v-3c0-.83-.67-1.5-1.5-1.5zM14 4.5a2.5 2.5 0 015 0v3a2.5 2.5 0 01-5 0v-3zM3.5 12a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1.5a.5.5 0 000-1H4v-2h2.5a.5.5 0 000-1h-3zm5 0a.5.5 0 00-.5.5v5a.5.5 0 001 0V16h1a2 2 0 100-4H8.5zm1.5 3H9v-2h1a1 1 0 110 2zm3-1.25c0-.97.78-1.75 1.75-1.75h.75c.83 0 1.5.67 1.5 1.5a.5.5 0 01-1 0 .5.5 0 00-.5-.5h-.75a.75.75 0 000 1.5h.5a1.75 1.75 0 110 3.5h-.75a1.5 1.5 0 01-1.5-1.5.5.5 0 011 0c0 .28.22.5.5.5h.75a.75.75 0 000-1.5h-.5c-.97 0-1.75-.78-1.75-1.75z",
    fill: primaryFill
  }));
};

export const Fps96020Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps96020RegularIcon, 'Fps96020Regular');

const Fps96024FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 15a2.25 2.25 0 01.15 4.5H11v1.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.5c0-.38.28-.7.65-.74l.1-.01h1.5zM18 15a2 2 0 012 2 .75.75 0 01-1.5.1V17a.5.5 0 00-.41-.5h-.72a.62.62 0 00-.09 1.24l.1.01h.5a2.13 2.13 0 01.15 4.24l-.16.01h-.62a2 2 0 01-2-2 .75.75 0 011.5-.1v.1c0 .25.18.45.41.5h.72a.62.62 0 00.09-1.24l-.1-.01h-.5a2.13 2.13 0 01-.15-4.24l.16-.01H18zM7.75 15a.75.75 0 01.1 1.5H5.5V18h1.75a.75.75 0 01.1 1.5H5.5v1.73c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.48c0-.38.28-.7.65-.74l.1-.01h3zm4 1.5H11V18h.75a.75.75 0 00.1-1.5h-.1zM5 3a3 3 0 013 3v4a3 3 0 01-2.82 3h-.43A2.75 2.75 0 012 10.25a1 1 0 012-.12v.12c0 .38.28.7.65.74l.1.01H5a1 1 0 001-.88V8.83A3 3 0 115 3zm7.25 0A2.75 2.75 0 0115 5.75a1 1 0 01-2 .12v-.12c0-.38-.28-.7-.65-.74l-.1-.01H12a1 1 0 00-1 .88v1.29A3 3 0 119 10V6a3 3 0 012.83-3H12.25zM19 3a3 3 0 013 2.82V10a3 3 0 01-6 .18V6a3 3 0 013-3zm-7 6a1 1 0 100 2 1 1 0 000-2zm7-4a1 1 0 00-1 .88V10a1 1 0 002 .12V6a1 1 0 00-1-1zM5 5a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }));
};

export const Fps96024Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps96024FilledIcon, 'Fps96024Filled');

const Fps96024RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 15a2.25 2.25 0 01.15 4.5H11v1.75c0 .38-.28.7-.65.74h-.1a.75.75 0 01-.74-.64l-.01-.1v-5.5c0-.38.28-.7.65-.74l.1-.01h1.5zM18 15a2 2 0 012 2 .75.75 0 01-1.5.1V17a.5.5 0 00-.41-.5h-.72a.62.62 0 00-.09 1.24h.6a2.13 2.13 0 01.15 4.25h-.78a2 2 0 01-2-2 .75.75 0 011.5-.1v.1c0 .25.18.46.41.5h.72a.62.62 0 00.09-1.23l-.1-.01h-.5a2.13 2.13 0 01-.15-4.25H18zM7.75 15a.75.75 0 01.1 1.5H5.5V18h1.75a.75.75 0 01.1 1.5H5.5v1.73c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-5.48c0-.38.28-.7.65-.74l.1-.01h3zm4 1.5H11V18h.75a.75.75 0 00.1-1.5h-.1zM12 3a3 3 0 013 2.82v.35a.75.75 0 01-1.5.1V5.85a1.5 1.5 0 00-3 0V7.4A3 3 0 119 10.18V6a3 3 0 013-3zM5 3a3 3 0 013 2.82V10a3 3 0 01-6 .17v-.34a.75.75 0 011.5-.1V10a1.5 1.5 0 003 .14V8.6A3 3 0 115 3zm14 0a3 3 0 013 2.82V10a3 3 0 01-2.82 3h-.37a3 3 0 01-2.8-2.82L16 10V6a3 3 0 012.82-3H19zm-7 5.5c-.78 0-1.42.6-1.5 1.35V10A1.5 1.5 0 1012 8.5zm7-4c-.78 0-1.42.6-1.5 1.35V10c0 .78.6 1.42 1.35 1.5H19.15a1.5 1.5 0 001.34-1.35l.01-.15V6c0-.83-.67-1.5-1.5-1.5zm-14 0a1.5 1.5 0 101.5 1.65V6c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const Fps96024Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Fps96024RegularIcon, 'Fps96024Regular');

const FullScreenMaximize16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5a.5.5 0 00-.5.5v1.61a.75.75 0 01-1.5 0V4c0-1.1.9-2 2-2h1.61a.75.75 0 010 1.5H4zm5.64-.75c0-.41.33-.75.75-.75H12a2 2 0 012 2v1.61a.75.75 0 01-1.5 0V4a.5.5 0 00-.5-.5h-1.61a.75.75 0 01-.75-.75zM2.75 9.64c.41 0 .75.33.75.75V12c0 .28.22.5.5.5h1.61a.75.75 0 010 1.5H4a2 2 0 01-2-2v-1.61c0-.42.34-.75.75-.75zm10.5 0c.41 0 .75.33.75.75V12a2 2 0 01-2 2h-1.61a.75.75 0 110-1.5H12a.5.5 0 00.5-.5v-1.61c0-.42.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const FullScreenMaximize16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximize16FilledIcon, 'FullScreenMaximize16Filled');

const FullScreenMaximize16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 3a.75.75 0 00-.75.75V5.5a.5.5 0 01-1 0V3.75C2 2.78 2.78 2 3.75 2H5.5a.5.5 0 010 1H3.75zM10 2.5c0-.28.22-.5.5-.5h1.75c.97 0 1.75.78 1.75 1.75V5.5a.5.5 0 01-1 0V3.75a.75.75 0 00-.75-.75H10.5a.5.5 0 01-.5-.5zM2.5 10c.28 0 .5.22.5.5v1.75c0 .41.34.75.75.75H5.5a.5.5 0 010 1H3.75C2.78 14 2 13.22 2 12.25V10.5c0-.28.22-.5.5-.5zm11 0c.28 0 .5.22.5.5v1.75c0 .97-.78 1.75-1.75 1.75H10.5a.5.5 0 010-1h1.75c.41 0 .75-.34.75-.75V10.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const FullScreenMaximize16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximize16RegularIcon, 'FullScreenMaximize16Regular');

const FullScreenMaximize20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.25C3 4.01 4 3 5.25 3h1.87a.75.75 0 110 1.5H5.25a.75.75 0 00-.75.75v1.87a.75.75 0 11-1.5 0V5.25zm9.13-1.5c0-.41.34-.75.75-.75h1.87C15.99 3 17 4 17 5.25v1.87a.75.75 0 01-1.5 0V5.25a.75.75 0 00-.75-.75h-1.87a.75.75 0 01-.75-.75zm-8.38 8.38c.41 0 .75.34.75.75v1.87c0 .41.34.75.75.75h1.87a.75.75 0 010 1.5H5.25C4.01 17 3 16 3 14.75v-1.87c0-.41.34-.75.75-.75zm12.5 0c.41 0 .75.34.75.75v1.87c0 1.24-1 2.25-2.25 2.25h-1.87a.75.75 0 010-1.5h1.87c.41 0 .75-.34.75-.75v-1.87c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const FullScreenMaximize20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximize20FilledIcon, 'FullScreenMaximize20Filled');

const FullScreenMaximize20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5c0-1.1.9-2 2-2h2a.5.5 0 010 1H5a1 1 0 00-1 1v2a.5.5 0 01-1 0V5zm9.5-1.5c0-.28.22-.5.5-.5h2a2 2 0 012 2v2a.5.5 0 01-1 0V5a1 1 0 00-1-1h-2a.5.5 0 01-.5-.5zm-9 9c.28 0 .5.22.5.5v2a1 1 0 001 1h2a.5.5 0 010 1H5a2 2 0 01-2-2v-2c0-.28.22-.5.5-.5zm13 0c.28 0 .5.22.5.5v2a2 2 0 01-2 2h-2a.5.5 0 010-1h2a1 1 0 001-1v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const FullScreenMaximize20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximize20RegularIcon, 'FullScreenMaximize20Regular');

const FullScreenMaximize24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6a1 1 0 011-1h2a1 1 0 000-2H6a3 3 0 00-3 3v2a1 1 0 002 0V6zm0 12a1 1 0 001 1h2a1 1 0 110 2H6a3 3 0 01-3-3v-2a1 1 0 112 0v2zM18 5a1 1 0 011 1v2a1 1 0 102 0V6a3 3 0 00-3-3h-2a1 1 0 100 2h2zm1 13a1 1 0 01-1 1h-2a1 1 0 100 2h2a3 3 0 003-3v-2a1 1 0 10-2 0v2z",
    fill: primaryFill
  }));
};

export const FullScreenMaximize24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximize24FilledIcon, 'FullScreenMaximize24Filled');

const FullScreenMaximize24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 5.75c0-.69.56-1.25 1.25-1.25h2a.75.75 0 000-1.5h-2A2.75 2.75 0 003 5.75v2a.75.75 0 001.5 0v-2zm0 12.5c0 .69.56 1.25 1.25 1.25h2a.75.75 0 010 1.5h-2A2.75 2.75 0 013 18.25v-2a.75.75 0 011.5 0v2zM18.25 4.5c.69 0 1.25.56 1.25 1.25v2a.75.75 0 001.5 0v-2A2.75 2.75 0 0018.25 3h-2a.75.75 0 000 1.5h2zm1.25 13.75c0 .69-.56 1.25-1.25 1.25h-2a.75.75 0 000 1.5h2A2.75 2.75 0 0021 18.25v-2a.75.75 0 00-1.5 0v2z",
    fill: primaryFill
  }));
};

export const FullScreenMaximize24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMaximize24RegularIcon, 'FullScreenMaximize24Regular');

const FullScreenMinimize16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4c0 .28.22.5.5.5h1.75a.75.75 0 010 1.5H12a2 2 0 01-2-2V2.25a.75.75 0 011.5 0V4zm0 8c0-.28.22-.5.5-.5h1.75a.75.75 0 000-1.5H12a2 2 0 00-2 2v1.75a.75.75 0 001.5 0V12zM4 11.5c.28 0 .5.22.5.5v1.75a.75.75 0 001.5 0V12a2 2 0 00-2-2H2.25a.75.75 0 000 1.5H4zM4.5 4a.5.5 0 01-.5.5H2.25a.75.75 0 000 1.5H4a2 2 0 002-2V2.25a.75.75 0 00-1.5 0V4z",
    fill: primaryFill
  }));
};

export const FullScreenMinimize16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimize16FilledIcon, 'FullScreenMinimize16Filled');

const FullScreenMinimize16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 4a1 1 0 001 1h1.5a.5.5 0 010 1H12a2 2 0 01-2-2V2.5a.5.5 0 011 0V4zm0 8a1 1 0 011-1h1.5a.5.5 0 000-1H12a2 2 0 00-2 2v1.5a.5.5 0 001 0V12zm-7-1a1 1 0 011 1v1.5a.5.5 0 001 0V12a2 2 0 00-2-2H2.5a.5.5 0 000 1H4zm1-7a1 1 0 01-1 1H2.5a.5.5 0 000 1H4a2 2 0 002-2V2.5a.5.5 0 00-1 0V4z",
    fill: primaryFill
  }));
};

export const FullScreenMinimize16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimize16RegularIcon, 'FullScreenMinimize16Regular');

const FullScreenMinimize20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5.5a.5.5 0 01-.5-.5V2.75a.75.75 0 00-1.5 0V5c0 1.1.9 2 2 2h2.25a.75.75 0 000-1.5H15zM5.5 15a.5.5 0 00-.5-.5H2.75a.75.75 0 010-1.5H5a2 2 0 012 2v2.25a.75.75 0 01-1.5 0V15zm9 0c0-.28.22-.5.5-.5h2.25a.75.75 0 000-1.5H15a2 2 0 00-2 2v2.25a.75.75 0 001.5 0V15zm-9-10a.5.5 0 01-.5.5H2.75a.75.75 0 000 1.5H5a2 2 0 002-2V2.75a.75.75 0 00-1.5 0V5z",
    fill: primaryFill
  }));
};

export const FullScreenMinimize20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimize20FilledIcon, 'FullScreenMinimize20Filled');

const FullScreenMinimize20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 5a1 1 0 001 1h2a.5.5 0 010 1h-2a2 2 0 01-2-2V3a.5.5 0 011 0v2zM6 15a1 1 0 00-1-1H3a.5.5 0 010-1h2a2 2 0 012 2v2a.5.5 0 01-1 0v-2zm8 0a1 1 0 011-1h2a.5.5 0 000-1h-2a2 2 0 00-2 2v2a.5.5 0 001 0v-2zM5 6a1 1 0 001-1V3a.5.5 0 011 0v2a2 2 0 01-2 2H3a.5.5 0 010-1h2z",
    fill: primaryFill
  }));
};

export const FullScreenMinimize20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimize20RegularIcon, 'FullScreenMinimize20Regular');

const FullScreenMinimize24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4a1 1 0 00-2 0v2.5a.5.5 0 01-.5.5H4a1 1 0 000 2h2.5A2.5 2.5 0 009 6.5V4zm0 16a1 1 0 11-2 0v-2.5a.5.5 0 00-.5-.5H4a1 1 0 110-2h2.5A2.5 2.5 0 019 17.5V20zm7-17a1 1 0 00-1 1v2.5A2.5 2.5 0 0017.5 9H20a1 1 0 100-2h-2.5a.5.5 0 01-.5-.5V4a1 1 0 00-1-1zm-1 17a1 1 0 102 0v-2.5c0-.28.22-.5.5-.5H20a1 1 0 100-2h-2.5a2.5 2.5 0 00-2.5 2.5V20z",
    fill: primaryFill
  }));
};

export const FullScreenMinimize24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimize24FilledIcon, 'FullScreenMinimize24Filled');

const FullScreenMinimize24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3.75a.75.75 0 00-1.5 0v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 000 1.5h2.5c1.24 0 2.25-1 2.25-2.25v-2.5zm0 16.5a.75.75 0 01-1.5 0v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 010-1.5h2.5c1.24 0 2.25 1 2.25 2.25v2.5zM16.25 3a.75.75 0 00-.75.75v2.5c0 1.24 1 2.25 2.25 2.25h2.5a.75.75 0 000-1.5h-2.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75zm-.75 17.25a.75.75 0 001.5 0v-2.5c0-.41.34-.75.75-.75h2.5a.75.75 0 000-1.5h-2.5c-1.24 0-2.25 1-2.25 2.25v2.5z",
    fill: primaryFill
  }));
};

export const FullScreenMinimize24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/FullScreenMinimize24RegularIcon, 'FullScreenMinimize24Regular');

const Games16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3a4.5 4.5 0 000 9h5.01a4.5 4.5 0 100-9h-5zm-2 4.5c0-.28.23-.5.5-.5h1V6a.5.5 0 111 0v1h1a.5.5 0 010 1H6v1a.5.5 0 01-1 0V8H4a.5.5 0 01-.5-.5zM11 9a1 1 0 11-2 0 1 1 0 012 0zm0-2a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const Games16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games16FilledIcon, 'Games16Filled');

const Games16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 7.5c0-.28.23-.5.5-.5h1V6a.5.5 0 011 0v1h1a.5.5 0 010 1H6v1a.5.5 0 11-1 0V8H4a.5.5 0 01-.5-.5zM11 9a1 1 0 11-2 0 1 1 0 012 0zm0-2a1 1 0 100-2 1 1 0 000 2zM1 7.5A4.5 4.5 0 015.5 3h5a4.5 4.5 0 110 9h-5A4.5 4.5 0 011 7.5zM5.5 4a3.5 3.5 0 100 7h5a3.5 3.5 0 100-7h-5z",
    fill: primaryFill
  }));
};

export const Games16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games16RegularIcon, 'Games16Regular');

const Games20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 4a5.5 5.5 0 100 11h5a5.5 5.5 0 100-11h-5zM6 7.5a.5.5 0 011 0V9h1.5a.5.5 0 010 1H7v1.5a.5.5 0 01-1 0V10H4.5a.5.5 0 010-1H6V7.5zm9 .5a1 1 0 11-2 0 1 1 0 012 0zm-3 4a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const Games20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games20FilledIcon, 'Games20Filled');

const Games20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 7.5a.5.5 0 011 0V9h1.5a.5.5 0 010 1H7v1.5a.5.5 0 01-1 0V10H4.5a.5.5 0 010-1H6V7.5zm9 .5a1 1 0 11-2 0 1 1 0 012 0zm-3 4a1 1 0 100-2 1 1 0 000 2zM2 9.5A5.5 5.5 0 017.5 4h5a5.5 5.5 0 110 11h-5A5.5 5.5 0 012 9.5zM7.5 5a4.5 4.5 0 000 9h5a4.5 4.5 0 100-9h-5z",
    fill: primaryFill
  }));
};

export const Games20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games20RegularIcon, 'Games20Regular');

const Games24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5a7 7 0 01.24 14H9a7 7 0 01-.24-14H15zm-.25 7.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM8 9c-.38 0-.7.28-.74.65l-.01.1v1.5h-1.5a.75.75 0 00-.1 1.5h1.6v1.5a.75.75 0 001.5.1v-1.6h1.5a.75.75 0 00.1-1.5h-1.6v-1.5A.75.75 0 008 9zm8.75 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z",
    fill: primaryFill
  }));
};

export const Games24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games24FilledIcon, 'Games24Filled');

const Games24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 5a7 7 0 01.24 14H9a7 7 0 01-.24-14H15zm0 1.5H9a5.5 5.5 0 00-.22 11H15a5.5 5.5 0 00.22-11H15zM8 9c.41 0 .75.34.75.75v1.5h1.5a.75.75 0 010 1.5h-1.5v1.5a.75.75 0 01-1.5 0v-1.5h-1.5a.75.75 0 110-1.5h1.5v-1.5c0-.41.34-.75.75-.75zm6.75 3.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm2-3.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z",
    fill: primaryFill
  }));
};

export const Games24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games24RegularIcon, 'Games24Regular');

const Games28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 5.5a8.5 8.5 0 000 17h7a8.5 8.5 0 100-17h-7zm7.5 11a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.5-2.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-14-.25c0-.41.34-.75.75-.75H8v-1.75a.75.75 0 011.5 0V13h1.75a.75.75 0 010 1.5H9.5v1.75a.75.75 0 11-1.5 0V14.5H6.25a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Games28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games28FilledIcon, 'Games28Filled');

const Games28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm1.5-2.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-14-.25c0-.41.34-.75.75-.75H8v-1.75a.75.75 0 011.5 0V13h1.75a.75.75 0 010 1.5H9.5v1.75a.75.75 0 01-1.5 0V14.5H6.25a.75.75 0 01-.75-.75zM2 14c0-4.7 3.8-8.5 8.5-8.5h7a8.5 8.5 0 110 17h-7A8.5 8.5 0 012 14zm8.5-7a7 7 0 100 14h7a7 7 0 100-14h-7z",
    fill: primaryFill
  }));
};

export const Games28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games28RegularIcon, 'Games28Regular');

const Games32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6a10 10 0 000 20h8a10 10 0 000-20h-8zm10 13a2 2 0 11-4 0 2 2 0 014 0zm0-4a2 2 0 110-4 2 2 0 010 4zm-12-3a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2H7a1 1 0 110-2h2v-2a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const Games32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games32FilledIcon, 'Games32Filled');

const Games32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 19a2 2 0 11-4 0 2 2 0 014 0zm0-4a2 2 0 100-4 2 2 0 000 4zm-12-3a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2H7a1 1 0 110-2h2v-2a1 1 0 011-1zm-8 4A10 10 0 0112 6h8a10 10 0 010 20h-8A10 10 0 012 16zm10-8a8 8 0 100 16h8a8 8 0 100-16h-8z",
    fill: primaryFill
  }));
};

export const Games32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Games32RegularIcon, 'Games32Regular');